export const episodes = [
  {
    "id": "legacy-eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid",
    "slug": {
      "en": "eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid",
      "es": "eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid",
      "nl": "eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid",
      "pap": "eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 1,
    "title": {
      "en": "Eigen Pad S1E1 - The 7 Principles of a Moral Society - Truth",
      "es": "Eigen Pad S1E1 - Los 7 Principios de una Sociedad Moral - Verdad",
      "nl": "Eigen Pad S1E1 - De 7 Principes voor een Morele Samenleving - Waarheid",
      "pap": "Eigen Pad S1E1 - E 7 Prinsipionan di un Sosiedat Moral - Bèrdat"
    },
    "language": "nl",
    "summary": {
      "en": "This episode discusses natural law, free will, and truth. Many believe that Truth is relative and that no absolute truth exists. In this presentation we show that this is not the case.",
      "es": "Este episodio trata la ley natural, el libre albedrío y la verdad. Muchos creen que la Verdad es relativa y que no existe una verdad absoluta. En esta presentación mostramos que no es así.",
      "nl": "In deze aflevering worden natuurlijke wetten, vrije wil en waarheid besproken. Velen lopen rond met het idee dat Waarheid relatief is en dat er geen absolute waarheid bestaat. In deze presentatie laten we zien dat dit niet het geval is.",
      "pap": "E episodio aki ta trata lei natural, boluntat liber i bèrdat. Hopi hende ta kere ku Bèrdat ta relativo i ku no tin bèrdat absoluto. Den e presentashon aki nos ta mustra ku no ta asina."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e1/06afc4cf618075b2e568e80cd22b225a16c70801?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E1 - De 7 Principes voor een Morele Samenleving - Waarheid - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e1/06afc4cf618075b2e568e80cd22b225a16c70801?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E1-Waarheid.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": null,
    "nextEpisode": "legacy-eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 202,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid",
    "slug": {
      "en": "eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid",
      "es": "eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid",
      "nl": "eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid",
      "pap": "eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 2,
    "title": {
      "en": "Eigen Pad S1E2 - The 7 Principles of a Moral Society - Justice",
      "es": "Eigen Pad S1E2 - Los 7 Principios de una Sociedad Moral - Justicia",
      "nl": "Eigen Pad S1E2 - De 7 Principes voor een Morele Samenleving - Gerechtigheid",
      "pap": "Eigen Pad S1E2 - E 7 Prinsipionan di un Sosiedat Moral - Hustisia"
    },
    "language": "nl",
    "summary": {
      "en": "This episode discusses natural law and justice. Many believe that justice is the job of the government. In this presentation we show that this is not the case.",
      "es": "Este episodio trata la ley natural y la justicia. Muchos creen que la justicia es tarea del gobierno. En esta presentación mostramos que no es así.",
      "nl": "In deze aflevering worden natuurwetten en gerechtigheid besproken. Velen lopen rond met het idee dat gerechtigheid een taak is van de regering. In deze presentatie laten we zien dat dit niet het geval is.",
      "pap": "E episodio aki ta trata lei natural i hustisia. Hopi hende ta kere ku hustisia ta tarea di gobièrnu. Den e presentashon aki nos ta mustra ku no ta asina."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e2/b5a848faf0bfb82f0d95505885c75508a789dca7?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E2 - De 7 Principes voor een Morele Samenleving - Gerechtigheid - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e2/b5a848faf0bfb82f0d95505885c75508a789dca7?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E2-Gerechtigheid.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid",
    "nextEpisode": "legacy-eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 226,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie",
    "slug": {
      "en": "eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie",
      "es": "eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie",
      "nl": "eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie",
      "pap": "eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 3,
    "title": {
      "en": "Eigen Pad S1E3 - The 7 Principles of a Moral Society - Harmony",
      "es": "Eigen Pad S1E3 - Los 7 Principios de una Sociedad Moral - Armonía",
      "nl": "Eigen Pad S1E3 - De 7 Principes voor een Morele Samenleving - Harmonie",
      "pap": "Eigen Pad S1E3 - E 7 Prinsipionan di un Sosiedat Moral - Armonia"
    },
    "language": "nl",
    "summary": {
      "en": "This episode discusses natural law and harmony. The ultimate goal is to harmonize with natural law, but also to harmonize within: as you think, so you feel, so you act.",
      "es": "Este episodio trata la ley natural y la armonía. La meta final es armonizar con la ley natural, pero también armonizar por dentro: como piensas, así sientes, y así actúas.",
      "nl": "In deze aflevering worden natuurwetten, en harmonie besproken. Het uiteindelijke doel is om te harmoniseren met natuurwetten, maar ook om binnenin te harmoniseren - zo denk je, zo voel je, dus zo doe je.",
      "pap": "E episodio aki ta trata lei natural i armonia. E meta final ta armonisá ku lei natural, pero tambe armonisá paden: manera bo ta pensa, asina bo ta sinti, i asina bo ta aktua."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e3/d4ab4fdad9dabfb15cbbf1b0adb363636c4c987a?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E3 - De 7 Principes voor een Morele Samenleving - Harmonie - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e3/d4ab4fdad9dabfb15cbbf1b0adb363636c4c987a?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E3-Harmonie.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid",
    "nextEpisode": "legacy-eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 250,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht",
    "slug": {
      "en": "eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht",
      "es": "eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht",
      "nl": "eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht",
      "pap": "eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 4,
    "title": {
      "en": "Eigen Pad S1E4 - The 7 Principles of a Moral Society - Balance",
      "es": "Eigen Pad S1E4 - Los 7 Principios de una Sociedad Moral - Equilibrio",
      "nl": "Eigen Pad S1E4 - De 7 Principes voor een Morele Samenleving - Evenwicht",
      "pap": "Eigen Pad S1E4 - E 7 Prinsipionan di un Sosiedat Moral - Balansa"
    },
    "language": "nl",
    "summary": {
      "en": "This episode discusses natural law and balance. The triune brain is examined, along with the implications for an unbalanced person who relies mainly on the left or the right hemisphere.",
      "es": "Este episodio trata la ley natural y el equilibrio. Se examina el cerebro triuno y las implicaciones en una persona desequilibrada que usa principalmente el hemisferio izquierdo o el derecho.",
      "nl": "In deze aflevering worden natuurwetten en balans besproken. Het drievoudige brein wordt besproken en de implicaties bij een onevenwichtig persoon die voornamelijk de linkerhersenhelft of de rechterhersenhelft gebruikt.",
      "pap": "E episodio aki ta trata lei natural i balansa. Ta analisá e serebro triuno i e implikashonnan pa un persona desbalansá ku ta usa prinsipalmente e banda robes òf drechi di serebro."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e4/57b5cf9bdf6f310c675fe7e3d3f8fccd9902cedf?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E4 - De 7 Principes voor een Morele Samenleving - Evenwicht - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e4/57b5cf9bdf6f310c675fe7e3d3f8fccd9902cedf?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E4-Evenwicht.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie",
    "nextEpisode": "legacy-eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflevering-orde-met-uitleg-va",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 274,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflevering-orde-met-uitleg-va",
    "slug": {
      "en": "eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflev",
      "es": "eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflev",
      "nl": "eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflev",
      "pap": "eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflev"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 5,
    "title": {
      "en": "Eigen Pad S1E5 - The 7 Principles of a Moral Society - Special Episode: Order, with an explanation of 'The Great Reset'",
      "es": "Eigen Pad S1E5 - Los 7 Principios de una Sociedad Moral - Episodio Especial: Orden, con una explicación de 'The Great Reset'",
      "nl": "Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'",
      "pap": "Eigen Pad S1E5 - E 7 Prinsipionan di un Sosiedat Moral - Episodio Spesial: Òrden, ku un splikashon di 'The Great Reset'"
    },
    "language": "nl",
    "summary": {
      "en": "This episode discusses natural law and order. It is a special episode in which \"The Great Reset\", the book by Klaus Schwab, is examined in light of current events.",
      "es": "Este episodio trata la ley natural y el orden. Es un episodio especial en el que se examina \"The Great Reset\", el libro de Klaus Schwab, en relación con la actualidad.",
      "nl": "In deze aflevering worden natuurwetten en orde besproken. Dit is een speciale aflevering waarin \"The Great Reset\", het boek van Klaus Schwab, wordt besproken in verband met de actualiteit.",
      "pap": "E episodio aki ta trata lei natural i òrden. Ta un episodio spesial kaminda ta analisá \"The Great Reset\", e buki di Klaus Schwab, relashoná ku aktualidat."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e5/559f68ea3a63510580b1c5ecba270b459aeed955?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset' - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e5/559f68ea3a63510580b1c5ecba270b459aeed955?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E5-Orde.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kybalion E-Book",
          "es": "Kybalion E-Book",
          "nl": "Kybalion E-Book",
          "pap": "Kybalion E-Book"
        },
        "url": "./media/Kybalion.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Interview met Klaus Schwab over zijn plannen met de World Economic Forum",
          "es": "Interview met Klaus Schwab over zijn plannen met de World Economic Forum",
          "nl": "Interview met Klaus Schwab over zijn plannen met de World Economic Forum",
          "pap": "Interview met Klaus Schwab over zijn plannen met de World Economic Forum"
        },
        "url": "./videos/Interview-Ben-Verwaayen-en-Klaus-Schwab.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Klaus Schwab Sith Lord Initiation Ceremonie",
          "es": "Klaus Schwab Sith Lord Initiation Ceremonie",
          "nl": "Klaus Schwab Sith Lord Initiation Ceremonie",
          "pap": "Klaus Schwab Sith Lord Initiation Ceremonie"
        },
        "url": "./videos/Klaus-Schwab-Caught-In-Secret-Sith-Lord-Initiation-Ceremony.mp4",
        "type": "video"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht",
    "nextEpisode": "legacy-eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 298,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid",
    "slug": {
      "en": "eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid",
      "es": "eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid",
      "nl": "eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid",
      "pap": "eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 6,
    "title": {
      "en": "Eigen Pad S1E6 - The 7 Principles of a Moral Society - Reciprocity",
      "es": "Eigen Pad S1E6 - Los 7 Principios de una Sociedad Moral - Reciprocidad",
      "nl": "Eigen Pad S1E6 - De 7 Principes voor een Morele Samenleving - Wederkerigheid",
      "pap": "Eigen Pad S1E6 - E 7 Prinsipionan di un Sosiedat Moral - Resiprosidat"
    },
    "language": "nl",
    "summary": {
      "en": "This episode discusses natural law and reciprocity. The idea is that one must be willing to give what one expects to receive.",
      "es": "Este episodio trata la ley natural y la reciprocidad. La idea es que uno debe estar dispuesto a dar lo que espera recibir.",
      "nl": "In deze aflevering worden natuurwetten en wederkerigheid besproken. Het idee is dat men bereid moet zijn te geven wat men verwacht.",
      "pap": "E episodio aki ta trata lei natural i resiprosidat. E idea ta ku bo mester ta dispuesto pa duna loke bo ta spera risibí."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e6/e727c497248da5d251ad343a8ae8a7ca487e3da0?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E6 - De 7 Principes voor een Morele Samenleving - Wederkerigheid - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e6/e727c497248da5d251ad343a8ae8a7ca487e3da0?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E6-Wederkerigheid.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflevering-orde-met-uitleg-va",
    "nextEpisode": "legacy-eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 328,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen",
    "slug": {
      "en": "eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen",
      "es": "eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen",
      "nl": "eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen",
      "pap": "eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 7,
    "title": {
      "en": "Eigen Pad S1E7 - The 7 Principles of a Moral Society - Decency",
      "es": "Eigen Pad S1E7 - Los 7 Principios de una Sociedad Moral - Decencia",
      "nl": "Eigen Pad S1E7 - De 7 Principes voor een Morele Samenleving - Fatsoen",
      "pap": "Eigen Pad S1E7 - E 7 Prinsipionan di un Sosiedat Moral - Desensia"
    },
    "language": "nl",
    "summary": {
      "en": "This episode discusses natural law and decency. Morality is the end product of a decent person.",
      "es": "Este episodio trata la ley natural y la decencia. La moralidad es el producto final de una persona decente.",
      "nl": "In deze aflevering worden natuurlijke wetten en fatsoen besproken. Moraliteit is het eindproduct van een fatsoenlijk persoon.",
      "pap": "E episodio aki ta trata lei natural i desensia. Moralidat ta e produkto final di un persona desente."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e7/25cbb8287089a79ab18c3b947e40bd05f9823319?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E7 - De 7 Principes voor een Morele Samenleving - Fatsoen - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e7/25cbb8287089a79ab18c3b947e40bd05f9823319?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E7-Fatsoen.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid",
    "nextEpisode": "legacy-eigen-pad-s1e8-interview-met-matt-landman",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 354,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s1e8-interview-met-matt-landman",
    "slug": {
      "en": "eigen-pad-s1e8-interview-met-matt-landman",
      "es": "eigen-pad-s1e8-interview-met-matt-landman",
      "nl": "eigen-pad-s1e8-interview-met-matt-landman",
      "pap": "eigen-pad-s1e8-interview-met-matt-landman"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 8,
    "title": {
      "en": "Eigen Pad S1E8 - Interview with Matt Landman",
      "es": "Eigen Pad S1E8 - Entrevista con Matt Landman",
      "nl": "Eigen Pad S1E8 - Interview met Matt Landman",
      "pap": "Eigen Pad S1E8 - Entrevista ku Matt Landman"
    },
    "language": "en",
    "summary": {
      "en": "This episode discusses chemtrails, GMOs, fluoride, vaccines, 5G, and the things we can do to protect ourselves from all these chemicals.",
      "es": "Este episodio trata sobre los chemtrails, los transgénicos, el flúor, las vacunas, el 5G y lo que podemos hacer para protegernos de todos estos químicos.",
      "nl": "Deze aflevering bespreekt chemtrails, GMO, fluoride, vaccin, 5G en de dingen die we kunnen doen om ons tegen al deze chemicaliën te beschermen.",
      "pap": "E episodio aki ta papia di chemtrails, GMO, fluor, vakuna, 5G i e kosnan ku nos por hasi pa protehá nos kontra tur e kímikonan aki."
    },
    "videoUrl": "https://odysee.com/$/embed/de-7-principes-s1e8/56f4cde30bbe8230ade4ac4f27f80802ca01007c?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/eigenpad.png",
    "imageAlt": "Eigen Pad S1E8 - Interview met Matt Landman - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/de-7-principes-s1e8/56f4cde30bbe8230ade4ac4f27f80802ca01007c?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen 1E8-Bonus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen",
    "nextEpisode": "legacy-eigen-pad-s2e0-de-matrix-gedecodeerd-promo",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-2.html",
      "sourceLine": 379,
      "kind": "media",
      "image": "images/eigenpad.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e0-de-matrix-gedecodeerd-promo",
    "slug": {
      "en": "eigen-pad-s2e0-de-matrix-gedecodeerd-promo",
      "es": "eigen-pad-s2e0-de-matrix-gedecodeerd-promo",
      "nl": "eigen-pad-s2e0-de-matrix-gedecodeerd-promo",
      "pap": "eigen-pad-s2e0-de-matrix-gedecodeerd-promo"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 9,
    "title": {
      "en": "Eigen Pad S2E0 - The Matrix Decoded - Promo",
      "es": "Eigen Pad S2E0 - La Matrix Decodificada - Promo",
      "nl": "Eigen Pad S2E0 - De Matrix Gedecodeerd - Promo",
      "pap": "Eigen Pad S2E0 - E Matrix Dekodifiká - Promo"
    },
    "language": "nl",
    "summary": {
      "en": "Remember the film The Matrix? In the coming season we explore the principles of our reality. I will discuss the true meaning behind all four films and explain why they say more about our reality than you might think.",
      "es": "¿Recuerdas la película The Matrix? En la próxima temporada exploramos los principios de nuestra realidad. Hablaré del verdadero significado tras las cuatro películas y explicaré por qué dicen más sobre nuestra realidad de lo que crees.",
      "nl": "Herinner je de film The Matrix nog? Het komende seizoen gaan we het hebben over de principes van onze realiteit. Ik zal de ware betekenis achter alle 4 films bespreken en uitleggen waarom deze films meer over onze realiteit praten dan je denkt.",
      "pap": "Bo ta kòrda e pelíkula The Matrix? Den e temporada ku ta bin nos ta eksplorá e prinsipionan di nos realidat. Lo mi papia di e berdadero nifikashon tras di tur kuater pelíkula i splika dikon nan ta papia mas di nos realidat ku bo ta pensa."
    },
    "videoUrl": "https://odysee.com/$/embed/matrix-promo/7321f11bd77a331e560f41568c52f0e3a7d29439?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E0 - De Matrix Gedecodeerd - Promo - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/matrix-promo/7321f11bd77a331e560f41568c52f0e3a7d29439?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Seizoen 2 - Matrix Flyer",
          "es": "Seizoen 2 - Matrix Flyer",
          "nl": "Seizoen 2 - Matrix Flyer",
          "pap": "Seizoen 2 - Matrix Flyer"
        },
        "url": "./images/flyer-season-2-white-version.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s1e8-interview-met-matt-landman",
    "nextEpisode": "legacy-eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 199,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix",
    "slug": {
      "en": "eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix",
      "es": "eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix",
      "nl": "eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix",
      "pap": "eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 10,
    "title": {
      "en": "Eigen Pad S2E1/Part 1 - The Matrix Decoded: What Is The Matrix?",
      "es": "Eigen Pad S2E1/Parte 1 - La Matrix Decodificada: ¿Qué Es La Matrix?",
      "nl": "Eigen Pad S2E1/Deel 1 - De Matrix Gedecodeerd: Wat Is De Matrix?",
      "pap": "Eigen Pad S2E1/Parti 1 - E Matrix Dekodifiká: Kiko Ta E Matrix?"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we begin to explain the true meaning of the Matrix, starting above all with the question \"What is the Matrix?\".",
      "es": "En este episodio empezamos a explicar el verdadero significado de la Matrix, comenzando sobre todo por la pregunta \"¿Qué es la Matrix?\".",
      "nl": "In deze aflevering beginnen we met het uitleggen van de ware betekenis van de Matrix. We zullen vooral beginnen met het uitleggen van \"Wat is de Matrix?\".",
      "pap": "Den e episodio aki nos ta kuminsá splika e berdadero nifikashon di e Matrix, prinsipalmente ku e pregunta \"Kiko ta e Matrix?\"."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e1-wat-is-de-matrix-part1/4482201e84bddf73afd48a983a3d2227ed8a4d26?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E1/Deel 1 - De Matrix Gedecodeerd: Wat Is De Matrix? - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e1-wat-is-de-matrix-part1/4482201e84bddf73afd48a983a3d2227ed8a4d26?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen-2E1-Wat-Is-De-Matrix-P1.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e0-de-matrix-gedecodeerd-promo",
    "nextEpisode": "legacy-eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 223,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix",
    "slug": {
      "en": "eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix",
      "es": "eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix",
      "nl": "eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix",
      "pap": "eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 11,
    "title": {
      "en": "Eigen Pad S2E2/Part 2 - The Matrix Decoded: What Is The Matrix?",
      "es": "Eigen Pad S2E2/Parte 2 - La Matrix Decodificada: ¿Qué Es La Matrix?",
      "nl": "Eigen Pad S2E2/Deel 2 - De Matrix Gedecodeerd: Wat Is De Matrix?",
      "pap": "Eigen Pad S2E2/Parti 2 - E Matrix Dekodifiká: Kiko Ta E Matrix?"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we continue explaining the true meaning of the Matrix, starting above all with the question \"What is the Matrix?\".",
      "es": "En este episodio seguimos explicando el verdadero significado de la Matrix, comenzando sobre todo por la pregunta \"¿Qué es la Matrix?\".",
      "nl": "In deze aflevering gaan we verder met het uitleggen van de ware betekenis van de Matrix. We zullen vooral beginnen met het uitleggen van \"Wat is de Matrix?\".",
      "pap": "Den e episodio aki nos ta sigui splika e berdadero nifikashon di e Matrix, prinsipalmente ku e pregunta \"Kiko ta e Matrix?\"."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e2-wat-is-de-matrix-part2/391e060a9486b67f0bb780b612d01a7f5daab26b?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E2/Deel 2 - De Matrix Gedecodeerd: Wat Is De Matrix? - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e2-wat-is-de-matrix-part2/391e060a9486b67f0bb780b612d01a7f5daab26b?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen-2E1-Wat-Is-De-Matrix-P1.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix",
    "nextEpisode": "legacy-eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 247,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo",
    "slug": {
      "en": "eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo",
      "es": "eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo",
      "nl": "eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo",
      "pap": "eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 12,
    "title": {
      "en": "Eigen Pad S2E2.5 - The Matrix Decoded - Promo",
      "es": "Eigen Pad S2E2.5 - La Matrix Decodificada - Promo",
      "nl": "Eigen Pad S2E2.5 - De Matrix Gedecodeerd - Promo",
      "pap": "Eigen Pad S2E2.5 - E Matrix Dekodifiká - Promo"
    },
    "language": "nl",
    "summary": {
      "en": "Remember the film The Matrix? In the coming season we explore the principles of our reality. I will discuss the true meaning behind all four films and explain why they say more about our reality than you might think.",
      "es": "¿Recuerdas la película The Matrix? En la próxima temporada exploramos los principios de nuestra realidad. Hablaré del verdadero significado tras las cuatro películas y explicaré por qué dicen más sobre nuestra realidad de lo que crees.",
      "nl": "Herinner je de film The Matrix nog? Het komende seizoen gaan we het hebben over de principes van onze realiteit. Ik zal de ware betekenis achter alle 4 films bespreken en uitleggen waarom deze films meer over onze realiteit praten dan je denkt.",
      "pap": "Bo ta kòrda e pelíkula The Matrix? Den e temporada ku ta bin nos ta eksplorá e prinsipionan di nos realidat. Lo mi papia di e berdadero nifikashon tras di tur kuater pelíkula i splika dikon nan ta papia mas di nos realidat ku bo ta pensa."
    },
    "videoUrl": "https://odysee.com/$/embed/matrix-promo-marja-west/ea91e8babaecc67337fb219a36ad49cfe3538c0c?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E2.5 - De Matrix Gedecodeerd - Promo - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/matrix-promo-marja-west/ea91e8babaecc67337fb219a36ad49cfe3538c0c?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Seizoen 2 - Matrix Flyer",
          "es": "Seizoen 2 - Matrix Flyer",
          "nl": "Seizoen 2 - Matrix Flyer",
          "pap": "Seizoen 2 - Matrix Flyer"
        },
        "url": "./images/flyer-season-2-white-version.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e2-deel-2-de-matrix-gedecodeerd-wat-is-de-matrix",
    "nextEpisode": "legacy-eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 271,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west",
    "slug": {
      "en": "eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west",
      "es": "eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west",
      "nl": "eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west",
      "pap": "eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 13,
    "title": {
      "en": "Eigen Pad S2E3 - The Matrix Decoded: Interview with Marja West",
      "es": "Eigen Pad S2E3 - La Matrix Decodificada: Entrevista con Marja West",
      "nl": "Eigen Pad S2E3 - De Matrix Gedecodeerd: Interview met Marja West",
      "pap": "Eigen Pad S2E3 - E Matrix Dekodifiká: Entrevista ku Marja West"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode Marja West and I, with her flamboyant presenting style, continue explaining and diving into the true meaning of the Matrix.",
      "es": "En este episodio Marja West y yo, con su estilo expositivo extravagante, seguimos explicando y profundizando en el verdadero significado de la Matrix.",
      "nl": "In deze aflevering gaan Marja West en ik, met haar flamboyante presentatiestijl, verder met het uitleggen en duiken in de ware betekenis van de Matrix.",
      "pap": "Den e episodio aki Marja West i ami, ku su estilo flamboyante di presentá, ta sigui splika i profundisá den e berdadero nifikashon di e Matrix."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e3-wat-is-de-matrix-marja-west/9bd3e627f99f8bd61457cb4f3bc1d20165bde132?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E3 - De Matrix Gedecodeerd: Interview met Marja West - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e3-wat-is-de-matrix-marja-west/9bd3e627f99f8bd61457cb4f3bc1d20165bde132?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e2-5-de-matrix-gedecodeerd-promo",
    "nextEpisode": "legacy-eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 295,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix",
    "slug": {
      "en": "eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix",
      "es": "eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix",
      "nl": "eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix",
      "pap": "eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 14,
    "title": {
      "en": "Eigen Pad S2E4 - The Matrix Decoded: Why Are We In The Matrix",
      "es": "Eigen Pad S2E4 - La Matrix Decodificada: Por Qué Estamos En La Matrix",
      "nl": "Eigen Pad S2E4 - De Matrix Gedecodeerd: Waarom Zijn We In De Matrix",
      "pap": "Eigen Pad S2E4 - E Matrix Dekodifiká: Dikon Nos Ta Den E Matrix"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explain \"Why Are We In The Matrix\".",
      "es": "En este episodio explicamos \"Por qué estamos en la Matrix\".",
      "nl": "In deze aflevering leggen we uit \"Waarom we in de Matrix\".",
      "pap": "Den e episodio aki nos ta splika \"Dikon nos ta den e Matrix\"."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e4-waarom-zijn-we-in-de-matrix/a7cd7b2641d67313b976d66920790b59e0a724d0?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E4 - De Matrix Gedecodeerd: Waarom Zijn We In De Matrix - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e4-waarom-zijn-we-in-de-matrix/a7cd7b2641d67313b976d66920790b59e0a724d0?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen-2E4-Waarom-Zijn-We-In-De-Matrix.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e3-de-matrix-gedecodeerd-interview-met-marja-west",
    "nextEpisode": "legacy-eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 318,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo",
    "slug": {
      "en": "eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo",
      "es": "eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo",
      "nl": "eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo",
      "pap": "eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 15,
    "title": {
      "en": "Eigen Pad S2E4.5 - The Matrix Decoded - Promo",
      "es": "Eigen Pad S2E4.5 - La Matrix Decodificada - Promo",
      "nl": "Eigen Pad S2E4.5 - De Matrix Gedecodeerd - Promo",
      "pap": "Eigen Pad S2E4.5 - E Matrix Dekodifiká - Promo"
    },
    "language": "nl",
    "summary": {
      "en": "Remember the film The Matrix? In the coming season we explore the principles of our reality. I will discuss the true meaning behind all four films and explain why they say more about our reality than you might think.",
      "es": "¿Recuerdas la película The Matrix? En la próxima temporada exploramos los principios de nuestra realidad. Hablaré del verdadero significado tras las cuatro películas y explicaré por qué dicen más sobre nuestra realidad de lo que crees.",
      "nl": "Herinner je de film The Matrix nog? Het komende seizoen gaan we het hebben over de principes van onze realiteit. Ik zal de ware betekenis achter alle 4 films bespreken en uitleggen waarom deze films meer over onze realiteit praten dan je denkt.",
      "pap": "Bo ta kòrda e pelíkula The Matrix? Den e temporada ku ta bin nos ta eksplorá e prinsipionan di nos realidat. Lo mi papia di e berdadero nifikashon tras di tur kuater pelíkula i splika dikon nan ta papia mas di nos realidat ku bo ta pensa."
    },
    "videoUrl": "https://odysee.com/$/embed/matrix-promo-nicky-rojer/3398c4aba42f0fff09d97bf54d37d808335f0917?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E4.5 - De Matrix Gedecodeerd - Promo - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/matrix-promo-nicky-rojer/3398c4aba42f0fff09d97bf54d37d808335f0917?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix",
    "nextEpisode": "legacy-eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met-nicky-rojer",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 342,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met-nicky-rojer",
    "slug": {
      "en": "eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met",
      "es": "eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met",
      "nl": "eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met",
      "pap": "eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 16,
    "title": {
      "en": "Eigen Pad S2E5 - The Matrix Decoded: The Illusion of Normal | Interview with Nicky Rojer",
      "es": "Eigen Pad S2E5 - La Matrix Decodificada: La Ilusión de lo Normal | Entrevista con Nicky Rojer",
      "nl": "Eigen Pad S2E5 - De Matrix Gedecodeerd: De Illusie van Normal | Interview met Nicky Rojer",
      "pap": "Eigen Pad S2E5 - E Matrix Dekodifiká: E Ilushon di Normal | Entrevista ku Nicky Rojer"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode Nicky and I talk about how what people consider normal is actually not normal at all.",
      "es": "En este episodio Nicky y yo conversamos sobre cómo lo que la gente considera normal en realidad no lo es.",
      "nl": "In deze aflevering zijn Nicky en ik in gesprek over wat mensen normaal vinden, eigenlijk niet normaal is.",
      "pap": "Den e episodio aki Nicky i ami ta papia di kon loke hende ta konsiderá normal en realidat no ta normal."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e5-illusie-van-normal-nicky-rojer/bcf8a16b8ee3d6804ee793b919422a5f9dc84264?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E5 - De Matrix Gedecodeerd: De Illusie van Normal | Interview met Nicky Rojer - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e5-illusie-van-normal-nicky-rojer/bcf8a16b8ee3d6804ee793b919422a5f9dc84264?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e4-5-de-matrix-gedecodeerd-promo",
    "nextEpisode": "legacy-eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 365,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2",
    "slug": {
      "en": "eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2",
      "es": "eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2",
      "nl": "eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2",
      "pap": "eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 17,
    "title": {
      "en": "Eigen Pad S2E6 - The Matrix Decoded: Interview with Marja West Part 2",
      "es": "Eigen Pad S2E6 - La Matrix Decodificada: Entrevista con Marja West Parte 2",
      "nl": "Eigen Pad S2E6 - De Matrix Gedecodeerd: Interview met Marja West Deel 2",
      "pap": "Eigen Pad S2E6 - E Matrix Dekodifiká: Entrevista ku Marja West Parti 2"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode Marja West and I, with her flamboyant presenting style, continue explaining and diving into the reasons why we are in the Matrix.",
      "es": "En este episodio Marja West y yo, con su estilo expositivo extravagante, seguimos explicando y profundizando en las razones por las que estamos en la Matrix.",
      "nl": "In deze aflevering gaan Marja West en ik, met haar flamboyante presentatiestijl, verder met het uitleggen en duiken in de redenen waarom we in de Matrix zijn.",
      "pap": "Den e episodio aki Marja West i ami, ku su estilo flamboyante di presentá, ta sigui splika i profundisá den e motibunan dikon nos ta den e Matrix."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e6-waarom-zijn-we-in-de-matrix-marja-west/e499b9658ea4724f62ad7adac00d837bd9760e3c?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E6 - De Matrix Gedecodeerd: Interview met Marja West Deel 2 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e6-waarom-zijn-we-in-de-matrix-marja-west/e499b9658ea4724f62ad7adac00d837bd9760e3c?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e5-de-matrix-gedecodeerd-de-illusie-van-normal-interview-met-nicky-rojer",
    "nextEpisode": "legacy-eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 388,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix",
    "slug": {
      "en": "eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix",
      "es": "eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix",
      "nl": "eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix",
      "pap": "eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 18,
    "title": {
      "en": "Eigen Pad S2E7 - The Matrix Decoded: How Do We Get Out Of The Matrix",
      "es": "Eigen Pad S2E7 - La Matrix Decodificada: Cómo Salimos De La Matrix",
      "nl": "Eigen Pad S2E7 - De Matrix Gedecodeerd: Hoe Komen We Uit De Matrix",
      "pap": "Eigen Pad S2E7 - E Matrix Dekodifiká: Kon Nos Ta Sali For Di E Matrix"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explain \"How We Get Out Of The Matrix\".",
      "es": "En este episodio explicamos \"Cómo salimos de la Matrix\".",
      "nl": "In deze aflevering leggen we uit \"Hoe we uit de Matrix komen\".",
      "pap": "Den e episodio aki nos ta splika \"Kon nos ta sali for di e Matrix\"."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e7-hoe-komen-we-uit-de-matrix/bad464a522d2c3d125b962a5d4af6b69ebb7c714?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E7 - De Matrix Gedecodeerd: Hoe Komen We Uit De Matrix - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e7-hoe-komen-we-uit-de-matrix/bad464a522d2c3d125b962a5d4af6b69ebb7c714?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen-2E7-Hoe-Komen-We-Uit-De-Matrix.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e6-de-matrix-gedecodeerd-interview-met-marja-west-deel-2",
    "nextEpisode": "legacy-eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 411,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn",
    "slug": {
      "en": "eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn",
      "es": "eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn",
      "nl": "eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn",
      "pap": "eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 19,
    "title": {
      "en": "Eigen Pad S2E8 - The Matrix Decoded: What It Means To Be \"Awake\"",
      "es": "Eigen Pad S2E8 - La Matrix Decodificada: Qué Significa Estar \"Despierto\"",
      "nl": "Eigen Pad S2E8 - De Matrix Gedecodeerd: Wat Betekent Om \"Wakker\" te Zijn",
      "pap": "Eigen Pad S2E8 - E Matrix Dekodifiká: Kiko Ta Nifiká Ta \"Lantá\""
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we discuss what awakening truly means. Many carry a mistaken idea of what it means to be awake. Often we are more asleep than we realize.",
      "es": "En este episodio hablamos de lo que realmente significa despertar. Muchos tienen una idea equivocada de lo que es estar despierto. A menudo dormimos más de lo que creemos.",
      "nl": "In deze aflevering bespreken we wat echt ontwaken betekent. Velen lopen rond met een verkeerd idee van wat het betekent om wakker te zijn. Vaak slapen we meer dan we denken.",
      "pap": "Den e episodio aki nos ta papia di kiko spièrtamentu di bèrdat ta nifiká. Hopi hende tin un idea robes di loke ta nifiká ta lanta. Hopi biaha nos ta drumi mas ku nos ta kere."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e8-wat-betekent-om-wakker-te-zijn/8d08df7598055811f531deced90e0527d8fa5d4d?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E8 - De Matrix Gedecodeerd: Wat Betekent Om \"Wakker\" te Zijn - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e8-wat-betekent-om-wakker-te-zijn/8d08df7598055811f531deced90e0527d8fa5d4d?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen-2E8-Wat-Betekent-Ontwaakt-Zijn.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix",
    "nextEpisode": "legacy-eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 435,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3",
    "slug": {
      "en": "eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3",
      "es": "eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3",
      "nl": "eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3",
      "pap": "eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 20,
    "title": {
      "en": "Eigen Pad S2E9 - The Matrix Decoded: Interview with Marja West Part 3",
      "es": "Eigen Pad S2E9 - La Matrix Decodificada: Entrevista con Marja West Parte 3",
      "nl": "Eigen Pad S2E9 - De Matrix Gedecodeerd: Interview met Marja West Deel 3",
      "pap": "Eigen Pad S2E9 - E Matrix Dekodifiká: Entrevista ku Marja West Parti 3"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode Marja West and I, with her flamboyant presenting style, continue introducing and diving into the ways we can escape the Matrix.",
      "es": "En este episodio Marja West y yo, con su estilo expositivo extravagante, seguimos presentando y profundizando en las maneras de escapar de la Matrix.",
      "nl": "In deze aflevering gaan Marja West en ik, met haar flamboyante presentatiestijl, door met het introduceren van en duiken in de manieren waarop we aan de Matrix kunnen ontsnappen.",
      "pap": "Den e episodio aki Marja West i ami, ku su estilo flamboyante di presentá, ta sigui introdusí i profundisá den e maneranan ku nos por skapa for di e Matrix."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e9-je-aandacht-bezitten-marja-west/e8702db48b29bea23646fe3364d79b7f57f86855?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E9 - De Matrix Gedecodeerd: Interview met Marja West Deel 3 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e9-je-aandacht-bezitten-marja-west/e8702db48b29bea23646fe3364d79b7f57f86855?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn",
    "nextEpisode": "legacy-eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 459,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
    "slug": {
      "en": "eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "es": "eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "nl": "eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "pap": "eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 21,
    "title": {
      "en": "Eigen Pad S2E10/Part 1 - The Matrix Decoded: Who Are You? What Is Your Purpose?",
      "es": "Eigen Pad S2E10/Parte 1 - La Matrix Decodificada: ¿Quién Eres? ¿Cuál Es Tu Propósito?",
      "nl": "Eigen Pad S2E10/Deel 1 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?",
      "pap": "Eigen Pad S2E10/Parti 1 - E Matrix Dekodifiká: Ken Bo Ta? Kiko Ta Bo Propósito?"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explain \"who you are, and what your purpose is\" based on the latest Matrix 4 film.",
      "es": "En este episodio explicamos \"quién eres y cuál es tu propósito\" con base en la última película Matrix 4.",
      "nl": "In deze aflevering leggen we uit \"wie je bent, en wat je doel is\" op basis van de laatste Matrix 4 film.",
      "pap": "Den e episodio aki nos ta splika \"ken bo ta i kiko ta bo propósito\" basá riba e último pelikula Matrix 4."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e10-wie-ben-je/a4983e1868678bdb67047bb7785e65d2510ba2c9?",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E10/Deel 1 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel? - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e10-wie-ben-je/a4983e1868678bdb67047bb7785e65d2510ba2c9?",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen-2E10-Wie-Ben-Je-Wat-Is-Jou-Doel - Deel 1.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e9-de-matrix-gedecodeerd-interview-met-marja-west-deel-3",
    "nextEpisode": "legacy-eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 482,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
    "slug": {
      "en": "eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "es": "eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "nl": "eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
      "pap": "eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 22,
    "title": {
      "en": "Eigen Pad S2E11/Part 2 - The Matrix Decoded: Who Are You? What Is Your Purpose?",
      "es": "Eigen Pad S2E11/Parte 2 - La Matrix Decodificada: ¿Quién Eres? ¿Cuál Es Tu Propósito?",
      "nl": "Eigen Pad S2E11/Deel 2 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?",
      "pap": "Eigen Pad S2E11/Parti 2 - E Matrix Dekodifiká: Ken Bo Ta? Kiko Ta Bo Propósito?"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we continue explaining \"who you are and what your purpose is\", based on the latest Matrix 4 film.",
      "es": "En este episodio seguimos explicando \"quién eres y cuál es tu propósito\", a partir de la última película Matrix 4.",
      "nl": "In deze aflevering gaan we verder met het uileggen van \"wie je bent, en wat je doel is\" op basis van de laatste Matrix 4 film.",
      "pap": "Den e episodio aki nos ta sigui splika \"ken bo ta i kiko ta bo propósito\", basá riba e último pelíkula Matrix 4."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e11-wie-ben-je/f27d4f49322126a168813b2b91bc4ed252fbcc4d?",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E11/Deel 2 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel? - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e11-wie-ben-je/f27d4f49322126a168813b2b91bc4ed252fbcc4d?",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/Seizoen-2E11-Wie-Ben-Je-Wat-Is-Jou-Doel - Deel 2.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
    "nextEpisode": "legacy-eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 506,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4",
    "slug": {
      "en": "eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4",
      "es": "eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4",
      "nl": "eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4",
      "pap": "eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 23,
    "title": {
      "en": "Eigen Pad S2E12 - The Matrix Decoded: Interview with Marja West Part 4",
      "es": "Eigen Pad S2E12 - La Matrix Decodificada: Entrevista con Marja West Parte 4",
      "nl": "Eigen Pad S2E12 - De Matrix Gedecodeerd: Interview met Marja West Deel 4",
      "pap": "Eigen Pad S2E12 - E Matrix Dekodifiká: Entrevista ku Marja West Parti 4"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode Marja West and I, with her flamboyant presenting style, continue introducing and diving into the ways we can activate the god within us.",
      "es": "En este episodio Marja West y yo, con su estilo expositivo extravagante, seguimos presentando y profundizando en las maneras de activar al dios que llevamos dentro.",
      "nl": "In deze aflevering gaan Marja West en ik, met haar flamboyante presentatiestijl, door met het introduceren van en duiken in de manieren waarop we de god in ons kunnen activeren.",
      "pap": "Den e episodio aki Marja West i ami, ku su estilo flamboyante di presentá, ta sigui introdusí i profundisá den e maneranan pa aktivá e dios den nos."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e12-je-bent-goddelijk-in-het-vlees-marja-west/6e7cd894fc499ca8f144778491fefe266707241f?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E12 - De Matrix Gedecodeerd: Interview met Marja West Deel 4 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e12-je-bent-goddelijk-in-het-vlees-marja-west/6e7cd894fc499ca8f144778491fefe266707241f?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel",
    "nextEpisode": "legacy-eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-nicky-rojer",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 530,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-nicky-rojer",
    "slug": {
      "en": "eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-ni",
      "es": "eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-ni",
      "nl": "eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-ni",
      "pap": "eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-ni"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 24,
    "title": {
      "en": "Eigen Pad S2E13 - The Matrix Decoded: Real Evolution | Interview with Nicky Rojer",
      "es": "Eigen Pad S2E13 - La Matrix Decodificada: La Evolución Real | Entrevista con Nicky Rojer",
      "nl": "Eigen Pad S2E13 - De Matrix Gedecodeerd: De Echte Evolutie | Interview met Nicky Rojer",
      "pap": "Eigen Pad S2E13 - E Matrix Dekodifiká: E Berdadero Evolushon | Entrevista ku Nicky Rojer"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode Nicky and I talk about what real evolution is. Often we simply follow our programming and fail to understand that, as a society, we must first grasp what love is. Because evolution begins when we learn to TRULY love.",
      "es": "En este episodio Nicky y yo hablamos de lo que es la verdadera evolución. A menudo solo seguimos nuestra programación y no comprendemos que, como sociedad, primero debemos entender qué es el amor. Porque la evolución comienza cuando aprendemos a amar DE VERDAD.",
      "nl": "In deze aflevering hebben Nicky en ik het over wat echte evolutie is. Vaak volgen we gewoon onze programmering en begrijpen we niet dat we als samenleving eerst moeten gaan begrijpen wat liefde is. Omdat evolutie begint wanneer we leren ECHT liefhebben.",
      "pap": "Den e episodio aki Nicky i ami ta papia di kiko ta berdadero evolushon. Hopi biaha nos ta djis sigui nos programashon i no ta komprondé ku, komo sosiedat, nos mester komprondé promé kiko ta amor. Pasobra evolushon ta kuminsá ora nos siña stima DI BÈRDAT."
    },
    "videoUrl": "https://odysee.com/$/embed/s2e13-evolutie-vs-programmering-nicky-rojer/f845f79e7a36176e5f9bd7387c6c666b00526a98?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/bg-matrix.jpg",
    "imageAlt": "Eigen Pad S2E13 - De Matrix Gedecodeerd: De Echte Evolutie | Interview met Nicky Rojer - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s2e13-evolutie-vs-programmering-nicky-rojer/f845f79e7a36176e5f9bd7387c6c666b00526a98?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e12-de-matrix-gedecodeerd-interview-met-marja-west-deel-4",
    "nextEpisode": "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 552,
      "kind": "media",
      "image": "images/bg-matrix.jpg"
    }
  },
  {
    "id": "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers",
    "slug": {
      "en": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers",
      "es": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers",
      "nl": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers",
      "pap": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 25,
    "title": {
      "en": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers",
      "es": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers",
      "nl": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers",
      "pap": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers"
    },
    "language": "en",
    "summary": {
      "en": "In this episode, after two years of the extensive Matrix season, Glenn Tramm returns to this classic film and offers the audience more gold nuggets and forgotten or overlooked lessons.",
      "es": "En este episodio, tras dos años de la extensa temporada de Matrix, Glenn Tramm vuelve a esta película clásica y ofrece al público más pepitas de oro y lecciones olvidadas o pasadas por alto.",
      "nl": "in deze aflevering, en na twee jaar het uitgebreide Matrix-seizoen te hebben gegeven, neemt Glenn Tramm opnieuw deel aan deze klassieke film en biedt het publiek meer goudklompjes en vergeten of over het hoofd geziene lessen.",
      "pap": "Den e episodio aki, despues di dos aña di e temporada ekstenso di Matrix, Glenn Tramm ta bòlbe na e pelíkula klásiko aki i ta ofresé e públiko mas pida-pida di oro i lèsnan lubidá òf pasá por alto."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/resurrecting-the-ignored-lessons-from-the-matrix:9?r=6NBkuFKUCKo4hTzBqQecxyDkppvwCxzQ",
    "audioUrl": null,
    "image": "/assets/images/resurrecting-the-ignored-lessons-from-the-matrix-cover.jpg",
    "imageAlt": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/resurrecting-the-ignored-lessons-from-the-matrix:9?r=6NBkuFKUCKo4hTzBqQecxyDkppvwCxzQ",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s2e13-de-matrix-gedecodeerd-de-echte-evolutie-interview-met-nicky-rojer",
    "nextEpisode": "legacy-eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-3.html",
      "sourceLine": 574,
      "kind": "media",
      "image": "images/resurrecting-the-ignored-lessons-from-the-matrix-cover.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo",
    "slug": {
      "en": "eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo",
      "es": "eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo",
      "nl": "eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo",
      "pap": "eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 26,
    "title": {
      "en": "Eigen Pad S3E0: Kabbalah & Tarot Revealed - Promo",
      "es": "Eigen Pad S3E0: Cábala y Tarot Revelados - Promo",
      "nl": "Eigen Pad S3E0: Kabbala & Tarot Onthuld - Promo",
      "pap": "Eigen Pad S3E0: Kabala & Tarot Revelá - Promo"
    },
    "language": "en",
    "summary": {
      "en": "Did you know that Kabbalah & Tarot are two main currents underlying many modern religions? In the coming season we will discuss Kabbalah & Tarot. I will reveal their meanings and explain why these schools are more connected to Judeo-Christian religions than you think. So mark your calendar: 20 Sept 2022 through 6 Dec 2022 @ 21:00 NL time / 15:00 CUR time. See you soon!",
      "es": "¿Sabías que la Cábala y el Tarot son dos corrientes principales que subyacen a muchas religiones modernas? En la próxima temporada hablaremos de la Cábala y el Tarot. Revelaré sus significados y explicaré por qué estas escuelas están más conectadas con las religiones judeocristianas de lo que crees. Apúntalo en tu agenda: del 20 de sept. de 2022 al 6 de dic. de 2022 a las 21:00 hora NL / 15:00 hora CUR. ¡Nos vemos pronto!",
      "nl": "Weet je dat Kabbala & Tarot twee hoofdstromingen zijn die ten grondslag liggen aan veel moderne religies? Het komende seizoen gaan we het hebben over Kabbala & Tarot. Ik zal de betekenissen onthullen en uitleggen waarom deze scholen meer verbonden zijn met judeo-christelijke religies dan je denkt. Dus zet het in je agenda: 20 Sept 2022 t/m 6 Dec 2022 @ 21 uur NL tijd/15 uur CUR tijd. ik zie je snel!",
      "pap": "Bo sa ku Kabala & Tarot ta dos koriente prinsipal ku ta bib'abou di hopi religion moderno? E temporada ku ta bin nos lo papia di Kabala & Tarot. Lo mi revelá nan nifikashon i splika dikon e skolnan aki ta mas konektá ku religionnan hudio-kristian ku bo ta pensa. P'esei pone den bo agenda: 20 sèpt 2022 t/m 6 des 2022 @ 21 ora NL / 15 ora CUR. Te aworó!"
    },
    "videoUrl": "https://odysee.com/$/embed/kabbala-tarot/494bcf2395aeadd0fddcdc6dd857e6311d0e6f80?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E0: Kabbala & Tarot Onthuld - Promo - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/kabbala-tarot/494bcf2395aeadd0fddcdc6dd857e6311d0e6f80?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Seizoen 3 - Kabbala & Tarot Flyer",
          "es": "Seizoen 3 - Kabbala & Tarot Flyer",
          "nl": "Seizoen 3 - Kabbala & Tarot Flyer",
          "pap": "Seizoen 3 - Kabbala & Tarot Flyer"
        },
        "url": "./images/flyer-eigenpad-seizoen-3.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers",
    "nextEpisode": "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 198,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch",
    "slug": {
      "en": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch",
      "es": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch",
      "nl": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch",
      "pap": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 27,
    "title": {
      "en": "The Occult Revealed: Back To The Source - Part 1 (Dutch)",
      "es": "Lo Oculto Revelado: De Vuelta A La Fuente - Parte 1 (neerlandés)",
      "nl": "Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch)",
      "pap": "E Okulto Revelá: Bèk Na E Fuente - Parti 1 (hulandes)"
    },
    "language": "nl",
    "summary": {
      "en": "This presentation discusses the most common occult traditions of our time. First the occult is treated in general. Then a broad overview of their teachings is given, and finally the symbols they use.",
      "es": "Esta presentación trata las tradiciones ocultas más comunes de nuestro tiempo. Primero se aborda lo oculto en general. Luego se ofrece un panorama general de sus enseñanzas y, por último, los símbolos que utilizan.",
      "nl": "In deze presentatie worden de meest voorkomende occulte tradities van onze tijd besproken. Ten eerste wordt het occulte in het algemeen behandeld. Vervolgens wordt een algemeen overzicht van hun leringen besproken en tot slot de symbolen die worden gebruikt.",
      "pap": "E presentashon aki ta trata e tradishonnan okulto di mas komun di nos tempu. Promé ta trata e okulto en general. Despues ta duna un bista general di nan siñansanan i finalmente e símbolonan ku nan ta usa."
    },
    "videoUrl": "https://odysee.com/$/embed/het-occulte-onthuld-deel-1/685eb5a15d3cf6ef89837f48d1935d72c9e68dd3?",
    "audioUrl": null,
    "image": "/assets/images/img0.png",
    "imageAlt": "Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/het-occulte-onthuld-deel-1/685eb5a15d3cf6ef89837f48d1935d72c9e68dd3?",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 1 - Sheets (pdf)",
          "es": "Het Occulte Onthuld Deel 1 - Sheets (pdf)",
          "nl": "Het Occulte Onthuld Deel 1 - Sheets (pdf)",
          "pap": "Het Occulte Onthuld Deel 1 - Sheets (pdf)"
        },
        "url": "/media/het-occulte-onthuld-deel-1.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 1 - Sheets (zip)",
          "es": "Het Occulte Onthuld Deel 1 - Sheets (zip)",
          "nl": "Het Occulte Onthuld Deel 1 - Sheets (zip)",
          "pap": "Het Occulte Onthuld Deel 1 - Sheets (zip)"
        },
        "url": "/media/het-occulte-onthuld-deel-1.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Tijdlijn van Religies",
          "es": "Tijdlijn van Religies",
          "nl": "Tijdlijn van Religies",
          "pap": "Tijdlijn van Religies"
        },
        "url": "./images/religions-chart.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e0-kabbala-and-tarot-onthuld-promo",
    "nextEpisode": "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 224,
      "kind": "media",
      "image": "images/img0.png"
    }
  },
  {
    "id": "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch",
    "slug": {
      "en": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch",
      "es": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch",
      "nl": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch",
      "pap": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 28,
    "title": {
      "en": "The Occult Revealed: Dark Occultism (Satanism) - Part 2 (Dutch)",
      "es": "Lo Oculto Revelado: Ocultismo Oscuro (Satanismo) - Parte 2 (neerlandés)",
      "nl": "Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch)",
      "pap": "E Okulto Revelá: Okultismo Skur (Satanismo) - Parti 2 (hulandes)"
    },
    "language": "nl",
    "summary": {
      "en": "This presentation discusses the ideology of Satanism and how it enters our society almost unnoticed. Some of its symbols and strategies are examined. At the end, some solutions are also discussed.",
      "es": "Esta presentación trata la ideología del satanismo y cómo se infiltra en nuestra sociedad casi sin que nos demos cuenta. Se examinan algunos de sus símbolos y estrategias. Al final también se plantean algunas soluciones.",
      "nl": "Deze presentatie bespreekt de ideologie van het satanisme en hoe dit bijna onopgemerkt onze samenleving binnendringt. Enkele van hun symbolen en strategieën worden besproken. Aan het einde worden ook enkele oplossingen besproken.",
      "pap": "E presentashon aki ta trata e ideologia di satanismo i kon e ta drenta nos sosiedat kasi sin ku nos ta ripará. Ta analisá algun di su símbolonan i strategianan. Na fin tambe ta trata algun solushon."
    },
    "videoUrl": "https://odysee.com/$/embed/het-occulte-onthuld-deel-2/cb06f3cd96aef7bbf6b6dfc98f3a981b66a80e31?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/img0-1.png",
    "imageAlt": "Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/het-occulte-onthuld-deel-2/cb06f3cd96aef7bbf6b6dfc98f3a981b66a80e31?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 2 - Sheets (pdf)",
          "es": "Het Occulte Onthuld Deel 2 - Sheets (pdf)",
          "nl": "Het Occulte Onthuld Deel 2 - Sheets (pdf)",
          "pap": "Het Occulte Onthuld Deel 2 - Sheets (pdf)"
        },
        "url": "/media/het-occulte-onthuld-deel-2.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 2 - Sheets (zip)",
          "es": "Het Occulte Onthuld Deel 2 - Sheets (zip)",
          "nl": "Het Occulte Onthuld Deel 2 - Sheets (zip)",
          "pap": "Het Occulte Onthuld Deel 2 - Sheets (zip)"
        },
        "url": "/media/het-occulte-onthuld-deel-2.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Tijdlijn van Religies",
          "es": "Tijdlijn van Religies",
          "nl": "Tijdlijn van Religies",
          "pap": "Tijdlijn van Religies"
        },
        "url": "./images/religions-chart.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch",
    "nextEpisode": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 259,
      "kind": "media",
      "image": "images/img0-1.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen",
    "slug": {
      "en": "eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen",
      "es": "eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen",
      "nl": "eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen",
      "pap": "eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 29,
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "language": "en",
    "summary": {
      "en": "The start of the new season. Here we discuss what symbols are and examine some specific examples of symbols and what they do to our consciousness.",
      "es": "El comienzo de la nueva temporada. Aquí hablamos de qué son los símbolos y examinamos algunos ejemplos específicos de símbolos y lo que hacen a nuestra conciencia.",
      "nl": "de start van het nieuwe seizoen. Hier bespreken we wat symbolen zijn en onderzoeken we enkele specifieke voorbeelden van symbolen en wat ze met ons bewustzijn doen.",
      "pap": "E komienso di e temporada nobo. Akinan nos ta papia di kiko ta símbolonan i ta analisá algun ehèmpel spesífiko di símbolo i kiko nan ta hasi ku nos konsenshi."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e1-kabbala-tarot/7a4168f32458498208ceaa147681d9ea379e7e39?",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e1-kabbala-tarot/7a4168f32458498208ceaa147681d9ea379e7e39?",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e1-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch",
    "nextEpisode": "legacy-eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 292,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit",
    "slug": {
      "en": "eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit",
      "es": "eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit",
      "nl": "eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit",
      "pap": "eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 30,
    "title": {
      "en": "Eigen Pad S3E2: Kabbalah & Tarot Revealed - Symbols and Reality",
      "es": "Eigen Pad S3E2: Cábala y Tarot Revelados - Símbolos y Realidad",
      "nl": "Eigen Pad S3E2: Kabbala & Tarot Onthuld - Symbolen en Realiteit",
      "pap": "Eigen Pad S3E2: Kabala & Tarot Revelá - Símbolonan i Realidat"
    },
    "language": "en",
    "summary": {
      "en": "The start of the new season. Here we continue with symbols and begin to examine the Kabbalistic ways of thinking.",
      "es": "El comienzo de la nueva temporada. Aquí seguimos con los símbolos y empezamos a examinar las formas de pensamiento cabalísticas.",
      "nl": "De start van het nieuwe seizoen. Hier bespreken gaan we verder met symbolen en beginnen we de kabbalistische denkwijzen te onderzoeken.",
      "pap": "E komienso di e temporada nobo. Akinan nos ta sigui ku símbolonan i ta kuminsá analisá e maneranan di pensa kabalístiko."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e2-kabbala-tarot:e?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E2: Kabbala & Tarot Onthuld - Symbolen en Realiteit - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e2-kabbala-tarot:e?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e2-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen",
    "nextEpisode": "legacy-eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-werelden",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 351,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-werelden",
    "slug": {
      "en": "eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-were",
      "es": "eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-were",
      "nl": "eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-were",
      "pap": "eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-were"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 31,
    "title": {
      "en": "Eigen Pad S3E3: Kabbalah & Tarot Revealed - Making Contact With The Higher Worlds",
      "es": "Eigen Pad S3E3: Cábala y Tarot Revelados - Hacer Contacto Con Los Mundos Superiores",
      "nl": "Eigen Pad S3E3: Kabbala & Tarot Onthuld - Contact Maken Met De Boven Werelden",
      "pap": "Eigen Pad S3E3: Kabala & Tarot Revelá - Hasi Kontakto Ku E Mundunan Superior"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explore what Kabbalah teaches about making contact with the spiritual worlds. First, however, some basic explanations are given of concepts such as spirit, soul, and persona.",
      "es": "En este episodio exploramos lo que la Cábala enseña sobre el contacto con los mundos espirituales. Pero primero se dan algunas explicaciones básicas de conceptos como espíritu, alma y persona.",
      "nl": "In deze aflevering zullen we onderzoeken wat Kabbalah leert over contact maken met de spirituele werelden. Eerst worden echter enkele basisverklaringen gegeven over concepten als geest, ziel en persona.",
      "pap": "Den e episodio aki nos ta eksplorá kiko Kabala ta siña tokante hasi kontakto ku e mundunan spiritual. Pero promé ta duna algun splikashon básiko di konseptonan manera spiritu, alma i persona."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e3-kabbala-tarot:2?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E3: Kabbala & Tarot Onthuld - Contact Maken Met De Boven Werelden - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e3-kabbala-tarot:2?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e3-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit",
    "nextEpisode": "legacy-eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 410,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1",
    "slug": {
      "en": "eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1",
      "es": "eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1",
      "nl": "eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1",
      "pap": "eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 32,
    "title": {
      "en": "Eigen Pad S3E4: Kabbalah & Tarot Revealed - Who Is God? Part 1",
      "es": "Eigen Pad S3E4: Cábala y Tarot Revelados - ¿Quién Es Dios? Parte 1",
      "nl": "Eigen Pad S3E4: Kabbala & Tarot Onthuld - Wie Is God? Deel 1",
      "pap": "Eigen Pad S3E4: Kabala & Tarot Revelá - Ken Ta Dios? Parti 1"
    },
    "language": "en",
    "summary": {
      "en": "In this episode we begin to explore the Kabbalistic concepts regarding 'God'. It will begin to unfold that the true 'God' of Creation is not limited to our perceptions and naming conventions.",
      "es": "En este episodio comenzamos a explorar los conceptos cabalísticos relativos a 'Dios'. Empezará a revelarse que el verdadero 'Dios' de la Creación no se limita a nuestras percepciones ni a nuestras convenciones de nombres.",
      "nl": "In deze aflevering beginnen we de kabbalistische concepten met betrekking tot 'God' te verkennen. het zal beginnen te ontvouwen dat de ware 'God' van de Schepping niet beperkt is tot onze waarnemingen en naamgevingsconventies.",
      "pap": "Den e episodio aki nos ta kuminsá eksplorá e konseptonan kabalístiko relashoná ku 'Dios'. Lo kuminsá bira kla ku e berdadero 'Dios' di Kreashon no ta limitá na nos persepshonnan i konvenshonnan di nòmber."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e4-kabbala-tarot/27b9f3de193b93d9d8b4b85abc78a504a753b337?",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E4: Kabbala & Tarot Onthuld - Wie Is God? Deel 1 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e4-kabbala-tarot/27b9f3de193b93d9d8b4b85abc78a504a753b337?",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e4-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-werelden",
    "nextEpisode": "legacy-eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 468,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2",
    "slug": {
      "en": "eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2",
      "es": "eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2",
      "nl": "eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2",
      "pap": "eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 33,
    "title": {
      "en": "Eigen Pad S3E5: Kabbalah & Tarot Revealed - Who Is God? Part 2",
      "es": "Eigen Pad S3E5: Cábala y Tarot Revelados - ¿Quién Es Dios? Parte 2",
      "nl": "Eigen Pad S3E5: Kabbala & Tarot Onthuld - Wie Is God? Deel 2",
      "pap": "Eigen Pad S3E5: Kabala & Tarot Revelá - Ken Ta Dios? Parti 2"
    },
    "language": "en",
    "summary": {
      "en": "In this episode we continue to explore the Kabbalistic concepts regarding 'God'.",
      "es": "En este episodio seguimos explorando los conceptos cabalísticos relativos a 'Dios'.",
      "nl": "In deze aflevering gaan we verder met de kabbalistische concepten met betrekking tot 'God' te verkennen.",
      "pap": "Den e episodio aki nos ta sigui eksplorá e konseptonan kabalístiko relashoná ku 'Dios'."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e5-kabbala-tarot:e?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E5: Kabbala & Tarot Onthuld - Wie Is God? Deel 2 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e5-kabbala-tarot:e?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e5-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1",
    "nextEpisode": "legacy-eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-deel-1",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 526,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-deel-1",
    "slug": {
      "en": "eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-dee",
      "es": "eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-dee",
      "nl": "eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-dee",
      "pap": "eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-dee"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 34,
    "title": {
      "en": "Eigen Pad S3E6: Kabbalah & Tarot Revealed - Through Being, You Will Become, Part 1",
      "es": "Eigen Pad S3E6: Cábala y Tarot Revelados - A Través del Ser, Llegarás a Ser, Parte 1",
      "nl": "Eigen Pad S3E6: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Deel 1",
      "pap": "Eigen Pad S3E6: Kabala & Tarot Revelá - Dor di Ser, Lo Bo Bira, Parti 1"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we close our theme of 'God' and turn to Being. We set out to explore the qualities of 'God' and how they can be used to become a better version of yourself.",
      "es": "En este episodio cerramos nuestro tema de 'Dios' y pasamos al Ser. Nos disponemos a explorar las cualidades de 'Dios' y cómo pueden usarse para llegar a ser una mejor versión de ti mismo.",
      "nl": "In deze aflevering sluiten we ons thema 'God' af en gaan we het hebben over Zijn. We gaan aan de slag om de kwaliteiten van 'God' te verkennen en hoe deze gebruikt kunnen worden om een betere versie van jezelf te worden.",
      "pap": "Den e episodio aki nos ta sera nos tema di 'Dios' i ta pasa na Ser. Nos ta kuminsá eksplorá e kualidatnan di 'Dios' i kon nan por wòrdu usá pa bira un mihó version di bo mes."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e6-kabbala-tarot:9?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E6: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Deel 1 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e6-kabbala-tarot:9?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e6-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2",
    "nextEpisode": "legacy-eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-mazzaroth-de-zodiac-deel-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 584,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-mazzaroth-de-zodiac-deel-2",
    "slug": {
      "en": "eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-maz",
      "es": "eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-maz",
      "nl": "eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-maz",
      "pap": "eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-maz"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 35,
    "title": {
      "en": "Eigen Pad S3E7: Kabbalah & Tarot Revealed - Through Being, You Will Become, Mazzaroth (The Zodiac) Part 2",
      "es": "Eigen Pad S3E7: Cábala y Tarot Revelados - A Través del Ser, Llegarás a Ser, Mazzaroth (El Zodíaco) Parte 2",
      "nl": "Eigen Pad S3E7: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Mazzaroth (De Zodiac) Deel 2",
      "pap": "Eigen Pad S3E7: Kabala & Tarot Revelá - Dor di Ser, Lo Bo Bira, Mazzaroth (E Zodíako) Parti 2"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we discuss the qualities of 'God' one should take on in order to attain equivalence with form. As a bonus, we begin discussing the zodiac, a hidden message of change.",
      "es": "En este episodio hablamos de las cualidades de 'Dios' que uno debería asumir para alcanzar la equivalencia con la forma. Como extra, comenzamos a hablar del zodíaco, un mensaje oculto de cambio.",
      "nl": "In deze aflevering zullen we het hebben over de eigenschappen van 'God' die men zou moeten aannemen om gelijkwaardig aan vorm te bereiken. Als bonus zullen we beginnen met het bespreken van de dierenriem, een verborgen boodschap van verandering.",
      "pap": "Den e episodio aki nos ta papia di e kualidatnan di 'Dios' ku un hende mester asumí pa alkansá ekivalensia ku forma. Komo bonus, nos ta kuminsá papia di e zodíako, un mensahe skondí di kambio."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e7-kabbala-tarot:1?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E7: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Mazzaroth (De Zodiac) Deel 2 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e7-kabbala-tarot:1?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e7-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-deel-1",
    "nextEpisode": "legacy-eigen-pad-s3e8-mazzaroth-de-zodiac",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 642,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e8-mazzaroth-de-zodiac",
    "slug": {
      "en": "eigen-pad-s3e8-mazzaroth-de-zodiac",
      "es": "eigen-pad-s3e8-mazzaroth-de-zodiac",
      "nl": "eigen-pad-s3e8-mazzaroth-de-zodiac",
      "pap": "eigen-pad-s3e8-mazzaroth-de-zodiac"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 36,
    "title": {
      "en": "Eigen Pad S3E8: Mazzaroth (The Zodiac)",
      "es": "Eigen Pad S3E8: Mazzaroth (El Zodíaco)",
      "nl": "Eigen Pad S3E8: Mazzaroth (De Zodiac)",
      "pap": "Eigen Pad S3E8: Mazzaroth (E Zodíako)"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we go deeper into the zodiac. We discuss a little of how the Egyptians viewed life in general and how this influenced our current zodiac system.",
      "es": "En este episodio profundizamos en el zodíaco. Comentamos un poco cómo veían los egipcios la vida en general y cómo influyó en nuestro sistema zodiacal actual.",
      "nl": "In deze aflevering gaan we uitgebreider in op de dierenriem (de zodiac). We zullen een beetje bespreken hoe de Egyptenaren het leven in het algemeen zagen en hoe dit ons huidige dierenriemsysteem beïnvloedde.",
      "pap": "Den e episodio aki nos ta profundisá den e zodíako. Nos ta papia un poko di kon e egipsionan tabata mira bida en general i kon esaki a influensiá nos sistema zodiakal aktual."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e8-kabbala-tarot:b?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E8: Mazzaroth (De Zodiac) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e8-kabbala-tarot:b?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e8-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-mazzaroth-de-zodiac-deel-2",
    "nextEpisode": "legacy-eigen-pad-s3e9-gilgulim-reincarnatie",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 700,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e9-gilgulim-reincarnatie",
    "slug": {
      "en": "eigen-pad-s3e9-gilgulim-reincarnatie",
      "es": "eigen-pad-s3e9-gilgulim-reincarnatie",
      "nl": "eigen-pad-s3e9-gilgulim-reincarnatie",
      "pap": "eigen-pad-s3e9-gilgulim-reincarnatie"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 37,
    "title": {
      "en": "Eigen Pad S3E9: Gilgulim (Reincarnation)",
      "es": "Eigen Pad S3E9: Gilgulim (Reencarnación)",
      "nl": "Eigen Pad S3E9: Gilgulim (Reïncarnatie)",
      "pap": "Eigen Pad S3E9: Gilgulim (Reenkarnashon)"
    },
    "language": "en",
    "summary": {
      "en": "In this episode we wrap up the topic of the qualities of 'God' and discuss the subject of reincarnation — Gilgulim.",
      "es": "En este episodio cerramos el tema de las cualidades de 'Dios' y abordamos el tema de la reencarnación: Gilgulim.",
      "nl": "In deze aflevering ronden we het onderwerp van de kwaliteiten van 'God' af en bespreken we het onderwerp reïncarnatie - Gilgulim.",
      "pap": "Den e episodio aki nos ta sera e tema di e kualidatnan di 'Dios' i ta papia di e tema di reenkarnashon — Gilgulim."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e9-kabbala-tarot:2?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E9: Gilgulim (Reïncarnatie) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e9-kabbala-tarot:2?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e9-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e8-mazzaroth-de-zodiac",
    "nextEpisode": "legacy-eigen-pad-s3e10-de-hemelen-en-zijn-wezens",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 758,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e10-de-hemelen-en-zijn-wezens",
    "slug": {
      "en": "eigen-pad-s3e10-de-hemelen-en-zijn-wezens",
      "es": "eigen-pad-s3e10-de-hemelen-en-zijn-wezens",
      "nl": "eigen-pad-s3e10-de-hemelen-en-zijn-wezens",
      "pap": "eigen-pad-s3e10-de-hemelen-en-zijn-wezens"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 38,
    "title": {
      "en": "Eigen Pad S3E10: The Heavens and Their Beings",
      "es": "Eigen Pad S3E10: Los Cielos y Sus Seres",
      "nl": "Eigen Pad S3E10: De Hemelen en Zijn Wezens",
      "pap": "Eigen Pad S3E10: E Shelunan i Nan Sernan"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we discuss the beings of the various heavens. I will also share some secrets about the kundalini and how this balancing force relates to the macrocosm just as it does to the microcosm.",
      "es": "En este episodio hablamos de los seres de los distintos cielos. También compartiré algunos secretos sobre la kundalini y cómo esta fuerza equilibradora se relaciona con el macrocosmos igual que con el microcosmos.",
      "nl": "In deze aflevering gaan we het hebben over de wezens van de verschillende hemelen. Ik zal ook enkele geheimen vertellen over de kundalini en hoe deze balancerende kracht zich ook verhoudt tot de macrokosmos, hetzelfde als de microkosmos.",
      "pap": "Den e episodio aki nos ta papia di e sernan di e diferente shelunan. Lo mi kompartí tambe algun sekreto tokante e kundalini i kon e forsa balansadó aki ta relashoná ku e makrokosmo, mes manera ku e mikrokosmo."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e10-kabbala-tarot:3?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E10: De Hemelen en Zijn Wezens - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e10-kabbala-tarot:3?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e10-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e9-gilgulim-reincarnatie",
    "nextEpisode": "legacy-eigen-pad-s3e11-wat-is-de-shekinah-kundalini",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 816,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e11-wat-is-de-shekinah-kundalini",
    "slug": {
      "en": "eigen-pad-s3e11-wat-is-de-shekinah-kundalini",
      "es": "eigen-pad-s3e11-wat-is-de-shekinah-kundalini",
      "nl": "eigen-pad-s3e11-wat-is-de-shekinah-kundalini",
      "pap": "eigen-pad-s3e11-wat-is-de-shekinah-kundalini"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 39,
    "title": {
      "en": "Eigen Pad S3E11: What is the Shekinah (Kundalini)?",
      "es": "Eigen Pad S3E11: ¿Qué es la Shekinah (Kundalini)?",
      "nl": "Eigen Pad S3E11: Wat is de Shekinah (Kundalini)?",
      "pap": "Eigen Pad S3E11: Kiko ta e Shekinah (Kundalini)?"
    },
    "language": "nl",
    "summary": {
      "en": "This episode is a special one, and if you are here, it is not by accident. I talk about the kundalini energy, its purpose, and how you can recognize it.",
      "es": "Este episodio es especial y, si estás aquí, no es por casualidad. Hablo de la energía kundalini, su propósito y cómo puedes reconocerla.",
      "nl": "Deze aflevering is een speciale en als je hier bent, is dat niet per ongeluk. Ik praat over de kundalini-energie, het doel ervan en hoe je deze kunt herkennen.",
      "pap": "E episodio aki ta spesial i, si bo ta akinan, no ta pa kasualidat. Mi ta papia di e energia kundalini, su propósito i kon bo por rekonosé."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e11-kabbala-tarot:c?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E11: Wat is de Shekinah (Kundalini)? - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e11-kabbala-tarot:c?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e11-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e10-de-hemelen-en-zijn-wezens",
    "nextEpisode": "legacy-eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 874,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot",
    "slug": {
      "en": "eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot",
      "es": "eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot",
      "nl": "eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot",
      "pap": "eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 40,
    "title": {
      "en": "Eigen Pad S3E12: The Self and The Universe Revealed in Symbols (Tarot)",
      "es": "Eigen Pad S3E12: El Yo y El Universo Revelados en Símbolos (Tarot)",
      "nl": "Eigen Pad S3E12: Het Zelf en Het Universum Geopenbaard in Symbolen (Tarot)",
      "pap": "Eigen Pad S3E12: E Mes i E Universo Revelá den Símbolonan (Tarot)"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode the Tarot is introduced by way of Kabbalah. This is an ideal transition into our next season on Tarot.",
      "es": "En este episodio se introduce el Tarot a través de la Cábala. Es una transición ideal hacia nuestra próxima temporada sobre el Tarot.",
      "nl": "In deze aflevering wordt de Tarot geïntroduceerd via Kabbala. Dit is een ideale overgang naar ons volgende seizoen van Tarot.",
      "pap": "Den e episodio aki ta introdusí Tarot via Kabala. Esaki ta un transishon ideal pa nos siguiente temporada tokante Tarot."
    },
    "videoUrl": "https://odysee.com/$/embed/s3e12-kabbala-tarot:2?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/kabbala-tarot-bg.jpg",
    "imageAlt": "Eigen Pad S3E12: Het Zelf en Het Universum Geopenbaard in Symbolen (Tarot) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/s3e12-kabbala-tarot:2?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s3e12-de-kabbala-en-tarot-onthuld.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaZohar Uittreksel",
          "es": "Sepher HaZohar Uittreksel",
          "nl": "Sepher HaZohar Uittreksel",
          "pap": "Sepher HaZohar Uittreksel"
        },
        "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher HaBahir",
          "es": "Sepher HaBahir",
          "nl": "Sepher HaBahir",
          "pap": "Sepher HaBahir"
        },
        "url": "./media/Sepher-HaBahir.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Raziel HaMalek",
          "es": "Sepher Raziel HaMalek",
          "nl": "Sepher Raziel HaMalek",
          "pap": "Sepher Raziel HaMalek"
        },
        "url": "./media/Sepher-Raziel.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sepher Yetzirah",
          "es": "Sepher Yetzirah",
          "nl": "Sepher Yetzirah",
          "pap": "Sepher Yetzirah"
        },
        "url": "./media/Sepher-Yetzirah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Chicken Qabala",
          "es": "Chicken Qabala",
          "nl": "Chicken Qabala",
          "pap": "Chicken Qabala"
        },
        "url": "./media/Chicken_Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah For Beginners",
          "es": "Kabbalah For Beginners",
          "nl": "Kabbalah For Beginners",
          "pap": "Kabbalah For Beginners"
        },
        "url": "./media/Kabbalah-For-Beginners.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Kabbalah And Freemasonry",
          "es": "Kabbalah And Freemasonry",
          "nl": "Kabbalah And Freemasonry",
          "pap": "Kabbalah And Freemasonry"
        },
        "url": "./media/Kabbalah-And-Freemasonry.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Introduction To The-Kabbalah",
          "es": "Introduction To The-Kabbalah",
          "nl": "Introduction To The-Kabbalah",
          "pap": "Introduction To The-Kabbalah"
        },
        "url": "./media/Introduction-To-The-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Treasures Of Ancient Qabalah",
          "es": "Hidden Treasures Of Ancient Qabalah",
          "nl": "Hidden Treasures Of Ancient Qabalah",
          "pap": "Hidden Treasures Of Ancient Qabalah"
        },
        "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Hidden Wisdom Of Kabbalah",
          "es": "Hidden Wisdom Of Kabbalah",
          "nl": "Hidden Wisdom Of Kabbalah",
          "pap": "Hidden Wisdom Of Kabbalah"
        },
        "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Middle Pillar",
          "es": "Middle Pillar",
          "nl": "Middle Pillar",
          "pap": "Middle Pillar"
        },
        "url": "./media/Middle-Pillar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Garden Of Pomegranates",
          "es": "Garden Of Pomegranates",
          "nl": "Garden Of Pomegranates",
          "pap": "Garden Of Pomegranates"
        },
        "url": "./media/Garden-Of-Pomegranates.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Blazing Star",
          "es": "Blazing Star",
          "nl": "Blazing Star",
          "pap": "Blazing Star"
        },
        "url": "./media/Blazing-Star.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Book Of Tokens",
          "es": "The Book Of Tokens",
          "nl": "The Book Of Tokens",
          "pap": "The Book Of Tokens"
        },
        "url": "./media/the-book-of-tokens.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e11-wat-is-de-shekinah-kundalini",
    "nextEpisode": "legacy-eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-4.html",
      "sourceLine": 932,
      "kind": "media",
      "image": "images/kabbala-tarot-bg.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo",
    "slug": {
      "en": "eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo",
      "es": "eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo",
      "nl": "eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo",
      "pap": "eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 41,
    "title": {
      "en": "Eigen Pad S4E0: The Ever-Rising Son/Sun - Promo",
      "es": "Eigen Pad S4E0: El Hijo/Sol Siempre Naciente - Promo",
      "nl": "Eigen Pad S4E0: De Steeds Opkomende Zo(o)n - Promo",
      "pap": "Eigen Pad S4E0: E Yu/Solo Semper Sali - Promo"
    },
    "language": "nl",
    "summary": {
      "en": "In this season we go deeper into the mysteries of the Tarot. Last season we explored the Kabbalah and laid a foundation for our study of the trump cards. This season we show how the Tarot can be used to better understand both yourself and the world. You are warmly welcome every Tuesday during the coming season of EigenPad. From 10 September 2024 through 3 December 2024 I take you along on the journey of the Magician, revealed by the Tarot. Join at 19:30 Netherlands time, or 13:30/14:30 Curaçao time. We meet live on the Pikapika platform. I look forward to seeing you there.",
      "es": "En esta temporada profundizamos en los misterios del Tarot. La temporada pasada exploramos la Cábala y sentamos una base para el estudio de los arcanos. Esta temporada mostramos cómo el Tarot puede usarse para comprenderte mejor a ti mismo y al mundo. Estás invitado cada martes durante la próxima temporada de EigenPad. Del 10 de septiembre de 2024 al 3 de diciembre de 2024 te llevo en el viaje del Mago, revelado por el Tarot. Únete a las 19:30 hora de los Países Bajos, o 13:30/14:30 hora de Curazao. Nos encontramos en vivo en la plataforma Pikapika. Espero verte allí.",
      "nl": "In dit seizoen gaan we dieper in op de mysteries van de Tarot. Vorig seizoen hebben we de Kabbalah verkend en een basis gelegd voor onze studie van de troefkaarten. In dit seizoen laten we zien hoe de Tarot kan worden gebruikt om zowel jezelf als de wereld beter te begrijpen. Je bent van harte welkom elke dinsdag tijdens het komende seizoen van EigenPad. Vanaf 10 september 2024 tot en met 3 december 2024 neem ik je mee op de reis van de Magiër, onthuld door de Tarot. Sluit je aan om 19:30 Nederlandse tijd, of 13:30/14.30 Curaçaose tijd. We ontmoeten elkaar live op het Pikapika-platform. Ik kijk ernaar uit je daar te zien.",
      "pap": "Den e temporada aki nos ta profundisá den e misterionan di Tarot. Temporada pasá nos a eksplorá Kabala i a pone un base pa nos estudio di e kartanan trump. E temporada aki nos ta mustra kon Tarot por wòrdu usá pa komprondé tantu bo mes komo mundu mihó. Bo ta bonbiní tur diamars durante e siguiente temporada di EigenPad. For di 10 di sèptèmber 2024 te ku 3 di desèmber 2024 mi ta hiba bo riba e biahe di e Mago, revelá pa Tarot. Partisipá pa 19:30 ora hulandes, òf 13:30/14:30 ora di Kòrsou. Nos ta topa na bibo riba e plataforma Pikapika. Mi ta spera di mira bo einan."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-promo:0?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E0: De Steeds Opkomende Zo(o)n - Promo - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-promo:0?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Seizoen 4 - De Steeds Opkomende Zo(o)n Flyer",
          "es": "Seizoen 4 - De Steeds Opkomende Zo(o)n Flyer",
          "nl": "Seizoen 4 - De Steeds Opkomende Zo(o)n Flyer",
          "pap": "Seizoen 4 - De Steeds Opkomende Zo(o)n Flyer"
        },
        "url": "./images/flyer-eigenpad-seizoen-4.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot",
    "nextEpisode": "legacy-de-onheilige-drie-eenheid-dutch",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 198,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-de-onheilige-drie-eenheid-dutch",
    "slug": {
      "en": "de-onheilige-drie-eenheid-dutch",
      "es": "de-onheilige-drie-eenheid-dutch",
      "nl": "de-onheilige-drie-eenheid-dutch",
      "pap": "de-onheilige-drie-eenheid-dutch"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 42,
    "title": {
      "en": "The Unholy Trinity (Dutch)",
      "es": "La Trinidad Impía (neerlandés)",
      "nl": "De OnHeilige Drie Eenheid (Dutch)",
      "pap": "E Trinidat Insanto (hulandes)"
    },
    "language": "nl",
    "summary": {
      "en": "This presentation addresses the condition of the human race, the problem tied to it, why this problem persists, and its solution. The present human condition is shaped by our conscious or unconscious participation in created belief systems. Our fate—damned or saved—depends on how well we understand what our actual condition is right now.",
      "es": "Esta presentación aborda la condición de la raza humana, el problema ligado a ella, por qué este problema persiste y su solución. La condición humana actual está determinada por nuestra participación consciente o inconsciente en los sistemas de creencias creados. Nuestro destino —condenado o salvado— depende de cuán bien comprendamos cuál es realmente nuestra condición en este momento.",
      "nl": "Deze presentatie behandelt de toestand van het menselijk ras, het probleem dat hiermee samenhangt, waarom dit probleem voortduurt, en de oplossing ervoor. De huidige menselijke conditie wordt bepaald door onze bewuste of onbewuste deelname aan de gecreëerde geloofssystemen. Ons lot—verdoemd of gered—hangt af van hoe goed we begrijpen wat onze werkelijke toestand op dit moment is.",
      "pap": "E presentashon aki ta trata e kondishon di e rasa humano, e problema ligá ku dje, dikon e problema aki ta sigui, i su solushon. E kondishon humano aktual ta wòrdu determiná pa nos partisipashon konsiente òf inkonsiente den e sistemanan di kreensia kreá. Nos destino —kondená òf salbá— ta dependé di kon bon nos ta komprondé kiko ta nos kondishon real awor."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-onheilige-drie-eenheid:2?r=BMRzpa1V7rSTgkkC8hPR2qnQVjheLwci",
    "audioUrl": null,
    "image": "/assets/images/de-onheilige-drie-eenheid-cover-2.jpg",
    "imageAlt": "De OnHeilige Drie Eenheid (Dutch) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-onheilige-drie-eenheid:2?r=BMRzpa1V7rSTgkkC8hPR2qnQVjheLwci",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "De OnHeilige Drie Eenheid - Sheets (pdf)",
          "es": "De OnHeilige Drie Eenheid - Sheets (pdf)",
          "nl": "De OnHeilige Drie Eenheid - Sheets (pdf)",
          "pap": "De OnHeilige Drie Eenheid - Sheets (pdf)"
        },
        "url": "/media/de-onheilige-drie-eenheid.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "De OnHeilige Drie Eenheid - Sheets (zip)",
          "es": "De OnHeilige Drie Eenheid - Sheets (zip)",
          "nl": "De OnHeilige Drie Eenheid - Sheets (zip)",
          "pap": "De OnHeilige Drie Eenheid - Sheets (zip)"
        },
        "url": "/media/de-onheilige-drie-eenheid.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e0-de-steeds-opkomende-zo-o-n-promo",
    "nextEpisode": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 226,
      "kind": "media",
      "image": "images/de-onheilige-drie-eenheid-cover-2.jpg"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking",
    "slug": {
      "en": "eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking",
      "es": "eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking",
      "nl": "eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking",
      "pap": "eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 43,
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "language": "nl",
    "summary": {
      "en": "The start of a new season. We dive deeper into the origin and structure of the tarot and explore some notable examples of people who helped shape the card system. In addition, we introduce here the Jungian archetype and the way it interweaves with the rich tradition of the tarot.",
      "es": "El comienzo de una nueva temporada. Profundizamos en el origen y la estructura del tarot y exploramos algunos ejemplos notables de personas que ayudaron a formar el sistema de cartas. Además, introducimos aquí el arquetipo junguiano y la manera en que se entrelaza con la rica tradición del tarot.",
      "nl": "Het begin van een nieuw seizoen. We duiken dieper in de oorsprong en structuur van de tarot en verkennen enkele bijzondere voorbeelden van mensen die hebben bijgedragen aan de vorming van het kaartensysteem. Bovendien introduceren we hier het Jungiaanse archetype en de manier waarop dit zich verweeft met de rijke traditie van de tarot",
      "pap": "E komienso di un temporada nobo. Nos ta profundisá den e orígen i struktura di tarot i ta eksplorá algun ehèmpel notabel di hende ku a yuda forma e sistema di karta. Ademas, akinan nos ta introdusí e arketipo Jungiano i e manera ku e ta entrelasá ku e rika tradishon di tarot."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-I-s4e1:2?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-I-s4e1:2?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-I-s4e1.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-de-onheilige-drie-eenheid-dutch",
    "nextEpisode": "legacy-eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 259,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "slug": {
      "en": "eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "es": "eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "nl": "eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "pap": "eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 44,
    "title": {
      "en": "Eigen Pad S4E2: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E2: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E2: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E2: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "Today we continue the journey of the soul. In this episode we dive into the meaning of the tarot as a tool for conscious development. I will also give a basic explanation of the first six cards: The Fool, The Magician, The High Priestess, The Empress, The Emperor, and The Hierophant.",
      "es": "Hoy continuamos el viaje del alma. En este episodio profundizamos en el significado del tarot como herramienta de desarrollo consciente. También daré una explicación básica de las primeras seis cartas: El Loco, El Mago, La Sacerdotisa, La Emperatriz, El Emperador y El Hierofante.",
      "nl": "Vandaag gaan we verder met de reis van de ziel. In deze aflevering duiken we in de betekenis van de tarot als hulpmiddel voor bewuste ontwikkeling. Ik zal ook een basisuitleg geven van de eerste zes kaarten: De Dwaas, De Magiër, De Hogepriesteres, De Keizerin, De Keizer en De Hierofant.",
      "pap": "Awe nos ta sigui e biahe di e alma. Den e episodio aki nos ta profundisá den e nifikashon di tarot komo un hèrmènt pa desaroyo konsiente. Lo mi duna tambe un splikashon básiko di e promé seis kartanan: E Bobo, E Mago, E Sumo Saserdotisa, E Emperatris, E Emperador i E Hierofante."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-I-s4e2:0?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E2: De Steeds Opkomende Zo(o)n - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-I-s4e2:0?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e2.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking",
    "nextEpisode": "legacy-eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 322,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "slug": {
      "en": "eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "es": "eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "nl": "eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "pap": "eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 45,
    "title": {
      "en": "Eigen Pad S4E3: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E3: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E3: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E3: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we continue our journey through the Major Arcana and discuss six new cards: The Lovers, The Chariot, Strength, The Hermit, The Wheel of Fortune, and Justice. Each card carries its own powerful symbolism and meaning. These cards deepen the themes of duality, willpower, inner strength, and cosmic justice.",
      "es": "En este episodio continuamos nuestro viaje por los Arcanos Mayores y hablamos de seis cartas nuevas: Los Enamorados, El Carro, La Fuerza, El Ermitaño, La Rueda de la Fortuna y La Justicia. Cada carta lleva su propia simbología y significado poderosos. Estas cartas profundizan los temas de la dualidad, la voluntad, la fuerza interior y la justicia cósmica.",
      "nl": "In deze aflevering zetten we onze reis door de Grote Arcana voort en bespreken we zes nieuwe kaarten: De Geliefden, De Zegewagen, Kracht, De Kluizenaar, Het Rad van Fortuin en Gerechtigheid. Elke kaart draagt zijn eigen krachtige symboliek en betekenis. Deze kaarten verdiepen de thema’s van dualiteit, wilskracht, innerlijke kracht en kosmische rechtvaardigheid.",
      "pap": "Den e episodio aki nos ta sigui nos biahe dor di e Arkano Mayor i ta papia di seis karta nobo: E Namorá, E Garoshi, Forsa, E Ermitaño, E Wil di Fortuna i Hustisia. Kada karta tin su mes simbolismo i nifikashon poderoso. E kartanan aki ta profundisá e temanan di dualidat, forsa di boluntat, forsa interno i hustisia kósmiko."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-II-s4e3:6?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E3: De Steeds Opkomende Zo(o)n - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-II-s4e3:6?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e3.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "nextEpisode": "legacy-eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 385,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "slug": {
      "en": "eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "es": "eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "nl": "eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "pap": "eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 46,
    "title": {
      "en": "Eigen Pad S4E4: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E4: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E4: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E4: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode of our tarot series we discuss the meaning of six cards: The Hanged Man (XII), symbolizing self-sacrifice and a new perspective; Death (XIII), a card of transformation; Temperance (XIV), about balance and harmony; The Devil (XV), showing bondage and temptation; The Tower (XVI), a card of sudden change; and The Star (XVII), which brings hope and inspiration. These cards offer deep insight into personal growth and transformation.",
      "es": "En este episodio de nuestra serie de tarot hablamos del significado de seis cartas: El Colgado (XII), que simboliza el autosacrificio y una nueva perspectiva; La Muerte (XIII), carta de transformación; La Templanza (XIV), sobre equilibrio y armonía; El Diablo (XV), que muestra la atadura y la tentación; La Torre (XVI), carta de cambio repentino; y La Estrella (XVII), que trae esperanza e inspiración. Estas cartas ofrecen una visión profunda del crecimiento y la transformación personal.",
      "nl": "In deze aflevering van onze tarotserie bespreken we de betekenis van zes kaarten: De Gehangene (XII), die zelfopoffering en nieuw perspectief symboliseert, Dood (XIII), een kaart van transformatie, Matigheid (XIV), over balans en harmonie, De Duivel (XV), die gebondenheid en verleiding toont, De Toren (XVI), een kaart van plotselinge verandering, en De Ster (XVII), die hoop en inspiratie brengt. Deze kaarten bieden diepe inzichten in persoonlijke groei en transformatie.",
      "pap": "Den e episodio aki di nos seri di tarot nos ta papia di e nifikashon di seis karta: E Kologá (XII), ku ta simbolisá outosakrifisio i un nobo perspektiva; Morto (XIII), un karta di transformashon; Temperansa (XIV), tokante balansa i armonia; E Diabel (XV), ku ta mustra atamentu i tentashon; E Tore (XVI), un karta di kambio repentino; i E Strea (XVII), ku ta trese speransa i inspirashon. E kartanan aki ta ofresé bista profundo den kresementu i transformashon personal."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/De-Steeds-Opkomende-Zon-Deel-II-S4e4:4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E4: De Steeds Opkomende Zo(o)n - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/De-Steeds-Opkomende-Zon-Deel-II-S4e4:4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e4.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "nextEpisode": "legacy-eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 448,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "slug": {
      "en": "eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "es": "eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "nl": "eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana",
      "pap": "eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 47,
    "title": {
      "en": "Eigen Pad S4E5: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E5: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E5: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E5: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we discuss the last four cards of the Major Arcana in the tarot: The Moon (XVIII), The Sun (XIX), Judgement (XX), and The World (XXI). We dive deep into their symbolism and meaning, and how they can guide us on our spiritual journey. At the end of the show we also have a little bonus for you, so be sure to keep watching!",
      "es": "En este episodio hablamos de las últimas cuatro cartas de los Arcanos Mayores: La Luna (XVIII), El Sol (XIX), El Juicio (XX) y El Mundo (XXI). Profundizamos en su simbología y significado, y en cómo pueden guiarnos en nuestro viaje espiritual. ¡Al final del programa también tenemos un pequeño extra para ti, así que no dejes de mirar!",
      "nl": "In deze aflevering bespreken we de laatste vier kaarten van de Grote Arcana in de tarot: De Maan(XVIII), De Zon(XIX), Het Oordeel(XX), en De Wereld(XXI). We duiken diep in hun symboliek en betekenis, en hoe ze ons kunnen begeleiden op onze spirituele reis. Aan het einde van de show hebben we ook een kleine bonus voor je, dus blijf zeker kijken!",
      "pap": "Den e episodio aki nos ta papia di e último kuater kartanan di e Arkano Mayor: E Luna (XVIII), E Solo (XIX), E Huisio (XX) i E Mundu (XXI). Nos ta profundisá den nan simbolismo i nifikashon, i kon nan por guia nos riba nos biahe spiritual. Na fin di e show nos tin tambe un bonus chikitu pa bo, p'esei sigui wak!"
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-II-s4e5:1?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E5: De Steeds Opkomende Zo(o)n - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-II-s4e5:1?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e5.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "nextEpisode": "legacy-eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 509,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven",
    "slug": {
      "en": "eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven",
      "es": "eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven",
      "nl": "eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven",
      "pap": "eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 48,
    "title": {
      "en": "Eigen Pad S4E6: The Ever-Rising Son/Sun - The Minor Arcana/Wands",
      "es": "Eigen Pad S4E6: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Bastos",
      "nl": "Eigen Pad S4E6: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Staven",
      "pap": "Eigen Pad S4E6: E Yu/Solo Semper Sali - E Arkano Menor/Garoti"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Fire and the 14 cards of the Wands suit. Wands symbolize action, willpower, inspiration, and energy. They represent our passion, creativity, and the fire that drives us into motion.",
      "es": "En este episodio nos adentramos en el elemento Fuego y las 14 cartas del palo de Bastos. Los Bastos simbolizan la acción, la voluntad, la inspiración y la energía. Representan nuestra pasión, creatividad y el fuego que nos impulsa a movernos.",
      "nl": "In deze aflevering duiken we in het element Vuur en de 14 kaarten van de Staven-serie. Staven staan symbool voor actie, wilskracht, inspiratie en energie. Ze vertegenwoordigen onze passie, creativiteit en het vuur dat ons drijft om in beweging te komen.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Kandela i e 14 kartanan di e seri di Garoti. Garoti ta simbolisá akshon, forsa di boluntat, inspirashon i energia. Nan ta representá nos pashon, kreatividat i e kandela ku ta pusha nos pa move."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e6:9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E6: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Staven - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e6:9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e6.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana",
    "nextEpisode": "legacy-eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 571,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers",
    "slug": {
      "en": "eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers",
      "es": "eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers",
      "nl": "eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers",
      "pap": "eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 49,
    "title": {
      "en": "Eigen Pad S4E7: The Ever-Rising Son/Sun - The Minor Arcana/Cups",
      "es": "Eigen Pad S4E7: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Copas",
      "nl": "Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers",
      "pap": "Eigen Pad S4E7: E Yu/Solo Semper Sali - E Arkano Menor/Kopa"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Water and the 14 cards of the Cups suit. Cups symbolize emotions, feelings, relationships, and intuition. They represent our inner life, our connections with others, and the flow of our emotions that lead us to deeper insight and fulfillment.",
      "es": "En este episodio nos adentramos en el elemento Agua y las 14 cartas del palo de Copas. Las Copas simbolizan las emociones, los sentimientos, las relaciones y la intuición. Representan nuestra vida interior, nuestros vínculos con los demás y el fluir de nuestras emociones que nos llevan a una comprensión y plenitud más profundas.",
      "nl": "In deze aflevering duiken we in het element Water en de 14 kaarten van de Beker-serie. Bekers staan symbool voor emoties, gevoelens, relaties en intuïtie. Ze vertegenwoordigen ons innerlijk leven, onze verbindingen met anderen en de stroom van onze emoties die ons leiden naar diepere inzichten en vervulling.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Awa i e 14 kartanan di e seri di Kopa. Kopa ta simbolisá emoshon, sintimentu, relashon i intuishon. Nan ta representá nos bida interno, nos konekshonnan ku otro i e fluho di nos emoshonnan ku ta hiba nos na komprondementu i kumplimentu mas profundo."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e7:9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e7:9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e7.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven",
    "nextEpisode": "legacy-eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 633,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden",
    "slug": {
      "en": "eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden",
      "es": "eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden",
      "nl": "eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden",
      "pap": "eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 50,
    "title": {
      "en": "Eigen Pad S4E8: The Ever-Rising Son/Sun - The Minor Arcana/Swords",
      "es": "Eigen Pad S4E8: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Espadas",
      "nl": "Eigen Pad S4E8: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Zwaarden",
      "pap": "Eigen Pad S4E8: E Yu/Solo Semper Sali - E Arkano Menor/Spada"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Air and the 14 cards of the Swords suit. Swords symbolize intellect, thought, communication, and decisiveness. They represent our mental life, the sharpness of our thinking, and our power to overcome obstacles through logic and reason. The Swords cards invite us to examine our thoughts, find clarity in complex situations, and make conscious choices that lead to truth and insight.",
      "es": "En este episodio nos adentramos en el elemento Aire y las 14 cartas del palo de Espadas. Las Espadas simbolizan el intelecto, el pensamiento, la comunicación y la decisión. Representan nuestra vida mental, la agudeza de nuestro pensar y nuestra capacidad de superar obstáculos mediante la lógica y la razón. Las cartas de Espadas nos invitan a examinar nuestros pensamientos, hallar claridad en situaciones complejas y tomar decisiones conscientes que conduzcan a la verdad y la comprensión.",
      "nl": "In deze aflevering duiken we in het element Lucht en de 14 kaarten van de Zwaarden-serie. Zwaarden staan symbool voor intellect, gedachten, communicatie en besluitvaardigheid. Ze vertegenwoordigen ons mentale leven, de scherpte van ons denken en onze kracht om obstakels te overwinnen door middel van logica en verstand. De Zwaarden kaarten nodigen ons uit om onze gedachten te onderzoeken, helderheid te vinden in complexe situaties, en bewuste keuzes te maken die leiden tot waarheid en inzicht.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Airu i e 14 kartanan di e seri di Spada. Spada ta simbolisá intelekto, pensamentu, komunikashon i desishon. Nan ta representá nos bida mental, e skèrpnan di nos pensamentu i nos forsa pa superá opstákulo via lógika i rason. E kartanan di Spada ta invitá nos pa analisá nos pensamentunan, haña klaridat den situashonnan kompliká, i hasi eskohonan konsiente ku ta hiba na bèrdat i komprondementu."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e8:8?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E8: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Zwaarden - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e8:8?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e8.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers",
    "nextEpisode": "legacy-eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 698,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels",
    "slug": {
      "en": "eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels",
      "es": "eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels",
      "nl": "eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels",
      "pap": "eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 51,
    "title": {
      "en": "Eigen Pad S4E9: The Ever-Rising Son/Sun - The Minor Arcana/Pentacles",
      "es": "Eigen Pad S4E9: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Oros",
      "nl": "Eigen Pad S4E9: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Pentakels",
      "pap": "Eigen Pad S4E9: E Yu/Solo Semper Sali - E Arkano Menor/Pentákulo"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Earth and the 14 cards of the Pentacles suit. Pentacles symbolize material security, work, health, and abundance. They represent our physical world, the tangible result of our efforts, and the balance between work, well-being, and matter. The Pentacles cards invite us to examine our relationship with the material world, to appreciate the work we do, and to build a solid foundation for our future. They remind us of the importance of patience, discipline, and perseverance in manifesting our goals and creating inner and outer wealth.",
      "es": "En este episodio nos adentramos en el elemento Tierra y las 14 cartas del palo de Oros. Los Oros simbolizan la seguridad material, el trabajo, la salud y la abundancia. Representan nuestro mundo físico, el resultado tangible de nuestros esfuerzos y el equilibrio entre trabajo, bienestar y materia. Las cartas de Oros nos invitan a examinar nuestra relación con el mundo material, a valorar el trabajo que realizamos y a construir una base sólida para nuestro futuro. Nos recuerdan la importancia de la paciencia, la disciplina y la perseverancia para manifestar nuestras metas y crear riqueza interior y exterior.",
      "nl": "In deze aflevering duiken we in het element Aarde en de 14 kaarten van de Pentakels-serie. Pentakels staan symbool voor materiële zekerheid, werk, gezondheid en overvloed. Ze vertegenwoordigen onze fysieke wereld, het tastbare resultaat van onze inspanningen en de balans tussen werk, welzijn en materie. De Pentakels kaarten nodigen ons uit om onze relatie met de materiële wereld te onderzoeken, om waardering te vinden voor het werk dat we verrichten, en om een solide basis op te bouwen voor onze toekomst. Ze herinneren ons aan het belang van geduld, discipline en doorzettingsvermogen om onze doelen te manifesteren en innerlijke en uiterlijke rijkdom te creëren.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Tera i e 14 kartanan di e seri di Pentákulo. Pentákulo ta simbolisá siguridat material, trabou, salú i abundansia. Nan ta representá nos mundu físiko, e resultado tanjibel di nos esfuerso i e balansa entre trabou, bienestar i materia. E kartanan di Pentákulo ta invitá nos pa analisá nos relashon ku e mundu material, pa apresiá e trabou ku nos ta hasi, i pa konstruí un base solido pa nos futuro. Nan ta korda nos di e importansia di pasenshi, disiplina i perseveransia pa manifestá nos metanan i krea rikesa interno i externo."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e9:9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E9: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Pentakels - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e9:9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e9.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden",
    "nextEpisode": "legacy-eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kleine-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 762,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kleine-arcana",
    "slug": {
      "en": "eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kl",
      "es": "eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kl",
      "nl": "eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kl",
      "pap": "eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kl"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 52,
    "title": {
      "en": "Eigen Pad S4E10: The Ever-Rising Son/Sun - Integration of the Major and Minor Arcana",
      "es": "Eigen Pad S4E10: El Hijo/Sol Siempre Naciente - Integración de los Arcanos Mayores y Menores",
      "nl": "Eigen Pad S4E10: De Steeds Opkomende Zo(o)n - Integratie van de Grote en Kleine Arcana",
      "pap": "Eigen Pad S4E10: E Yu/Solo Semper Sali - Integrashon di e Arkano Mayor i Menor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we go deeper into the integration of the Major and Minor Arcana in the tarot and explore how these cards together represent a full spectrum of human and spiritual life. The Major Arcana, with its archetypal journey through universal themes and transformations, shows us the essence of our life's journey: growth, challenge, and the development of wisdom. The Minor Arcana, divided across the elements of Fire, Water, Air, and Earth, brings this back to daily life. Each card offers lessons and insights that manifest in our everyday existence and gives us tools to find balance between the material and the spiritual. This episode invites us to explore the interplay between the larger life path and daily challenges, and inspires us to use the Major Arcana as a guide while the Minor Arcana helps us walk the path step by step. Together these cards remind us that both the grandeur of our spiritual aspirations and the simplicity of our daily life are valuable and must be brought into harmony to achieve inner and outer balance.",
      "es": "En este episodio profundizamos en la integración de los Arcanos Mayores y Menores del tarot y exploramos cómo, juntas, estas cartas representan todo el espectro de la vida humana y espiritual. Los Arcanos Mayores, con su viaje arquetípico por temas y transformaciones universales, nos muestran la esencia del viaje de la vida: crecimiento, desafío y desarrollo de la sabiduría. Los Arcanos Menores, repartidos entre los elementos Fuego, Agua, Aire y Tierra, lo traen de vuelta a la vida cotidiana. Cada carta ofrece lecciones e ideas que se manifiestan en nuestra existencia diaria y nos da herramientas para hallar el equilibrio entre lo material y lo espiritual. Este episodio nos invita a explorar la interacción entre el gran camino de la vida y los retos cotidianos, y nos inspira a usar los Arcanos Mayores como guía mientras los Menores nos ayudan a recorrer el camino paso a paso. Juntas, estas cartas nos recuerdan que tanto la grandeza de nuestras aspiraciones espirituales como la sencillez de nuestra vida diaria son valiosas y deben armonizarse para alcanzar el equilibrio interior y exterior.",
      "nl": "In deze aflevering gaan we dieper in op de integratie van de Grote en Kleine Arcana in de tarot en onderzoeken we hoe deze kaarten samen een volledig spectrum van het menselijke en spirituele leven vertegenwoordigen. De Grote Arcana, met zijn archetypische reis door universele thema's en transformaties, laat ons de essentie van onze levensreis zien: groei, uitdaging, en de ontwikkeling van wijsheid. De Kleine Arcana, verdeeld over de elementen Vuur, Water, Lucht en Aarde, brengt dit terug naar het dagelijkse leven. Elke kaart biedt lessen en inzichten die zich in ons alledaagse bestaan manifesteren en geeft ons handvatten om evenwicht te vinden tussen het materiële en spirituele. Deze aflevering nodigt ons uit om de wisselwerking tussen het grotere levenspad en de dagelijkse uitdagingen te verkennen en inspireert ons om de Grote Arcana als leidraad te gebruiken terwijl de Kleine Arcana ons helpt het pad stap voor stap te belopen. Samen herinneren deze kaarten ons eraan dat zowel de grootsheid van onze spirituele ambities als de eenvoud van ons dagelijks leven waardevol zijn en in harmonie moeten worden gebracht om innerlijke en uiterlijke balans te bereiken.",
      "pap": "Den e episodio aki nos ta profundisá den e integrashon di e Arkano Mayor i Menor di tarot i ta eksplorá kon huntu e kartanan aki ta representá un spektro kompleto di bida humano i spiritual. E Arkano Mayor, ku su biahe arketípiko dor di temanan i transformashonnan universal, ta mustra nos e esensia di nos biahe di bida: kresementu, desafio i desaroyo di sabiduria. E Arkano Menor, dividí entre e elementonan Kandela, Awa, Airu i Tera, ta trese esaki bèk na bida diario. Kada karta ta ofresé lès i komprondementu ku ta manifestá den nos eksistensia diario i ta duna nos hèrmèntnan pa haña balansa entre e material i e spiritual. E episodio aki ta invitá nos pa eksplorá e interakshon entre e kaminda di bida mas grandi i e retonan diario, i ta inspirá nos pa usa e Arkano Mayor komo guia miéntras e Arkano Menor ta yuda nos kana e kaminda paso pa paso. Huntu, e kartanan aki ta korda nos ku tantu e grandesa di nos aspirashonnan spiritual komo e simplisidat di nos bida diario ta balioso i mester wòrdu trahé na armonia pa alkansá balansa interno i externo."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e10:5?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E10: De Steeds Opkomende Zo(o)n - Integratie van de Grote en Kleine Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e10:5?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e10.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels",
    "nextEpisode": "legacy-eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-en-de-kabbalistische-leve",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 826,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-en-de-kabbalistische-leve",
    "slug": {
      "en": "eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-e",
      "es": "eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-e",
      "nl": "eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-e",
      "pap": "eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-e"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 53,
    "title": {
      "en": "Eigen Pad S4E11: The Ever-Rising Son/Sun - Hebrew Letters, Numbers and the Kabbalistic Tree of Life",
      "es": "Eigen Pad S4E11: El Hijo/Sol Siempre Naciente - Letras Hebreas, Números y el Árbol de la Vida Cabalístico",
      "nl": "Eigen Pad S4E11: De Steeds Opkomende Zo(o)n - Hebreeuwse letters, getallen en de Kabbalistische Levensboom",
      "pap": "Eigen Pad S4E11: E Yu/Solo Semper Sali - Lèternan Hebreo, Number i e Palu di Bida Kabalístiko"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the mystical world of the Hebrew letters, numbers, and the Kabbalistic Tree of Life. The Hebrew letters carry not only deep spiritual meaning but also form the building blocks of the universe. Each number holds a hidden wisdom that helps us understand the connection between the divine and the earthly. The Kabbalistic Tree of Life, with its ten sefirot and 22 paths, functions as a map of consciousness and a guide for spiritual growth. These symbols invite us to examine our relationship with the transcendent, find balance between heaven and earth, and discover the mysteries of our inner universe.",
      "es": "En este episodio nos adentramos en el mundo místico de las letras hebreas, los números y el Árbol de la Vida cabalístico. Las letras hebreas no solo portan un profundo significado espiritual, sino que también son los pilares del universo. Cada número guarda una sabiduría oculta que nos ayuda a entender la conexión entre lo divino y lo terrenal. El Árbol de la Vida cabalístico, con sus diez sefirot y 22 senderos, funciona como un mapa de la conciencia y una guía para el crecimiento espiritual. Estos símbolos nos invitan a examinar nuestra relación con lo trascendente, hallar el equilibrio entre el cielo y la tierra y descubrir los misterios de nuestro universo interior.",
      "nl": "In deze aflevering duiken we in de mystieke wereld van de Hebreeuwse letters, getallen en de Kabbalistische Levensboom. De Hebreeuwse letters dragen niet alleen diepe spirituele betekenis, maar vormen ook de bouwstenen van het universum. Elk getal heeft een verborgen wijsheid die ons helpt om de verbinding tussen het goddelijke en het aardse te begrijpen. De Kabbalistische Levensboom, met zijn tien sefirot en 22 paden, fungeert als een kaart van bewustzijn en een gids voor spirituele groei. Deze symbolen nodigen ons uit om onze relatie met het transcendente te onderzoeken, balans te vinden tussen hemel en aarde, en de mysteries van ons innerlijke universum te ontdekken.",
      "pap": "Den e episodio aki nos ta sumi den e mundu místiko di e lèternan hebreo, e number i e Palu di Bida kabalístiko. E lèternan hebreo no solamente ta karga un nifikashon spiritual profundo, sino tambe ta forma e blòkinan di konstrukshon di e universo. Kada number tin un sabiduria skondí ku ta yuda nos komprondé e konekshon entre e divino i e terenal. E Palu di Bida kabalístiko, ku su dies sefirot i 22 kaminda, ta funshoná komo un mapa di konsenshi i un guia pa kresementu spiritual. E símbolonan aki ta invitá nos pa analisá nos relashon ku e transendente, haña balansa entre shelu i tera, i deskubrí e misterionan di nos universo interno."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e11:7?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E11: De Steeds Opkomende Zo(o)n - Hebreeuwse letters, getallen en de Kabbalistische Levensboom - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e11:7?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e11.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kleine-arcana",
    "nextEpisode": "legacy-eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-tarot-zelftransformatie",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 893,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-tarot-zelftransformatie",
    "slug": {
      "en": "eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-t",
      "es": "eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-t",
      "nl": "eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-t",
      "pap": "eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-t"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 54,
    "title": {
      "en": "Eigen Pad S4E12: The Ever-Rising Son/Sun - Alchemical Symbolism in Tarot – Self-Transformation",
      "es": "Eigen Pad S4E12: El Hijo/Sol Siempre Naciente - Simbolismo Alquímico en el Tarot – Autotransformación",
      "nl": "Eigen Pad S4E12: De Steeds Opkomende Zo(o)n - Alchemistische symboliek in Tarot – Zelftransformatie",
      "pap": "Eigen Pad S4E12: E Yu/Solo Semper Sali - Simbolismo Alkímiko den Tarot – Outotransformashon"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explore the profound alchemical symbolism hidden in the Tarot, and how it can guide us on the path of self-transformation. The Tarot acts as a mirror of our inner world and reveals the elements of fire, water, air, and earth as forces that shape our psyche.",
      "es": "En este episodio exploramos la profunda simbología alquímica oculta en el Tarot y cómo puede guiarnos en el camino de la autotransformación. El Tarot actúa como un espejo de nuestro mundo interior y revela los elementos de fuego, agua, aire y tierra como fuerzas que dan forma a nuestra psique.",
      "nl": "In deze aflevering verkennen we de diepgaande alchemistische symboliek die verborgen ligt in de Tarot, en hoe deze ons kan leiden op het pad van zelftransformatie. De Tarot fungeert als een spiegel van onze innerlijke wereld en onthult de elementen van vuur, water, lucht en aarde als krachten die onze psyche vormgeven.",
      "pap": "Den e episodio aki nos ta eksplorá e simbolismo alkímiko profundo skondí den Tarot, i kon e por guia nos riba e kaminda di outotransformashon. Tarot ta aktua komo un spil di nos mundu interno i ta revelá e elementonan di kandela, awa, airu i tera komo forsanan ku ta forma nos sike."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e12:f?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E12: De Steeds Opkomende Zo(o)n - Alchemistische symboliek in Tarot – Zelftransformatie - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e12:f?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e12.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-en-de-kabbalistische-leve",
    "nextEpisode": "legacy-eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen-en-praktische-toepassin",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 957,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen-en-praktische-toepassin",
    "slug": {
      "en": "eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen",
      "es": "eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen",
      "nl": "eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen",
      "pap": "eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 55,
    "title": {
      "en": "Eigen Pad S4E13: The Ever-Rising Son/Sun - Divination, Card Spreads and Practical Application",
      "es": "Eigen Pad S4E13: El Hijo/Sol Siempre Naciente - Adivinación, Tiradas de Cartas y Aplicación Práctica",
      "nl": "Eigen Pad S4E13: De Steeds Opkomende Zo(o)n - Waarzeggerij, Kaartenleggingen en Praktische Toepassing",
      "pap": "Eigen Pad S4E13: E Yu/Solo Semper Sali - Divinashon, Plasamentu di Karta i Aplikashon Práktiko"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the art of divination, card spreads, and their practical applications in daily life. We explore how the symbolism of the cards offers insight into the unconscious and also serves as a compass for making decisions and understanding life patterns. Here the Tarot reveals itself as a powerful instrument that bridges intuition and action, bringing the spiritual and the practical into harmony.",
      "es": "En este episodio nos adentramos en el arte de la adivinación, las tiradas de cartas y sus aplicaciones prácticas en la vida diaria. Exploramos cómo la simbología de las cartas no solo ofrece una visión del inconsciente, sino que también sirve de brújula para tomar decisiones y comprender los patrones de la vida. Aquí el Tarot se revela como un instrumento poderoso que tiende un puente entre la intuición y la acción, armonizando lo espiritual y lo práctico.",
      "nl": "In deze aflevering duiken we in de kunst van waarzeggerij, kaartenleggingen en hun praktische toepassingen in het dagelijks leven. We onderzoeken hoe de symboliek van de kaarten niet alleen inzicht biedt in het onbewuste, maar ook dient als een kompas voor het nemen van beslissingen en het begrijpen van levenspatronen. De Tarot onthult zich hier als een krachtig instrument dat de brug slaat tussen intuïtie en actie, waardoor het spirituele en het praktische in harmonie samenkomen.",
      "pap": "Den e episodio aki nos ta sumi den e arte di divinashon, plasamentu di karta i nan aplikashonnan práktiko den bida diario. Nos ta eksplorá kon e simbolismo di e kartanan ta ofresé bista den e inkonsiente i tambe ta sirbi komo un kompas pa tuma desishon i komprondé patronchi di bida. Akinan Tarot ta revelá su mes komo un instrumento poderoso ku ta uni intuishon i akshon, trayendo e spiritual i e práktiko na armonia."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e13:0?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Eigen Pad S4E13: De Steeds Opkomende Zo(o)n - Waarzeggerij, Kaartenleggingen en Praktische Toepassing - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-steeds-opkomende-zon-deel-III-s4e13:0?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e13.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-tarot-zelftransformatie",
    "nextEpisode": "legacy-eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-5.html",
      "sourceLine": 1021,
      "kind": "media",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo",
    "slug": {
      "en": "eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo",
      "es": "eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo",
      "nl": "eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo",
      "pap": "eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 56,
    "title": {
      "en": "Eigen Pad S5E0: The Occult Side of the Bible - Promo",
      "es": "Eigen Pad S5E0: El Lado Oculto de la Biblia - Promo",
      "nl": "Eigen Pad S5E0: De Occulte Kant van de Bijbel - Promo",
      "pap": "Eigen Pad S5E0: E Banda Okulto di Beibel - Promo"
    },
    "language": "nl",
    "summary": {
      "en": "In this season we dive into the hidden history and esoteric layers of the Bible. With a detailed timeline as our guide, we place each book and prophecy in its historical and spiritual context. We unravel the hidden messages, the mystical structures, and the influence of ancient civilizations such as Egypt, Mesopotamia, and Greece. Each episode brings you closer to the essence of the ancient writings, not only as historical documents but as keys to deeper knowledge and self-realization. From 11 March 2025 through 3 June 2025, every Tuesday at 19:30, I take you on this journey through the Sacred Scriptures. We meet live on the Pikapika platform (https://www.facebook.com/pikapikatalkshow/), where together we unravel the mysteries of the Bible. I look forward to seeing you there.",
      "es": "En esta temporada nos adentramos en la historia oculta y las capas esotéricas de la Biblia. Con una línea de tiempo detallada como guía, situamos cada libro y profecía en su contexto histórico y espiritual. Desentrañamos los mensajes ocultos, las estructuras místicas y la influencia de civilizaciones antiguas como Egipto, Mesopotamia y Grecia. Cada episodio te acerca a la esencia de los escritos antiguos, no solo como documentos históricos, sino como llaves de un conocimiento más profundo y de la autorrealización. Del 11 de marzo de 2025 al 3 de junio de 2025, cada martes a las 19:30, te llevo en este viaje por las Sagradas Escrituras. Nos encontramos en vivo en la plataforma Pikapika (https://www.facebook.com/pikapikatalkshow/), donde juntos desentrañamos los misterios de la Biblia. Espero verte allí.",
      "nl": "In dit seizoen duiken we in de verborgen geschiedenis en esoterische lagen van de Bijbel. Met een gedetailleerde tijdlijn als leidraad plaatsen we elk boek en elke profetie in zijn historische en spirituele context. We ontrafelen de verborgen boodschappen, de mystieke structuren en de invloed van oude beschavingen zoals Egypte, Mesopotamië en Griekenland. Elke aflevering brengt je dichter bij de essentie van de oude geschriften, niet alleen als historische documenten, maar als sleutels tot diepere kennis en zelfrealisatie. Vanaf 11 Maart 2025 tot en met 3 Juni 2025, elke Dinsdag @19.30 neem ik je mee op deze reis door de Heilige Geschriften. We ontmoeten elkaar live op het Pikapika-platform (https://www.facebook.com/pikapikatalkshow/), waar we samen de mysteries van de Bijbel ontrafelen. Ik kijk ernaar uit je daar te zien.",
      "pap": "Den e temporada aki nos ta sumi den e historia skondí i e kapanan esotériko di Beibel. Ku un linea di tempu detayá komo guia, nos ta pone kada buki i profesia den su konteksto históriko i spiritual. Nos ta deskubrí e mensahenan skondí, e strukturanan místiko i e influensia di sivilisashonnan antiguo manera Egipto, Mesopotamia i Gresia. Kada episodio ta hiba bo mas serka di e esensia di e skrituranan antiguo, no solamente komo dokumentonan históriko, sino komo yabinan pa konosementu mas profundo i outorealisashon. For di 11 di mart 2025 te ku 3 di yüni 2025, tur diamars pa 19:30, mi ta hiba bo riba e biahe aki dor di e Skrituranan Sagrado. Nos ta topa na bibo riba e plataforma Pikapika (https://www.facebook.com/pikapikatalkshow/), kaminda huntu nos ta deskubrí e misterionan di Beibel. Mi ta spera di mira bo einan."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-occulte-kant-van-de-bijbelpromo-final:6?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E0: De Occulte Kant van de Bijbel - Promo - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-occulte-kant-van-de-bijbelpromo-final:6?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Seizoen 5 - De Occulte Kant van De Bijbel Flyer",
          "es": "Seizoen 5 - De Occulte Kant van De Biblia Flyer",
          "nl": "Seizoen 5 - De Occulte Kant van De Bijbel Flyer",
          "pap": "Seizoen 5 - De Occulte Kant van De Beibel Flyer"
        },
        "url": "./images/flyer-eigenpad-seizoen-5.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen-en-praktische-toepassin",
    "nextEpisode": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 197,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties",
    "slug": {
      "en": "eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-int",
      "es": "eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-int",
      "nl": "eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-int",
      "pap": "eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-int"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 57,
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "language": "nl",
    "summary": {
      "en": "This episode sketches a chronological timeline of the Bible, from the creation to the early Christian church. It covers key figures, events, and historical context, such as the Exodus, the Babylonian exile, and Roman rule. Occult and mystical themes are touched upon briefly, including Kabbalistic and esoteric influences. The episode offers a framework for understanding the spiritual and historical development of the Bible and is foundational for the following episodes.",
      "es": "Este episodio traza una línea de tiempo cronológica de la Biblia, desde la creación hasta la primera Iglesia cristiana. Aborda figuras clave, acontecimientos y contexto histórico, como el Éxodo, el exilio babilónico y la dominación romana. Se mencionan brevemente temas ocultos y místicos, incluidas influencias cabalísticas y esotéricas. El episodio ofrece un marco para comprender el desarrollo espiritual e histórico de la Biblia y es fundamental para los episodios siguientes.",
      "nl": "Deze aflevering schetst een chronologische tijdlijn van de Bijbel, van de schepping tot de vroege christelijke kerk. Het behandelt sleutelfiguren, gebeurtenissen en historische context, zoals de Exodus, de Babylonische ballingschap en de Romeinse overheersing. Occulte en mystieke thema’s worden kort aangestipt, inclusief Kabbalistische en esoterische invloeden. De aflevering biedt een raamwerk om de spirituele en historische ontwikkeling van de Bijbel te begrijpen en is fundamenteel voor vervolg afleveringen.",
      "pap": "E episodio aki ta trasa un linea di tempu kronológiko di Beibel, for di e kreashon te ku e promé iglesia kristian. E ta trata figuranan klave, eventonan i konteksto históriko, manera e Eksodo, e eksilio babilóniko i e dominashon romano. Ta mensoná brevemente temanan okulto i místiko, inkluyendo influensianan kabalístiko i esotériko. E episodio ta ofresé un struktura pa komprondé e desaroyo spiritual i históriko di Beibel i ta fundamental pa e episodionan siguiente."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e1%3Ae?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e1%3Ae?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e1.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of God - ShemHaMephorash (EN)",
          "es": "72 Names of God - ShemHaMephorash (EN)",
          "nl": "72 Names of God - ShemHaMephorash (EN)",
          "pap": "72 Names of God - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e0-de-occulte-kant-van-de-bijbel-promo",
    "nextEpisode": "legacy-eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 224,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften",
    "slug": {
      "en": "eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften",
      "es": "eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften",
      "nl": "eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften",
      "pap": "eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 58,
    "title": {
      "en": "Eigen Pad S5E2: The Occult Side of the Bible - Genesis of the Scriptures",
      "es": "Eigen Pad S5E2: El Lado Oculto de la Biblia - Génesis de las Escrituras",
      "nl": "Eigen Pad S5E2: De Occulte Kant van de Bijbel - Genesis van de Schriften",
      "pap": "Eigen Pad S5E2: E Banda Okulto di Beibel - Génesis di e Skrituranan"
    },
    "language": "nl",
    "summary": {
      "en": "This episode explores the origin of the biblical writings and draws a chronological connection between the biblical timeline and the history of the Netherlands. We examine the influence of religion on the Dutch timeline and reveal the origin of the Protestant translation. In addition, we highlight the points of contact between this history and that of Curaçao, offering insight into how faith, politics, colonial structures, and cultural identity are interwoven.",
      "es": "Este episodio explora el origen de los escritos bíblicos y traza una conexión cronológica entre la línea de tiempo bíblica y la historia de los Países Bajos. Examinamos la influencia de la religión en la cronología neerlandesa y revelamos el origen de la traducción protestante. Además, destacamos los puntos de contacto entre esta historia y la de Curazao, ofreciendo una visión de cómo se entrelazan la fe, la política, las estructuras coloniales y la identidad cultural.",
      "nl": "Deze aflevering verkent de oorsprong van de bijbelse geschriften en legt een chronologische verbinding tussen de bijbelse tijdlijn en de geschiedenis van Nederland. We onderzoeken de invloed van religie op de Nederlandse tijdlijn en onthullen de herkomst van de protestantse vertaling. Daarnaast belichten we de raakvlakken tussen deze geschiedenis en die van Curaçao, waarbij we inzicht bieden in hoe geloof, politiek, koloniale structuren en culturele identiteit met elkaar verweven zijn.",
      "pap": "E episodio aki ta eksplorá e orígen di e skrituranan bíbliko i ta trasa un konekshon kronológiko entre e linea di tempu bíbliko i e historia di Hulanda. Nos ta analisá e influensia di religion riba e linea di tempu hulandes i ta revelá e orígen di e tradukshon protestant. Ademas, nos ta destaká e puntonan di kontakto entre e historia aki i esun di Kòrsou, ofresiendo bista den kon fe, polítika, struktura kolonial i identidat kultural ta entrelasá."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e2%3A9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E2: De Occulte Kant van de Bijbel - Genesis van de Schriften - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e2%3A9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e2.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties",
    "nextEpisode": "legacy-eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 377,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua",
    "slug": {
      "en": "eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua",
      "es": "eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua",
      "nl": "eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua",
      "pap": "eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 59,
    "title": {
      "en": "Eigen Pad S5E3: The Occult Side of the Bible - Genesis through Joshua",
      "es": "Eigen Pad S5E3: El Lado Oculto de la Biblia - Génesis hasta Josué",
      "nl": "Eigen Pad S5E3: De Occulte Kant van de Bijbel - Genesis t/m Jozua",
      "pap": "Eigen Pad S5E3: E Banda Okulto di Beibel - Génesis te Josué"
    },
    "language": "nl",
    "summary": {
      "en": "This episode dives into the deeper layers of the first six books of the Bible – Genesis, Exodus, Leviticus, Numbers, Deuteronomy, and Joshua. We unravel their spiritual and esoteric meaning as a metaphor for the journey of the soul and its transformation. In addition, we reveal hidden codes and symbolic messages that have remained concealed for centuries, and shed new light on the mystical structure of these sacred texts.",
      "es": "Este episodio profundiza en las capas más hondas de los primeros seis libros de la Biblia: Génesis, Éxodo, Levítico, Números, Deuteronomio y Josué. Desentrañamos su significado espiritual y esotérico como metáfora del viaje del alma y su transformación. Además, revelamos códigos ocultos y mensajes simbólicos que han permanecido velados durante siglos, y arrojamos nueva luz sobre la estructura mística de estos textos sagrados.",
      "nl": "Deze aflevering duikt in de diepere lagen van de eerste zes boeken van de Bijbel – Genesis, Exodus, Leviticus, Numeri, Deuteronomium en Jozua. We ontrafelen hun spirituele en esoterische betekenis als een metafoor voor de reis van de ziel en haar transformatie. Daarnaast onthullen we verborgen coderingen en symbolische boodschappen die eeuwenlang verborgen zijn gebleven, en werpen we nieuw licht op de mystieke structuur van deze heilige teksten.",
      "pap": "E episodio aki ta sumi den e kapanan mas profundo di e promé seis bukinan di Beibel – Génesis, Eksodo, Levítiko, Number, Deuteronomio i Josué. Nos ta deskubrí nan nifikashon spiritual i esotériko komo un metáfora pa e biahe di e alma i su transformashon. Ademas, nos ta revelá kódigonan skondí i mensahenan simbóliko ku a keda tapá pa siglonan, i ta tira nobo lus riba e struktura místiko di e tekstonan sagrado aki."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e3%3Ab?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E3: De Occulte Kant van de Bijbel - Genesis t/m Jozua - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e3%3Ab?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e3.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften",
    "nextEpisode": "legacy-eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 530,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel",
    "slug": {
      "en": "eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel",
      "es": "eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel",
      "nl": "eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel",
      "pap": "eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 60,
    "title": {
      "en": "Eigen Pad S5E4: The Occult Side of the Bible - Joshua through 2 Samuel",
      "es": "Eigen Pad S5E4: El Lado Oculto de la Biblia - Josué hasta 2 Samuel",
      "nl": "Eigen Pad S5E4: De Occulte Kant van de Bijbel - Jozua t/m 2 Samuel",
      "pap": "Eigen Pad S5E4: E Banda Okulto di Beibel - Josué te 2 Samuel"
    },
    "language": "nl",
    "summary": {
      "en": "This episode unravels the deeper layers of Joshua, Judges, Ruth, 1 Samuel, and 2 Samuel. We explore their esoteric meaning as phases in the soul's spiritual journey and its transformation through trials, victories, and inner growth. In addition, we reveal hidden codes and symbolic messages that pervade these texts, and shed new light on their mystical and universal wisdom.",
      "es": "Este episodio desentraña las capas más profundas de Josué, Jueces, Rut, 1 Samuel y 2 Samuel. Exploramos su significado esotérico como fases del viaje espiritual del alma y su transformación a través de pruebas, victorias y crecimiento interior. Además, revelamos códigos ocultos y mensajes simbólicos que impregnan estos textos, y arrojamos nueva luz sobre su sabiduría mística y universal.",
      "nl": "Deze aflevering ontrafelt de diepere lagen van Jozua, Rechters, Ruth, 1 Samuel en 2 Samuel. We verkennen hun esoterische betekenis als fasen in de spirituele reis van de ziel en haar transformatie door beproevingen, overwinningen en innerlijke groei. Daarnaast onthullen we verborgen coderingen en symbolische boodschappen die deze teksten doordringen, en werpen we nieuw licht op hun mystieke en universele wijsheid.",
      "pap": "E episodio aki ta deskubrí e kapanan mas profundo di Josué, Hueznan, Rut, 1 Samuel i 2 Samuel. Nos ta eksplorá nan nifikashon esotériko komo fasenan den e biahe spiritual di e alma i su transformashon dor di prueba, viktoria i kresementu interno. Ademas, nos ta revelá kódigonan skondí i mensahenan simbóliko ku ta penetrá e tekstonan aki, i ta tira nobo lus riba nan sabiduria místiko i universal."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e4-final%3Ac?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E4: De Occulte Kant van de Bijbel - Jozua t/m 2 Samuel - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e4-final%3Ac?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e4.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua",
    "nextEpisode": "legacy-eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 684,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken",
    "slug": {
      "en": "eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken",
      "es": "eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken",
      "nl": "eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken",
      "pap": "eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 61,
    "title": {
      "en": "Eigen Pad S5E5: The Occult Side of the Bible - 1 Samuel through 2 Chronicles",
      "es": "Eigen Pad S5E5: El Lado Oculto de la Biblia - 1 Samuel hasta 2 Crónicas",
      "nl": "Eigen Pad S5E5: De Occulte Kant van de Bijbel - 1 Samuel t/m 2 Kronieken",
      "pap": "Eigen Pad S5E5: E Banda Okulto di Beibel - 1 Samuel te 2 Krónika"
    },
    "language": "nl",
    "summary": {
      "en": "This episode dives into the esoteric layers of 1 & 2 Samuel, 1 & 2 Kings, and 1 & 2 Chronicles. We explore how these royal books are symbolic depictions of the soul on its path of power, fall, and resurrection. Kingship is summarized here as an inner state of mastery and divine alignment. We unravel how these texts contain hidden codes about inner leadership, spiritual responsibility, and the pitfalls of the ego. This episode reveals the mystical symbolism and deeper messages that have remained concealed for centuries, offering a key to understanding the archetype of the 'king' within every person.",
      "es": "Este episodio se adentra en las capas esotéricas de 1 y 2 Samuel, 1 y 2 Reyes y 1 y 2 Crónicas. Exploramos cómo estos libros reales son representaciones simbólicas del alma en su camino de poder, caída y resurrección. La realeza se resume aquí como un estado interior de maestría y alineación divina. Desentrañamos cómo estos textos contienen códigos ocultos sobre el liderazgo interior, la responsabilidad espiritual y las trampas del ego. Este episodio revela el simbolismo místico y los mensajes profundos velados durante siglos, ofreciendo una llave para comprender el arquetipo del 'rey' dentro de cada persona.",
      "nl": "Deze aflevering duikt in de esoterische lagen van 1 & 2 Samuel, 1 & 2 Koningen en 1 & 2 Kronieken. We verkennen hoe deze koninklijke boeken symbolische weergaven zijn van de ziel op haar pad van macht, val, en heropstanding. Koningschap wordt hier samengevat als een innerlijke staat van meesterschap en goddelijke afstemming. We ontrafelen hoe deze teksten verborgen coderingen bevatten over innerlijk leiderschap, spirituele verantwoordelijkheid, en de valstrikken van het ego. Deze aflevering onthult de mystieke symboliek en diepere boodschappen die eeuwenlang verborgen zijn gebleven, en biedt daarmee een sleutel tot het begrijpen van het archetype van de ‘koning’ binnenin ieder mens.",
      "pap": "E episodio aki ta sumi den e kapanan esotériko di 1 i 2 Samuel, 1 i 2 Reinan i 1 i 2 Krónika. Nos ta eksplorá kon e bukinan real aki ta representashonnan simbóliko di e alma riba su kaminda di poder, kaida i resurekshon. Reinado ta resumí akinan komo un estado interno di maestria i alineashon divino. Nos ta deskubrí kon e tekstonan aki ta kontené kódigonan skondí tokante liderazgo interno, responsabilidat spiritual i e trampanan di ego. E episodio aki ta revelá e simbolismo místiko i e mensahenan profundo ku a keda tapá pa siglonan, ofresiendo un yabi pa komprondé e arketipo di e 'rei' den kada persona."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e5%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E5: De Occulte Kant van de Bijbel - 1 Samuel t/m 2 Kronieken - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e5%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e5.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel",
    "nextEpisode": "legacy-eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-daniel-hosea-t-m-maleachi",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 838,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-daniel-hosea-t-m-maleachi",
    "slug": {
      "en": "eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-dan",
      "es": "eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-dan",
      "nl": "eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-dan",
      "pap": "eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-dan"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 62,
    "title": {
      "en": "Eigen Pad S5E6: The Occult Side of the Bible - Isaiah, Jeremiah, Ezekiel, Daniel, Hosea through Malachi",
      "es": "Eigen Pad S5E6: El Lado Oculto de la Biblia - Isaías, Jeremías, Ezequiel, Daniel, Oseas hasta Malaquías",
      "nl": "Eigen Pad S5E6: De Occulte Kant van de Bijbel - Jesaja, Jeremia, Ezechiël, Daniel, Hosea t/m Maleachi",
      "pap": "Eigen Pad S5E6: E Banda Okulto di Beibel - Isaías, Jeremías, Ezekiel, Daniel, Oseas te Malakias"
    },
    "language": "nl",
    "summary": {
      "en": "We dive into the spiritual implosion of the once-united kingdom: the split between Israel and Judah as an archetypal schism between higher Will and lower desire. Through the prophets — from Isaiah to Malachi — we reveal mystical visions, inner transformations, and cosmic messages that guide the soul from chaos to restoration, from exile to enlightenment.",
      "es": "Nos adentramos en la implosión espiritual del reino que una vez estuvo unido: la división entre Israel y Judá como cisma arquetípico entre la Voluntad superior y el deseo inferior. A través de los profetas —de Isaías a Malaquías— revelamos visiones místicas, transformaciones interiores y mensajes cósmicos que guían al alma del caos a la restauración, del destierro a la iluminación.",
      "nl": "We duiken in de spirituele implosie van het eens verenigde rijk: de splitsing tussen Israël en Juda als archetypisch schisma tussen hogere Wil en lagere begeerte. Via de profeten — van Jesaja tot Maleachi — onthullen we mystieke visioenen, innerlijke transformaties en kosmische boodschappen die de ziel leiden van chaos naar herstel, van verbanning naar verlichting.",
      "pap": "Nos ta sumi den e imploshon spiritual di e reino ku un biaha tabata uní: e divishon entre Israel i Juda komo un schisma arketípiko entre e Boluntat mas haltu i e deseo mas abou. Via e profetanan —for di Isaías te Malakias— nos ta revelá vishonnan místiko, transformashonnan interno i mensahenan kósmiko ku ta guia e alma for di kaos pa restorashon, for di eksilio pa iluminashon."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e6%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E6: De Occulte Kant van de Bijbel - Jesaja, Jeremia, Ezechiël, Daniel, Hosea t/m Maleachi - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e6%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e6.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken",
    "nextEpisode": "legacy-eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-tobit",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 992,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-tobit",
    "slug": {
      "en": "eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-",
      "es": "eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-",
      "nl": "eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-",
      "pap": "eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 63,
    "title": {
      "en": "Eigen Pad S5E7: The Occult Side of the Bible - Ezra, Nehemiah, Esther, (Judith, Tobit)",
      "es": "Eigen Pad S5E7: El Lado Oculto de la Biblia - Esdras, Nehemías, Ester, (Judit, Tobías)",
      "nl": "Eigen Pad S5E7: De Occulte Kant van de Bijbel - Ezra, Nehemia, Esther, (Judith, Tobit)",
      "pap": "Eigen Pad S5E7: E Banda Okulto di Beibel - Esra, Nehemías, Ester, (Judit, Tobit)"
    },
    "language": "nl",
    "summary": {
      "en": "This episode explores the hidden wisdom in the Bible books of exile and restoration – from Tobit to Malachi. We follow the soul on its journey through darkness, visions, courageous deeds, and sacred rebuilding. From Daniel's visions to Esther's courage, from the rebuilding by Zerubbabel to the purification by Malachi – each story reveals a phase of inner transformation and divine guidance in hidden form. A mystical blueprint for the soul in times of crisis and rebirth.",
      "es": "Este episodio explora la sabiduría oculta en los libros bíblicos del exilio y la restauración, de Tobías a Malaquías. Seguimos al alma en su viaje por la oscuridad, las visiones, los actos de valentía y la reconstrucción sagrada. De las visiones de Daniel al valor de Ester, de la reconstrucción por Zorobabel a la purificación por Malaquías, cada relato revela una fase de transformación interior y guía divina en forma oculta. Un plano místico para el alma en tiempos de crisis y renacimiento.",
      "nl": "Deze aflevering verkent de verborgen wijsheid in de Bijbelboeken van ballingschap en herstel – van Tobit tot Maleachi. We volgen de ziel in haar reis door duisternis, visioenen, moedige daden en heilige wederopbouw. Van Daniel’s visioenen tot Esther’s moed, van de herbouw door Zerubbabel tot de zuivering door Maleachi – elk verhaal onthult een fase van innerlijke transformatie en goddelijke leiding in verborgen vorm. Een mystieke blauwdruk voor de ziel in tijden van crisis en wedergeboorte.",
      "pap": "E episodio aki ta eksplorá e sabiduria skondí den e bukinan bíbliko di eksilio i restorashon – for di Tobit te Malakias. Nos ta sigui e alma riba su biahe dor di skuridat, vishonnan, akshonnan di koral i rekonstrukshon sagrado. For di e vishonnan di Daniel te ku e koral di Ester, for di e rekonstrukshon dor di Zerubabel te ku e purifikashon dor di Malakias – kada historia ta revelá un fase di transformashon interno i guia divino den forma skondí. Un blòprènt místiko pa e alma den tempu di krisis i nasementu nobo."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e7%3A4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E7: De Occulte Kant van de Bijbel - Ezra, Nehemia, Esther, (Judith, Tobit) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e7%3A4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e7.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-daniel-hosea-t-m-maleachi",
    "nextEpisode": "legacy-eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 1145,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen",
    "slug": {
      "en": "eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen",
      "es": "eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen",
      "nl": "eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen",
      "pap": "eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 64,
    "title": {
      "en": "Eigen Pad S5E8: The Occult Side of the Bible - 1 & 2 Maccabees",
      "es": "Eigen Pad S5E8: El Lado Oculto de la Biblia - 1 y 2 Macabeos",
      "nl": "Eigen Pad S5E8: De Occulte Kant van de Bijbel - 1 & 2 Makkabeeën",
      "pap": "Eigen Pad S5E8: E Banda Okulto di Beibel - 1 i 2 Makabeo"
    },
    "language": "nl",
    "summary": {
      "en": "This episode explores the hidden wisdom in the books of 1 & 2 Maccabees – a fiery testimony of faith, struggle, and inner devotion in times of oppression. We follow the soul in its resistance to inner and outer tyranny, in its refusal to submit to idolatry, and in its courage to stay faithful to the sacred, even at any cost. A mystical blueprint of spiritual courage, resurrection, and the power of pure devotion in a world full of temptation and violence.",
      "es": "Este episodio explora la sabiduría oculta en los libros de 1 y 2 Macabeos: un ardiente testimonio de fe, lucha y devoción interior en tiempos de opresión. Seguimos al alma en su resistencia a la tiranía interior y exterior, en su negativa a someterse a la idolatría y en su valor para permanecer fiel a lo sagrado, aun a cualquier precio. Un plano místico de coraje espiritual, resurrección y el poder de la devoción pura en un mundo lleno de tentación y violencia.",
      "nl": "Deze aflevering verkent de verborgen wijsheid in de boeken van 1 & 2 Makkabeeën – een vurige getuigenis van geloof, strijd en innerlijke toewijding in tijden van onderdrukking. We volgen de ziel in haar verzet tegen innerlijke en uiterlijke tirannie, in haar weigering om zich te onderwerpen aan afgoderij, en in haar moed om trouw te blijven aan het heilige, zelfs ten koste van alles. Een mystieke blauwdruk van spirituele moed, opstanding en de kracht van zuivere toewijding in een wereld vol verleiding en geweld.",
      "pap": "E episodio aki ta eksplorá e sabiduria skondí den e bukinan di 1 i 2 Makabeo – un testimonio ardiente di fe, lucha i devoshon interno den tempu di opreshon. Nos ta sigui e alma den su resistensia kontra tirania interno i externo, den su negashon di someté na idolatria, i den su koral pa keda fiel na e sagrado, asta na kualke preis. Un blòprènt místiko di koral spiritual, resurekshon i e poder di devoshon puru den un mundu yen di tentashon i violensia."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e8%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E8: De Occulte Kant van de Bijbel - 1 & 2 Makkabeeën - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e8%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e8.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-tobit",
    "nextEpisode": "legacy-eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-prediker-hooglied-klaagliedere",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 1300,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-prediker-hooglied-klaagliedere",
    "slug": {
      "en": "eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-predik",
      "es": "eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-predik",
      "nl": "eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-predik",
      "pap": "eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-predik"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 65,
    "title": {
      "en": "Eigen Pad S5E9: The Occult Side of the Bible - Job, Psalms, Proverbs, Ecclesiastes, Song of Songs, Lamentations, Ecclesiasticus, Wisdom of Solomon, Baruch",
      "es": "Eigen Pad S5E9: El Lado Oculto de la Biblia - Job, Salmos, Proverbios, Eclesiastés, Cantar de los Cantares, Lamentaciones, Eclesiástico, Sabiduría de Salomón, Baruc",
      "nl": "Eigen Pad S5E9: De Occulte Kant van de Bijbel - Job, Psalmen, Spreuken, Prediker, Hooglied, Klaagliederen, Ecclesiasticus, Wijsheid van Salomo, Baruch",
      "pap": "Eigen Pad S5E9: E Banda Okulto di Beibel - Job, Salmonan, Proverbionan, Eklesiastés, Kantika di Kantikanan, Lamentashonnan, Eklesiástiko, Sabiduria di Salomon, Baruk"
    },
    "language": "nl",
    "summary": {
      "en": "This episode explores the hidden wisdom in the wisdom books – from Job to Baruch – in which the soul learns to speak, to understand suffering, to love, to seek, and to remember. From Job's cry in the dark to the songs of the Psalms, from the proverbs of Solomon to the soul's love song in the Song of Songs – each book is a mirror of the inner way toward wisdom, surrender, and divine unity. A mystical blueprint of the soul that learns to live with paradoxes, to love with depth, and to remember who she truly is.",
      "es": "Este episodio explora la sabiduría oculta en los libros sapienciales, de Job a Baruc, en los que el alma aprende a hablar, a comprender el sufrimiento, a amar, a buscar y a recordar. Del clamor de Job en la oscuridad a los cantos de los Salmos, de los proverbios de Salomón al canto de amor del alma en el Cantar de los Cantares, cada libro es un espejo del camino interior hacia la sabiduría, la entrega y la unidad divina. Un plano místico del alma que aprende a vivir con las paradojas, a amar con profundidad y a recordar quién es en verdad.",
      "nl": "Deze aflevering verkent de verborgen wijsheid in de wijsheidsboeken – van Job tot Baruch – waarin de ziel leert te spreken, lijden te begrijpen, te beminnen, te zoeken en te herinneren. Van de roep van Job in het duister tot de lofzangen van de Psalmen, van de spreuken van Salomo tot het liefdeslied van de ziel in Hooglied – elk boek is een spiegel van de innerlijke weg naar wijsheid, overgave en goddelijke eenheid. Een mystieke blauwdruk van de ziel die leert leven met paradoxen, liefhebben met diepte, en herinneren wie zij werkelijk is.",
      "pap": "E episodio aki ta eksplorá e sabiduria skondí den e bukinan di sabiduria – for di Job te Baruk – den kua e alma ta siña papia, komprondé sufrimentu, stima, buska i korda. For di e gritu di Job den skuridat te ku e kantikanan di e Salmonan, for di e proverbionan di Salomon te ku e kantika di amor di e alma den Kantika di Kantikanan – kada buki ta un spil di e kaminda interno pa sabiduria, entrega i unidat divino. Un blòprènt místiko di e alma ku ta siña biba ku paradohanan, stima ku profundidat, i korda ken e ta di bèrdat."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2FDark-Side-Of-The-Bible-S5e9%3A7?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E9: De Occulte Kant van de Bijbel - Job, Psalmen, Spreuken, Prediker, Hooglied, Klaagliederen, Ecclesiasticus, Wijsheid van Salomo, Baruch - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2FDark-Side-Of-The-Bible-S5e9%3A7?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e9.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen",
    "nextEpisode": "legacy-eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johannes-en-handelingen",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 1454,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johannes-en-handelingen",
    "slug": {
      "en": "eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johan",
      "es": "eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johan",
      "nl": "eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johan",
      "pap": "eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johan"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 66,
    "title": {
      "en": "Eigen Pad S5E10: The Occult Side of the Bible - Matthew, Mark, Luke, John and Acts",
      "es": "Eigen Pad S5E10: El Lado Oculto de la Biblia - Mateo, Marcos, Lucas, Juan y Hechos",
      "nl": "Eigen Pad S5E10: De Occulte Kant van de Bijbel - Matteüs, Marcus, Lucas, Johannes en Handelingen",
      "pap": "Eigen Pad S5E10: E Banda Okulto di Beibel - Mateo, Marko, Lukas, Huan i Echonan"
    },
    "language": "nl",
    "summary": {
      "en": "This episode explores the gospels of Matthew, Mark, Luke, John, and the book of Acts – the beginning of the living Christ-force in the human being. We follow the soul in its encounter with the Light of the World, in its death and resurrection, and its calling to carry that Spirit further in deeds, words, and miracles. A mystical blueprint of incarnation, transformation, and the awakening of the inner Christ – as eternal guide, living temple, and power of true love.",
      "es": "Este episodio explora los evangelios de Mateo, Marcos, Lucas y Juan y el libro de los Hechos: el comienzo de la fuerza viva de Cristo en el ser humano. Seguimos al alma en su encuentro con la Luz del Mundo, en su muerte y resurrección, y en su llamado a llevar más lejos ese Espíritu en obras, palabras y milagros. Un plano místico de encarnación, transformación y despertar del Cristo interior, como guía eterno, templo vivo y poder del amor verdadero.",
      "nl": "Deze aflevering verkent de verborgen wijsheid in de evangeliën van Matteüs, Marcus, Lucas, Johannes en het boek Handelingen – het begin van de levende Christus-kracht in de mens. We volgen de ziel in haar ontmoeting met het Licht van de Wereld, in haar dood en opstanding, en haar roeping om die Geest verder te dragen in daden, woorden en wonderen. Een mystieke blauwdruk van incarnatie, transformatie en het ontwaken van de innerlijke Christus – als eeuwige gids, levende tempel en kracht van ware liefde.",
      "pap": "E episodio aki ta eksplorá e evangelionan di Mateo, Marko, Lukas, Huan i e buki di Echonan – e komienso di e forsa bibu di Kristu den e ser humano. Nos ta sigui e alma den su enkuentro ku e Lus di Mundu, den su morto i resurekshon, i su yamada pa karga e Spiritu aki mas leu den echo, palabra i milager. Un blòprènt místiko di enkarnashon, transformashon i e spièrtamentu di e Kristu interno – komo guia eterno, tèmpel bibu i poder di berdadero amor."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e10%3A1?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E10: De Occulte Kant van de Bijbel - Matteüs, Marcus, Lucas, Johannes en Handelingen - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e10%3A1?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e10.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-prediker-hooglied-klaagliedere",
    "nextEpisode": "legacy-eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galaten-efeziers-filippenzen-k",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 1608,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galaten-efeziers-filippenzen-k",
    "slug": {
      "en": "eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galate",
      "es": "eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galate",
      "nl": "eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galate",
      "pap": "eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galate"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 67,
    "title": {
      "en": "Eigen Pad S5E11: The Occult Side of the Bible - Romans, Corinthians, Galatians, Ephesians, Philippians, Colossians, Thessalonians, Timothy, Titus, Philemon, Hebrews, James, Peter, John, Jude",
      "es": "Eigen Pad S5E11: El Lado Oculto de la Biblia - Romanos, Corintios, Gálatas, Efesios, Filipenses, Colosenses, Tesalonicenses, Timoteo, Tito, Filemón, Hebreos, Santiago, Pedro, Juan, Judas",
      "nl": "Eigen Pad S5E11: De Occulte Kant van de Bijbel - Romeinen, Korintiërs, Galaten, Efeziërs, Filippenzen, Kolossenzen, Thessalonicenzen, Timotheüs, Titus, Filemon, Hebreeën, Jakobus, Petrus, Johannes, Judas",
      "pap": "Eigen Pad S5E11: E Banda Okulto di Beibel - Romanonan, Korintionan, Galatianan, Efesionan, Filipensenan, Kolosensenan, Tesalonisensenan, Timoteo, Tito, Filemon, Hebreonan, Santiago, Pedro, Huan, Hudas"
    },
    "language": "nl",
    "summary": {
      "en": "This episode explores the secret messages in the epistles from Romans to Jude – a chain of hidden codes that reveal the struggle, liberation, and resurrection of the human being.",
      "es": "Este episodio explora los mensajes secretos en las epístolas de Romanos a Judas: una cadena de códigos ocultos que revelan la lucha, la liberación y la resurrección del ser humano.",
      "nl": "Deze aflevering verkent de geheime boodschappen in de brieven van Romeinen t/m Judas – een ketting van verborgen coderingen die de strijd, bevrijding en wederopstanding van de mens onthullen.",
      "pap": "E episodio aki ta eksplorá e mensahenan sekreto den e kartanan for di Romanonan te Hudas – un kadena di kódigonan skondí ku ta revelá e lucha, liberashon i resurekshon di e ser humano."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e11%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E11: De Occulte Kant van de Bijbel - Romeinen, Korintiërs, Galaten, Efeziërs, Filippenzen, Kolossenzen, Thessalonicenzen, Timotheüs, Titus, Filemon, Hebreeën, Jakobus, Petrus, Johannes, Judas - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e11%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e11.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johannes-en-handelingen",
    "nextEpisode": "legacy-eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 1762,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring",
    "slug": {
      "en": "eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring",
      "es": "eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring",
      "nl": "eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring",
      "pap": "eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 68,
    "title": {
      "en": "Eigen Pad S5E12: The Occult Side of the Bible - Revelation",
      "es": "Eigen Pad S5E12: El Lado Oculto de la Biblia - Apocalipsis",
      "nl": "Eigen Pad S5E12: De Occulte Kant van de Bijbel - Openbaring",
      "pap": "Eigen Pad S5E12: E Banda Okulto di Beibel - Revelashon"
    },
    "language": "nl",
    "summary": {
      "en": "This episode explores the hidden wisdom in the book of Revelation – the closing chord of the Bible and the culmination of the inner Christ-force.",
      "es": "Este episodio explora la sabiduría oculta en el libro del Apocalipsis: el acorde final de la Biblia y la culminación de la fuerza interior de Cristo.",
      "nl": "Deze aflevering verkent de verborgen wijsheid in het boek Openbaring – het slotakkoord van de Bijbel en de apotheose van de innerlijke Christus-kracht.",
      "pap": "E episodio aki ta eksplorá e sabiduria skondí den e buki di Revelashon – e akòrdo final di Beibel i e kulminashon di e forsa interno di Kristu."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e12%3A2?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/holy_lance.png",
    "imageAlt": "Eigen Pad S5E12: De Occulte Kant van de Bijbel - Openbaring - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fdark-side-of-the-bible-s5e12%3A2?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s5/dark-side-of-the-bible-s5e12.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Vaticanus",
          "es": "Codex Vaticanus",
          "nl": "Codex Vaticanus",
          "pap": "Codex Vaticanus"
        },
        "url": "./media/s5/codex-vaticanus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Geneva Bijbel",
          "es": "Geneva Biblia",
          "nl": "Geneva Bijbel",
          "pap": "Geneva Beibel"
        },
        "url": "./media/s5/geneva_bible1560.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "KJV Bijbel",
          "es": "KJV Biblia",
          "nl": "KJV Bijbel",
          "pap": "KJV Beibel"
        },
        "url": "./media/s5/king-james-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Masoretische Tekst",
          "es": "Masoretische Tekst",
          "nl": "Masoretische Tekst",
          "pap": "Masoretische Tekst"
        },
        "url": "./media/s5/massoretic-text.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Septuaginta",
          "es": "Septuaginta",
          "nl": "Septuaginta",
          "pap": "Septuaginta"
        },
        "url": "./media/s5/septuaginta.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Statenvertaling",
          "es": "Statenvertaling",
          "nl": "Statenvertaling",
          "pap": "Statenvertaling"
        },
        "url": "./media/s5/statenvertaling.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh",
          "es": "Tanakh",
          "nl": "Tanakh",
          "pap": "Tanakh"
        },
        "url": "./media/s5/tanakh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Textus Receptus",
          "es": "Textus Receptus",
          "nl": "Textus Receptus",
          "pap": "Textus Receptus"
        },
        "url": "./media/s5/textus-receptus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Vulgata",
          "es": "Vulgata",
          "nl": "Vulgata",
          "pap": "Vulgata"
        },
        "url": "./media/s5/vulgate.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Sinaiticus",
          "es": "Codex Sinaiticus",
          "nl": "Codex Sinaiticus",
          "pap": "Codex Sinaiticus"
        },
        "url": "./media/s5/codex-sinaiticus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aleppo Codex",
          "es": "Aleppo Codex",
          "nl": "Aleppo Codex",
          "pap": "Aleppo Codex"
        },
        "url": "./media/s5/aleppo.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Alexandrinus",
          "es": "Codex Alexandrinus",
          "nl": "Codex Alexandrinus",
          "pap": "Codex Alexandrinus"
        },
        "url": "./media/s5/alexandrinus.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Codex Bazae",
          "es": "Codex Bazae",
          "nl": "Codex Bazae",
          "pap": "Codex Bazae"
        },
        "url": "./media/s5/bazae.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Leningrad Codex",
          "es": "Leningrad Codex",
          "nl": "Leningrad Codex",
          "pap": "Leningrad Codex"
        },
        "url": "./media/s5/leningrad.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Samaritaanse Pentateuch",
          "es": "Samaritaanse Pentateuch",
          "nl": "Samaritaanse Pentateuch",
          "pap": "Samaritaanse Pentateuch"
        },
        "url": "./media/s5/samaritan-torah.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (nieuwe testament)",
          "es": "Peshitta (nieuwe testament)",
          "nl": "Peshitta (nieuwe testament)",
          "pap": "Peshitta (nieuwe testament)"
        },
        "url": "./media/s5/peshitta-syriac-new-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Peshitta (oude testament)",
          "es": "Peshitta (oude testament)",
          "nl": "Peshitta (oude testament)",
          "pap": "Peshitta (oude testament)"
        },
        "url": "./media/s5/peshitta-syriac-old-testament.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tanakh (Targoems)",
          "es": "Tanakh (Targoems)",
          "nl": "Tanakh (Targoems)",
          "pap": "Tanakh (Targoems)"
        },
        "url": "./media/s5/tanakh-with-targum.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "The Bible Unearthed",
          "es": "The Bible Unearthed",
          "nl": "The Bible Unearthed",
          "pap": "The Bible Unearthed"
        },
        "url": "./media/s5/the-bible-unearthed.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "David & Salomon",
          "es": "David & Salomon",
          "nl": "David & Salomon",
          "pap": "David & Salomon"
        },
        "url": "./media/s5/david-and-solomon.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Namen van God - ShemHaMephorash (NL)",
          "es": "72 Namen van God - ShemHaMephorash (NL)",
          "nl": "72 Namen van God - ShemHaMephorash (NL)",
          "pap": "72 Namen van God - ShemHaMephorash (NL)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "72 Names of Gog - ShemHaMephorash (EN)",
          "es": "72 Names of Gog - ShemHaMephorash (EN)",
          "nl": "72 Names of Gog - ShemHaMephorash (EN)",
          "pap": "72 Names of Gog - ShemHaMephorash (EN)"
        },
        "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Illuminati Training Video",
          "es": "Illuminati Training Video",
          "nl": "Illuminati Training Video",
          "pap": "Illuminati Training Video"
        },
        "url": "./media/s5/illuminati-training-video.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Agora Video",
          "es": "Agora Video",
          "nl": "Agora Video",
          "pap": "Agora Video"
        },
        "url": "./media/s5/agora.2009.1080p.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "es": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "nl": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)",
          "pap": "Descent of Ishtar (Engels - Akkadisch/Babylonisch)"
        },
        "url": "./media/s5/the-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish & Atrahasis (Engels)",
          "es": "Enuma Elish & Atrahasis (Engels)",
          "nl": "Enuma Elish & Atrahasis (Engels)",
          "pap": "Enuma Elish & Atrahasis (Engels)"
        },
        "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Volledige Lijst v. Babylonische Kronieken",
          "es": "Volledige Lijst v. Babylonische Kronieken",
          "nl": "Volledige Lijst v. Babylonische Kronieken",
          "pap": "Volledige Lijst v. Babylonische Kronieken"
        },
        "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "es": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "nl": "Descent of Innana (Engels - Summerische versie v. Ishtar)",
          "pap": "Descent of Innana (Engels - Summerische versie v. Ishtar)"
        },
        "url": "./media/s5/descent-of-inanna.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Tammuz & Ishtar (Engels)",
          "es": "Tammuz & Ishtar (Engels)",
          "nl": "Tammuz & Ishtar (Engels)",
          "pap": "Tammuz & Ishtar (Engels)"
        },
        "url": "./media/s5/tammuz-and-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "es": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "nl": "Satanische Ritueel v. Descent of Ishtar (Engels)",
          "pap": "Satanische Ritueel v. Descent of Ishtar (Engels)"
        },
        "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Code of Hammubari (Engels)",
          "es": "Code of Hammubari (Engels)",
          "nl": "Code of Hammubari (Engels)",
          "pap": "Code of Hammubari (Engels)"
        },
        "url": "./media/s5/code-of-hammubari.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Myth of Etana (Engels)",
          "es": "Myth of Etana (Engels)",
          "nl": "Myth of Etana (Engels)",
          "pap": "Myth of Etana (Engels)"
        },
        "url": "./media/s5/the-myth-of-etana.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Atrahasis (Engels)",
          "es": "Epic of Atrahasis (Engels)",
          "nl": "Epic of Atrahasis (Engels)",
          "pap": "Epic of Atrahasis (Engels)"
        },
        "url": "./media/s5/epic-of-atrahasis.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Epic of Gilgamesh (Engels)",
          "es": "Epic of Gilgamesh (Engels)",
          "nl": "Epic of Gilgamesh (Engels)",
          "pap": "Epic of Gilgamesh (Engels)"
        },
        "url": "./media/s5/epic-of-gilgamesh.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Enuma Elish (Engels)",
          "es": "Enuma Elish (Engels)",
          "nl": "Enuma Elish (Engels)",
          "pap": "Enuma Elish (Engels)"
        },
        "url": "./media/s5/enuma-elish.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Dode Zee Rollen (Engels)",
          "es": "Dode Zee Rollen (Engels)",
          "nl": "Dode Zee Rollen (Engels)",
          "pap": "Dode Zee Rollen (Engels)"
        },
        "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Nag Hammadi (Engels)",
          "es": "Nag Hammadi (Engels)",
          "nl": "Nag Hammadi (Engels)",
          "pap": "Nag Hammadi (Engels)"
        },
        "url": "./media/s5/the-nag-hammadi.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken I (Engels)",
          "es": "Babylonische Kronieken I (Engels)",
          "nl": "Babylonische Kronieken I (Engels)",
          "pap": "Babylonische Kronieken I (Engels)"
        },
        "url": "./media/s5/mesopotamian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Babylonische Kronieken II (Engels)",
          "es": "Babylonische Kronieken II (Engels)",
          "nl": "Babylonische Kronieken II (Engels)",
          "pap": "Babylonische Kronieken II (Engels)"
        },
        "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Aegyptiaca (Engels)",
          "es": "Aegyptiaca (Engels)",
          "nl": "Aegyptiaca (Engels)",
          "pap": "Aegyptiaca (Engels)"
        },
        "url": "./media/s5/manetho-aegyptiaca.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Engels)",
          "es": "Contra Apionem (Engels)",
          "nl": "Contra Apionem (Engels)",
          "pap": "Contra Apionem (Engels)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Contra Apionem (Grieks)",
          "es": "Contra Apionem (Grieks)",
          "nl": "Contra Apionem (Grieks)",
          "pap": "Contra Apionem (Grieks)"
        },
        "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galaten-efeziers-filippenzen-k",
    "nextEpisode": "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-6.html",
      "sourceLine": 1914,
      "kind": "media",
      "image": "images/holy_lance.png"
    }
  },
  {
    "id": "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij",
    "slug": {
      "en": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-",
      "es": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-",
      "nl": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-",
      "pap": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 69,
    "title": {
      "en": "The Reformed Cult Of The State | Where obedience strangles the goddess, and order-followers keep slavery in place.",
      "es": "El Culto Reformado Del Estado | Donde la obediencia estrangula a la diosa, y los seguidores de órdenes mantienen la esclavitud.",
      "nl": "De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden.",
      "pap": "E Kulto Reformá Di E Estado | Kaminda obedensia ta wuru e diosa, i siguidónan di órdu ta mantené esklabitut."
    },
    "language": "nl",
    "summary": {
      "en": "This presentation lays bare the \"cult\" behind authority: how commands, indoctrination, and fear replace conscience, and how people (consciously or unconsciously) cooperate with systems that legitimize harm. We go deep into: what an order-follower is (and why following orders runs counter to conscience); the logical/philosophical proof of Natural Law (cause leads to effect, including in human behavior); the difference between Right Action and Wrong Action; cult techniques such as isolation, conformity, indoctrination, and trauma; psychological roots such as willful ignorance, fear of responsibility, self-hatred or lack of self-respect, fear of abandonment, and fear of chaos; the Law of Moral Entropy (inaction is not neutral); the return of the sacred feminine (care / non-aggression) and the sacred masculine (self-defense); and the \"Lost Word\" — the Word of all Power: NO. This presentation is meant as a mirror, not as comfort. Not to \"believe\", but to see: what is Truth, what is conditioning, and which choices build freedom — or keep slavery in place. Source/presentation: Glenn Tramm – The Great Work Experience. Disclaimer: this video is meant for education, reflection, and philosophical/psychological interpretation. Not legal advice.",
      "es": "Esta presentación desnuda el \"culto\" detrás de la autoridad: cómo las órdenes, el adoctrinamiento y el miedo reemplazan a la conciencia, y cómo las personas (consciente o inconscientemente) cooperan con sistemas que legitiman el daño. Profundizamos en: qué es un seguidor de órdenes (y por qué seguir órdenes va en contra de la conciencia); la prueba lógica y filosófica de la Ley Natural (la causa lleva al efecto, también en la conducta humana); la diferencia entre la Acción Correcta y la Acción Incorrecta; técnicas de culto como el aislamiento, el conformismo, el adoctrinamiento y el trauma; raíces psicológicas como la ignorancia deliberada, el miedo a la responsabilidad, el autodesprecio o la falta de autoestima, el miedo al abandono y el miedo al caos; la Ley de la Entropía Moral (la inacción no es neutral); el retorno de lo femenino sagrado (cuidado / no agresión) y lo masculino sagrado (autodefensa); y la \"Palabra Perdida\", la Palabra de todo Poder: NO. Esta presentación es un espejo, no un consuelo. No para \"creer\", sino para ver: qué es la Verdad, qué es el condicionamiento y qué decisiones construyen libertad o mantienen la esclavitud. Fuente/presentación: Glenn Tramm – The Great Work Experience. Aviso: este video es para educación, reflexión e interpretación filosófica y psicológica. No es asesoramiento legal.",
      "nl": "In deze presentatie wordt de “cultus” achter autoriteit blootgelegd: hoe bevelen, indoctrinatie en angst het geweten vervangen, en hoe mensen (bewust of onbewust) meewerken aan systemen die schade legitimeren. We gaan diep in op: - Wat een ordevolger is (en waarom orde volgen haaks staat op het geweten) - Het logische/filosofische bewijs van Natuurwetten (oorzaak â†’ gevolg, ook in menselijk gedrag) - Het verschil tussen Juiste Handelingen vs. Verkeerde Handelingen - Cult-technieken: isolatie, conformisme, indoctrinatie, trauma - Psychologische wortels: opzettelijke onwetendheid, angst voor verantwoordelijkheid, zelfhaat/gebrek aan zelfrespect, verlatingsangst, angst voor chaos - De Wet van Morele Entropie: niet-handelen is niet neutraal - De terugkeer van het heilige vrouwelijke (zorg / niet-agressie) én het heilige mannelijke (zelfverdediging) - Het “Verloren Woord” — het Woord van alle Macht: NEE Deze presentatie is bedoeld als spiegel, niet als comfort. Niet om te “geloven”, maar om te zien: wat is Waarheid, wat is conditionering, en welke keuzes bouwen vrijheid — of houden slavernij in stand. Bron/presentatie: Glenn Tramm – The Great Work Experience Abonneer voor meer werk over Waarheid, Geweten, Natuurwetten en soevereiniteit. Disclaimer: Deze video is bedoeld voor educatie, reflectie en filosofische/psychologische duiding. Geen juridisch advies.",
      "pap": "E presentashon aki ta deskubrí e \"kulto\" tras di outoridat: kon órdu, indoktrinashon i miedu ta remplasá konsenshi, i kon hende (konsiente òf inkonsiente) ta kolaborá ku sistemanan ku ta legitimá daño. Nos ta profundisá den: kiko ta un siguidó di órdu (i dikon sigui órdu ta kontra konsenshi); e prueba lógiko/filosófiko di Lei Natural (kousa ta hiba na efekto, tambe den komportashon humano); e diferensia entre Akshon Korekto i Akshon Robes; teknikanan di kulto manera isolashon, konformismo, indoktrinashon i trauma; rais sikológiko manera ignoransia intenshonal, miedu di responsabilidat, odio pa bo mes òf falta di respèt pa bo mes, miedu di abandono i miedu di kaos; e Lei di Entropia Moral (no-akshon no ta neutral); e bòlbementu di e femenino sagrado (kuido / no-agreshon) i e maskulino sagrado (outodefensa); i e \"Palabra Pèrdí\", e Palabra di tur Poder: NO. E presentashon aki ta un spil, no un konsuelo. No pa \"kere\", sino pa mira: kiko ta Bèrdat, kiko ta kondishonamentu, i kua eskohonan ta konstruí libertat – òf ta mantené esklabitut. Fuente/presentashon: Glenn Tramm – The Great Work Experience. Aviso: e video aki ta pa edukashon, refleshon i interpretashon filosófiko/sikológiko. No ta konseho legal."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2FDe-Gereformeerde-Cultus-Van-De-Staat%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/de-gereformeerde-cultus-van-de-staat-cover.png",
    "imageAlt": "De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden. - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2FDe-Gereformeerde-Cultus-Van-De-Staat%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "De Gereformeerde Cultus van de Staat - Sheets (pdf)",
          "es": "De Gereformeerde Cultus van de Staat - Sheets (pdf)",
          "nl": "De Gereformeerde Cultus van de Staat - Sheets (pdf)",
          "pap": "De Gereformeerde Cultus van de Staat - Sheets (pdf)"
        },
        "url": "/media/de-gereformeerde-cultus-van-de-staat.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "De Gereformeerde Cultus van de Staat - Sheets (zip)",
          "es": "De Gereformeerde Cultus van de Staat - Sheets (zip)",
          "nl": "De Gereformeerde Cultus van de Staat - Sheets (zip)",
          "pap": "De Gereformeerde Cultus van de Staat - Sheets (zip)"
        },
        "url": "/media/de-gereformeerde-cultus-van-de-staat.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring",
    "nextEpisode": "legacy-eigen-pad-s6e0-het-gilgamesj-epos-promo",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 198,
      "kind": "media",
      "image": "images/de-gereformeerde-cultus-van-de-staat-cover.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e0-het-gilgamesj-epos-promo",
    "slug": {
      "en": "eigen-pad-s6e0-het-gilgamesj-epos-promo",
      "es": "eigen-pad-s6e0-het-gilgamesj-epos-promo",
      "nl": "eigen-pad-s6e0-het-gilgamesj-epos-promo",
      "pap": "eigen-pad-s6e0-het-gilgamesj-epos-promo"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 70,
    "title": {
      "en": "Eigen Pad S6E0: The Epic of Gilgamesh - Promo",
      "es": "Eigen Pad S6E0: La Epopeya de Gilgamesh - Promo",
      "nl": "Eigen Pad S6E0: Het Gilgamesj-Epos - Promo",
      "pap": "Eigen Pad S6E0: E Epopeya di Gilgamesh - Promo"
    },
    "language": "nl",
    "summary": {
      "en": "This season... we go back to the beginning. Before religion. Before dogma. Before humanity forgot itself. We enter the oldest story ever recorded: the Epic of Gilgamesh. A king. A wild man. A friendship that changes everything. But this is not a myth. It is an initiation. A journey through power, through loss, through fear, and the illusion of immortality. What is told here is the story of humanity itself: the struggle with the ego, the confrontation with the shadow, the search for meaning in a mortal existence. Each episode opens a new gate. Each tablet reveals a deeper layer, until nothing remains but truth. From 7 April through 2 June 2026, every Tuesday at 19:30 (NL), 13:30 (Curaçao). We meet live on the Pikapika platform (www.facebook.com/pikapikatalkshow/), to enter the first great initiation together.",
      "es": "Esta temporada... volvemos al principio. Antes de la religión. Antes del dogma. Antes de que la humanidad se olvidara de sí misma. Entramos en la historia más antigua jamás registrada: la Epopeya de Gilgamesh. Un rey. Un hombre salvaje. Una amistad que lo cambia todo. Pero esto no es un mito. Es una iniciación. Un viaje a través del poder, de la pérdida, del miedo y de la ilusión de la inmortalidad. Lo que aquí se narra es la historia de la humanidad misma: la lucha con el ego, la confrontación con la sombra, la búsqueda de sentido en una existencia mortal. Cada episodio abre una nueva puerta. Cada tablilla revela una capa más profunda, hasta que no queda más que la verdad. Del 7 de abril al 2 de junio de 2026, cada martes a las 19:30 (NL), 13:30 (Curazao). Nos encontramos en vivo en la plataforma Pikapika (www.facebook.com/pikapikatalkshow/), para entrar juntos en la primera gran iniciación.",
      "nl": "Dit seizoen… gaan we terug naar het begin. Nog vóór religie. Nog vóór dogma. Nog vóór de mens zichzelf vergat. We betreden het oudste verhaal ooit opgetekend. Het epos van Gilgamesj. Een koning. Een wilde man. Een vriendschap die alles verandert. Maar dit… is geen mythe. Het is een initiatie. Een reis door macht… door verlies… door angst… en de illusie van onsterfelijkheid. Wat hier verteld wordt, is het verhaal van de mens zelf. De strijd met het ego. De confrontatie met de schaduw. De zoektocht naar betekenis… in een sterfelijk bestaan. Elke aflevering opent een nieuwe poort. Elke tablet onthult een laag dieper. Tot er niets meer overblijft… behalve waarheid. Vanaf 7 april t/m 2 juni 2026 Elke dinsdag om 19:30 (NL), 13:30 (Curaçao) We ontmoeten elkaar live op het Pikapika-platform (www.facebook.com/pikapikatalkshow/). Om samen… de eerste grote initiatie te betreden.",
      "pap": "E temporada aki... nos ta bai bèk na e komienso. Promé ku religion. Promé ku dogma. Promé ku humanidat a lubidá su mes. Nos ta drenta e historia mas antiguo registrá: e Epopeya di Gilgamesh. Un rei. Un hòmber salbahe. Un amistat ku ta kambia tur kos. Pero esaki no ta un mito. E ta un inisiashon. Un biahe dor di poder, dor di pèrdida, dor di miedu, i e ilushon di inmortalidat. Loke ta wòrdu kontá akinan ta e historia di humanidat mes: e lucha ku ego, e konfrontashon ku e sombra, e buskeda di sentido den un eksistensia mortal. Kada episodio ta habri un porta nobo. Kada tablèt ta revelá un kapa mas profundo, te ku no ta keda nada sino bèrdat. For di 7 di aprel te ku 2 di yüni 2026, tur diamars pa 19:30 (NL), 13:30 (Kòrsou). Nos ta topa na bibo riba e plataforma Pikapika (www.facebook.com/pikapikatalkshow/), pa drenta huntu e promé gran inisiashon."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-promo%3A8?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E0: Het Gilgamesj-Epos - Promo - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-promo%3A8?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Seizoen 6 - Het Gilgamesj-Epos Flyer",
          "es": "Seizoen 6 - Het Gilgamesj-Epos Flyer",
          "nl": "Seizoen 6 - Het Gilgamesj-Epos Flyer",
          "pap": "Seizoen 6 - Het Gilgamesj-Epos Flyer"
        },
        "url": "./images/flyer-eigenpad-seizoen-6.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij",
    "nextEpisode": "legacy-eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 256,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties",
    "slug": {
      "en": "eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties",
      "es": "eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties",
      "nl": "eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties",
      "pap": "eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 71,
    "title": {
      "en": "Eigen Pad S6E1: The Epic of Gilgamesh - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S6E1: La Epopeya de Gilgamesh - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S6E1: E Epopeya di Gilgamesh - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "language": "nl",
    "summary": {
      "en": "What if humanity has learned nothing... because it never understood itself? From world wars to modern chaos, the pattern stays the same. In this first episode of Eigen Pad – Season 6 we open the gate to humanity's oldest epic: Gilgamesh. Not a history lesson. Not a story. But an initiatory mirror: what is a myth really? Why is Gilgamesh older than the Bible? And more importantly: where are you living this story right now? This is the beginning of a journey: from power to loss to search to insight. Every Tuesday LIVE at 19:30 (NL) / 13:30 (CUR).",
      "es": "¿Y si la humanidad no ha aprendido nada... porque nunca se entendió a sí misma? De las guerras mundiales al caos moderno, el patrón sigue siendo el mismo. En este primer episodio de Eigen Pad – Temporada 6 abrimos la puerta a la epopeya más antigua de la humanidad: Gilgamesh. No es una lección de historia. No es un relato. Es un espejo iniciático: ¿qué es realmente un mito? ¿Por qué Gilgamesh es más antiguo que la Biblia? Y más importante: ¿dónde vives tú esta historia ahora mismo? Este es el comienzo de un viaje: del poder a la pérdida, a la búsqueda, a la comprensión. Cada martes EN VIVO a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "Wat als de mens niets geleerd heeft… omdat hij zichzelf nooit heeft begrepen? Van wereldoorlogen tot moderne chaos, het patroon blijft hetzelfde. In deze eerste aflevering van Eigen Pad – Seizoen 6 openen we de poort naar het oudste epos van de mensheid: Gilgamesj. Geen geschiedenisles. Geen verhaal. Maar een initiatieve spiegel: Wat is een mythe werkelijk? Waarom is Gilgamesj ouder dan de Bijbel? En belangrijker: waar leef jij dit verhaal nu? Dit is het begin van een reis: van macht â†’ verlies â†’ zoektocht â†’ inzicht Elke dinsdag LIVE 19:30 (NL) / 13:30 (CUR)",
      "pap": "Kiko si humanidat no a siña nada... pasobra e nunka a komprondé su mes? For di gueranan mundial te ku kaos moderno, e patronchi ta keda mes. Den e promé episodio aki di Eigen Pad – Temporada 6 nos ta habri e porta pa e epopeya mas antiguo di humanidat: Gilgamesh. No ta un lès di historia. No ta un kuenta. Sino un spil inisiátiko: kiko un mito ta di bèrdat? Dikon Gilgamesh ta mas bieu ku Beibel? I mas importante: unda bo ta biba e historia aki awor? Esaki ta e komienso di un biahe: for di poder pa pèrdida pa buskeda pa komprondementu. Tur diamars NA BIBO pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e1%3A9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e1%3A9?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e1.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e0-het-gilgamesj-epos-promo",
    "nextEpisode": "legacy-eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 305,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego",
    "slug": {
      "en": "eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego",
      "es": "eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego",
      "nl": "eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego",
      "pap": "eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 72,
    "title": {
      "en": "Eigen Pad S6E2: The Epic of Gilgamesh | Tablet I - The Ego",
      "es": "Eigen Pad S6E2: La Epopeya de Gilgamesh | Tablilla I - El Ego",
      "nl": "Eigen Pad S6E2: Het Gilgamesj-Epos | Tablet I - Het Ego",
      "pap": "Eigen Pad S6E2: E Epopeya di Gilgamesh | Tablèt I - E Ego"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode of Eigen Pad we dive into Tablet I of the Epic of Gilgamesh and reveal the true nature of the ego. No theory, but a mirror: how power without awareness turns into tyranny, and how this same mechanism lives in every person. This is the first step of transformation: recognizing what rules... before it breaks. Every Tuesday LIVE at 19:30 (NL) / 13:30 (CUR).",
      "es": "En este episodio de Eigen Pad nos adentramos en la Tablilla I de la Epopeya de Gilgamesh y revelamos la verdadera naturaleza del ego. No es teoría, sino un espejo: cómo el poder sin conciencia se convierte en tiranía, y cómo este mismo mecanismo vive en cada persona. Este es el primer paso de la transformación: reconocer lo que gobierna... antes de que se rompa. Cada martes EN VIVO a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "In deze aflevering van Eigen Pad duiken we in Tablet I van het Gilgamesj-epos en onthullen we de ware aard van het ego. Geen theorie, maar een spiegel: hoe macht zonder bewustzijn verandert in tirannie en hoe ditzelfde mechanisme leeft in ieder mens. Dit is de eerste stap van transformatie: herkennen wat regeert… voordat het breekt. Elke dinsdag LIVE 19:30 (NL) / 13:30 (CUR)",
      "pap": "Den e episodio aki di Eigen Pad nos ta sumi den Tablèt I di e Epopeya di Gilgamesh i ta revelá e berdadero naturalesa di ego. No ta teoria, sino un spil: kon poder sin konsenshi ta bira tirania, i kon e mesun mekanismo aki ta biba den kada persona. Esaki ta e promé paso di transformashon: rekonosé kiko ta goberná... promé ku e kibra. Tur diamars NA BIBO pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e2-final%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E2: Het Gilgamesj-Epos | Tablet I - Het Ego - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e2-final%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e2.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties",
    "nextEpisode": "legacy-eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 361,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw",
    "slug": {
      "en": "eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw",
      "es": "eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw",
      "nl": "eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw",
      "pap": "eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 73,
    "title": {
      "en": "Eigen Pad S6E3: The Epic of Gilgamesh | Tablet II - The Shadow",
      "es": "Eigen Pad S6E3: La Epopeya de Gilgamesh | Tablilla II - La Sombra",
      "nl": "Eigen Pad S6E3: Het Gilgamesj-Epos | Tablet II - De Schaduw",
      "pap": "Eigen Pad S6E3: E Epopeya di Gilgamesh | Tablèt II - E Sombra"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode of Eigen Pad we enter Tablet II of the Epic of Gilgamesh — where the shadow appears. Enkidu is not an enemy. He is that which you do not live. We examine the Jungian shadow, the inner split between nature and civilization, and how suppressed parts of yourself inevitably return — through tension, conflict, and crisis. With the Tarot (The Devil) as a mirror, it becomes clear: what you do not see... rules you. This is not theory. This is confrontation. The question is not whether the shadow appears... but when. Every Tuesday LIVE at 19:30 (NL) / 13:30 (CUR).",
      "es": "En este episodio de Eigen Pad entramos en la Tablilla II de la Epopeya de Gilgamesh, donde aparece la sombra. Enkidu no es un enemigo. Es aquello que no vives. Examinamos la sombra junguiana, la división interior entre naturaleza y civilización, y cómo las partes reprimidas de ti mismo inevitablemente regresan, a través de la tensión, el conflicto y la crisis. Con el Tarot (El Diablo) como espejo, queda claro: lo que no ves... te gobierna. Esto no es teoría. Es confrontación. La pregunta no es si la sombra aparece... sino cuándo. Cada martes EN VIVO a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "In deze aflevering van Eigen Pad betreden we Tablet II van het Gilgamesj-epos — waar de schaduw verschijnt. Enkidu is geen vijand. Hij is dat wat jij niet leeft. We onderzoeken de Jungiaanse schaduw, de innerlijke splitsing tussen natuur en beschaving, en hoe onderdrukte delen van jezelf onvermijdelijk terugkeren — via spanning, conflict en crisis. Met de Tarot (De Duivel) als spiegel, wordt duidelijk: wat je niet ziet… beheerst je. Dit is geen theorie. Dit is confrontatie. De vraag is niet óf de schaduw verschijnt… maar wanneer. Elke dinsdag LIVE 19:30 (NL) / 13:30 (CUR)",
      "pap": "Den e episodio aki di Eigen Pad nos ta drenta Tablèt II di e Epopeya di Gilgamesh — kaminda e sombra ta aparesé. Enkidu no ta un enemigu. E ta loke bo no ta biba. Nos ta analisá e sombra Jungiano, e divishon interno entre naturalesa i sivilisashon, i kon partinan suprimí di bo mes ta bòlbe inevitablemente — via tenshon, konflikto i krisis. Ku Tarot (E Diabel) komo spil, ta bira kla: loke bo no ta mira... ta goberná bo. Esaki no ta teoria. Esaki ta konfrontashon. E pregunta no ta SI e sombra ta aparesé... sino ki ora. Tur diamars NA BIBO pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e3-Cover%3Ac?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E3: Het Gilgamesj-Epos | Tablet II - De Schaduw - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e3-Cover%3Ac?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e3.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego",
    "nextEpisode": "legacy-eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 407,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis",
    "slug": {
      "en": "eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis",
      "es": "eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis",
      "nl": "eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis",
      "pap": "eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 74,
    "title": {
      "en": "Eigen Pad S6E4: The Epic of Gilgamesh | Tablets III–IV - The Journey",
      "es": "Eigen Pad S6E4: La Epopeya de Gilgamesh | Tablillas III–IV - El Viaje",
      "nl": "Eigen Pad S6E4: Het Gilgamesj-Epos | Tablet III t/m IV - De Reis",
      "pap": "Eigen Pad S6E4: E Epopeya di Gilgamesh | Tablèt III–IV - E Biahe"
    },
    "language": "nl",
    "summary": {
      "en": "When insight appears... you can no longer stay where you are. In this episode of Eigen Pad we dive into Tablets 3–4 of the Epic of Gilgamesh: the moment the journey begins. The ego has been seen. The shadow has appeared. The tension is palpable. And then... comes the choice. Do you stay where you are? Or do you move into the unknown? This episode is about fear, doubt, and courage; the step into the unknown; why change is inevitable; and the journey as an initiation of consciousness. Not as theory... but as something taking place within you. The journey always comes. The form differs. Voluntary... or forced. Every Tuesday LIVE at 19:30 (NL) / 13:30 (CUR).",
      "es": "Cuando aparece la comprensión... ya no puedes quedarte donde estás. En este episodio de Eigen Pad nos adentramos en las Tablillas 3–4 de la Epopeya de Gilgamesh: el momento en que comienza el viaje. El ego ha sido visto. La sombra ha aparecido. La tensión es palpable. Y entonces... llega la elección. ¿Te quedas donde estás? ¿O avanzas hacia lo desconocido? Este episodio trata del miedo, la duda y el valor; el paso a lo desconocido; por qué el cambio es inevitable; y el viaje como una iniciación de la conciencia. No como teoría... sino como algo que ocurre dentro de ti. El viaje siempre llega. La forma cambia. Voluntario... o forzado. Cada martes EN VIVO a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "Wanneer inzicht verschijnt… kan je niet meer blijven waar je bent. In deze aflevering van Eigen Pad duiken we in Tablet 3–4 van het Gilgamesj-epos: het moment waarop de reis begint.  Ego is gezien  De schaduw is verschenen  De spanning is voelbaar En dan… komt de keuze. Blijf je waar je bent? Of beweeg je het onbekende in? Deze aflevering gaat over: – Angst, twijfel en moed – De stap in het onbekende – Waarom verandering onvermijdelijk is – De reis als initiatie van bewustzijn Niet als theorie… maar als iets dat zich in jou afspeelt. De reis komt altijd. De vorm verschilt. Vrijwillig… of geforceerd. Elke dinsdag LIVE 19:30 (NL) / 13:30 (CUR)",
      "pap": "Ora komprondementu ta aparesé... bo no por keda mas kaminda bo ta. Den e episodio aki di Eigen Pad nos ta sumi den Tablèt 3–4 di e Epopeya di Gilgamesh: e momento ku e biahe ta kuminsá. E ego a wòrdu mirá. E sombra a aparesé. E tenshon ta palpabel. I anto... ta bin e eskoho. Bo ta keda kaminda bo ta? Òf bo ta move den e deskonosí? E episodio aki ta tokante miedu, duda i koral; e paso den e deskonosí; dikon kambio ta inevitabel; i e biahe komo un inisiashon di konsenshi. No komo teoria... sino komo algu ku ta sosodé den bo. E biahe semper ta bin. E forma ta diferensiá. Boluntario... òf forsá. Tur diamars NA BIBO pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e4-final%3A4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E4: Het Gilgamesj-Epos | Tablet III t/m IV - De Reis - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e4-final%3A4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e4.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw",
    "nextEpisode": "legacy-eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 463,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie",
    "slug": {
      "en": "eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie",
      "es": "eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie",
      "nl": "eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie",
      "pap": "eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 75,
    "title": {
      "en": "Eigen Pad S6E5: The Epic of Gilgamesh | Tablet V - The Confrontation",
      "es": "Eigen Pad S6E5: La Epopeya de Gilgamesh | Tablilla V - La Confrontación",
      "nl": "Eigen Pad S6E5: Het Gilgamesj-Epos | Tablet V - De Confrontatie",
      "pap": "Eigen Pad S6E5: E Epopeya di Gilgamesh | Tablèt V - E Konfrontashon"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode of The Epic of Gilgamesh, Gilgamesh and Enkidu reach the forbidden forest of Humbaba. But Humbaba is not just a monster. He represents fear, projection, distorted perception, and the boundary between the known and the unknown. Why do people make their fears bigger than they really are? Why do so many stay stuck in procrastination, doubt, avoidance, and inner paralysis? And more importantly: is every boundary truly an illusion? Or do some boundaries protect something sacred? Tablet 5 — \"The Monster That Does Not Exist... Until You See It\". Every Tuesday LIVE at 19:30 (NL) / 13:30 (CUR).",
      "es": "En este episodio de La Epopeya de Gilgamesh, Gilgamesh y Enkidu llegan al bosque prohibido de Humbaba. Pero Humbaba no es solo un monstruo. Representa el miedo, la proyección, la percepción distorsionada y la frontera entre lo conocido y lo desconocido. ¿Por qué la gente agranda sus miedos más de lo que realmente son? ¿Por qué tantos se quedan atascados en la postergación, la duda, la evasión y la parálisis interior? Y más importante: ¿es toda frontera realmente una ilusión? ¿O algunas fronteras protegen algo sagrado? Tablilla 5 — \"El Monstruo Que No Existe... Hasta Que Lo Ves\". Cada martes EN VIVO a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "In deze aflevering van Het Gilgamesj-Epos bereiken Gilgamesj en Enkidu het verboden woud van Humbaba. Maar Humbaba is niet zomaar een monster. Hij vertegenwoordigt: – angst – projectie – vervormde waarneming – de grens tussen het bekende en het onbekende Waarom maken mensen hun angsten groter dan ze werkelijk zijn? Waarom blijven velen hangen in: – uitstelgedrag – twijfel – vermijden – innerlijke verlamming? En belangrijker: Is elke grens werkelijk een illusie? Of beschermen sommige grenzen iets heiligs? Tablet 5 — “Het Monster Dat Niet Bestaat… Tot Je Het Ziet” Elke dinsdag LIVE 19:30 (NL) / 13:30 (CUR)",
      "pap": "Den e episodio aki di E Epopeya di Gilgamesh, Gilgamesh i Enkidu ta yega e mondi prohibí di Humbaba. Pero Humbaba no ta djis un monster. E ta representá miedu, proyekshon, persepshon distorsioná, i e frontera entre e konosí i e deskonosí. Dikon hende ta hasi nan miedunan mas grandi ku nan ta di bèrdat? Dikon asina tantu hende ta keda pegá den postergashon, duda, evitashon i parálisis interno? I mas importante: tur frontera ta di bèrdat un ilushon? Òf algun frontera ta protehá algu sagrado? Tablèt 5 — \"E Monster Ku No Ta Eksistí... Te Ora Bo Mir'é\". Tur diamars NA BIBO pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e5-final%3Ad?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E5: Het Gilgamesj-Epos | Tablet V - De Confrontatie - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e5-final%3Ad?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e5.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis",
    "nextEpisode": "legacy-eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 533,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing",
    "slug": {
      "en": "eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing",
      "es": "eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing",
      "nl": "eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing",
      "pap": "eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 76,
    "title": {
      "en": "Eigen Pad S6E6: The Epic of Gilgamesh | Tablet VI - Desire and Mastery",
      "es": "Eigen Pad S6E6: La Epopeya de Gilgamesh | Tablilla VI - Deseo y Dominio",
      "nl": "Eigen Pad S6E6: Het Gilgamesj-Epos | Tablet VI - Verlangen en Beheersing",
      "pap": "Eigen Pad S6E6: E Epopeya di Gilgamesh | Tablèt VI - Deseo i Dominio"
    },
    "language": "nl",
    "summary": {
      "en": "What if the greatest test is not fear... but desire? In Tablet 6 of the Epic of Gilgamesh, Ishtar appears — goddess of beauty, seduction, power, and desire. But behind her lies a deeper question: do you master your desires... or do they master you? An episode about sex and seduction; masculine and feminine power; Venus and the Bull of Heaven; instinct and consciousness; the Tarot cards The Lovers and Strength; and the psychology of desire. The fight with Humbaba was external. Now the inner fight begins. Every Tuesday LIVE at 19:30 (NL) / 13:30 (CUR).",
      "es": "¿Y si la mayor prueba no es el miedo... sino el deseo? En la Tablilla 6 de la Epopeya de Gilgamesh aparece Ishtar, diosa de la belleza, la seducción, el poder y el deseo. Pero tras ella hay una pregunta más profunda: ¿dominas tus deseos... o ellos te dominan a ti? Un episodio sobre el sexo y la seducción; el poder masculino y femenino; Venus y el Toro del Cielo; el instinto y la conciencia; las cartas del Tarot Los Enamorados y La Fuerza; y la psicología del deseo. La lucha con Humbaba fue externa. Ahora comienza la lucha interior. Cada martes EN VIVO a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "Wat als de grootste test niet angst is… maar verlangen? In Tablet 6 van het Gilgamesj-epos verschijnt Ishtar — godin van schoonheid, verleiding, macht en verlangen. Maar achter haar schuilt een diepere vraag: Beheers jij jouw verlangens… of beheersen zij jou? Een aflevering over: • seks & verleiding • mannelijke en vrouwelijke kracht • Venus & de Hemelstier • instinct & bewustzijn • Tarot: De Geliefden & Kracht • en de psychologie van verlangen  Het gevecht met Humbaba was extern. Nu begint het gevecht van binnen. #Gilgamesj #Ishtar #Bewustzijn #Psychologie #CarlJung #Tarot #Zelfontwikkeling #Spiritualiteit #Taurus #Venus #SchaduwWerk #EigenPad #Mythologie #InnerlijkWerk #Transformatie Elke dinsdag LIVE 19:30 (NL) / 13:30 (CUR)",
      "pap": "Kiko si e prueba mas grandi no ta miedu... sino deseo? Den Tablèt 6 di e Epopeya di Gilgamesh, Ishtar ta aparesé — diosa di beyesa, sedukshon, poder i deseo. Pero tras di dje tin un pregunta mas profundo: bo ta dominá bo deseonan... òf nan ta dominá bo? Un episodio tokante sèkso i sedukshon; poder maskulino i femenino; Venus i e Toro di Shelu; instinkt i konsenshi; e kartanan di Tarot E Namorá i Forsa; i e sikologia di deseo. E lucha ku Humbaba tabata externo. Awor e lucha interno ta kuminsá. Tur diamars NA BIBO pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e6-final%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E6: Het Gilgamesj-Epos | Tablet VI - Verlangen en Beheersing - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e6-final%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e6.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie",
    "nextEpisode": "legacy-eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 600,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood",
    "slug": {
      "en": "eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood",
      "es": "eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood",
      "nl": "eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood",
      "pap": "eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 77,
    "title": {
      "en": "Eigen Pad S6E7: The Epic of Gilgamesh | Tablet VII - Death",
      "es": "Eigen Pad S6E7: La Epopeya de Gilgamesh | Tablilla VII - La Muerte",
      "nl": "Eigen Pad S6E7: Het Gilgamesj-Epos | Tablet VII - De Dood",
      "pap": "Eigen Pad S6E7: E Epopeya di Gilgamesh | Tablèt VII - Morto"
    },
    "language": "nl",
    "summary": {
      "en": "What happens when a part of yourself dies? In Tablet 7 of the Epic of Gilgamesh, Enkidu dies. Not only is a friend lost... but also a part of Gilgamesh himself. This episode is about loss, grief, the confrontation with mortality, and the breaking apart of the old consciousness. Because sometimes the real search only begins... after everything breaks. Without dying... there is no rebirth. New episode of Eigen Pad: \"The Death of Enkidu\". Every Tuesday LIVE at 19:30 (NL) / 13:30 (CUR).",
      "es": "¿Qué ocurre cuando una parte de ti mismo muere? En la Tablilla 7 de la Epopeya de Gilgamesh, Enkidu muere. No solo se pierde un amigo... sino también una parte del propio Gilgamesh. Este episodio trata de la pérdida, el duelo, la confrontación con la mortalidad y la disolución de la vieja conciencia. Porque a veces la verdadera búsqueda solo comienza... después de que todo se rompe. Sin morir... no hay renacimiento. Nuevo episodio de Eigen Pad: \"La Muerte de Enkidu\". Cada martes EN VIVO a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "Wat gebeurt er wanneer een deel van jezelf sterft? In Tablet 7 van het Gilgamesj-epos sterft Enkidu. Niet alleen een vriend gaat verloren… maar ook een deel van Gilgamesj zelf. Deze aflevering gaat over: – verlies – rouw – confrontatie met sterfelijkheid – en het uiteenvallen van het oude bewustzijn Want soms begint de echte zoektocht pas… nadat alles breekt. Zonder sterven… geen wedergeboorte. Nieuwe aflevering van Eigen Pad: “De Dood van Enkidu” #Gilgamesj #bewustzijn #zelfontwikkeling #psychologie #CarlJung #rouw #transformatie #persoonlijkegroei #innerlijkwerk #tarot #DeDood #mythologie #EigenPad Elke dinsdag LIVE 19:30 (NL) / 13:30 (CUR)",
      "pap": "Kiko ta sosodé ora un parti di bo mes ta muri? Den Tablèt 7 di e Epopeya di Gilgamesh, Enkidu ta muri. No solamente un amigu ta pèrdè... sino tambe un parti di Gilgamesh mes. E episodio aki ta tokante pèrdida, rou, e konfrontashon ku mortalidat, i e kibramentu di e bieu konsenshi. Pasobra tin biaha e berdadero buskeda ta kuminsá solamente... despues ku tur kos kibra. Sin muri... no tin nasementu nobo. Episodio nobo di Eigen Pad: \"E Morto di Enkidu\". Tur diamars NA BIBO pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e7-final%3A4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E7: Het Gilgamesj-Epos | Tablet VII - De Dood - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e7-final%3A4?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e7.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing",
    "nextEpisode": "legacy-eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-terugkeer",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 657,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-terugkeer",
    "slug": {
      "en": "eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-te",
      "es": "eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-te",
      "nl": "eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-te",
      "pap": "eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-te"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 78,
    "title": {
      "en": "Eigen Pad S6E8: The Epic of Gilgamesh | Tablets VIII–XII - The Quest and the Return",
      "es": "Eigen Pad S6E8: La Epopeya de Gilgamesh | Tablillas VIII–XII - La Búsqueda y el Regreso",
      "nl": "Eigen Pad S6E8: Het Gilgamesj-Epos | Tablet VIII t/m XII - De Zoektocht en Terugkeer",
      "pap": "Eigen Pad S6E8: E Epopeya di Gilgamesh | Tablèt VIII–XII - E Buskeda i e Bòlbementu"
    },
    "language": "nl",
    "summary": {
      "en": "The Illusion of Eternal Existence. After the death of Enkidu, Gilgamesh sets out on humanity's oldest quest: can the human being escape death? In this final episode we follow his journey to Utnapishtim, the plant of life, the serpent, and the ultimate discovery that no hero, king, or seeker can evade Natural Law. From Ego to Wisdom. From Quest to Acceptance. The question is not \"How do I become immortal?\" but \"Why can I not accept my mortality?\" Season finale of The Epic of Gilgamesh. Next season: The 12 Laws of the NtRW. Live every Tuesday at 19:30 (NL) / 13:30 (CUR).",
      "es": "La Ilusión de la Existencia Eterna. Tras la muerte de Enkidu, Gilgamesh emprende la búsqueda más antigua de la humanidad: ¿puede el ser humano escapar de la muerte? En este episodio final seguimos su viaje hacia Utnapishtim, la planta de la vida, la serpiente y el descubrimiento final de que ningún héroe, rey o buscador puede eludir la Ley Natural. Del Ego a la Sabiduría. De la Búsqueda a la Aceptación. La pregunta no es \"¿Cómo me vuelvo inmortal?\" sino \"¿Por qué no puedo aceptar mi mortalidad?\". Final de temporada de La Epopeya de Gilgamesh. Próxima temporada: Las 12 Leyes de los NtRW. En vivo cada martes a las 19:30 (NL) / 13:30 (CUR).",
      "nl": "De Illusie van Eeuwig Bestaan. Na de dood van Enkidu begint Gilgamesj aan de oudste zoektocht van de mensheid: kan de mens ontsnappen aan de dood? In deze laatste aflevering volgen we zijn reis naar Utnapishtim, de plant van het leven, de slang, en de uiteindelijke ontdekking dat geen held, koning of zoeker de Natuurwetten kan ontwijken. Van Ego naar Wijsheid. Van Zoektocht naar Acceptatie. De vraag is niet \"Hoe word ik onsterfelijk?\" maar \"Waarom kan ik mijn sterfelijkheid niet accepteren?\" Seizoensfinale van Het Gilgamesj-Epos. Volgend seizoen: De 12 Wetten van de NtRW. Elke dinsdag live om 19:30 (NL) / 13:30 (CUR).",
      "pap": "E Ilushon di Eksistensia Eterno. Despues di e morto di Enkidu, Gilgamesh ta kuminsá e buskeda mas antiguo di humanidat: e ser humano por skapa for di morto? Den e episodio final aki nos ta sigui su biahe na Utnapishtim, e mata di bida, e kolebra, i e deskubrimentu final ku ningun héroe, rei òf buskadó por evitá Lei Natural. For di Ego pa Sabiduria. For di Buskeda pa Aseptashon. E pregunta no ta \"Kon mi ta bira inmortal?\" sino \"Dikon mi no por aseptá mi mortalidat?\". Final di temporada di E Epopeya di Gilgamesh. Siguiente temporada: E 12 Leinan di e NtRW. Na bibo tur diamars pa 19:30 (NL) / 13:30 (CUR)."
    },
    "videoUrl": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e8-final%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/gilgamesh.png",
    "imageAlt": "Eigen Pad S6E8: Het Gilgamesj-Epos | Tablet VIII t/m XII - De Zoektocht en Terugkeer - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/%24/embed/%40TGWE%3A0%2Fhet-gilgamesj-epos-s6e8-final%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s6/het-gilgamesj-epos-s6e8.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (EN)",
          "es": "Gilgamesh (EN)",
          "nl": "Gilgamesh (EN)",
          "pap": "Gilgamesh (EN)"
        },
        "url": "./media/s6/gilgamesh-en.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gilgamesh (NL)",
          "es": "Gilgamesh (NL)",
          "nl": "Gilgamesh (NL)",
          "pap": "Gilgamesh (NL)"
        },
        "url": "./media/s6/gilgamesh-nl.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood",
    "nextEpisode": "legacy-pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-7.html",
      "sourceLine": 721,
      "kind": "media",
      "image": "images/gilgamesh.png"
    }
  },
  {
    "id": "legacy-pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe",
    "slug": {
      "en": "pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe",
      "es": "pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe",
      "nl": "pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe",
      "pap": "pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 79,
    "title": {
      "en": "Pika Pika Talkshow - Why Do These Things Keep Happening To Me",
      "es": "Pika Pika Talkshow - Por Qué Me Siguen Pasando Estas Cosas",
      "nl": "Pika Pika Talkshow - Waarom Overkomen Mij Deze Dingen Steeds",
      "pap": "Pika Pika Talkshow - Dikon e Kosnan Aki ta Pasa mi Atrobe"
    },
    "language": "en",
    "summary": {
      "en": "A Pika Pika Talkshow episode (in Papiamentu) on why the same hardships keep returning in our lives.",
      "es": "Un episodio del Pika Pika Talkshow (en papiamento) sobre por qué las mismas dificultades vuelven una y otra vez a nuestra vida.",
      "nl": "Een Pika Pika Talkshow-aflevering (in het Papiaments) over waarom dezelfde tegenslagen steeds terugkeren in ons leven.",
      "pap": "Un episodio di Pika Pika Talkshow (na papiamentu) tokante dikon e mesun difikultatnan ta sigui bòlbe den nos bida."
    },
    "videoUrl": "/assets/media/pika-pika/pika-pika-dikon-e-kosnan-aki-ta-pasa-mi-atrobe.mp4",
    "audioUrl": null,
    "image": "/assets/images/pika.png",
    "imageAlt": "Pika Pika Talkshow - Dikon e Kosnan Aki ta Pasa mi Atrobe - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Pika Pika Talkshow",
          "es": "Pika Pika Talkshow",
          "nl": "Pika Pika Talkshow",
          "pap": "Pika Pika Talkshow"
        },
        "url": "https://fb.watch/4PcpppY3ti/",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-terugkeer",
    "nextEpisode": "legacy-pika-pika-talkshow-kortamentu-di-orea-i-adulterio",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-pika.html",
      "sourceLine": 195,
      "kind": "media",
      "image": "images/pika.png"
    }
  },
  {
    "id": "legacy-pika-pika-talkshow-kortamentu-di-orea-i-adulterio",
    "slug": {
      "en": "pika-pika-talkshow-kortamentu-di-orea-i-adulterio",
      "es": "pika-pika-talkshow-kortamentu-di-orea-i-adulterio",
      "nl": "pika-pika-talkshow-kortamentu-di-orea-i-adulterio",
      "pap": "pika-pika-talkshow-kortamentu-di-orea-i-adulterio"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 80,
    "title": {
      "en": "Pika Pika Talkshow - Ear-Cutting and Adultery",
      "es": "Pika Pika Talkshow - El Corte de Orejas y el Adulterio",
      "nl": "Pika Pika Talkshow - Het Afsnijden van Oren en Overspel",
      "pap": "Pika Pika Talkshow - Kòrtamentu di Orea i Adulterio"
    },
    "language": "en",
    "summary": {
      "en": "A Pika Pika Talkshow episode (in Papiamentu) on ear-cutting and adultery.",
      "es": "Un episodio del Pika Pika Talkshow (en papiamento) sobre el corte de orejas y el adulterio.",
      "nl": "Een Pika Pika Talkshow-aflevering (in het Papiaments) over het afsnijden van oren en overspel.",
      "pap": "Un episodio di Pika Pika Talkshow (na papiamentu) tokante kòrtamentu di orea i adulterio."
    },
    "videoUrl": "/assets/media/pika-pika/pika-pika-kortamentu-di-orea-i-adulterio.mp4",
    "audioUrl": null,
    "image": "/assets/images/pika.png",
    "imageAlt": "Pika Pika Talkshow - Kòrtamentu di Orea i Adulterio - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Pika Pika Talkshow",
          "es": "Pika Pika Talkshow",
          "nl": "Pika Pika Talkshow",
          "pap": "Pika Pika Talkshow"
        },
        "url": "https://fb.watch/5i_WrNryk7/",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-pika-pika-talkshow-dikon-e-kosnan-aki-ta-pasa-mi-atrobe",
    "nextEpisode": "legacy-pika-pika-talkshow-reenkarnashon-ta-eksisti",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-pika.html",
      "sourceLine": 213,
      "kind": "media",
      "image": "images/pika.png"
    }
  },
  {
    "id": "legacy-pika-pika-talkshow-reenkarnashon-ta-eksisti",
    "slug": {
      "en": "pika-pika-talkshow-reenkarnashon-ta-eksisti",
      "es": "pika-pika-talkshow-reenkarnashon-ta-eksisti",
      "nl": "pika-pika-talkshow-reenkarnashon-ta-eksisti",
      "pap": "pika-pika-talkshow-reenkarnashon-ta-eksisti"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 81,
    "title": {
      "en": "Pika Pika Talkshow - Does Reincarnation Exist?",
      "es": "Pika Pika Talkshow - ¿Existe la Reencarnación?",
      "nl": "Pika Pika Talkshow - Bestaat Reïncarnatie?",
      "pap": "Pika Pika Talkshow - Reenkarnáshon ta eksisti?"
    },
    "language": "en",
    "summary": {
      "en": "A Pika Pika Talkshow episode (in Papiamentu) asking whether reincarnation exists.",
      "es": "Un episodio del Pika Pika Talkshow (en papiamento) que pregunta si existe la reencarnación.",
      "nl": "Een Pika Pika Talkshow-aflevering (in het Papiaments) met de vraag of reïncarnatie bestaat.",
      "pap": "Un episodio di Pika Pika Talkshow (na papiamentu) ku ta puntra si reenkarnashon ta eksistí."
    },
    "videoUrl": "/assets/media/pika-pika/pika-pika-reenkarnashon-ta-eksisti.mp4",
    "audioUrl": null,
    "image": "/assets/images/pika.png",
    "imageAlt": "Pika Pika Talkshow - Reenkarnáshon ta eksisti? - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Pika Pika Talkshow",
          "es": "Pika Pika Talkshow",
          "nl": "Pika Pika Talkshow",
          "pap": "Pika Pika Talkshow"
        },
        "url": "https://fb.watch/88_rPMzsjz/",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-pika-pika-talkshow-kortamentu-di-orea-i-adulterio",
    "nextEpisode": "legacy-pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-pika.html",
      "sourceLine": 231,
      "kind": "media",
      "image": "images/pika.png"
    }
  },
  {
    "id": "legacy-pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi",
    "slug": {
      "en": "pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi",
      "es": "pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi",
      "nl": "pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi",
      "pap": "pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 82,
    "title": {
      "en": "Pika Pika Talkshow - Why Can't I Find a Decent Man",
      "es": "Pika Pika Talkshow - Por Qué No Encuentro un Buen Hombre",
      "nl": "Pika Pika Talkshow - Waarom Kan Ik Geen Fatsoenlijke Man Vinden",
      "pap": "Pika Pika Talkshow - Dikon Mi No Por Hanja Un Homber Na Drechi"
    },
    "language": "en",
    "summary": {
      "en": "A Pika Pika Talkshow episode (in Papiamentu) on why finding a good partner can feel so hard.",
      "es": "Un episodio del Pika Pika Talkshow (en papiamento) sobre por qué encontrar una buena pareja puede resultar tan difícil.",
      "nl": "Een Pika Pika Talkshow-aflevering (in het Papiaments) over waarom een goede partner vinden zo moeilijk kan voelen.",
      "pap": "Un episodio di Pika Pika Talkshow (na papiamentu) tokante dikon haña un bon kompañero por ta asina difísil."
    },
    "videoUrl": "/assets/media/pika-pika/pika-pika-dikon-mi-no-por-hanja-un-homber-na-drechi.mp4",
    "audioUrl": null,
    "image": "/assets/images/pika.png",
    "imageAlt": "Pika Pika Talkshow - Dikon Mi No Por Hanja Un Homber Na Drechi - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Pika Pika Talkshow",
          "es": "Pika Pika Talkshow",
          "nl": "Pika Pika Talkshow",
          "pap": "Pika Pika Talkshow"
        },
        "url": "https://fb.watch/9hn44q_GAH/",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-pika-pika-talkshow-reenkarnashon-ta-eksisti",
    "nextEpisode": "legacy-pika-pika-talkshow-euthanasia",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-pika.html",
      "sourceLine": 249,
      "kind": "media",
      "image": "images/pika.png"
    }
  },
  {
    "id": "legacy-pika-pika-talkshow-euthanasia",
    "slug": {
      "en": "pika-pika-talkshow-euthanasia",
      "es": "pika-pika-talkshow-euthanasia",
      "nl": "pika-pika-talkshow-euthanasia",
      "pap": "pika-pika-talkshow-euthanasia"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 83,
    "title": {
      "en": "Pika Pika Talkshow - Euthanasia",
      "es": "Pika Pika Talkshow - Eutanasia",
      "nl": "Pika Pika Talkshow - Euthanasie",
      "pap": "Pika Pika Talkshow - Euthanasia"
    },
    "language": "en",
    "summary": {
      "en": "A Pika Pika Talkshow episode (in Papiamentu) on euthanasia.",
      "es": "Un episodio del Pika Pika Talkshow (en papiamento) sobre la eutanasia.",
      "nl": "Een Pika Pika Talkshow-aflevering (in het Papiaments) over euthanasie.",
      "pap": "Un episodio di Pika Pika Talkshow (na papiamentu) tokante eutanasia."
    },
    "videoUrl": "/assets/media/pika-pika/pika-pika-euthanasia.mp4",
    "audioUrl": null,
    "image": "/assets/images/pika.png",
    "imageAlt": "Pika Pika Talkshow - Euthanasia - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Pika Pika Talkshow",
          "es": "Pika Pika Talkshow",
          "nl": "Pika Pika Talkshow",
          "pap": "Pika Pika Talkshow"
        },
        "url": "https://fb.watch/gO1l9T5a2L/",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-pika-pika-talkshow-dikon-mi-no-por-hanja-un-homber-na-drechi",
    "nextEpisode": "legacy-pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-pika.html",
      "sourceLine": 267,
      "kind": "media",
      "image": "images/pika.png"
    }
  },
  {
    "id": "legacy-pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko",
    "slug": {
      "en": "pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko",
      "es": "pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko",
      "nl": "pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko",
      "pap": "pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 84,
    "title": {
      "en": "Pika Pika Talkshow - What Is a Satanic Cult to You?",
      "es": "Pika Pika Talkshow - ¿Qué Es para Ti una Secta Satánica?",
      "nl": "Pika Pika Talkshow - Wat Is Een Satanische Sekte Voor Jou?",
      "pap": "Pika Pika Talkshow - Kiko pabo ta sekta sataniko?"
    },
    "language": "en",
    "summary": {
      "en": "A Pika Pika Talkshow episode (in Papiamentu) asking what a satanic cult really is.",
      "es": "Un episodio del Pika Pika Talkshow (en papiamento) que pregunta qué es realmente una secta satánica.",
      "nl": "Een Pika Pika Talkshow-aflevering (in het Papiaments) met de vraag wat een satanische sekte werkelijk is.",
      "pap": "Un episodio di Pika Pika Talkshow (na papiamentu) ku ta puntra kiko ta un sekta sataniko di bèrdat."
    },
    "videoUrl": "/assets/media/pika-pika/pika-pika-kiko-pabo-ta-sekta-sataniko.mp4",
    "audioUrl": null,
    "image": "/assets/images/pika.png",
    "imageAlt": "Pika Pika Talkshow - Kiko pabo ta sekta sataniko? - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Pika Pika Talkshow",
          "es": "Pika Pika Talkshow",
          "nl": "Pika Pika Talkshow",
          "pap": "Pika Pika Talkshow"
        },
        "url": "https://fb.watch/gO1l9T5a2L/",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/de-facto-satanism.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-pika-pika-talkshow-euthanasia",
    "nextEpisode": "legacy-nothing-new-under-the-sun-interviewed-by-jonathan-wright-english",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-pika.html",
      "sourceLine": 289,
      "kind": "media",
      "image": "images/pika.png"
    }
  },
  {
    "id": "legacy-nothing-new-under-the-sun-interviewed-by-jonathan-wright-english",
    "slug": {
      "en": "nothing-new-under-the-sun-interviewed-by-jonathan-wright-english",
      "es": "nothing-new-under-the-sun-interviewed-by-jonathan-wright-english",
      "nl": "nothing-new-under-the-sun-interviewed-by-jonathan-wright-english",
      "pap": "nothing-new-under-the-sun-interviewed-by-jonathan-wright-english"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 85,
    "title": {
      "en": "Nothing New Under The Sun - Interviewed by Jonathan Wright (English)",
      "es": "Nothing New Under The Sun - Entrevistado por Jonathan Wright (inglés)",
      "nl": "Nothing New Under The Sun - Geïnterviewd door Jonathan Wright (Engels)",
      "pap": "Nothing New Under The Sun - Entrevistá pa Jonathan Wright (ingles)"
    },
    "language": "en",
    "summary": {
      "en": "This is a great discussion with my friend Jonathan Wright, a podcaster from the US, where we discussed topics such as the Archons and the Nag Hammadi writings, as well as the nature of the matrix we find ourselves in. We discuss ways to live with as little damage as possible and ways to live in harmony with nature and with each other. Towards the end, as usual, there is great music.",
      "es": "Esta es una excelente conversación con mi amigo Jonathan Wright, un podcaster de EE. UU., en la que hablamos de temas como los Arcontes y los escritos de Nag Hammadi, así como de la naturaleza de la matrix en la que nos encontramos. Hablamos de formas de vivir con el menor daño posible y de vivir en armonía con la naturaleza y entre nosotros. Hacia el final, como de costumbre, hay buena música.",
      "nl": "Dit is een geweldig gesprek met mijn vriend Jonathan Wright, een podcaster uit de VS, waarin we onderwerpen bespraken zoals de Archonten en de Nag Hammadi-geschriften, evenals de aard van de matrix waarin we ons bevinden. We bespreken manieren om met zo min mogelijk schade te leven en manieren om in harmonie met de natuur en met elkaar te leven. Tegen het einde is er, zoals gebruikelijk, geweldige muziek.",
      "pap": "Esaki ta un kòmbersashon ekselente ku mi amigu Jonathan Wright, un podcaster di Merka, kaminda nos a papia di tópikonan manera e Arkontenan i e skrituranan di Nag Hammadi, i tambe e naturalesa di e matrix den kua nos ta. Nos ta papia di maneranan pa biba ku mas tiki daño posibel i pa biba na armonia ku naturalesa i ku otro. Na fin, manera di kustumber, tin músika bunita."
    },
    "videoUrl": "https://odysee.com/$/embed/nothing-new-under-the-sun/7d2081d0c13d6a4bd1e66ceab55e19fb4b261ef5?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/Perichoresis-Sigil.png",
    "imageAlt": "Nothing New Under The Sun - Interviewed by Jonathan Wright (English) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/nothing-new-under-the-sun/7d2081d0c13d6a4bd1e66ceab55e19fb4b261ef5?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "The Kybalion (audio/video)",
          "es": "The Kybalion (audio/video)",
          "nl": "The Kybalion (audio/video)",
          "pap": "The Kybalion (audio/video)"
        },
        "url": "https://youtu.be/aL43l2SFVWQ",
        "type": "video"
      },
      {
        "label": {
          "en": "The Kybalion (e-book)",
          "es": "The Kybalion (e-book)",
          "nl": "The Kybalion (e-book)",
          "pap": "The Kybalion (e-book)"
        },
        "url": "/media/Kybalion.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Jonathan Wright's Bitchute Channel",
          "es": "Jonathan Wright's Bitchute Channel",
          "nl": "Jonathan Wright's Bitchute Channel",
          "pap": "Jonathan Wright's Bitchute Channel"
        },
        "url": "https://bitchute.com/nothingnewunderthesun/",
        "type": "video"
      },
      {
        "label": {
          "en": "Jonathan Wright's Youtube Channel",
          "es": "Jonathan Wright's Youtube Channel",
          "nl": "Jonathan Wright's Youtube Channel",
          "pap": "Jonathan Wright's Youtube Channel"
        },
        "url": "https://www.youtube.com/channel/UCGhUJj4zE0qfyd8jccrVFhA",
        "type": "video"
      },
      {
        "label": {
          "en": "Jonathan Wright's Odysee Channel",
          "es": "Jonathan Wright's Odysee Channel",
          "nl": "Jonathan Wright's Odysee Channel",
          "pap": "Jonathan Wright's Odysee Channel"
        },
        "url": "https://odysee.com/@NothingNewUnderTheSun:2?r=6R9w3UbtFdN2Q3AkJmkYE8CjHV7npveN",
        "type": "video"
      },
      {
        "label": {
          "en": "Jonathan Wright's Rumble Channel",
          "es": "Jonathan Wright's Rumble Channel",
          "nl": "Jonathan Wright's Rumble Channel",
          "pap": "Jonathan Wright's Rumble Channel"
        },
        "url": "https://rumble.com/c/c-1083871",
        "type": "external"
      },
      {
        "label": {
          "en": "Jonathan Wright's Flote Channel",
          "es": "Jonathan Wright's Flote Channel",
          "nl": "Jonathan Wright's Flote Channel",
          "pap": "Jonathan Wright's Flote Channel"
        },
        "url": "https://flote.app/user/JonathanWright93",
        "type": "external"
      },
      {
        "label": {
          "en": "Jonathan Wright's Apple Podcasts Channel",
          "es": "Jonathan Wright's Apple Podcasts Channel",
          "nl": "Jonathan Wright's Apple Podcasts Channel",
          "pap": "Jonathan Wright's Apple Podcasts Channel"
        },
        "url": "https://podcasts.apple.com/us/podcast/nothing-new-under-the-sun/id1603949386",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko",
    "nextEpisode": "legacy-interviewed-by-axel-dahi-english",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 197,
      "kind": "media",
      "image": "images/Perichoresis-Sigil.png"
    }
  },
  {
    "id": "legacy-interviewed-by-axel-dahi-english",
    "slug": {
      "en": "interviewed-by-axel-dahi-english",
      "es": "interviewed-by-axel-dahi-english",
      "nl": "interviewed-by-axel-dahi-english",
      "pap": "interviewed-by-axel-dahi-english"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 86,
    "title": {
      "en": "Interviewed by Axel Dahi (English)",
      "es": "Entrevistado por Axel Dahi (inglés)",
      "nl": "Geïnterviewd door Axel Dahi (Engels)",
      "pap": "Entrevistá pa Axel Dahi (ingles)"
    },
    "language": "en",
    "summary": {
      "en": "An interesting conversation with Axel Dahi. Topics such as anarchy, spirituality, religion, politics, and morality are being discussed also in the context of current events.",
      "es": "Una conversación interesante con Axel Dahi. Se tratan temas como la anarquía, la espiritualidad, la religión, la política y la moralidad, también en el contexto de la actualidad.",
      "nl": "Een interessant gesprek met Axel Dahi. Onderwerpen als anarchie, spiritualiteit, religie, politiek en moraliteit komen aan bod, ook in de context van de actualiteit.",
      "pap": "Un kòmbersashon interesante ku Axel Dahi. Tópikonan manera anarkia, spiritualidat, religion, polítika i moralidat ta wòrdu tratá, tambe den e konteksto di aktualidat."
    },
    "videoUrl": "https://odysee.com/$/embed/interview-with-axel-dahi/111c2c08bfea0be5a0738401b744f86185b04199?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/TGW_logo_def.png",
    "imageAlt": "Interviewed by Axel Dahi (English) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/interview-with-axel-dahi/111c2c08bfea0be5a0738401b744f86185b04199?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Axel Dahi's Bitchute Channel",
          "es": "Axel Dahi's Bitchute Channel",
          "nl": "Axel Dahi's Bitchute Channel",
          "pap": "Axel Dahi's Bitchute Channel"
        },
        "url": "https://www.bitchute.com/channel/YNQebN9ptQND/",
        "type": "video"
      },
      {
        "label": {
          "en": "Axel Dahi's Youtube Channel",
          "es": "Axel Dahi's Youtube Channel",
          "nl": "Axel Dahi's Youtube Channel",
          "pap": "Axel Dahi's Youtube Channel"
        },
        "url": "https://youtube.com/channel/UC8UhDBbLB2ts_ymKefop_ZQ",
        "type": "video"
      },
      {
        "label": {
          "en": "Axel Dahi's Odysee Channel",
          "es": "Axel Dahi's Odysee Channel",
          "nl": "Axel Dahi's Odysee Channel",
          "pap": "Axel Dahi's Odysee Channel"
        },
        "url": "https://odysee.com/@AxelDahi:5",
        "type": "video"
      }
    ],
    "previousEpisode": "legacy-nothing-new-under-the-sun-interviewed-by-jonathan-wright-english",
    "nextEpisode": "legacy-interviewed-by-nicholas-peter-urgero-english",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 244,
      "kind": "media",
      "image": "images/TGW_logo_def.png"
    }
  },
  {
    "id": "legacy-interviewed-by-nicholas-peter-urgero-english",
    "slug": {
      "en": "interviewed-by-nicholas-peter-urgero-english",
      "es": "interviewed-by-nicholas-peter-urgero-english",
      "nl": "interviewed-by-nicholas-peter-urgero-english",
      "pap": "interviewed-by-nicholas-peter-urgero-english"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 87,
    "title": {
      "en": "Interviewed by Nicholas Peter Urgero (English)",
      "es": "Entrevistado por Nicholas Peter Urgero (inglés)",
      "nl": "Geïnterviewd door Nicholas Peter Urgero (Engels)",
      "pap": "Entrevistá pa Nicholas Peter Urgero (ingles)"
    },
    "language": "en",
    "summary": {
      "en": "An interesting conversation with Nicholas Peter Urgero. Topics such as anarchy, spirituality, religion, politics, and morality are being discussed also in the context of current events.",
      "es": "Una conversación interesante con Nicholas Peter Urgero. Se tratan temas como la anarquía, la espiritualidad, la religión, la política y la moralidad, también en el contexto de la actualidad.",
      "nl": "Een interessant gesprek met Nicholas Peter Urgero. Onderwerpen als anarchie, spiritualiteit, religie, politiek en moraliteit komen aan bod, ook in de context van de actualiteit.",
      "pap": "Un kòmbersashon interesante ku Nicholas Peter Urgero. Tópikonan manera anarkia, spiritualidat, religion, polítika i moralidat ta wòrdu tratá, tambe den e konteksto di aktualidat."
    },
    "videoUrl": "https://odysee.com/$/embed/Interviewed-by-nicholas-peter-urgero/21a1b6534997e2eb90eedaa81ac8f7e2f20ab805?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/photo_2022-09-18_18-05-47.jpg",
    "imageAlt": "Interviewed by Nicholas Peter Urgero (English) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/Interviewed-by-nicholas-peter-urgero/21a1b6534997e2eb90eedaa81ac8f7e2f20ab805?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's Bitchute Channel",
          "es": "Nicholas Peter Urgero's Bitchute Channel",
          "nl": "Nicholas Peter Urgero's Bitchute Channel",
          "pap": "Nicholas Peter Urgero's Bitchute Channel"
        },
        "url": "https://www.bitchute.com/channel/1VmB8q7FsAiI/",
        "type": "video"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's Instagram Channel",
          "es": "Nicholas Peter Urgero's Instagram Channel",
          "nl": "Nicholas Peter Urgero's Instagram Channel",
          "pap": "Nicholas Peter Urgero's Instagram Channel"
        },
        "url": "https://www.instagram.com/nicholas_peter92/",
        "type": "external"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's Flote Channel",
          "es": "Nicholas Peter Urgero's Flote Channel",
          "nl": "Nicholas Peter Urgero's Flote Channel",
          "pap": "Nicholas Peter Urgero's Flote Channel"
        },
        "url": "https://flote.app/user/NicholasPeterUrgero",
        "type": "external"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's Odysee Channel",
          "es": "Nicholas Peter Urgero's Odysee Channel",
          "nl": "Nicholas Peter Urgero's Odysee Channel",
          "pap": "Nicholas Peter Urgero's Odysee Channel"
        },
        "url": "https://odysee.com/@NicholasPeter:9/My-Video:5f",
        "type": "video"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's YouTube Channel",
          "es": "Nicholas Peter Urgero's YouTube Channel",
          "nl": "Nicholas Peter Urgero's YouTube Channel",
          "pap": "Nicholas Peter Urgero's YouTube Channel"
        },
        "url": "https://www.youtube.com/channel/UCZltMW_HZftOTjBMbVtBVFg",
        "type": "video"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's Twitter Channel",
          "es": "Nicholas Peter Urgero's Twitter Channel",
          "nl": "Nicholas Peter Urgero's Twitter Channel",
          "pap": "Nicholas Peter Urgero's Twitter Channel"
        },
        "url": "https://twitter.com/nickurgero",
        "type": "external"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's Minds Channel",
          "es": "Nicholas Peter Urgero's Minds Channel",
          "nl": "Nicholas Peter Urgero's Minds Channel",
          "pap": "Nicholas Peter Urgero's Minds Channel"
        },
        "url": "https://www.minds.com/NicholasPeter/",
        "type": "external"
      },
      {
        "label": {
          "en": "Nicholas Peter Urgero's Linktree Channel",
          "es": "Nicholas Peter Urgero's Linktree Channel",
          "nl": "Nicholas Peter Urgero's Linktree Channel",
          "pap": "Nicholas Peter Urgero's Linktree Channel"
        },
        "url": "https://linktr.ee/nicholaspeterurgero",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-interviewed-by-axel-dahi-english",
    "nextEpisode": "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 279,
      "kind": "media",
      "image": "images/photo_2022-09-18_18-05-47.jpg"
    }
  },
  {
    "id": "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2",
    "slug": {
      "en": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2",
      "es": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2",
      "nl": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2",
      "pap": "het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 88,
    "title": {
      "en": "The Occult Revealed: Back To The Source - Part 1 (Dutch)",
      "es": "Lo Oculto Revelado: De Vuelta A La Fuente - Parte 1 (neerlandés)",
      "nl": "Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch)",
      "pap": "E Okulto Revelá: Bèk Na E Fuente - Parti 1 (hulandes)"
    },
    "language": "nl",
    "summary": {
      "en": "This presentation discusses the most common occult traditions of our time. First the occult is treated in general. Then a broad overview of their teachings is given, and finally the symbols they use.",
      "es": "Esta presentación trata las tradiciones ocultas más comunes de nuestro tiempo. Primero se aborda lo oculto en general. Luego se ofrece un panorama general de sus enseñanzas y, por último, los símbolos que utilizan.",
      "nl": "In deze presentatie worden de meest voorkomende occulte tradities van onze tijd besproken. Ten eerste wordt het occulte in het algemeen behandeld. Vervolgens wordt een algemeen overzicht van hun leringen besproken en tot slot de symbolen die worden gebruikt.",
      "pap": "E presentashon aki ta trata e tradishonnan okulto di mas komun di nos tempu. Promé ta trata e okulto en general. Despues ta duna un bista general di nan siñansanan i finalmente e símbolonan ku nan ta usa."
    },
    "videoUrl": "https://odysee.com/$/embed/het-occulte-onthuld-deel-1/685eb5a15d3cf6ef89837f48d1935d72c9e68dd3?",
    "audioUrl": null,
    "image": "/assets/images/img0.png",
    "imageAlt": "Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/het-occulte-onthuld-deel-1/685eb5a15d3cf6ef89837f48d1935d72c9e68dd3?",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 1 - Sheets (pdf)",
          "es": "Het Occulte Onthuld Deel 1 - Sheets (pdf)",
          "nl": "Het Occulte Onthuld Deel 1 - Sheets (pdf)",
          "pap": "Het Occulte Onthuld Deel 1 - Sheets (pdf)"
        },
        "url": "/media/het-occulte-onthuld-deel-1.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 1 - Sheets (zip)",
          "es": "Het Occulte Onthuld Deel 1 - Sheets (zip)",
          "nl": "Het Occulte Onthuld Deel 1 - Sheets (zip)",
          "pap": "Het Occulte Onthuld Deel 1 - Sheets (zip)"
        },
        "url": "/media/het-occulte-onthuld-deel-1.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Tijdlijn van Religies",
          "es": "Tijdlijn van Religies",
          "nl": "Tijdlijn van Religies",
          "pap": "Tijdlijn van Religies"
        },
        "url": "./images/religions-chart.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-interviewed-by-nicholas-peter-urgero-english",
    "nextEpisode": "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 329,
      "kind": "media",
      "image": "images/img0.png"
    }
  },
  {
    "id": "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2",
    "slug": {
      "en": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2",
      "es": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2",
      "nl": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2",
      "pap": "het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 89,
    "title": {
      "en": "The Occult Revealed: Dark Occultism (Satanism) - Part 2 (Dutch)",
      "es": "Lo Oculto Revelado: Ocultismo Oscuro (Satanismo) - Parte 2 (neerlandés)",
      "nl": "Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch)",
      "pap": "E Okulto Revelá: Okultismo Skur (Satanismo) - Parti 2 (hulandes)"
    },
    "language": "nl",
    "summary": {
      "en": "This presentation discusses the ideology of Satanism and how it enters our society almost unnoticed. Some of its symbols and strategies are examined. At the end, some solutions are also discussed.",
      "es": "Esta presentación trata la ideología del satanismo y cómo se infiltra en nuestra sociedad casi sin que nos demos cuenta. Se examinan algunos de sus símbolos y estrategias. Al final también se plantean algunas soluciones.",
      "nl": "Deze presentatie bespreekt de ideologie van het satanisme en hoe dit bijna onopgemerkt onze samenleving binnendringt. Enkele van hun symbolen en strategieën worden besproken. Aan het einde worden ook enkele oplossingen besproken.",
      "pap": "E presentashon aki ta trata e ideologia di satanismo i kon e ta drenta nos sosiedat kasi sin ku nos ta ripará. Ta analisá algun di su símbolonan i strategianan. Na fin tambe ta trata algun solushon."
    },
    "videoUrl": "https://odysee.com/$/embed/het-occulte-onthuld-deel-2/cb06f3cd96aef7bbf6b6dfc98f3a981b66a80e31?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
    "audioUrl": null,
    "image": "/assets/images/img0-1.png",
    "imageAlt": "Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/het-occulte-onthuld-deel-2/cb06f3cd96aef7bbf6b6dfc98f3a981b66a80e31?r=AXPRoTuZUwFMpRK6AEyPQ4iqCiZcRp5f",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 2 - Sheets (pdf)",
          "es": "Het Occulte Onthuld Deel 2 - Sheets (pdf)",
          "nl": "Het Occulte Onthuld Deel 2 - Sheets (pdf)",
          "pap": "Het Occulte Onthuld Deel 2 - Sheets (pdf)"
        },
        "url": "/media/het-occulte-onthuld-deel-2.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Het Occulte Onthuld Deel 2 - Sheets (zip)",
          "es": "Het Occulte Onthuld Deel 2 - Sheets (zip)",
          "nl": "Het Occulte Onthuld Deel 2 - Sheets (zip)",
          "pap": "Het Occulte Onthuld Deel 2 - Sheets (zip)"
        },
        "url": "/media/het-occulte-onthuld-deel-2.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Tijdlijn van Religies",
          "es": "Tijdlijn van Religies",
          "nl": "Tijdlijn van Religies",
          "pap": "Tijdlijn van Religies"
        },
        "url": "./images/religions-chart.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-2",
    "nextEpisode": "legacy-interviewed-by-marja-west-english",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 364,
      "kind": "media",
      "image": "images/img0-1.png"
    }
  },
  {
    "id": "legacy-interviewed-by-marja-west-english",
    "slug": {
      "en": "interviewed-by-marja-west-english",
      "es": "interviewed-by-marja-west-english",
      "nl": "interviewed-by-marja-west-english",
      "pap": "interviewed-by-marja-west-english"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 90,
    "title": {
      "en": "Interviewed by Marja West (English)",
      "es": "Entrevistado por Marja West (inglés)",
      "nl": "Geïnterviewd door Marja West (Engels)",
      "pap": "Entrevistá pa Marja West (ingles)"
    },
    "language": "en",
    "summary": {
      "en": "Get Marja's free video training on what Waking Up (WTAF) is and means here. I thank you so much for supporting Marja's work here, or you can buy me the proverbial cup of coffee here. Hello my darlings, welcome to LoveTruth&Beauty Episode 295, our 9th installment of Conversations with Men. My honored guest for today — my dear friend and soul brother, colleague extraordinaire from One Great Work Network — Glenn Tramm. Glenn is the genius behind The Great Work Experience and his podcast Eigen Pad (Your Own Way).",
      "es": "Obtén el entrenamiento en video gratuito de Marja sobre qué es y qué significa Despertar (WTAF) aquí. Te agradezco mucho que apoyes el trabajo de Marja aquí, o puedes invitarme a la proverbial taza de café aquí. Hola, queridos, bienvenidos a LoveTruth&Beauty Episodio 295, nuestra novena entrega de Conversaciones con Hombres. Mi invitado de honor de hoy —mi querido amigo y hermano del alma, colega extraordinario de One Great Work Network— Glenn Tramm. Glenn es el genio detrás de The Great Work Experience y su pódcast Eigen Pad (Tu Propio Camino).",
      "nl": "Ontvang Marja's gratis videotraining over wat Ontwaken (WTAF) is en betekent hier. Heel veel dank dat je Marja's werk hier steunt, of je kunt me hier op het spreekwoordelijke kopje koffie trakteren. Hallo lieverds, welkom bij LoveTruth&Beauty aflevering 295, onze 9e aflevering van Conversations with Men. Mijn eregast van vandaag — mijn dierbare vriend en zielsbroeder, geweldige collega van One Great Work Network — Glenn Tramm. Glenn is het genie achter The Great Work Experience en zijn podcast Eigen Pad (Your Own Way).",
      "pap": "Haña Marja su training di video grátis tokante kiko Spièrtamentu (WTAF) ta i ta nifiká akinan. Mi ta gradisí bo masha pa sostené Marja su trabou akinan, òf bo por kumprá mi e proverbial taza di kòfi akinan. Hallo mi stimánan, bonbiní na LoveTruth&Beauty Episodio 295, nos di 9 entrega di Conversations with Men. Mi invitado di onor di awe —mi stimá amigu i ruman di alma, kolega ekstraordinario di One Great Work Network— Glenn Tramm. Glenn ta e genio tras di The Great Work Experience i su podcast Eigen Pad (Bo Mes Kaminda)."
    },
    "videoUrl": "https://odysee.com/$/embed/converstation-with-men-episode-295:4?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/conversations-with-men-cover.png",
    "imageAlt": "Interviewed by Marja West (English) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/converstation-with-men-episode-295:4?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Marja West's Website",
          "es": "Marja West's Website",
          "nl": "Marja West's Website",
          "pap": "Marja West's Website"
        },
        "url": "https://www.LoveTruthandBeauty.com",
        "type": "external"
      },
      {
        "label": {
          "en": "Marja West's Bitchute Channel",
          "es": "Marja West's Bitchute Channel",
          "nl": "Marja West's Bitchute Channel",
          "pap": "Marja West's Bitchute Channel"
        },
        "url": "https://www.bitchute.com/channel/7YSbnSrIpI6b/",
        "type": "video"
      },
      {
        "label": {
          "en": "Marja West's Odysee Channel",
          "es": "Marja West's Odysee Channel",
          "nl": "Marja West's Odysee Channel",
          "pap": "Marja West's Odysee Channel"
        },
        "url": "https://odysee.com/@lovetruthbeauty:0",
        "type": "video"
      },
      {
        "label": {
          "en": "Marja West's YouTube Channel",
          "es": "Marja West's YouTube Channel",
          "nl": "Marja West's YouTube Channel",
          "pap": "Marja West's YouTube Channel"
        },
        "url": "https://www.youtube.com/channel/UCfUCOEZ-2QhMvvwAXbLf-Jg",
        "type": "video"
      },
      {
        "label": {
          "en": "Marja West's Linktree Channel",
          "es": "Marja West's Linktree Channel",
          "nl": "Marja West's Linktree Channel",
          "pap": "Marja West's Linktree Channel"
        },
        "url": "https://linktr.ee/MarjaWest",
        "type": "external"
      },
      {
        "label": {
          "en": "here",
          "es": "here",
          "nl": "here",
          "pap": "here"
        },
        "url": "https://www.paypal.me/MarjaWest",
        "type": "external"
      },
      {
        "label": {
          "en": "here",
          "es": "here",
          "nl": "here",
          "pap": "here"
        },
        "url": "https://www.Ko-Fi.com/dakinikiss",
        "type": "external"
      },
      {
        "label": {
          "en": "295",
          "es": "295",
          "nl": "295",
          "pap": "295"
        },
        "url": "https://youtu.be/cani7hu-oLY",
        "type": "video"
      }
    ],
    "previousEpisode": "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-2",
    "nextEpisode": "legacy-interviewed-by-nathan-crabtree-english",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 398,
      "kind": "media",
      "image": "images/conversations-with-men-cover.png"
    }
  },
  {
    "id": "legacy-interviewed-by-nathan-crabtree-english",
    "slug": {
      "en": "interviewed-by-nathan-crabtree-english",
      "es": "interviewed-by-nathan-crabtree-english",
      "nl": "interviewed-by-nathan-crabtree-english",
      "pap": "interviewed-by-nathan-crabtree-english"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 91,
    "title": {
      "en": "Interviewed by Nathan Crabtree(English)",
      "es": "Entrevistado por Nathan Crabtree (inglés)",
      "nl": "Geïnterviewd door Nathan Crabtree (Engels)",
      "pap": "Entrevistá pa Nathan Crabtree (ingles)"
    },
    "language": "en",
    "summary": {
      "en": "Glenn Tramm is a father, entrepreneur, one great worker, and over-all caring, positive, smart person. He is also a techie and computer programmer. In this podcast, we talk about his book, the effects that religion have on people's minds and behaviors, the responsibility people have to truth and to do what's right, the overwhelming ignorance in society, and many other good topics.",
      "es": "Glenn Tramm es padre, emprendedor, un gran trabajador y, en general, una persona cariñosa, positiva e inteligente. También es un apasionado de la tecnología y programador. En este pódcast hablamos de su libro, de los efectos que la religión tiene en la mente y la conducta de las personas, de la responsabilidad que tenemos con la verdad y con hacer lo correcto, de la abrumadora ignorancia en la sociedad y de muchos otros buenos temas.",
      "nl": "Glenn Tramm is vader, ondernemer, one great worker en bovenal een zorgzaam, positief en slim persoon. Hij is ook een techneut en computerprogrammeur. In deze podcast praten we over zijn boek, de effecten die religie heeft op de geest en het gedrag van mensen, de verantwoordelijkheid die mensen hebben tegenover de waarheid en om te doen wat juist is, de overweldigende onwetendheid in de samenleving en vele andere goede onderwerpen.",
      "pap": "Glenn Tramm ta un tata, empresario, un gran trahadó i sobretodo un persona kariñoso, positivo i sabí. E ta tambe un fanátiko di teknologia i programadó di komputer. Den e podcast aki nos ta papia di su buki, e efektonan ku religion tin riba mente i komportashon di hende, e responsabilidat ku hende tin pa ku bèrdat i pa hasi loke ta korekto, e ignoransia abrumadó den sosiedat, i hopi otro bon tópiko."
    },
    "videoUrl": "https://odysee.com/$/embed/interviewed-by-nathan-crabtree:b?r=6NBkuFKUCKo4hTzBqQecxyDkppvwCxzQ",
    "audioUrl": null,
    "image": "/assets/images/nathan-crabtree-cover.png",
    "imageAlt": "Interviewed by Nathan Crabtree(English) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/interviewed-by-nathan-crabtree:b?r=6NBkuFKUCKo4hTzBqQecxyDkppvwCxzQ",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Nathan Crabtree's Twitch Channel",
          "es": "Nathan Crabtree's Twitch Channel",
          "nl": "Nathan Crabtree's Twitch Channel",
          "pap": "Nathan Crabtree's Twitch Channel"
        },
        "url": "https://www.twitch.tv/crystalspider420",
        "type": "external"
      },
      {
        "label": {
          "en": "Nathan Crabtree's Bitchute Channel",
          "es": "Nathan Crabtree's Bitchute Channel",
          "nl": "Nathan Crabtree's Bitchute Channel",
          "pap": "Nathan Crabtree's Bitchute Channel"
        },
        "url": "https://www.bitchute.com/channel/sdxpBTrybtYQ/",
        "type": "video"
      },
      {
        "label": {
          "en": "Nathan Crabtree's Odysee Channel",
          "es": "Nathan Crabtree's Odysee Channel",
          "nl": "Nathan Crabtree's Odysee Channel",
          "pap": "Nathan Crabtree's Odysee Channel"
        },
        "url": "https://odysee.com/@CrystalSpider:b/",
        "type": "video"
      },
      {
        "label": {
          "en": "Nathan Crabtree's YouTube Channel",
          "es": "Nathan Crabtree's YouTube Channel",
          "nl": "Nathan Crabtree's YouTube Channel",
          "pap": "Nathan Crabtree's YouTube Channel"
        },
        "url": "https://www.youtube.com/channel/UC9rW_-woz6CTCjFm1eiprDQ",
        "type": "video"
      },
      {
        "label": {
          "en": "Nathan Crabtree's Linktree Channel",
          "es": "Nathan Crabtree's Linktree Channel",
          "nl": "Nathan Crabtree's Linktree Channel",
          "pap": "Nathan Crabtree's Linktree Channel"
        },
        "url": "https://linktr.ee/crystalspider",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-interviewed-by-marja-west-english",
    "nextEpisode": "legacy-natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 449,
      "kind": "media",
      "image": "images/nathan-crabtree-cover.png"
    }
  },
  {
    "id": "legacy-natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch",
    "slug": {
      "en": "natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch",
      "es": "natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch",
      "nl": "natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch",
      "pap": "natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 92,
    "title": {
      "en": "Natural Law Is King w/ Glenn Tramm | PoppenCast #104 (Dutch)",
      "es": "La Ley Natural Es Rey w/ Glenn Tramm | PoppenCast #104 (neerlandés)",
      "nl": "Natuurwet Is Koning w/ Glenn Tramm | PoppenCast #104 (Dutch)",
      "pap": "Lei Natural Ta Rei w/ Glenn Tramm | PoppenCast #104 (hulandes)"
    },
    "language": "nl",
    "summary": {
      "en": "Lex, Rex. Anarchy is not Chaos! I speak with Glenn Tramm via Discord about how we would like to see the future. We also take a look at present-day existence, reality, and the mindfuck of society.",
      "es": "Lex, Rex. ¡La anarquía no es caos! Hablo con Glenn Tramm por Discord sobre cómo nos gustaría ver el futuro. También echamos un vistazo a la existencia actual, la realidad y el lavado de cerebro de la sociedad.",
      "nl": "Lex, Rex. Anarchie is geen Chaos! Ik spreek met Glenn Tramm via discord over hoe wij de toekomst zouden willen zien. Ook werpen we een blik op het hedendaagse bestaan, realiteit en de mindfuck van de samenleving.",
      "pap": "Lex, Rex. Anarkia no ta Kaos! Mi ta papia ku Glenn Tramm via Discord tokante kon nos lo kier mira e futuro. Tambe nos ta tira un bista riba e eksistensia di awe, realidat i e mindfuck di sosiedat."
    },
    "videoUrl": "https://odysee.com/$/embed/natuurwet-is-koning-poppencast-104:9?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
    "audioUrl": null,
    "image": "/assets/images/poppen-cast-104-cover.png",
    "imageAlt": "Natuurwet Is Koning w/ Glenn Tramm | PoppenCast #104 (Dutch) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/natuurwet-is-koning-poppencast-104:9?r=GwBkC33CVCid3F9rWeg6qocF7C2RasNm",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "PoppenCast's Telegram Channel",
          "es": "PoppenCast's Telegram Channel",
          "nl": "PoppenCast's Telegram Channel",
          "pap": "PoppenCast's Telegram Channel"
        },
        "url": "https://t.me/poppencast",
        "type": "external"
      },
      {
        "label": {
          "en": "PoppenCast's Facebook Channel",
          "es": "PoppenCast's Facebook Channel",
          "nl": "PoppenCast's Facebook Channel",
          "pap": "PoppenCast's Facebook Channel"
        },
        "url": "https://www.facebook.com/PoppenCast",
        "type": "external"
      },
      {
        "label": {
          "en": "PoppenCast's Spotify Channel",
          "es": "PoppenCast's Spotify Channel",
          "nl": "PoppenCast's Spotify Channel",
          "pap": "PoppenCast's Spotify Channel"
        },
        "url": "https://open.spotify.com/show/6hHdQzLORSC2DuhAoPoiFr",
        "type": "external"
      },
      {
        "label": {
          "en": "PoppenCast's YouTube Channel",
          "es": "PoppenCast's YouTube Channel",
          "nl": "PoppenCast's YouTube Channel",
          "pap": "PoppenCast's YouTube Channel"
        },
        "url": "https://www.youtube.com/c/DePoppenCast",
        "type": "video"
      },
      {
        "label": {
          "en": "PoppenCast's SoundCloud Channel",
          "es": "PoppenCast's SoundCloud Channel",
          "nl": "PoppenCast's SoundCloud Channel",
          "pap": "PoppenCast's SoundCloud Channel"
        },
        "url": "https://soundcloud.com/poppencast",
        "type": "external"
      },
      {
        "label": {
          "en": "PoppenCast's Instagram Channel",
          "es": "PoppenCast's Instagram Channel",
          "nl": "PoppenCast's Instagram Channel",
          "pap": "PoppenCast's Instagram Channel"
        },
        "url": "https://www.instagram.com/peterspoppencast/",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-interviewed-by-nathan-crabtree-english",
    "nextEpisode": "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 488,
      "kind": "media",
      "image": "images/poppen-cast-104-cover.png"
    }
  },
  {
    "id": "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2",
    "slug": {
      "en": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2",
      "es": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2",
      "nl": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2",
      "pap": "resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 93,
    "title": {
      "en": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers",
      "es": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers",
      "nl": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers",
      "pap": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers"
    },
    "language": "en",
    "summary": {
      "en": "In this episode, after two years of the extensive Matrix season, Glenn Tramm returns to this classic film and offers the audience more gold nuggets and forgotten or overlooked lessons.",
      "es": "En este episodio, tras dos años de la extensa temporada de Matrix, Glenn Tramm vuelve a esta película clásica y ofrece al público más pepitas de oro y lecciones olvidadas o pasadas por alto.",
      "nl": "in deze aflevering, en na twee jaar het uitgebreide Matrix-seizoen te hebben gegeven, neemt Glenn Tramm opnieuw deel aan deze klassieke film en biedt het publiek meer goudklompjes en vergeten of over het hoofd geziene lessen.",
      "pap": "Den e episodio aki, despues di dos aña di e temporada ekstenso di Matrix, Glenn Tramm ta bòlbe na e pelíkula klásiko aki i ta ofresé e públiko mas pida-pida di oro i lèsnan lubidá òf pasá por alto."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/resurrecting-the-ignored-lessons-from-the-matrix:9?r=6NBkuFKUCKo4hTzBqQecxyDkppvwCxzQ",
    "audioUrl": null,
    "image": "/assets/images/resurrecting-the-ignored-lessons-from-the-matrix-cover.jpg",
    "imageAlt": "Resurrecting The Ignored Lessons From The Matrix w/ Leslie Powers - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/resurrecting-the-ignored-lessons-from-the-matrix:9?r=6NBkuFKUCKo4hTzBqQecxyDkppvwCxzQ",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-natuurwet-is-koning-w-glenn-tramm-poppencast-104-dutch",
    "nextEpisode": "legacy-echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and-why-humanity-resists-ch",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 528,
      "kind": "media",
      "image": "images/resurrecting-the-ignored-lessons-from-the-matrix-cover.jpg"
    }
  },
  {
    "id": "legacy-echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and-why-humanity-resists-ch",
    "slug": {
      "en": "echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and",
      "es": "echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and",
      "nl": "echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and",
      "pap": "echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 94,
    "title": {
      "en": "Echos of the Past: Why Slavery Persists, Exploring Dutch Slave History, and Why Humanity Resists Change w/ Leslie Powers",
      "es": "Echos of the Past: Por Qué Persiste la Esclavitud, Explorando la Historia Esclavista Neerlandesa, y Por Qué la Humanidad Resiste al Cambio w/ Leslie Powers",
      "nl": "Echos of the Past: Waarom Slavernij Voortduurt, de Nederlandse Slavernijgeschiedenis Verkend, en Waarom de Mensheid Verandering Weerstaat w/ Leslie Powers",
      "pap": "Echos of the Past: Dikon Esklabitut ta Sigui, Eksplorando e Historia di Esklabitut Hulandes, i Dikon Humanidat ta Resistí Kambio w/ Leslie Powers"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode, the Dutch slave trade is discussed, including its cultural impact on modern civilization and the resistance to change.",
      "es": "En este episodio se analiza la trata neerlandesa de esclavos, su impacto cultural en la civilización moderna y la resistencia al cambio.",
      "nl": "In deze aflevering wordt de Nederlandse slavenhandel besproken, de culturele impact daarvan in de moderne beschaving en de weerstand tegen verandering.",
      "pap": "Den e episodio aki nos ta papia tokante e komersio hulandes di esklabo, su impacto kultural den sivilisashon moderno i e resistensia kontra kambio."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/ExploringDutchSlaveHistory:2?r=BMRzpa1V7rSTgkkC8hPR2qnQVjheLwci",
    "audioUrl": null,
    "image": "/assets/images/master-and-servant.jpg",
    "imageAlt": "Echos of the Past: Why Slavery Persists, Exploring Dutch Slave History, and Why Humanity Resists Change w/ Leslie Powers - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/ExploringDutchSlaveHistory:2?r=BMRzpa1V7rSTgkkC8hPR2qnQVjheLwci",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-resurrecting-the-ignored-lessons-from-the-matrix-w-leslie-powers-2",
    "nextEpisode": "legacy-de-onheilige-drie-eenheid-dutch-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 550,
      "kind": "media",
      "image": "images/master-and-servant.jpg"
    }
  },
  {
    "id": "legacy-de-onheilige-drie-eenheid-dutch-2",
    "slug": {
      "en": "de-onheilige-drie-eenheid-dutch-2",
      "es": "de-onheilige-drie-eenheid-dutch-2",
      "nl": "de-onheilige-drie-eenheid-dutch-2",
      "pap": "de-onheilige-drie-eenheid-dutch-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 95,
    "title": {
      "en": "The Unholy Trinity (Dutch)",
      "es": "La Trinidad Impía (neerlandés)",
      "nl": "De OnHeilige Drie Eenheid (Dutch)",
      "pap": "E Trinidat Insanto (hulandes)"
    },
    "language": "nl",
    "summary": {
      "en": "This presentation addresses the condition of the human race, the problem tied to it, why this problem persists, and its solution. The present human condition is shaped by our conscious or unconscious participation in created belief systems. Our fate—damned or saved—depends on how well we understand what our actual condition is right now.",
      "es": "Esta presentación aborda la condición de la raza humana, el problema ligado a ella, por qué este problema persiste y su solución. La condición humana actual está determinada por nuestra participación consciente o inconsciente en los sistemas de creencias creados. Nuestro destino —condenado o salvado— depende de cuán bien comprendamos cuál es realmente nuestra condición en este momento.",
      "nl": "Deze presentatie behandelt de toestand van het menselijk ras, het probleem dat hiermee samenhangt, waarom dit probleem voortduurt, en de oplossing ervoor. De huidige menselijke conditie wordt bepaald door onze bewuste of onbewuste deelname aan de gecreëerde geloofssystemen. Ons lot—verdoemd of gered—hangt af van hoe goed we begrijpen wat onze werkelijke toestand op dit moment is.",
      "pap": "E presentashon aki ta trata e kondishon di e rasa humano, e problema ligá ku dje, dikon e problema aki ta sigui, i su solushon. E kondishon humano aktual ta wòrdu determiná pa nos partisipashon konsiente òf inkonsiente den e sistemanan di kreensia kreá. Nos destino —kondená òf salbá— ta dependé di kon bon nos ta komprondé kiko ta nos kondishon real awor."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/de-onheilige-drie-eenheid:2?r=BMRzpa1V7rSTgkkC8hPR2qnQVjheLwci",
    "audioUrl": null,
    "image": "/assets/images/de-onheilige-drie-eenheid-cover-2.jpg",
    "imageAlt": "De OnHeilige Drie Eenheid (Dutch) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/de-onheilige-drie-eenheid:2?r=BMRzpa1V7rSTgkkC8hPR2qnQVjheLwci",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "De OnHeilige Drie Eenheid - Sheets (pdf)",
          "es": "De OnHeilige Drie Eenheid - Sheets (pdf)",
          "nl": "De OnHeilige Drie Eenheid - Sheets (pdf)",
          "pap": "De OnHeilige Drie Eenheid - Sheets (pdf)"
        },
        "url": "/media/de-onheilige-drie-eenheid.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "De OnHeilige Drie Eenheid - Sheets (zip)",
          "es": "De OnHeilige Drie Eenheid - Sheets (zip)",
          "nl": "De OnHeilige Drie Eenheid - Sheets (zip)",
          "pap": "De OnHeilige Drie Eenheid - Sheets (zip)"
        },
        "url": "/media/de-onheilige-drie-eenheid.zip",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-echos-of-the-past-why-slavery-persists-exploring-dutch-slave-history-and-why-humanity-resists-ch",
    "nextEpisode": "legacy-navigating-power-law-and-the-future-with-axel-dahi",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 572,
      "kind": "media",
      "image": "images/de-onheilige-drie-eenheid-cover-2.jpg"
    }
  },
  {
    "id": "legacy-navigating-power-law-and-the-future-with-axel-dahi",
    "slug": {
      "en": "navigating-power-law-and-the-future-with-axel-dahi",
      "es": "navigating-power-law-and-the-future-with-axel-dahi",
      "nl": "navigating-power-law-and-the-future-with-axel-dahi",
      "pap": "navigating-power-law-and-the-future-with-axel-dahi"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 96,
    "title": {
      "en": "Navigating Power, Law and The Future with Axel Dahi",
      "es": "Navegando el Poder, la Ley y el Futuro con Axel Dahi",
      "nl": "Navigeren door Macht, Wet en de Toekomst met Axel Dahi",
      "pap": "Navegando Poder, Lei i e Futuro ku Axel Dahi"
    },
    "language": "en",
    "summary": {
      "en": "In this thought-provoking podcast with Axel Dahi, we explore the intersections of power, law, and the future. From the historical impact of slavery to the complexities of government, taxes, and the rise of AI, we dive deep into how these forces shape society today and tomorrow. Tune in to \"Navigating Power, Law, and the Future\" for a fascinating conversation about the systems that govern us and their evolving role in shaping our world.",
      "es": "En este pódcast que invita a la reflexión con Axel Dahi, exploramos las intersecciones del poder, la ley y el futuro. Desde el impacto histórico de la esclavitud hasta las complejidades del gobierno, los impuestos y el auge de la IA, profundizamos en cómo estas fuerzas moldean la sociedad hoy y mañana. Sintoniza \"Navigating Power, Law, and the Future\" para una conversación fascinante sobre los sistemas que nos gobiernan y su papel cambiante en la configuración de nuestro mundo.",
      "nl": "In deze prikkelende podcast met Axel Dahi verkennen we de raakvlakken van macht, wet en de toekomst. Van de historische impact van slavernij tot de complexiteit van overheid, belastingen en de opkomst van AI gaan we diep in op hoe deze krachten de samenleving vandaag en morgen vormgeven. Luister naar \"Navigating Power, Law, and the Future\" voor een fascinerend gesprek over de systemen die ons besturen en hun veranderende rol in het vormgeven van onze wereld.",
      "pap": "Den e podcast ku ta pone bo pensa aki ku Axel Dahi, nos ta eksplorá e interseksonan di poder, lei i e futuro. For di e impakto históriko di esklabitut te ku e kompleksidatnan di gobièrnu, belasting i e subida di IA, nos ta profundisá den kon e forsanan aki ta forma sosiedat awe i mañan. Skucha \"Navigating Power, Law, and the Future\" pa un kòmbersashon fasinante tokante e sistemanan ku ta goberná nos i nan ròl ku ta kambia den e formashon di nos mundu."
    },
    "videoUrl": "https://odysee.com/$/embed/@TGWE:0/navigating-power-law-and-the-future-with-axel-dahi:5?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/navigating-power-law-and-the-future-with-axel-dahi-cover.jpg",
    "imageAlt": "Navigating Power, Law and The Future with Axel Dahi - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/@TGWE:0/navigating-power-law-and-the-future-with-axel-dahi:5?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-de-onheilige-drie-eenheid-dutch-2",
    "nextEpisode": "legacy-know-thy-self-podcast-11-with-chris-and-vuk",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 605,
      "kind": "media",
      "image": "images/navigating-power-law-and-the-future-with-axel-dahi-cover.jpg"
    }
  },
  {
    "id": "legacy-know-thy-self-podcast-11-with-chris-and-vuk",
    "slug": {
      "en": "know-thy-self-podcast-11-with-chris-and-vuk",
      "es": "know-thy-self-podcast-11-with-chris-and-vuk",
      "nl": "know-thy-self-podcast-11-with-chris-and-vuk",
      "pap": "know-thy-self-podcast-11-with-chris-and-vuk"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 97,
    "title": {
      "en": "Know Thy Self Podcast #11 with Chris and Vuk",
      "es": "Know Thy Self Podcast #11 con Chris y Vuk",
      "nl": "Know Thy Self Podcast #11 met Chris en Vuk",
      "pap": "Know Thy Self Podcast #11 ku Chris i Vuk"
    },
    "language": "en",
    "summary": {
      "en": "In this opening conversation with Chris and Vuk, we explore the foundations of my Work — from the principles of Anarkhos to the architecture of my forthcoming book Aletheia. This dialogue is the first spark in a series of transmissions uncovering the hidden structure beneath psyche, sovereignty, and sacred design.",
      "es": "En esta conversación inicial con Chris y Vuk, exploramos los fundamentos de mi Obra: desde los principios de Anarkhos hasta la arquitectura de mi próximo libro, Aletheia. Este diálogo es la primera chispa de una serie de transmisiones que desvelan la estructura oculta bajo la psique, la soberanía y el diseño sagrado.",
      "nl": "In dit openingsgesprek met Chris en Vuk verkennen we de fundamenten van mijn Werk — van de principes van Anarkhos tot de architectuur van mijn aankomende boek Aletheia. Deze dialoog is de eerste vonk in een reeks transmissies die de verborgen structuur onder psyche, soevereiniteit en heilig ontwerp blootleggen.",
      "pap": "Den e promé kòmbersashon aki ku Chris i Vuk, nos ta eksplorá e fundeshinan di mi Obra — for di e prinsipionan di Anarkhos te ku e arkitektura di mi buki ku ta bin, Aletheia. E diálogo aki ta e promé chispa den un seri di transmishon ku ta deskubrí e struktura skondí bou di sike, soberania i diseño sagrado."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Ferkenne-dich-selbst%3Ae?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/know-thy-self-cover.png",
    "imageAlt": "Know Thy Self Podcast #11 with Chris and Vuk - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Ferkenne-dich-selbst%3Ae?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-navigating-power-law-and-the-future-with-axel-dahi",
    "nextEpisode": "legacy-know-thy-self-podcast-13-with-chris-and-vuk",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 627,
      "kind": "media",
      "image": "images/know-thy-self-cover.png"
    }
  },
  {
    "id": "legacy-know-thy-self-podcast-13-with-chris-and-vuk",
    "slug": {
      "en": "know-thy-self-podcast-13-with-chris-and-vuk",
      "es": "know-thy-self-podcast-13-with-chris-and-vuk",
      "nl": "know-thy-self-podcast-13-with-chris-and-vuk",
      "pap": "know-thy-self-podcast-13-with-chris-and-vuk"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 98,
    "title": {
      "en": "Know Thy Self Podcast #13 with Chris and Vuk",
      "es": "Know Thy Self Podcast #13 con Chris y Vuk",
      "nl": "Know Thy Self Podcast #13 met Chris en Vuk",
      "pap": "Know Thy Self Podcast #13 ku Chris i Vuk"
    },
    "language": "en",
    "summary": {
      "en": "In this second conversation with Chris and Vuk, we confront Chaos — not the freedom of the unformed, but the imposed architectures of government, religion, and money. Here, Chaos is revealed as the force that demands control, a counterfeit order that must be dissolved. This dialogue opens the path toward true sovereignty, where the Work restores the natural harmony beyond all manufactured rule.",
      "es": "En esta segunda conversación con Chris y Vuk, confrontamos el Caos —no la libertad de lo no formado, sino las arquitecturas impuestas del gobierno, la religión y el dinero. Aquí el Caos se revela como la fuerza que exige control, un orden falsificado que debe disolverse. Este diálogo abre el camino hacia la verdadera soberanía, donde la Obra restaura la armonía natural más allá de toda regla fabricada.",
      "nl": "In dit tweede gesprek met Chris en Vuk confronteren we Chaos — niet de vrijheid van het ongevormde, maar de opgelegde structuren van overheid, religie en geld. Hier wordt Chaos onthuld als de kracht die controle eist, een valse orde die moet worden opgelost. Deze dialoog opent het pad naar ware soevereiniteit, waar het Werk de natuurlijke harmonie herstelt voorbij alle gefabriceerde heerschappij.",
      "pap": "Den e di dos kòmbersashon aki ku Chris i Vuk, nos ta konfrontá Kaos —no e libertat di loke no ta formá, sino e strukturanan imponé di gobièrnu, religion i plaka. Akinan Kaos ta wòrdu revelá komo e forsa ku ta eksigí kontrol, un òrden falsifiká ku mester wòrdu disolví. E diálogo aki ta habri e kaminda pa berdadero soberania, kaminda e Obra ta restorá e armonia natural mas ayá di tur regla fabriká."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fknow-thyself-podcast-13%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/know-thy-self-cover-13.png",
    "imageAlt": "Know Thy Self Podcast #13 with Chris and Vuk - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fknow-thyself-podcast-13%3A3?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-know-thy-self-podcast-11-with-chris-and-vuk",
    "nextEpisode": "legacy-know-thy-self-podcast-15-with-chris-and-vuk",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 649,
      "kind": "media",
      "image": "images/know-thy-self-cover-13.png"
    }
  },
  {
    "id": "legacy-know-thy-self-podcast-15-with-chris-and-vuk",
    "slug": {
      "en": "know-thy-self-podcast-15-with-chris-and-vuk",
      "es": "know-thy-self-podcast-15-with-chris-and-vuk",
      "nl": "know-thy-self-podcast-15-with-chris-and-vuk",
      "pap": "know-thy-self-podcast-15-with-chris-and-vuk"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 99,
    "title": {
      "en": "Know Thy Self Podcast #15 with Chris and Vuk",
      "es": "Know Thy Self Podcast #15 con Chris y Vuk",
      "nl": "Know Thy Self Podcast #15 met Chris en Vuk",
      "pap": "Know Thy Self Podcast #15 ku Chris i Vuk"
    },
    "language": "en",
    "summary": {
      "en": "In this third conversation with Chris and Vuk, we explore the All-Nothing — the Law of Union, the Law of One, and the Law of Mentalism. Each points to the same truth: the Source from which all arises and to which all returns. This dialogue invites the mind to dissolve into the whole.",
      "es": "En esta tercera conversación con Chris y Vuk, exploramos el Todo-Nada: la Ley de la Unión, la Ley del Uno y la Ley del Mentalismo. Cada una apunta a la misma verdad: la Fuente de la que todo surge y a la que todo regresa. Este diálogo invita a la mente a disolverse en el todo.",
      "nl": "In dit derde gesprek met Chris en Vuk verkennen we het Al-Niets — de Wet van Eenwording, de Wet van het Ene en de Wet van het Mentalisme. Elk wijst op dezelfde waarheid: de Bron waaruit alles voortkomt en waarnaar alles terugkeert. Deze dialoog nodigt de geest uit om op te lossen in het geheel.",
      "pap": "Den e di tres kòmbersashon aki ku Chris i Vuk, nos ta eksplorá e Tur-Nada —e Lei di Union, e Lei di Un i e Lei di Mentalismo. Kada un ta apuntá na e mesun bèrdat: e Fuente for di kua tur kos ta surgi i na kua tur kos ta bòlbe. E diálogo aki ta invitá e mente pa disolvé den e henter."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fknow-thyself-podcast-15%3A5?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/know-thy-self-cover-15.png",
    "imageAlt": "Know Thy Self Podcast #15 with Chris and Vuk - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fknow-thyself-podcast-15%3A5?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-know-thy-self-podcast-13-with-chris-and-vuk",
    "nextEpisode": "legacy-imposed-architectures-of-government-religion-and-money-ethereal-encounters-unveiled-with-glenn-t",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 673,
      "kind": "media",
      "image": "images/know-thy-self-cover-15.png"
    }
  },
  {
    "id": "legacy-imposed-architectures-of-government-religion-and-money-ethereal-encounters-unveiled-with-glenn-t",
    "slug": {
      "en": "imposed-architectures-of-government-religion-and-money-ethereal-encounte",
      "es": "imposed-architectures-of-government-religion-and-money-ethereal-encounte",
      "nl": "imposed-architectures-of-government-religion-and-money-ethereal-encounte",
      "pap": "imposed-architectures-of-government-religion-and-money-ethereal-encounte"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 100,
    "title": {
      "en": "Imposed Architectures of Government, Religion, and Money (Ethereal Encounters Unveiled with Glenn Tramm)",
      "es": "Arquitecturas Impuestas del Gobierno, la Religión y el Dinero (Ethereal Encounters Unveiled con Glenn Tramm)",
      "nl": "Opgelegde Structuren van Overheid, Religie en Geld (Ethereal Encounters Unveiled met Glenn Tramm)",
      "pap": "Strukturanan Imponé di Gobièrnu, Religion i Plaka (Ethereal Encounters Unveiled ku Glenn Tramm)"
    },
    "language": "en",
    "summary": {
      "en": "In this episode, spiritual explorer Glenn Tramm guides us through the hidden frameworks that shape our world—government, religion, and finance—peeling back layers to reveal how they're imposed upon human consciousness and collective reality. Join us for a thoughtful journey where power, structure, and belief interweave—rendering the invisible visible, and the mundane mystical. A stirring conversation that invites you to question, awaken, and reimagine the foundations beneath our everyday lives. Perfect for seekers of symbology, consciousness, and alternative wisdom.",
      "es": "En este episodio, el explorador espiritual Glenn Tramm nos guía a través de los marcos ocultos que dan forma a nuestro mundo —gobierno, religión y finanzas— retirando capas para revelar cómo se imponen sobre la conciencia humana y la realidad colectiva. Acompáñanos en un viaje reflexivo donde el poder, la estructura y la creencia se entrelazan, haciendo visible lo invisible y místico lo mundano. Una conversación conmovedora que te invita a cuestionar, despertar y reimaginar los cimientos bajo nuestra vida cotidiana. Perfecto para buscadores de la simbología, la conciencia y la sabiduría alternativa.",
      "nl": "In deze aflevering leidt spiritueel verkenner Glenn Tramm ons door de verborgen kaders die onze wereld vormgeven — overheid, religie en financiën — en pelt laag na laag af om te onthullen hoe ze worden opgelegd aan het menselijk bewustzijn en de collectieve werkelijkheid. Ga met ons mee op een doordachte reis waarin macht, structuur en geloof zich verweven — het onzichtbare zichtbaar makend en het alledaagse mystiek. Een aangrijpend gesprek dat je uitnodigt om te bevragen, te ontwaken en de fundamenten onder ons dagelijks leven opnieuw te verbeelden. Perfect voor zoekers van symboliek, bewustzijn en alternatieve wijsheid.",
      "pap": "Den e episodio aki, e eksploradó spiritual Glenn Tramm ta guia nos dor di e markonan skondí ku ta forma nos mundu —gobièrnu, religion i finansa— kitando kapa pa kapa pa revelá kon nan ta wòrdu imponé riba konsenshi humano i realidat kolektivo. Akompañá nos den un biahe refleksivo kaminda poder, struktura i kreensia ta entrelasá —hasiendo e invisibel visibel i e mundano místiko. Un kòmbersashon konmovedó ku ta invitá bo pa kuestioná, spièrta i reimaginá e fundeshinan bou di nos bida diario. Perfekto pa buskadónan di simbologia, konsenshi i sabiduria alternativo."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Fconfronting-chaos-imposed-architectures-of-government-religion-and-money%3Ab?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/ethereal-encounters-unveiled-cover.png",
    "imageAlt": "Imposed Architectures of Government, Religion, and Money - Ethereal Encounters Unveiled cover",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Fconfronting-chaos-imposed-architectures-of-government-religion-and-money%3Ab?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-know-thy-self-podcast-15-with-chris-and-vuk",
    "nextEpisode": "legacy-interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consciousness-episode-423",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 697,
      "kind": "media",
      "image": "images/ethereal-encounters-unveiled-cover.png"
    }
  },
  {
    "id": "legacy-interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consciousness-episode-423",
    "slug": {
      "en": "interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consc",
      "es": "interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consc",
      "nl": "interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consc",
      "pap": "interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consc"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 101,
    "title": {
      "en": "Interview w/ Marja West: University of the Ancient Elders~Degrees of Consciousness: Episode 423",
      "es": "Entrevista con Marja West: University of the Ancient Elders~Degrees of Consciousness: Episodio 423",
      "nl": "Interview met Marja West: University of the Ancient Elders~Degrees of Consciousness: Aflevering 423",
      "pap": "Entrevista ku Marja West: University of the Ancient Elders~Degrees of Consciousness: Episodio 423"
    },
    "language": "nl",
    "summary": {
      "en": "THE GREAT WORK EXPERIENCE — Interview with Marja West: The Art of Awakening. Fellow seekers of Truth, the gates of the University of the Ancient Elders now open once more. In this dialogue with the radiant Marja West, we traverse the living current of The Great Work Experience — a sanctuary for initiates of Consciousness, seekers of Sovereign Will, and those who remember that Knowledge must become Embodiment. We speak of the path of Self-Mastery through Tarot, Somatic Psychology, and Neuro-Linguistic Alchemy, and of how every breath and every thought shapes the temple of the soul. Here, Wisdom is not learned — it is lived. Upcoming initiations: Awaken the Healer Within — 6 months of Inner Alchemy & Self-Mastery, begins 6 July 2026. Hold the Light for Others — 3 months of Archetypal Healing & Embodied Guidance, begins 18 January 2027. Each course unfolds within The Great Work University, an initiatory school where ancient mystery teachings meet the science of transformation. True devotion will always find entry.",
      "es": "THE GREAT WORK EXPERIENCE — Entrevista con Marja West: El Arte de Despertar. Compañeros buscadores de la Verdad, las puertas de la University of the Ancient Elders se abren una vez más. En este diálogo con la radiante Marja West, recorremos la corriente viva de The Great Work Experience, un santuario para iniciados de la Conciencia, buscadores de la Voluntad Soberana y quienes recuerdan que el Conocimiento debe volverse Encarnación. Hablamos del camino del Autodominio a través del Tarot, la Psicología Somática y la Alquimia Neurolingüística, y de cómo cada aliento y cada pensamiento moldean el templo del alma. Aquí, la Sabiduría no se aprende: se vive. Próximas iniciaciones: Despierta al Sanador Interior — 6 meses de Alquimia Interior y Autodominio, comienza el 6 de julio de 2026. Sostén la Luz para Otros — 3 meses de Sanación Arquetípica y Guía Encarnada, comienza el 18 de enero de 2027. Cada curso se desarrolla dentro de The Great Work University, una escuela iniciática donde las antiguas enseñanzas de los misterios se encuentran con la ciencia de la transformación. La verdadera devoción siempre hallará entrada.",
      "nl": "THE GREAT WORK EXPERIENCE — Interview met Marja West: De Kunst van het Ontwaken. Mede-zoekers van Waarheid, de poorten van de University of the Ancient Elders openen opnieuw. In deze dialoog met de stralende Marja West doorkruisen we de levende stroom van The Great Work Experience — een toevluchtsoord voor ingewijden van het Bewustzijn, zoekers van Soevereine Wil, en zij die zich herinneren dat Kennis Belichaming moet worden. We spreken over het pad van Zelfmeesterschap via Tarot, Somatische Psychologie en Neurolinguïstische Alchemie, en over hoe elke ademhaling en elke gedachte de tempel van de ziel vormgeeft. Hier wordt Wijsheid niet geleerd — ze wordt geleefd. Komende initiaties: Wek de Heler in Jezelf — 6 maanden Innerlijke Alchemie & Zelfmeesterschap, begint 6 juli 2026. Houd het Licht vast voor Anderen — 3 maanden Archetypische Heling & Belichaamde Begeleiding, begint 18 januari 2027. Elke cursus vindt plaats binnen The Great Work University, een initiatieschool waar oude mysterieleringen de wetenschap van transformatie ontmoeten. Ware toewijding zal altijd toegang vinden.",
      "pap": "THE GREAT WORK EXPERIENCE — Entrevista ku Marja West: E Arte di Spièrtamentu. Kompañero buskadónan di Bèrdat, e portanan di e University of the Ancient Elders ta habri un biaha mas. Den e diálogo aki ku e radiante Marja West, nos ta krusa e koriente bibu di The Great Work Experience — un santuario pa inisiadonan di Konsenshi, buskadónan di Boluntat Soberano, i esnan ku ta korda ku Konosementu mester bira Enkarnashon. Nos ta papia di e kaminda di Outodominio via Tarot, Sikologia Somátiko i Alkimia Neurolingwístiko, i di kon kada rosea i kada pensamentu ta forma e tèmpel di alma. Akinan, Sabiduria no ta wòrdu siñá — e ta wòrdu bibí. Inisiashonnan ku ta bin: Spièrta e Kuradó Interno — 6 luna di Alkimia Interno i Outodominio, ta kuminsá 6 di yüli 2026. Tene e Lus pa Otronan — 3 luna di Kurashon Arketípiko i Guia Enkarná, ta kuminsá 18 di yanüari 2027. Kada kurso ta tuma lugá paden di The Great Work University, un skol inisiátiko kaminda siñansanan antiguo di misterio ta topa ku e siensia di transformashon. Berdadero devoshon semper lo haña entrada."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2Finterview-with-marja-west-episode-423%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/marja-west.png",
    "imageAlt": "Interview w/ Marja West: University of the Ancient Elders~Degrees of Consciousness: Episode 423 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2Finterview-with-marja-west-episode-423%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "thegreatworkexperience.com/university",
          "es": "thegreatworkexperience.com/university",
          "nl": "thegreatworkexperience.com/university",
          "pap": "thegreatworkexperience.com/university"
        },
        "url": "https://thegreatworkexperience.com/university",
        "type": "external"
      },
      {
        "label": {
          "en": "thegreatworkexperience.com/donations.html",
          "es": "thegreatworkexperience.com/donations.html",
          "nl": "thegreatworkexperience.com/donations.html",
          "pap": "thegreatworkexperience.com/donations.html"
        },
        "url": "https://thegreatworkexperience.com/donations.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-imposed-architectures-of-government-religion-and-money-ethereal-encounters-unveiled-with-glenn-t",
    "nextEpisode": "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 725,
      "kind": "media",
      "image": "images/marja-west.png"
    }
  },
  {
    "id": "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij-2",
    "slug": {
      "en": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt--2",
      "es": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt--2",
      "nl": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt--2",
      "pap": "de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt--2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 102,
    "title": {
      "en": "The Reformed Cult Of The State | Where obedience strangles the goddess, and order-followers keep slavery in place.",
      "es": "El Culto Reformado Del Estado | Donde la obediencia estrangula a la diosa, y los seguidores de órdenes mantienen la esclavitud.",
      "nl": "De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden.",
      "pap": "E Kulto Reformá Di E Estado | Kaminda obedensia ta wuru e diosa, i siguidónan di órdu ta mantené esklabitut."
    },
    "language": "nl",
    "summary": {
      "en": "This presentation lays bare the \"cult\" behind authority: how commands, indoctrination, and fear replace conscience, and how people (consciously or unconsciously) cooperate with systems that legitimize harm. We go deep into: what an order-follower is (and why following orders runs counter to conscience); the logical/philosophical proof of Natural Law (cause leads to effect, including in human behavior); the difference between Right Action and Wrong Action; cult techniques such as isolation, conformity, indoctrination, and trauma; psychological roots such as willful ignorance, fear of responsibility, self-hatred or lack of self-respect, fear of abandonment, and fear of chaos; the Law of Moral Entropy (inaction is not neutral); the return of the sacred feminine (care / non-aggression) and the sacred masculine (self-defense); and the \"Lost Word\" — the Word of all Power: NO. This presentation is meant as a mirror, not as comfort. Not to \"believe\", but to see: what is Truth, what is conditioning, and which choices build freedom — or keep slavery in place. Source/presentation: Glenn Tramm – The Great Work Experience. Disclaimer: this video is meant for education, reflection, and philosophical/psychological interpretation. Not legal advice.",
      "es": "Esta presentación desnuda el \"culto\" detrás de la autoridad: cómo las órdenes, el adoctrinamiento y el miedo reemplazan a la conciencia, y cómo las personas (consciente o inconscientemente) cooperan con sistemas que legitiman el daño. Profundizamos en: qué es un seguidor de órdenes (y por qué seguir órdenes va en contra de la conciencia); la prueba lógica y filosófica de la Ley Natural (la causa lleva al efecto, también en la conducta humana); la diferencia entre la Acción Correcta y la Acción Incorrecta; técnicas de culto como el aislamiento, el conformismo, el adoctrinamiento y el trauma; raíces psicológicas como la ignorancia deliberada, el miedo a la responsabilidad, el autodesprecio o la falta de autoestima, el miedo al abandono y el miedo al caos; la Ley de la Entropía Moral (la inacción no es neutral); el retorno de lo femenino sagrado (cuidado / no agresión) y lo masculino sagrado (autodefensa); y la \"Palabra Perdida\", la Palabra de todo Poder: NO. Esta presentación es un espejo, no un consuelo. No para \"creer\", sino para ver: qué es la Verdad, qué es el condicionamiento y qué decisiones construyen libertad o mantienen la esclavitud. Fuente/presentación: Glenn Tramm – The Great Work Experience. Aviso: este video es para educación, reflexión e interpretación filosófica y psicológica. No es asesoramiento legal.",
      "nl": "In deze presentatie wordt de “cultus” achter autoriteit blootgelegd: hoe bevelen, indoctrinatie en angst het geweten vervangen, en hoe mensen (bewust of onbewust) meewerken aan systemen die schade legitimeren. We gaan diep in op: - Wat een ordevolger is (en waarom orde volgen haaks staat op het geweten) - Het logische/filosofische bewijs van Natuurwetten (oorzaak â†’ gevolg, ook in menselijk gedrag) - Het verschil tussen Juiste Handelingen vs. Verkeerde Handelingen - Cult-technieken: isolatie, conformisme, indoctrinatie, trauma - Psychologische wortels: opzettelijke onwetendheid, angst voor verantwoordelijkheid, zelfhaat/gebrek aan zelfrespect, verlatingsangst, angst voor chaos - De Wet van Morele Entropie: niet-handelen is niet neutraal - De terugkeer van het heilige vrouwelijke (zorg / niet-agressie) én het heilige mannelijke (zelfverdediging) - Het “Verloren Woord” — het Woord van alle Macht: NEE Deze presentatie is bedoeld als spiegel, niet als comfort. Niet om te “geloven”, maar om te zien: wat is Waarheid, wat is conditionering, en welke keuzes bouwen vrijheid — of houden slavernij in stand. Bron/presentatie: Glenn Tramm – The Great Work Experience Abonneer voor meer werk over Waarheid, Geweten, Natuurwetten en innerlijke soevereiniteit. Disclaimer: Deze video is bedoeld voor educatie, reflectie en filosofische/psychologische duiding. Geen juridisch advies.",
      "pap": "E presentashon aki ta deskubrí e \"kulto\" tras di outoridat: kon órdu, indoktrinashon i miedu ta remplasá konsenshi, i kon hende (konsiente òf inkonsiente) ta kolaborá ku sistemanan ku ta legitimá daño. Nos ta profundisá den: kiko ta un siguidó di órdu (i dikon sigui órdu ta kontra konsenshi); e prueba lógiko/filosófiko di Lei Natural (kousa ta hiba na efekto, tambe den komportashon humano); e diferensia entre Akshon Korekto i Akshon Robes; teknikanan di kulto manera isolashon, konformismo, indoktrinashon i trauma; rais sikológiko manera ignoransia intenshonal, miedu di responsabilidat, odio pa bo mes òf falta di respèt pa bo mes, miedu di abandono i miedu di kaos; e Lei di Entropia Moral (no-akshon no ta neutral); e bòlbementu di e femenino sagrado (kuido / no-agreshon) i e maskulino sagrado (outodefensa); i e \"Palabra Pèrdí\", e Palabra di tur Poder: NO. E presentashon aki ta un spil, no un konsuelo. No pa \"kere\", sino pa mira: kiko ta Bèrdat, kiko ta kondishonamentu, i kua eskohonan ta konstruí libertat – òf ta mantené esklabitut. Fuente/presentashon: Glenn Tramm – The Great Work Experience. Aviso: e video aki ta pa edukashon, refleshon i interpretashon filosófiko/sikológiko. No ta konseho legal."
    },
    "videoUrl": "https://odysee.com/$/embed/%40TGWE%3A0%2FDe-Gereformeerde-Cultus-Van-De-Staat%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
    "audioUrl": null,
    "image": "/assets/images/de-gereformeerde-cultus-van-de-staat-cover.png",
    "imageAlt": "De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden. - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Watch video",
          "es": "Fuente multimedia integrada",
          "nl": "Ingebedde mediabron",
          "pap": "Fuente di media integrá"
        },
        "url": "https://odysee.com/$/embed/%40TGWE%3A0%2FDe-Gereformeerde-Cultus-Van-De-Staat%3Aa?r=A2FCTnZuHxH1uxwdz34obPHPf6fGmvxi",
        "type": "video"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "De Gereformeerde Cultus van de Staat - Sheets (pdf)",
          "es": "De Gereformeerde Cultus van de Staat - Sheets (pdf)",
          "nl": "De Gereformeerde Cultus van de Staat - Sheets (pdf)",
          "pap": "De Gereformeerde Cultus van de Staat - Sheets (pdf)"
        },
        "url": "/media/de-gereformeerde-cultus-van-de-staat.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "De Gereformeerde Cultus van de Staat - Sheets (zip)",
          "es": "De Gereformeerde Cultus van de Staat - Sheets (zip)",
          "nl": "De Gereformeerde Cultus van de Staat - Sheets (zip)",
          "pap": "De Gereformeerde Cultus van de Staat - Sheets (zip)"
        },
        "url": "/media/de-gereformeerde-cultus-van-de-staat.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "media-live.html",
          "es": "media-live.html",
          "nl": "media-live.html",
          "pap": "media-live.html"
        },
        "url": "media-live.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-pika.html",
          "es": "media-pika.html",
          "nl": "media-pika.html",
          "pap": "media-pika.html"
        },
        "url": "media-pika.html",
        "type": "external"
      },
      {
        "label": {
          "en": "media-videos.html",
          "es": "media-videos.html",
          "nl": "media-videos.html",
          "pap": "media-videos.html"
        },
        "url": "media-videos.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "media-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "media-3.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "media-4.html",
        "type": "external"
      },
      {
        "label": {
          "en": "4",
          "es": "4",
          "nl": "4",
          "pap": "4"
        },
        "url": "media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "5",
          "es": "5",
          "nl": "5",
          "pap": "5"
        },
        "url": "media-6.html",
        "type": "external"
      },
      {
        "label": {
          "en": "6",
          "es": "6",
          "nl": "6",
          "pap": "6"
        },
        "url": "media-7.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-interview-w-marja-west-university-of-the-ancient-elders-degrees-of-consciousness-episode-423",
    "nextEpisode": "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "media-videos.html",
      "sourceLine": 778,
      "kind": "media",
      "image": "images/de-gereformeerde-cultus-van-de-staat-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken",
    "slug": {
      "en": "season-02-episode-01-het-ego-en-manipulatie-technieken",
      "es": "season-02-episode-01-het-ego-en-manipulatie-technieken",
      "nl": "season-02-episode-01-het-ego-en-manipulatie-technieken",
      "pap": "season-02-episode-01-het-ego-en-manipulatie-technieken"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 103,
    "title": {
      "en": "Season 02/Episode 01: The Ego and Manipulation Techniques",
      "es": "Temporada 02/Episodio 01: El Ego y las Técnicas de Manipulación",
      "nl": "Season 02/Episode 01: Het Ego en Manipulatie Technieken",
      "pap": "Temporada 02/Episodio 01: E Ego i Teknikanan di Manipulashon"
    },
    "language": "nl",
    "summary": {
      "en": "An extensive discussion about the ego and some manipulation techniques. This is the first episode that will lead us into many other discussions about manipulation.",
      "es": "Una amplia discusión sobre el ego y algunas técnicas de manipulación. Este es el primer episodio que nos llevará a muchas otras discusiones sobre la manipulación.",
      "nl": "Een uitgebreide discussie over het ego en enkele manipulatietechnieken. Dit is de eerste aflevering die ons naar vele andere discussies over manipulatie zal leiden.",
      "pap": "Un diskushon amplio tokante e ego i algun teknika di manipulashon. Esaki ta e promé episodio ku lo hiba nos den hopi otro diskushon tokante manipulashon."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0201-%20Het%20Ego%20en%20Manipulatie%20Technieken.mp3",
    "image": "/assets/images/ego.jpg",
    "imageAlt": "Season 02/Episode 01: Het Ego en Manipulatie Technieken - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.com/Anarkhos-Conocimientos-Antiguos-Construir-Sdivociedades/dp/1095168495/ref=sr_1_2?dchild=1&qid=1608763217&refinements=p_27%3AEduard+H.+Locke&s=books&sr=1-2&text=Eduard+H.+Locke",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "De zwarte zon",
          "es": "De zwarte zon",
          "nl": "De zwarte zon",
          "pap": "De zwarte zon"
        },
        "url": "./images/darksun.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "De omgekeerde pentagram",
          "es": "De omgekeerde pentagram",
          "nl": "De omgekeerde pentagram",
          "pap": "De omgekeerde pentagram"
        },
        "url": "./images/pentagram.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De primaire kleuren",
          "es": "De primaire kleuren",
          "nl": "De primaire kleuren",
          "pap": "De primaire kleuren"
        },
        "url": "./images/colors.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij-2",
    "nextEpisode": "legacy-season-02-episode-02-oerangsten",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 191,
      "kind": "podcast",
      "image": "images/ego.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-02-oerangsten",
    "slug": {
      "en": "season-02-episode-02-oerangsten",
      "es": "season-02-episode-02-oerangsten",
      "nl": "season-02-episode-02-oerangsten",
      "pap": "season-02-episode-02-oerangsten"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 104,
    "title": {
      "en": "Season 02/Episode 02: Primal Fears",
      "es": "Temporada 02/Episodio 02: Miedos Primarios",
      "nl": "Season 02/Episode 02: Oerangsten",
      "pap": "Temporada 02/Episodio 02: Miedunan Primario"
    },
    "language": "nl",
    "summary": {
      "en": "In this podcast we continue discussing the methods of mass manipulation, in particular our primary fears. We examine our fears and discuss the effect they have on our psyche.",
      "es": "En este podcast seguimos hablando de los métodos de manipulación masiva, en particular de nuestros miedos primarios. Examinamos nuestros miedos y comentamos el efecto que tienen en nuestra psique.",
      "nl": "In deze podcast blijven we de methoden van massamanipulatie bespreken, in het bijzonder onze primaire angsten. We zullen onze angsten onderzoeken en bespreken welk effect ze hebben op onze psyche.",
      "pap": "Den e podcast aki nos ta sigui papia di e métodonan di manipulashon masivo, en partikular nos miedunan primario. Nos ta analisá nos miedunan i ta papia di e efekto ku nan tin riba nos sike."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0202%20-%20Oerangst.mp3",
    "image": "/assets/images/fear.png",
    "imageAlt": "Season 02/Episode 02: Oerangsten - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Kabbalistische levensboom",
          "es": "Kabbalistische levensboom",
          "nl": "Kabbalistische levensboom",
          "pap": "Kabbalistische levensboom"
        },
        "url": "./images/treeoflife.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken",
    "nextEpisode": "legacy-season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 220,
      "kind": "podcast",
      "image": "images/fear.png"
    }
  },
  {
    "id": "legacy-season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken",
    "slug": {
      "en": "season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken",
      "es": "season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken",
      "nl": "season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken",
      "pap": "season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 105,
    "title": {
      "en": "Season 02/Episode 03: Divide & Conquer, and Indoctrination Techniques",
      "es": "Temporada 02/Episodio 03: Divide y Vencerás, y Técnicas de Adoctrinamiento",
      "nl": "Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken",
      "pap": "Temporada 02/Episodio 03: Dividí i Vense, i Teknikanan di Indoktrinashon"
    },
    "language": "nl",
    "summary": {
      "en": "In this podcast we continue discussing the methods of mass manipulation, in particular the divide-and-conquer and indoctrination strategy. We put the education system under the magnifying glass and discuss how people in general perceive differences that divide us.",
      "es": "En este podcast seguimos hablando de los métodos de manipulación masiva, en particular la estrategia de divide y vencerás y el adoctrinamiento. Ponemos el sistema educativo bajo la lupa y comentamos cómo la gente, en general, percibe diferencias que nos dividen.",
      "nl": "In deze podcast blijven we de methoden van massamanipulatie bespreken, in het bijzonder de verdeel & heers, en indoctrinatie strategie. We zullen de educatie systeem onder de loop brengen en bespreken hoe mensen in het algemeen verschillen waarnemen die ons verdeeld.",
      "pap": "Den e podcast aki nos ta sigui papia di e métodonan di manipulashon masivo, en partikular e strategia di dividí i vense i indoktrinashon. Nos ta pone e sistema edukativo bou di lupa i ta papia di kon hende en general ta persibí diferensianan ku ta dividí nos."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0203%20-%20Verdeel%20&%20Heers,%20en%20Indoctrinatie%20Technieken.mp3",
    "image": "/assets/images/divide_conquer.jpg",
    "imageAlt": "Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Machiavelli - The art of war",
          "es": "Machiavelli - The art of war",
          "nl": "Machiavelli - The art of war",
          "pap": "Machiavelli - The art of war"
        },
        "url": "./articles/machiavelli-the-art-of-war.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Sun Tzu - The art of war",
          "es": "Sun Tzu - The art of war",
          "nl": "Sun Tzu - The art of war",
          "pap": "Sun Tzu - The art of war"
        },
        "url": "./articles/sun tzu-the-art-of-war.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-02-oerangsten",
    "nextEpisode": "legacy-season-02-ouroboros-the-passing-of-the-blue-crown",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 250,
      "kind": "podcast",
      "image": "images/divide_conquer.jpg"
    }
  },
  {
    "id": "legacy-season-02-ouroboros-the-passing-of-the-blue-crown",
    "slug": {
      "en": "season-02-ouroboros-the-passing-of-the-blue-crown",
      "es": "season-02-ouroboros-the-passing-of-the-blue-crown",
      "nl": "season-02-ouroboros-the-passing-of-the-blue-crown",
      "pap": "season-02-ouroboros-the-passing-of-the-blue-crown"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 106,
    "title": {
      "en": "Season 02/Ouroboros: The Passing of the Blue Crown",
      "es": "Temporada 02/Ouroboros: El Paso de la Corona Azul",
      "nl": "Seizoen 02/Ouroboros: The Passing of the Blue Crown",
      "pap": "Temporada 02/Ouroboros: E Pasamentu di e Korona Blou"
    },
    "language": "en",
    "summary": {
      "en": "Historically, serpents represent fertility, a creative life force, or sexual energy. The serpent is generally the symbol of Wisdom and Power. Because serpents shed their skin, they are associated with rebirth, immortality, and healing. The ouroboros is the symbol of eternity and the continual renewal of life.\n\n\"Behold, it is I who have tested you. With many subtle tests. Wise are you if you know that the subtle serpent of temptation is in truth the Anointed One, who brings you to liberation.\" - The Book of Tokens",
      "es": "Históricamente, las serpientes representan la fertilidad, una fuerza vital creativa o la energía sexual. La serpiente es, en general, el símbolo de la Sabiduría y el Poder. Dado que las serpientes mudan de piel, se asocian con el renacimiento, la inmortalidad y la sanación. El ouroboros es el símbolo de la eternidad y la renovación continua de la vida.\n\n\"He aquí, soy yo quien te ha puesto a prueba. Con muchas pruebas sutiles. Sabio eres si sabes que la sutil serpiente de la tentación es en verdad el Ungido, que te lleva a la liberación.\" - El Libro de los Tokens",
      "nl": "Historisch gezien vertegenwoordigen slangen vruchtbaarheid, een creatieve levenskracht of seksuele energie. De slang is in het algemeen het symbool van Wijsheid en Macht. Gezien slangen hun huid vervellen, worden ze geassocieerd met wedergeboorte, onsterfelijkheid en genezing. De ouroboros is het symbool van eeuwigheid en voortdurende vernieuwing van het leven.\n\n\"Zie, ik ben het die u heeft beproefd. Met veel subtiele tests. Wijs zijt gij als u weet dat de subtiele slang van verzoeking in waarheid de Gezalfde is. Die u tot bevrijding brengt.\" - Het boek met Penningen (The book of Tokens)",
      "pap": "Histórikamente, kolebranan ta representá fertilidat, un forsa di bida kreativo òf energia seksual. E kolebra en general ta e símbolo di Sabiduria i Poder. Komo kolebranan ta kambia nan kueru, nan ta wòrdu asosiá ku nasementu nobo, inmortalidat i kurashon. E ouroboros ta e símbolo di eternidat i renovashon kontinuo di bida.\n\n\"Mira, ta ami a pone bo na prueba. Ku hopi prueba sutil. Sabí bo ta si bo sa ku e kolebra sutil di tentashon ta en bèrdat e Ungí, ku ta hiba bo na liberashon.\" - E Buki di Tokens"
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/the-passing-of-the-blue-crown.mp3",
    "image": "/assets/images/ouroboros.jpg",
    "imageAlt": "Season 02/Ouroboros: The Passing of the Blue Crown - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken",
    "nextEpisode": "legacy-season-02-episode-03-and-189-symbologie",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 278,
      "kind": "podcast",
      "image": "images/ouroboros.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-03-and-189-symbologie",
    "slug": {
      "en": "season-02-episode-03-and-189-symbologie",
      "es": "season-02-episode-03-and-189-symbologie",
      "nl": "season-02-episode-03-and-189-symbologie",
      "pap": "season-02-episode-03-and-189-symbologie"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 107,
    "title": {
      "en": "Season 02/Episode 03&#189;: Symbology",
      "es": "Temporada 02/Episodio 03&#189;: Simbología",
      "nl": "Season 02/Episode 03&#189;: Symbologie",
      "pap": "Temporada 02/Episodio 03&#189;: Simbologia"
    },
    "language": "nl",
    "summary": {
      "en": "In this podcast we continue where we left off with the education systems. The symbolism of the graduation gown is discussed as a starting point for understanding the language of higher beings: the language expressed in symbology, colors, and numbers. The language of vibration.",
      "es": "En este podcast continuamos donde lo dejamos con los sistemas educativos. Se analiza el simbolismo de la toga de graduación como punto de partida para comprender el lenguaje de los seres superiores: el lenguaje expresado en simbología, colores y números. El lenguaje de la vibración.",
      "nl": "In deze podcast gaan verder waar we gebleven waren met de onderwijssystemen. De symboliek van de afstudeertoga wordt besproken als uitgangspunt om de taal van hogere wezens te begrijpen. De taal uitgedrukt in symbologie, kleuren en cijfers. De taal van vibratie.",
      "pap": "Den e podcast aki nos ta sigui kaminda nos a keda ku e sistemanan edukativo. Ta analisá e simbolismo di e toga di graduashon komo punto di salida pa komprondé e idioma di sernan superior: e idioma ekspresá den simbologia, koló i number. E idioma di vibrashon."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02035%20-%20Symbologie.mp3",
    "image": "/assets/images/masonic.jpg",
    "imageAlt": "Season 02/Episode 03&#189;: Symbologie - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Afstudeertoga en -hoed",
          "es": "Afstudeertoga en -hoed",
          "nl": "Afstudeertoga en -hoed",
          "pap": "Afstudeertoga en -hoed"
        },
        "url": "./images/gown.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Vrijmetselaars tempel",
          "es": "Vrijmetselaars tempel",
          "nl": "Vrijmetselaars tempel",
          "pap": "Vrijmetselaars tempel"
        },
        "url": "./images/masonic-temple.jpg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-ouroboros-the-passing-of-the-blue-crown",
    "nextEpisode": "legacy-season-02-episode-04-gecontroleerde-oppositie-techniek",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 301,
      "kind": "podcast",
      "image": "images/masonic.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-04-gecontroleerde-oppositie-techniek",
    "slug": {
      "en": "season-02-episode-04-gecontroleerde-oppositie-techniek",
      "es": "season-02-episode-04-gecontroleerde-oppositie-techniek",
      "nl": "season-02-episode-04-gecontroleerde-oppositie-techniek",
      "pap": "season-02-episode-04-gecontroleerde-oppositie-techniek"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 108,
    "title": {
      "en": "Season 02/Episode 04: Controlled Opposition Technique",
      "es": "Temporada 02/Episodio 04: Técnica de Oposición Controlada",
      "nl": "Season 02/Episode 04: Gecontroleerde Oppositie Techniek",
      "pap": "Temporada 02/Episodio 04: Teknika di Oposishon Kontrolá"
    },
    "language": "nl",
    "summary": {
      "en": "We continue with our subject of manipulation techniques. Here we discuss specifically the technique of controlled opposition. It is one of the most successful techniques used to date. Our current and past crises are modeled on this technique.",
      "es": "Continuamos con nuestro tema de las técnicas de manipulación. Aquí hablamos específicamente de la técnica de la oposición controlada. Es una de las técnicas más exitosas usadas hasta hoy. Nuestras crisis actuales y pasadas están modeladas según esta técnica.",
      "nl": "We gaan verder met ons onderwerp over manipulatie technieken. We zullen hier specifiek de techniek van gecontroleerde oppositie bespreken. Het is een van de meest succesvolle technieken die tot nu toe is gebruikt. Onze huidige en vroegere crisis is gemodelleerd naar deze techniek.",
      "pap": "Nos ta sigui ku nos tema di teknikanan di manipulashon. Akinan nos ta papia spesífikamente di e teknika di oposishon kontrolá. E ta un di e teknikanan di mas eksitoso usá te awe. Nos krisisnan aktual i di pasado ta modelá segun e teknika aki."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0204%20-%20%20Gecontroleerde%20Oppositie%20Techniek.mp3",
    "image": "/assets/images/opposition.jpg",
    "imageAlt": "Season 02/Episode 04: Gecontroleerde Oppositie Techniek - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-03-and-189-symbologie",
    "nextEpisode": "legacy-season-02-episode-04-and-189-de-new-age-beweging",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 331,
      "kind": "podcast",
      "image": "images/opposition.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-04-and-189-de-new-age-beweging",
    "slug": {
      "en": "season-02-episode-04-and-189-de-new-age-beweging",
      "es": "season-02-episode-04-and-189-de-new-age-beweging",
      "nl": "season-02-episode-04-and-189-de-new-age-beweging",
      "pap": "season-02-episode-04-and-189-de-new-age-beweging"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 109,
    "title": {
      "en": "Season 02/Episode 04&#189;: The New Age Movement",
      "es": "Temporada 02/Episodio 04&#189;: El Movimiento New Age",
      "nl": "Season 02/Episode 04&#189;: De New Age Beweging",
      "pap": "Temporada 02/Episodio 04&#189;: E Movementu New Age"
    },
    "language": "nl",
    "summary": {
      "en": "In this podcast we continue discussing the technique of controlled opposition, but from the perspective of the New Age movement.",
      "es": "En este podcast seguimos hablando de la técnica de la oposición controlada, pero desde la óptica del movimiento New Age.",
      "nl": "In deze podcast blijven we de techniek van gecontroleerde oppositie bespreken, maar vanuit de optiek van de New Age Beweging.",
      "pap": "Den e podcast aki nos ta sigui papia di e teknika di oposishon kontrolá, pero for di e óptika di e movementu New Age."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02045%20-%20De%20New%20Age%20Beweging.mp3",
    "image": "/assets/images/meditation.jpg",
    "imageAlt": "Season 02/Episode 04&#189;: De New Age Beweging - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "New Age Beweging",
          "es": "New Age Beweging",
          "nl": "New Age Beweging",
          "pap": "New Age Beweging"
        },
        "url": "./images/new-age-state.png",
        "type": "external"
      },
      {
        "label": {
          "en": "De temple van Apollo in Delphi (Griekenland)",
          "es": "De temple van Apollo in Delphi (Griekenland)",
          "nl": "De temple van Apollo in Delphi (Griekenland)",
          "pap": "De temple van Apollo in Delphi (Griekenland)"
        },
        "url": "./images/delphi-oracle.jpg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-04-gecontroleerde-oppositie-techniek",
    "nextEpisode": "legacy-season-02-de-macht-van-een-echte-koning-in-give-in",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 351,
      "kind": "podcast",
      "image": "images/meditation.jpg"
    }
  },
  {
    "id": "legacy-season-02-de-macht-van-een-echte-koning-in-give-in",
    "slug": {
      "en": "season-02-de-macht-van-een-echte-koning-in-give-in",
      "es": "season-02-de-macht-van-een-echte-koning-in-give-in",
      "nl": "season-02-de-macht-van-een-echte-koning-in-give-in",
      "pap": "season-02-de-macht-van-een-echte-koning-in-give-in"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 110,
    "title": {
      "en": "Season 02/The Power of a True King(Queen): Give In",
      "es": "Temporada 02/El Poder de un Verdadero Rey(Reina): Give In",
      "nl": "Season 02/De Macht van een Echte Koning(in): Give In",
      "pap": "Temporada 02/E Poder di un Berdadero Rei(Reina): Give In"
    },
    "language": "nl",
    "summary": {
      "en": "Right action is the power of a true king (or queen). There is an enormous amount of power in doing good. But first one must understand what right action is. Right action is one's ability to act in harmony and according to natural law, for life and the freedom of life. Do that, and you do right. Always think, say, and do what is right. Refuse to think, say, and do what is wrong. Always do the right thing. Right action leads to right results. Wrong action leads to wrong results. Good action cannot lead to wrong results. Wrong action cannot lead to right results. \"You have no right but to do right. Do that and no other shall say nay.\" - Aleister Crowley",
      "es": "La acción correcta es el poder de un verdadero rey (o reina). Hay una enorme cantidad de poder en hacer el bien. Pero primero hay que comprender qué es la acción correcta. La acción correcta es la capacidad de actuar en armonía y según la ley natural, por la vida y la libertad de la vida. Haz eso, y obras bien. Piensa, di y haz siempre lo correcto. Niégate a pensar, decir y hacer lo incorrecto. Haz siempre lo correcto. La acción correcta conduce a resultados correctos. La acción incorrecta conduce a resultados incorrectos. La buena acción no puede llevar a malos resultados. La mala acción no puede llevar a buenos resultados. \"No tienes más derecho que el de obrar bien. Hazlo y ningún otro dirá que no.\" - Aleister Crowley",
      "nl": "Juist gedrag is de macht van een echte koning(in). Er zit een enorme hoeveelheid kracht in het goed doen. Maar eerst moet men begrijpen wat juist gedrag is. Juist gedrag is het vermogen van iemand om in harmonie en volgens natuurwetten, het leven en de vrijheid van het leven te handelen. Doe dat, en je doet het goed. Denk, zeg en doe altijd wat juist is. Weiger te denken, zeg en doe wat verkeerd is. Doe altijd het juiste. De juiste actie leidt tot de juiste resultaten. Verkeerd handelen leidt tot verkeerde resultaten. Goede actie kan niet tot verkeerde resultaten leiden. Verkeerde actie kan niet leiden tot juiste resultaten. \"U hebt geen ander recht dan juist te handelen. Doe dat en geen ander zal nee zeggen.\" - Aleister Crowley",
      "pap": "Akshon korekto ta e poder di un berdadero rei (òf reina). Tin un kantidat enorme di poder den hasi bon. Pero promé un hende mester komprondé kiko ta akshon korekto. Akshon korekto ta e kapasidat di un hende pa aktua na armonia i segun lei natural, pa bida i e libertat di bida. Hasi esei, i bo ta hasi bon. Semper pensa, bisa i hasi loke ta korekto. Nenga di pensa, bisa i hasi loke ta robes. Semper hasi loke ta korekto. Akshon korekto ta hiba na resultadonan korekto. Akshon robes ta hiba na resultadonan robes. Akshon bon no por hiba na resultadonan robes. Akshon robes no por hiba na resultadonan korekto. \"Bo no tin otro derecho ku di hasi loke ta korekto. Hasi esei i ningun otro lo bisa nò.\" - Aleister Crowley"
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/give-in.mp3",
    "image": "/assets/images/zeus-power.gif",
    "imageAlt": "Season 02/De Macht van een Echte Koning(in): Give In - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-04-and-189-de-new-age-beweging",
    "nextEpisode": "legacy-season-02-episode-05-het-monetaire-systeem",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 382,
      "kind": "podcast",
      "image": "images/zeus-power.gif"
    }
  },
  {
    "id": "legacy-season-02-episode-05-het-monetaire-systeem",
    "slug": {
      "en": "season-02-episode-05-het-monetaire-systeem",
      "es": "season-02-episode-05-het-monetaire-systeem",
      "nl": "season-02-episode-05-het-monetaire-systeem",
      "pap": "season-02-episode-05-het-monetaire-systeem"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 111,
    "title": {
      "en": "Season 02/Episode 05: The Monetary System",
      "es": "Temporada 02/Episodio 05: El Sistema Monetario",
      "nl": "Season 02/Episode 05: Het Monetaire Systeem",
      "pap": "Temporada 02/Episodio 05: E Sistema Monetario"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we go beyond our standard 20 minutes and talk about the monetary system as an instrument for manipulation. We discuss the monetary system from an occult perspective.",
      "es": "En este episodio vamos más allá de nuestros 20 minutos habituales y hablamos del sistema monetario como instrumento de manipulación. Comentamos el sistema monetario desde una perspectiva oculta.",
      "nl": "In deze aflevering gaan we verder dan onze standaard van 20 minuten en gaan we het hebben over het monetaire systeem als een instrument voor manipulatie. We zullen het monetaire systeem bespreken vanuit een occult perspectief.",
      "pap": "Den e episodio aki nos ta pasa nos standard di 20 minüt i ta papia di e sistema monetario komo un instrumento di manipulashon. Nos ta papia di e sistema monetario for di un perspektiva okulto."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0205%20-%20Monetair%20Systeem.mp3",
    "image": "/assets/images/money.jpg",
    "imageAlt": "Season 02/Episode 05: Het Monetaire Systeem - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Beschadigde Hersenen",
          "es": "Beschadigde Hersenen",
          "nl": "Beschadigde Hersenen",
          "pap": "Beschadigde Hersenen"
        },
        "url": "./images/damaged-brain.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Euro Bankbiljetten",
          "es": "Euro Bankbiljetten",
          "nl": "Euro Bankbiljetten",
          "pap": "Euro Bankbiljetten"
        },
        "url": "./images/euro-bank-notes.png",
        "type": "external"
      },
      {
        "label": {
          "en": "God Zij Met Ons",
          "es": "God Zij Met Ons",
          "nl": "God Zij Met Ons",
          "pap": "God Zij Met Ons"
        },
        "url": "./images/god-with-us.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "In God Vertrouwen We",
          "es": "In God Vertrouwen We",
          "nl": "In God Vertrouwen We",
          "pap": "In God Vertrouwen We"
        },
        "url": "./images/in-god-we-trust.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Mayer Rothschild (Bauer)",
          "es": "Mayer Rothschild (Bauer)",
          "nl": "Mayer Rothschild (Bauer)",
          "pap": "Mayer Rothschild (Bauer)"
        },
        "url": "./images/mayer-bauer.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Euro & Dollar Symbolen",
          "es": "Euro & Dollar Symbolen",
          "nl": "Euro & Dollar Symbolen",
          "pap": "Euro & Dollar Symbolen"
        },
        "url": "./images/euro-dollar-sign.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Epsilon Symbool",
          "es": "Epsilon Symbool",
          "nl": "Epsilon Symbool",
          "pap": "Epsilon Symbool"
        },
        "url": "./images/epsilon.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Caduceus: De slangen",
          "es": "Caduceus: De slangen",
          "nl": "Caduceus: De slangen",
          "pap": "Caduceus: De slangen"
        },
        "url": "./images/caduceus.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Ossenprik",
          "es": "Ossenprik",
          "nl": "Ossenprik",
          "pap": "Ossenprik"
        },
        "url": "./images/ox-goad.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Lamed - Hebreeuwse letter 'L'",
          "es": "Lamed - Hebreeuwse letter 'L'",
          "nl": "Lamed - Hebreeuwse letter 'L'",
          "pap": "Lamed - Hebreeuwse letter 'L'"
        },
        "url": "./images/lamed.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Voorbeeld van een Talisman",
          "es": "Voorbeeld van een Talisman",
          "nl": "Voorbeeld van een Talisman",
          "pap": "Voorbeeld van een Talisman"
        },
        "url": "./images/talisman.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Chakras",
          "es": "Chakras",
          "nl": "Chakras",
          "pap": "Chakras"
        },
        "url": "./images/chakras.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Tarot 11: Gerechtigheid",
          "es": "Tarot 11: Gerechtigheid",
          "nl": "Tarot 11: Gerechtigheid",
          "pap": "Tarot 11: Gerechtigheid"
        },
        "url": "./images/justice.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Tarot 0: De Dwaas",
          "es": "Tarot 0: De Dwaas",
          "nl": "Tarot 0: De Dwaas",
          "pap": "Tarot 0: De Dwaas"
        },
        "url": "./images/dedwaas.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Tarot 5: De Hierofant of Hogepriester",
          "es": "Tarot 5: De Hierofant of Hogepriester",
          "nl": "Tarot 5: De Hierofant of Hogepriester",
          "pap": "Tarot 5: De Hierofant of Hogepriester"
        },
        "url": "./images/hierofant.jpeg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-de-macht-van-een-echte-koning-in-give-in",
    "nextEpisode": "legacy-season-02-loop-niet-over-mij-heen-valhalla",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 410,
      "kind": "podcast",
      "image": "images/money.jpg"
    }
  },
  {
    "id": "legacy-season-02-loop-niet-over-mij-heen-valhalla",
    "slug": {
      "en": "season-02-loop-niet-over-mij-heen-valhalla",
      "es": "season-02-loop-niet-over-mij-heen-valhalla",
      "nl": "season-02-loop-niet-over-mij-heen-valhalla",
      "pap": "season-02-loop-niet-over-mij-heen-valhalla"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 112,
    "title": {
      "en": "Season 02/Don't Walk All Over Me: Valhalla",
      "es": "Temporada 02/No Pases Por Encima de Mí: Valhalla",
      "nl": "Season 02/Loop Niet Over Mij Heen: Valhalla",
      "pap": "Temporada 02/No Kana Riba Mi: Valhalla"
    },
    "language": "en",
    "summary": {
      "en": "As discussed earlier, the serpent holds a prominent place in occultism. The Gadsden flag serpent (see alongside), or the American rattlesnake, was a symbol of America's true national identity, even though the media has criticized it very negatively. They see it as a symbol of rebellion, but also of terrorism. In reality it is a symbol of unity, love, and freedom. Benjamin Franklin, one of the founding fathers of the United States, gave a very precise explanation of this serpent:\n\n\"She [the serpent] never begins an attack, nor, once engaged, ever surrenders: she is therefore a symbol of magnanimity and true courage ... she never wounds till she has generously given notice, even to her enemy, and cautioned him against the danger of treading on her.\" - Benjamin Franklin\n\nIn other words, let this serpent be an emblem and symbol of the freedom fighters. Never begin an attack, but once someone wants to tread on you, never surrender. Always generously notify the offender of their transgression.",
      "es": "Como se comentó antes, la serpiente ocupa un lugar destacado en el ocultismo. La serpiente de la bandera de Gadsden (véase al lado), o la serpiente de cascabel americana, fue un símbolo de la verdadera identidad nacional de América, aunque los medios la han criticado muy negativamente. La ven como un símbolo de rebelión, pero también de terrorismo. En realidad es un símbolo de unidad, amor y libertad. Benjamin Franklin, uno de los padres fundadores de los Estados Unidos, dio una explicación muy precisa de esta serpiente:\n\n\"Ella [la serpiente] nunca inicia un ataque, ni, una vez involucrada, se rinde jamás: es por tanto un símbolo de magnanimidad y verdadero coraje ... nunca hiere hasta haber avisado generosamente, incluso a su enemigo, advirtiéndole del peligro de pisarla.\" - Benjamin Franklin\n\nEn otras palabras, que esta serpiente sea un emblema y símbolo de los luchadores por la libertad. Nunca inicies un ataque, pero una vez que alguien quiera pisarte, no te rindas jamás. Avisa siempre con generosidad al ofensor de su transgresión.",
      "nl": "Zoals eerder besproken, neemt de slang een vooraanstaande plaats in in het occultisme. De vlagslang van Gadsden (zie hiernaast), of de Amerikaanse ratelslang, was een symbool van de ware nationale identiteit van Amerika. Ook al heeft de media er zeer negatieve kritiek op gegeven. Ze zien het als een symbool van rebellie, maar ook van terrorisme. In werkelijkheid is het een symbool van eenheid, liefde en vrijheid. Benjamin Franklin, een van de grondleggers van de Verenigde Staten, gaf een zeer nauwkeurige uitleg van deze slang;\n\n\"Zij [de slang] begint nooit een aanval, noch, wanneer ze eenmaal betrokken is, geeft ze zich ooit over: ze is daarom een symbool van grootmoedigheid en echte moed ... ze verwondt nooit totdat ze genereus kennis heeft gegeven, zelfs aan haar vijand, en waarschuwde hem voor het gevaar haar te betreden.\" - Benjamin Franklin\n\nMet andere woorden, laat deze slang een embleem en symbool zijn van de vrijheidsstrijders. Begin nooit met een aanval, maar als iemand je eenmaal wil betreden, geef je dan nooit over. Breng de overtreder altijd genereus op de hoogte van zijn overtreding.",
      "pap": "Manera a wòrdu papia anteriormente, e kolebra tin un lugá prominente den okultismo. E kolebra di e bandera di Gadsden (mira banda), òf e kaskabel amerikano, tabata un símbolo di e berdadero identidat nashonal di Merka, maske media a kritik'é masha negativo. Nan ta mir'é komo un símbolo di rebelion, pero tambe di terorismo. En realidat e ta un símbolo di unidat, amor i libertat. Benjamin Franklin, un di e tatanan fundadó di Merka, a duna un splikashon masha presis di e kolebra aki:\n\n\"E [kolebra] nunka ta kuminsá un atake, ni, un biaha envolví, e ta entregá su mes: p'esei e ta un símbolo di grandesa di alma i berdadero koral ... e nunka ta heridá te ora el a duna aviso generosamente, asta na su enemigu, i a alertá riba e peliger di trapa riba dje.\" - Benjamin Franklin\n\nKu otro palabra, laga e kolebra aki ta un emblema i símbolo di e luchadónan pa libertat. Nunka kuminsá un atake, pero un biaha ku un hende ke trapa riba bo, nunka entregá. Semper avisá e ofensor generosamente di su transgreshon."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/Valhalla.mp3",
    "image": "/assets/images/dont-tread-on-me.png",
    "imageAlt": "Season 02/Loop Niet Over Mij Heen: Valhalla - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-05-het-monetaire-systeem",
    "nextEpisode": "legacy-season-02-karmishe-wet-of-niet",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 468,
      "kind": "podcast",
      "image": "images/dont-tread-on-me.png"
    }
  },
  {
    "id": "legacy-season-02-karmishe-wet-of-niet",
    "slug": {
      "en": "season-02-karmishe-wet-of-niet",
      "es": "season-02-karmishe-wet-of-niet",
      "nl": "season-02-karmishe-wet-of-niet",
      "pap": "season-02-karmishe-wet-of-niet"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 113,
    "title": {
      "en": "Season 02/ Karmic Law (or Not)",
      "es": "Temporada 02/ La Ley Kármica (o No)",
      "nl": "Season 02/ Karmishe Wet (of Niet)",
      "pap": "Temporada 02/ Lei Kármiko (òf Nò)"
    },
    "language": "en",
    "summary": {
      "en": "In this podcast we discuss whether karma is real or not. We discuss the consequences of understanding or not understanding its existence. We will discuss why karma found its way into Western civilization and the relationship it has with metempsychosis and reincarnation.",
      "es": "En este pódcast hablamos de si el karma es real o no. Comentamos las consecuencias de comprender o no su existencia. Hablaremos de por qué el karma encontró su camino en la civilización occidental y la relación que tiene con la metempsicosis y la reencarnación.",
      "nl": "In deze podcast gaan we bespreken of karma echt is of niet. We zullen de gevolgen bespreken van het al dan niet begrijpen van het bestaan ervan. We zullen bespreken waarom karma zijn weg vond in de westerse beschaving en de relatie die het heeft met metempsychose en reïncarnatie.",
      "pap": "Den e podcast aki nos ta papia di si karma ta real òf nò. Nos ta papia di e konsekuensianan di komprondé òf no komprondé su eksistensia. Nos lo papia di dikon karma a haña su kaminda den sivilisashon western i e relashon ku e tin ku metempsikosis i reenkarnashon."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02-%20Karmische%20Wet.mp3",
    "image": "/assets/images/karma.jpg",
    "imageAlt": "Season 02/ Karmishe Wet (of Niet) - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "De Leer Van Boeddha",
          "es": "De Leer Van Boeddha",
          "nl": "De Leer Van Boeddha",
          "pap": "De Leer Van Boeddha"
        },
        "url": "./articles/TheTeachingofBuddha.pdf",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-season-02-loop-niet-over-mij-heen-valhalla",
    "nextEpisode": "legacy-season-02-episode-05-and-189-het-blauwe-envelopje",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 492,
      "kind": "podcast",
      "image": "images/karma.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-05-and-189-het-blauwe-envelopje",
    "slug": {
      "en": "season-02-episode-05-and-189-het-blauwe-envelopje",
      "es": "season-02-episode-05-and-189-het-blauwe-envelopje",
      "nl": "season-02-episode-05-and-189-het-blauwe-envelopje",
      "pap": "season-02-episode-05-and-189-het-blauwe-envelopje"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 114,
    "title": {
      "en": "Season 02/Episode 05&#189;: The Blue Envelope",
      "es": "Temporada 02/Episodio 05&#189;: El Sobre Azul",
      "nl": "Season 02/Episode 05&#189;: Het Blauwe Envelopje",
      "pap": "Temporada 02/Episodio 05&#189;: E Karta Blou"
    },
    "language": "nl",
    "summary": {
      "en": "Season 2, Episode 5½: The Blue Envelope.",
      "es": "Temporada 2, Episodio 5½: El Sobre Azul.",
      "nl": "Seizoen 2, Aflevering 5½: Het Blauwe Envelopje.",
      "pap": "Temporada 2, Episodio 5½: E Karta Blou."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02055%20-%20Het%20Blauwe%20Envelopje.mp3",
    "image": "/assets/images/blue-envelope.jpeg",
    "imageAlt": "Season 02/Episode 05&#189;: Het Blauwe Envelopje - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Standbeeld van Wilhelmina - 1",
          "es": "Het Standbeeld van Wilhelmina - 1",
          "nl": "Het Standbeeld van Wilhelmina - 1",
          "pap": "Het Standbeeld van Wilhelmina - 1"
        },
        "url": "./images/wilhelmina.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Standbeeld van Wilhelmina - 2",
          "es": "Het Standbeeld van Wilhelmina - 2",
          "nl": "Het Standbeeld van Wilhelmina - 2",
          "pap": "Het Standbeeld van Wilhelmina - 2"
        },
        "url": "./images/wilhelmina-2.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Standbeeld van Wilhelmina - 3",
          "es": "Het Standbeeld van Wilhelmina - 3",
          "nl": "Het Standbeeld van Wilhelmina - 3",
          "pap": "Het Standbeeld van Wilhelmina - 3"
        },
        "url": "./images/wilhelmina-3.jpg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-karmishe-wet-of-niet",
    "nextEpisode": "legacy-season-02-episode-06-massa-media",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 523,
      "kind": "podcast",
      "image": "images/blue-envelope.jpeg"
    }
  },
  {
    "id": "legacy-season-02-episode-06-massa-media",
    "slug": {
      "en": "season-02-episode-06-massa-media",
      "es": "season-02-episode-06-massa-media",
      "nl": "season-02-episode-06-massa-media",
      "pap": "season-02-episode-06-massa-media"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 115,
    "title": {
      "en": "Season 02/Episode 06: Mass Media",
      "es": "Temporada 02/Episodio 06: Medios de Masas",
      "nl": "Season 02/Episode 06: Massa Media",
      "pap": "Temporada 02/Episodio 06: Medio di Masa"
    },
    "language": "nl",
    "summary": {
      "en": "This podcast discusses the intent and purpose of the mass media as a powerful instrument for manipulating the mind of the population. In a sense, this tool is used to manufacture consent in the minds of many.",
      "es": "Este podcast trata la intención y el propósito de los medios masivos como un instrumento poderoso para manipular la mente de la población. En cierto sentido, esta herramienta se usa para fabricar el consentimiento en las mentes de muchos.",
      "nl": "Deze podcast bespreekt de bedoeling en het doel van de massamedia als een krachtig instrument om de geest van de bevolking te manipuleren. In zekere zin wordt deze tool gebruikt om toestemming te creëren in de hoofden van velen.",
      "pap": "E podcast aki ta trata e intenshon i propósito di e medionan masivo komo un instrumento poderoso pa manipulá e mente di e poblashon. Den un sentido, e hèrmènt aki ta wòrdu usá pa fabriká konsentimentu den e mente di hopi hende."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0206%20-%20Massa%20Media.mp3",
    "image": "/assets/images/media-bg.jpg",
    "imageAlt": "Season 02/Episode 06: Massa Media - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Massa Media in VS",
          "es": "Massa Media in VS",
          "nl": "Massa Media in VS",
          "pap": "Massa Media in VS"
        },
        "url": "./images/media-owners-us.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Massa Media in Europa",
          "es": "Massa Media in Europa",
          "nl": "Massa Media in Europa",
          "pap": "Massa Media in Europa"
        },
        "url": "./images/media-owners-eu.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Adolf Hitler",
          "es": "Adolf Hitler",
          "nl": "Adolf Hitler",
          "pap": "Adolf Hitler"
        },
        "url": "./images/hitler.jpeg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-05-and-189-het-blauwe-envelopje",
    "nextEpisode": "legacy-season-02-het-niet-agressieprincipe-eternal-light",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 560,
      "kind": "podcast",
      "image": "images/media-bg.jpg"
    }
  },
  {
    "id": "legacy-season-02-het-niet-agressieprincipe-eternal-light",
    "slug": {
      "en": "season-02-het-niet-agressieprincipe-eternal-light",
      "es": "season-02-het-niet-agressieprincipe-eternal-light",
      "nl": "season-02-het-niet-agressieprincipe-eternal-light",
      "pap": "season-02-het-niet-agressieprincipe-eternal-light"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 116,
    "title": {
      "en": "Season 02/The Non-Aggression Principle: Eternal Light",
      "es": "Temporada 02/El Principio de No Agresión: Eternal Light",
      "nl": "Season 02/Het Niet-Agressieprincipe: Eternal Light",
      "pap": "Temporada 02/E Prinsipio di No-Agreshon: Eternal Light"
    },
    "language": "nl",
    "summary": {
      "en": "The non-aggression principle (NAP) is a concept in which aggression, defined as the initiation of any violent interference against a person, group, or their property, is inherently wrong. People often think that good is passive, non-judgmental, or merely merciful. The good is the antidote to evil. How then can the good heal, if it leaves evil untouched? If someone is truly unwilling to change their behavior for the better, do not hesitate to end the evil, without mercy, by whatever means.",
      "es": "El principio de no agresión (PNA) es un concepto según el cual la agresión, definida como el inicio de cualquier interferencia violenta contra una persona, un grupo o su propiedad, es intrínsecamente incorrecta. La gente suele pensar que el bien es pasivo, no enjuiciador o meramente misericordioso. El bien es el antídoto del mal. ¿Cómo puede entonces el bien sanar, si deja el mal intacto? Si alguien realmente no está dispuesto a cambiar su conducta para mejor, no dudes en poner fin al mal, sin misericordia, por cualquier medio.",
      "nl": "Het niet-agressieprincipe (NAP) is een concept waarin agressie, gedefinieerd als het initiëren van elke geweldadig inmenging tegen een persoon, groep, of hun eigendom, inherent verkeerd is. Mensen denken vaak dat goed passief, niet-oordelend of alleen barmhartig is. Het goede is het tegengif van het kwaad. Hoe kan het goede dan genezen, als het het kwaad onaangeroerd laat? Als men echt niet bereid is zijn gedrag ten goede te veranderen, aarzel dan niet om het kwaad, zonder genade, op welke manier dan ook, te beëindigen.",
      "pap": "E prinsipio di no-agreshon (NAP) ta un konsepto den kua agreshon, definí komo e inisiashon di kualke interferensia violento kontra un persona, grupo, òf nan propiedat, ta inherentemente robes. Hende hopi biaha ta pensa ku bon ta pasivo, sin huzga, òf solamente miserikòrdioso. E bon ta e antídoto di maldat. Kon anto e bon por kura, si e ta laga maldat intakto? Si un hende di bèrdat no ta dispuesto pa kambia su komportashon pa mihó, no duda di pone fin na e maldat, sin miserikòrdia, na kualke manera."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/eternal-light.mp3",
    "image": "/assets/images/serpent-and-dove.jpg",
    "imageAlt": "Season 02/Het Niet-Agressieprincipe: Eternal Light - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-06-massa-media",
    "nextEpisode": "legacy-season-02-episode-07-voedsel",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 597,
      "kind": "podcast",
      "image": "images/serpent-and-dove.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-07-voedsel",
    "slug": {
      "en": "season-02-episode-07-voedsel",
      "es": "season-02-episode-07-voedsel",
      "nl": "season-02-episode-07-voedsel",
      "pap": "season-02-episode-07-voedsel"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 117,
    "title": {
      "en": "Season 02/Episode 07: Food",
      "es": "Temporada 02/Episodio 07: Alimentos",
      "nl": "Season 02/Episode 07: Voedsel",
      "pap": "Temporada 02/Episodio 07: Kuminda"
    },
    "language": "nl",
    "summary": {
      "en": "In this podcast we talk about our food as a method of manipulation. The relationship between what we consume and our capacity for thought is discussed here.",
      "es": "En este podcast hablamos de nuestra comida como método de manipulación. Aquí se analiza la relación entre lo que consumimos y nuestra capacidad de pensar.",
      "nl": "In deze podcast praten we over ons voedsel als manipulatiemethode. De relatie tussen wat we consumeren en ons denkvermogen wordt hier besproken.",
      "pap": "Den e podcast aki nos ta papia di nos kuminda komo un método di manipulashon. Akinan ta analisá e relashon entre loke nos ta konsumí i nos kapasidat di pensa."
    },
    "videoUrl": "./media/earthlings.mp4",
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0207%20-%20Voedsel.mp3",
    "image": "/assets/images/foods.jpg",
    "imageAlt": "Season 02/Episode 07: Voedsel - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Earthlings",
          "es": "Earthlings",
          "nl": "Earthlings",
          "pap": "Earthlings"
        },
        "url": "./media/earthlings.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Supersize Me",
          "es": "Supersize Me",
          "nl": "Supersize Me",
          "pap": "Supersize Me"
        },
        "url": "./media/super-size-me.mkv",
        "type": "video"
      },
      {
        "label": {
          "en": "The World According to Monsanto",
          "es": "The World According to Monsanto",
          "nl": "The World According to Monsanto",
          "pap": "The World According to Monsanto"
        },
        "url": "./media/the-world-according-to-monsanto.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Frankenskies",
          "es": "Frankenskies",
          "nl": "Frankenskies",
          "pap": "Frankenskies"
        },
        "url": "./media/frankenskies.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Codex Alimentarius",
          "es": "Codex Alimentarius",
          "nl": "Codex Alimentarius",
          "pap": "Codex Alimentarius"
        },
        "url": "https://www.codexalimentarius.nl/",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-het-niet-agressieprincipe-eternal-light",
    "nextEpisode": "legacy-season-02-episode-08-medicijn",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 619,
      "kind": "podcast",
      "image": "images/foods.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-08-medicijn",
    "slug": {
      "en": "season-02-episode-08-medicijn",
      "es": "season-02-episode-08-medicijn",
      "nl": "season-02-episode-08-medicijn",
      "pap": "season-02-episode-08-medicijn"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 118,
    "title": {
      "en": "Season 02/Episode 08: Medicine",
      "es": "Temporada 02/Episodio 08: Medicina",
      "nl": "Season 02/Episode 08: Medicijn",
      "pap": "Temporada 02/Episodio 08: Remedi"
    },
    "language": "nl",
    "summary": {
      "en": "In this podcast we talk about medicines as a method of manipulation. The danger of these substances and what they do to our brain is discussed here.",
      "es": "En este podcast hablamos de los medicamentos como método de manipulación. Aquí se analiza el peligro de estas sustancias y lo que hacen a nuestro cerebro.",
      "nl": "In deze podcast praten we over medicijnen als manipulatiemethode. Het gevaar van deze middelen en wat ze doen met onze brein wordt hier besproken.",
      "pap": "Den e podcast aki nos ta papia di remedi komo un método di manipulashon. Akinan ta analisá e peliger di e sustansianan aki i kiko nan ta hasi ku nos serebro."
    },
    "videoUrl": "./media/frankenskies.mp4",
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02E08%20-%20Medicijn.mp3",
    "image": "/assets/images/pharma.jpg",
    "imageAlt": "Season 02/Episode 08: Medicijn - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Vaccin Vrij",
          "es": "Vaccin Vrij",
          "nl": "Vaccin Vrij",
          "pap": "Vaccin Vrij"
        },
        "url": "./media/vaccinvrij-boek.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Frankenskies",
          "es": "Frankenskies",
          "nl": "Frankenskies",
          "pap": "Frankenskies"
        },
        "url": "./media/frankenskies.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Chemtrails",
          "es": "Chemtrails",
          "nl": "Chemtrails",
          "pap": "Chemtrails"
        },
        "url": "./images/chemtrails.jpeg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-07-voedsel",
    "nextEpisode": "legacy-season-02-episode-09-de-illusie-van-tijd",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 664,
      "kind": "podcast",
      "image": "images/pharma.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-09-de-illusie-van-tijd",
    "slug": {
      "en": "season-02-episode-09-de-illusie-van-tijd",
      "es": "season-02-episode-09-de-illusie-van-tijd",
      "nl": "season-02-episode-09-de-illusie-van-tijd",
      "pap": "season-02-episode-09-de-illusie-van-tijd"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 119,
    "title": {
      "en": "Season 02/Episode 09: The Illusion of Time",
      "es": "Temporada 02/Episodio 09: La Ilusión del Tiempo",
      "nl": "Season 02/Episode 09: De illusie van Tijd",
      "pap": "Temporada 02/Episodio 09: E Ilushon di Tempu"
    },
    "language": "nl",
    "summary": {
      "en": "Season 2, Episode 9: The Illusion of Time.",
      "es": "Temporada 2, Episodio 9: La Ilusión del Tiempo.",
      "nl": "Seizoen 2, Aflevering 9: De Illusie van Tijd.",
      "pap": "Temporada 2, Episodio 9: E Ilushon di Tempu."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02E09%20-%20De%20Illusie%20van%20Tijd.mp3",
    "image": "/assets/images/time-bg.jpg",
    "imageAlt": "Season 02/Episode 09: De illusie van Tijd - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Oppervlakte van Saturnus",
          "es": "Oppervlakte van Saturnus",
          "nl": "Oppervlakte van Saturnus",
          "pap": "Oppervlakte van Saturnus"
        },
        "url": "./images/saturn-cube.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Chronus",
          "es": "Chronus",
          "nl": "Chronus",
          "pap": "Chronus"
        },
        "url": "./images/chronus.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Mazzaroth/Zodiac - De Pad van de Zon",
          "es": "Mazzaroth/Zodiac - De Pad van de Zon",
          "nl": "Mazzaroth/Zodiac - De Pad van de Zon",
          "pap": "Mazzaroth/Zodiac - De Pad van de Zon"
        },
        "url": "./images/mazzaroth.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Zonnestraling (Doornenkroon)",
          "es": "Zonnestraling (Doornenkroon)",
          "nl": "Zonnestraling (Doornenkroon)",
          "pap": "Zonnestraling (Doornenkroon)"
        },
        "url": "./images/sun-rays.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Precessie van de Equinoxen",
          "es": "Precessie van de Equinoxen",
          "nl": "Precessie van de Equinoxen",
          "pap": "Precessie van de Equinoxen"
        },
        "url": "./images/equinoxes.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Shofar",
          "es": "Shofar",
          "nl": "Shofar",
          "pap": "Shofar"
        },
        "url": "./images/shofar.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Zodiac Symbolen",
          "es": "Zodiac Symbolen",
          "nl": "Zodiac Symbolen",
          "pap": "Zodiac Symbolen"
        },
        "url": "./images/zodiac-symbols.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbool van de Zon",
          "es": "Symbool van de Zon",
          "nl": "Symbool van de Zon",
          "pap": "Symbool van de Zon"
        },
        "url": "./images/circle-dot.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Russische Poppen",
          "es": "Russische Poppen",
          "nl": "Russische Poppen",
          "pap": "Russische Poppen"
        },
        "url": "./images/russian-dolls.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Weekdagen",
          "es": "Weekdagen",
          "nl": "Weekdagen",
          "pap": "Weekdagen"
        },
        "url": "./images/weekdays-planets.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbolen van de 3 Grote Religies",
          "es": "Symbolen van de 3 Grote Religies",
          "nl": "Symbolen van de 3 Grote Religies",
          "pap": "Symbolen van de 3 Grote Religies"
        },
        "url": "./images/religions-symbols.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Kaaba",
          "es": "Kaaba",
          "nl": "Kaaba",
          "pap": "Kaaba"
        },
        "url": "./images/Kaaba.jpg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-08-medicijn",
    "nextEpisode": "legacy-season-02-episode-10-de-dhr-factor",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 701,
      "kind": "podcast",
      "image": "images/time-bg.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-10-de-dhr-factor",
    "slug": {
      "en": "season-02-episode-10-de-dhr-factor",
      "es": "season-02-episode-10-de-dhr-factor",
      "nl": "season-02-episode-10-de-dhr-factor",
      "pap": "season-02-episode-10-de-dhr-factor"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 120,
    "title": {
      "en": "Season 02/Episode 10: The DHR Factor",
      "es": "Temporada 02/Episodio 10: El Factor DHR",
      "nl": "Season 02/Episode 10: De DHR-Factor",
      "pap": "Temporada 02/Episodio 10: E Faktor DHR"
    },
    "language": "nl",
    "summary": {
      "en": "In this podcast we talk about the DHR factor as a method of manipulation. Often we do not want the hassle, the ridicule, that comes with speaking the truth. In addition, many people deny their reality. This will ultimately lead to their downfall if they do not deal with their reality.",
      "es": "En este podcast hablamos del factor DHR como método de manipulación. A menudo no queremos las molestias ni la burla que conlleva decir la verdad. Además, mucha gente niega su realidad. Esto terminará por llevarlos a la ruina si no afrontan su realidad.",
      "nl": "In deze podcast praten we over de DHR-factor als manipulatiemethode. Vaak willen we niet het gedoe, de spot als we de waarheid spreken. Daarnaast ontkennen veel mensen hun realiteit. Dit zal uiteindelijk leiden tot hun vernietiging als ze niet omgaan met hun realiteit.",
      "pap": "Den e podcast aki nos ta papia di e faktor DHR komo un método di manipulashon. Hopi biaha nos no ke e molèster, e bofon ku ta bin ku papia bèrdat. Ademas, hopi hende ta nenga nan realidat. Esaki ulteriormente lo hiba nan na destrukshon si nan no enfrentá nan realidat."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02E10%20-%20De%20DHR%20Methode.mp3",
    "image": "/assets/images/dhr.png",
    "imageAlt": "Season 02/Episode 10: De DHR-Factor - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-09-de-illusie-van-tijd",
    "nextEpisode": "legacy-season-02-de-drie-hoofdculten-dragonborn",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 765,
      "kind": "podcast",
      "image": "images/dhr.png"
    }
  },
  {
    "id": "legacy-season-02-de-drie-hoofdculten-dragonborn",
    "slug": {
      "en": "season-02-de-drie-hoofdculten-dragonborn",
      "es": "season-02-de-drie-hoofdculten-dragonborn",
      "nl": "season-02-de-drie-hoofdculten-dragonborn",
      "pap": "season-02-de-drie-hoofdculten-dragonborn"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 121,
    "title": {
      "en": "Season 02/The Three Main Cults: Dragonborn",
      "es": "Temporada 02/Los Tres Cultos Principales: Dragonborn",
      "nl": "Season 02/De Drie Hoofdculten: Dragonborn",
      "pap": "Temporada 02/E Tres Kultonan Prinsipal: Dragonborn"
    },
    "language": "nl",
    "summary": {
      "en": "According to ancient traditions, all religion is based on one of three main cults. The first is the cult of the sun. An example is the Christian religion. Its symbol is the Jewish cross that represents the zodiac/Mazzaroth. The zodiac/Mazzaroth is the path of our sun. Their sabbath is on Sunday – the day of the sun. The second is the cult of the Moon. An example is the religion of Islam. Its symbol is the Moon, but also Venus. Their sabbath is on Friday – the day of Venus. Both Venus and the Moon stand for the feminine principle, but reflect a difference in state. The Moon represents the woman who wishes for a child, while Venus represents the woman who is pregnant. The third is the cult of the lesser lights and planets. An example is the religion of the Jews. Its symbol is a six-pointed star called the Star of David. Their sabbath is on Saturday – the day of Saturn.",
      "es": "Según las tradiciones antiguas, toda religión se basa en uno de tres cultos principales. El primero es el culto del sol. Un ejemplo es la religión cristiana. Su símbolo es la cruz judía que representa el zodíaco/Mazzaroth. El zodíaco/Mazzaroth es el camino de nuestro sol. Su sabbat es el domingo, el día del sol. El segundo es el culto de la Luna. Un ejemplo es la religión del islam. Su símbolo es la Luna, pero también Venus. Su sabbat es el viernes, el día de Venus. Tanto Venus como la Luna representan el principio femenino, pero reflejan una diferencia de estado. La Luna representa a la mujer que desea un hijo, mientras que Venus representa a la mujer embarazada. El tercero es el culto de las luminarias menores y los planetas. Un ejemplo es la religión de los judíos. Su símbolo es una estrella de seis puntas llamada Estrella de David. Su sabbat es el sábado, el día de Saturno.",
      "nl": "Volgens oude tradities is alle religie gebaseerd op één van de drie hoofdculten; de eerste is de cultus van de zon. Een voorbeeld is de christelijke religie. Het symbool is het joodse kruis dat de dierenriem/Mazzaroth vertegenwoordigt. De dierenriem/Mazzaroth is het pad van onze zon. Hun sabbat is op zondag - de dag van de zon. de tweede is de cultus van de Maan. Een voorbeeld is de religie van de islam. Het symbool is de Maan, maar ook Venus. Hun sabbat is op vrijdag - de dag van Venus. Beide, Venus en de Maan, staan voor het vrouwelijke principe, maar weerspiegelen het verschil in toestand. De Maan vertegenwoordigt de vrouw die een kind wenst, terwijl Venus de vrouw vertegenwoordigt die zwanger is. de derde is de cultus van mindere lichten en planeten. Een voorbeeld is de religie van de joden. Het symbool is een 6-puntige ster genaamd de Davidster. Hun Sabbat is op zaterdag - de dag van Saturnus.",
      "pap": "Segun tradishonnan antiguo, tur religion ta basá riba un di tres kulto prinsipal. E promé ta e kulto di solo. Un ehèmpel ta e religion kristian. Su símbolo ta e krus hudiu ku ta representá e zodíako/Mazzaroth. E zodíako/Mazzaroth ta e kaminda di nos solo. Nan sabat ta riba diadomingo – e dia di solo. E di dos ta e kulto di Luna. Un ehèmpel ta e religion di islam. Su símbolo ta Luna, pero tambe Venus. Nan sabat ta riba diabièrnè – e dia di Venus. Tantu Venus komo Luna ta representá e prinsipio femenino, pero ta reflehá un diferensia di estado. Luna ta representá e muhé ku ta deseá un yu, miéntras Venus ta representá e muhé ku ta na estado. E di tres ta e kulto di e lusnan menor i e planetanan. Un ehèmpel ta e religion di e hudiunan. Su símbolo ta un strea di seis punta yamá Strea di David. Nan sabat ta riba diasabra – e dia di Saturno."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/skyrim-dovahkiin.mp3",
    "image": "/assets/images/dragon.png",
    "imageAlt": "Season 02/De Drie Hoofdculten: Dragonborn - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-10-de-dhr-factor",
    "nextEpisode": "legacy-season-02-episode-11-religie-deel-1",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 793,
      "kind": "podcast",
      "image": "images/dragon.png"
    }
  },
  {
    "id": "legacy-season-02-episode-11-religie-deel-1",
    "slug": {
      "en": "season-02-episode-11-religie-deel-1",
      "es": "season-02-episode-11-religie-deel-1",
      "nl": "season-02-episode-11-religie-deel-1",
      "pap": "season-02-episode-11-religie-deel-1"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 122,
    "title": {
      "en": "Season 02/Episode 11: Religion - Part 1",
      "es": "Temporada 02/Episodio 11: Religión - Parte 1",
      "nl": "Season 02/Episode 11: Religie - Deel 1",
      "pap": "Temporada 02/Episodio 11: Religion - Parti 1"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explain where religions come from and how religions are used as a manipulation technique.",
      "es": "En este episodio explicamos de dónde vienen las religiones y cómo se usan como técnica de manipulación.",
      "nl": "In deze aflevering leggen we uit waar religies vandaan komen en hoe religies worden gebruikt als manipulatietechniek.",
      "pap": "Den e episodio aki nos ta splika for di unda religionnan ta bini i kon religionnan ta wordu uza komo teknika di manipulashon."
    },
    "videoUrl": "./videos/Remember Your Essence - Manly P. Hall.mp4",
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02E11%20-%20Religie-Deel-1.mp3",
    "image": "/assets/images/religion-bg-1.jpg",
    "imageAlt": "Season 02/Episode 11: Religie - Deel 1 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Oppervlakte van Saturnus",
          "es": "Oppervlakte van Saturnus",
          "nl": "Oppervlakte van Saturnus",
          "pap": "Oppervlakte van Saturnus"
        },
        "url": "./images/saturn-cube.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)",
          "es": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)",
          "nl": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)",
          "pap": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)"
        },
        "url": "./articles/Pre-Existing-Data-Christianized-NL.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Mazzaroth/Zodiac - De Pad van de Zon",
          "es": "Mazzaroth/Zodiac - De Pad van de Zon",
          "nl": "Mazzaroth/Zodiac - De Pad van de Zon",
          "pap": "Mazzaroth/Zodiac - De Pad van de Zon"
        },
        "url": "./images/mazzaroth.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Parallellen tussen Jezus en Horus (pdf)",
          "es": "Parallellen tussen Jezus en Horus (pdf)",
          "nl": "Parallellen tussen Jezus en Horus (pdf)",
          "pap": "Parallellen tussen Jezus en Horus (pdf)"
        },
        "url": "./articles/Parallels-Between-Jesus-And-Horus-NL.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Precessie van de Equinoxen",
          "es": "Precessie van de Equinoxen",
          "nl": "Precessie van de Equinoxen",
          "pap": "Precessie van de Equinoxen"
        },
        "url": "./images/equinoxes.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Manly P. Hall - Astro Theologie Lessen (mp3)",
          "es": "Manly P. Hall - Astro Theologie Lessen (mp3)",
          "nl": "Manly P. Hall - Astro Theologie Lessen (mp3)",
          "pap": "Manly P. Hall - Astro Theologie Lessen (mp3)"
        },
        "url": "./pods/Astro-Theology.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Zodiac Symbolen",
          "es": "Zodiac Symbolen",
          "nl": "Zodiac Symbolen",
          "pap": "Zodiac Symbolen"
        },
        "url": "./images/zodiac-symbols.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Manly P. Hall - Remember Your Essence",
          "es": "Manly P. Hall - Remember Your Essence",
          "nl": "Manly P. Hall - Remember Your Essence",
          "pap": "Manly P. Hall - Remember Your Essence"
        },
        "url": "./videos/Remember Your Essence - Manly P. Hall.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Weekdagen",
          "es": "Weekdagen",
          "nl": "Weekdagen",
          "pap": "Weekdagen"
        },
        "url": "./images/weekdays-planets.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbolen van de 3 Grote Religies",
          "es": "Symbolen van de 3 Grote Religies",
          "nl": "Symbolen van de 3 Grote Religies",
          "pap": "Symbolen van de 3 Grote Religies"
        },
        "url": "./images/religions-symbols.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Kaaba",
          "es": "Kaaba",
          "nl": "Kaaba",
          "pap": "Kaaba"
        },
        "url": "./images/Kaaba.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Horus-Osiris-Seth",
          "es": "Horus-Osiris-Seth",
          "nl": "Horus-Osiris-Seth",
          "pap": "Horus-Osiris-Seth"
        },
        "url": "./images/horus-osiris-seth.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Djed",
          "es": "Djed",
          "nl": "Djed",
          "pap": "Djed"
        },
        "url": "./images/djed.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Horus-Osiris-Isis",
          "es": "Horus-Osiris-Isis",
          "nl": "Horus-Osiris-Isis",
          "pap": "Horus-Osiris-Isis"
        },
        "url": "./images/horus-osiris-isis.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Chakras",
          "es": "Chakras",
          "nl": "Chakras",
          "pap": "Chakras"
        },
        "url": "./images/chakras.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Protocols of the Learned Elders of Zion (pdf)",
          "es": "Protocols of the Learned Elders of Zion (pdf)",
          "nl": "Protocols of the Learned Elders of Zion (pdf)",
          "pap": "Protocols of the Learned Elders of Zion (pdf)"
        },
        "url": "./media/protocols.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)",
          "es": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)",
          "nl": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)",
          "pap": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)"
        },
        "url": "./images/zodiac-cross.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De Egyptische Sfinx van Giza",
          "es": "De Egyptische Sfinx van Giza",
          "nl": "De Egyptische Sfinx van Giza",
          "pap": "De Egyptische Sfinx van Giza"
        },
        "url": "./images/sphinx.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Leonardo Da Vinci's Laatste Avondmaal",
          "es": "Leonardo Da Vinci's Laatste Avondmaal",
          "nl": "Leonardo Da Vinci's Laatste Avondmaal",
          "pap": "Leonardo Da Vinci's Laatste Avondmaal"
        },
        "url": "./images/last-supper.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De Planeten in relatie met de Chakras",
          "es": "De Planeten in relatie met de Chakras",
          "nl": "De Planeten in relatie met de Chakras",
          "pap": "De Planeten in relatie met de Chakras"
        },
        "url": "./images/planets-chacras.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbool van de Zon",
          "es": "Symbool van de Zon",
          "nl": "Symbool van de Zon",
          "pap": "Symbool van de Zon"
        },
        "url": "./images/circle-dot.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Centrum van onze Melkweg",
          "es": "Het Centrum van onze Melkweg",
          "nl": "Het Centrum van onze Melkweg",
          "pap": "Het Centrum van onze Melkweg"
        },
        "url": "./images/milky-way-center.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De Ster van David (met de 2D Kubus)",
          "es": "De Ster van David (met de 2D Kubus)",
          "nl": "De Ster van David (met de 2D Kubus)",
          "pap": "De Ster van David (met de 2D Kubus)"
        },
        "url": "./images/david-star-cube.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbolische Temple van Salomon",
          "es": "Symbolische Temple van Salomon",
          "nl": "Symbolische Temple van Salomon",
          "pap": "Symbolische Temple van Salomon"
        },
        "url": "./images/symbolic-temple.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Correspondentie tussen de Wereld and Religies",
          "es": "Correspondentie tussen de Wereld and Religies",
          "nl": "Correspondentie tussen de Wereld and Religies",
          "pap": "Correspondentie tussen de Wereld and Religies"
        },
        "url": "./images/correspondance.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Cerebellum",
          "es": "Cerebellum",
          "nl": "Cerebellum",
          "pap": "Cerebellum"
        },
        "url": "./images/cerebellum.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Ma'at/Maria",
          "es": "Ma'at/Maria",
          "nl": "Ma'at/Maria",
          "pap": "Ma'at/Maria"
        },
        "url": "./images/maat.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Kabbalistische levensboom",
          "es": "Kabbalistische levensboom",
          "nl": "Kabbalistische levensboom",
          "pap": "Kabbalistische levensboom"
        },
        "url": "./images/treeoflife.png",
        "type": "external"
      },
      {
        "label": {
          "en": "De Seizoenen",
          "es": "De Seizoenen",
          "nl": "De Seizoenen",
          "pap": "De Seizoenen"
        },
        "url": "./images/seasons.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Ons Zonnestelsel",
          "es": "Ons Zonnestelsel",
          "nl": "Ons Zonnestelsel",
          "pap": "Ons Zonnestelsel"
        },
        "url": "./images/zonnestelsel.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Astro Theologie",
          "es": "Astro Theologie",
          "nl": "Astro Theologie",
          "pap": "Astro Theologie"
        },
        "url": "./images/astro-theologie.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Tijdlijn van Religies",
          "es": "Tijdlijn van Religies",
          "nl": "Tijdlijn van Religies",
          "pap": "Tijdlijn van Religies"
        },
        "url": "./images/religions-chart.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-de-drie-hoofdculten-dragonborn",
    "nextEpisode": "legacy-season-02-episode-11-religie-deel-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 820,
      "kind": "podcast",
      "image": "images/religion-bg-1.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-11-religie-deel-2",
    "slug": {
      "en": "season-02-episode-11-religie-deel-2",
      "es": "season-02-episode-11-religie-deel-2",
      "nl": "season-02-episode-11-religie-deel-2",
      "pap": "season-02-episode-11-religie-deel-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 123,
    "title": {
      "en": "Season 02/Episode 11: Religion - Part 2",
      "es": "Temporada 02/Episodio 11: Religión - Parte 2",
      "nl": "Season 02/Episode 11: Religie - Deel 2",
      "pap": "Temporada 02/Episodio 11: Religion - Parti 2"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explain where religions come from and how religions are used as a manipulation technique.",
      "es": "En este episodio explicamos de dónde vienen las religiones y cómo se usan como técnica de manipulación.",
      "nl": "In deze aflevering leggen we uit waar religies vandaan komen en hoe religies worden gebruikt als manipulatietechniek.",
      "pap": "Den e episodio aki nos ta splika for di unda religionnan ta bini i kon religionnan ta wordu uza komo teknika di manipulashon."
    },
    "videoUrl": "./videos/Remember Your Essence - Manly P. Hall.mp4",
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S02E11%20-%20Religie-Deel-2.mp3",
    "image": "/assets/images/religion-bg-3.jpg",
    "imageAlt": "Season 02/Episode 11: Religie - Deel 2 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Oppervlakte van Saturnus",
          "es": "Oppervlakte van Saturnus",
          "nl": "Oppervlakte van Saturnus",
          "pap": "Oppervlakte van Saturnus"
        },
        "url": "./images/saturn-cube.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)",
          "es": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)",
          "nl": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)",
          "pap": "Vergelijkende lijst van reeds bestaande gegevens die in het Nieuwe Testament zijn gekerstend (pdf)"
        },
        "url": "./articles/Pre-Existing-Data-Christianized-NL.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Mazzaroth/Zodiac - De Pad van de Zon",
          "es": "Mazzaroth/Zodiac - De Pad van de Zon",
          "nl": "Mazzaroth/Zodiac - De Pad van de Zon",
          "pap": "Mazzaroth/Zodiac - De Pad van de Zon"
        },
        "url": "./images/mazzaroth.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Parallellen tussen Jezus en Horus (pdf)",
          "es": "Parallellen tussen Jezus en Horus (pdf)",
          "nl": "Parallellen tussen Jezus en Horus (pdf)",
          "pap": "Parallellen tussen Jezus en Horus (pdf)"
        },
        "url": "./articles/Parallels-Between-Jesus-And-Horus-NL.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Precessie van de Equinoxen",
          "es": "Precessie van de Equinoxen",
          "nl": "Precessie van de Equinoxen",
          "pap": "Precessie van de Equinoxen"
        },
        "url": "./images/equinoxes.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Manly P. Hall - Astro Theologie Lessen (mp3)",
          "es": "Manly P. Hall - Astro Theologie Lessen (mp3)",
          "nl": "Manly P. Hall - Astro Theologie Lessen (mp3)",
          "pap": "Manly P. Hall - Astro Theologie Lessen (mp3)"
        },
        "url": "./pods/Astro-Theology.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Zodiac Symbolen",
          "es": "Zodiac Symbolen",
          "nl": "Zodiac Symbolen",
          "pap": "Zodiac Symbolen"
        },
        "url": "./images/zodiac-symbols.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Manly P. Hall - Remember Your Essence",
          "es": "Manly P. Hall - Remember Your Essence",
          "nl": "Manly P. Hall - Remember Your Essence",
          "pap": "Manly P. Hall - Remember Your Essence"
        },
        "url": "./videos/Remember Your Essence - Manly P. Hall.mp4",
        "type": "video"
      },
      {
        "label": {
          "en": "Weekdagen",
          "es": "Weekdagen",
          "nl": "Weekdagen",
          "pap": "Weekdagen"
        },
        "url": "./images/weekdays-planets.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbolen van de 3 Grote Religies",
          "es": "Symbolen van de 3 Grote Religies",
          "nl": "Symbolen van de 3 Grote Religies",
          "pap": "Symbolen van de 3 Grote Religies"
        },
        "url": "./images/religions-symbols.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Kaaba",
          "es": "Kaaba",
          "nl": "Kaaba",
          "pap": "Kaaba"
        },
        "url": "./images/Kaaba.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Horus-Osiris-Seth",
          "es": "Horus-Osiris-Seth",
          "nl": "Horus-Osiris-Seth",
          "pap": "Horus-Osiris-Seth"
        },
        "url": "./images/horus-osiris-seth.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Djed",
          "es": "Djed",
          "nl": "Djed",
          "pap": "Djed"
        },
        "url": "./images/djed.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Horus-Osiris-Isis",
          "es": "Horus-Osiris-Isis",
          "nl": "Horus-Osiris-Isis",
          "pap": "Horus-Osiris-Isis"
        },
        "url": "./images/horus-osiris-isis.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Chakras",
          "es": "Chakras",
          "nl": "Chakras",
          "pap": "Chakras"
        },
        "url": "./images/chakras.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Protocols of the Learned Elders of Zion (pdf)",
          "es": "Protocols of the Learned Elders of Zion (pdf)",
          "nl": "Protocols of the Learned Elders of Zion (pdf)",
          "pap": "Protocols of the Learned Elders of Zion (pdf)"
        },
        "url": "./media/protocols.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)",
          "es": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)",
          "nl": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)",
          "pap": "De Kruis van de Dierenriem (Blauwe Kruis) en de Galactische Kruis (Rode Kruis)"
        },
        "url": "./images/zodiac-cross.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De Egyptische Sfinx van Giza",
          "es": "De Egyptische Sfinx van Giza",
          "nl": "De Egyptische Sfinx van Giza",
          "pap": "De Egyptische Sfinx van Giza"
        },
        "url": "./images/sphinx.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Leonardo Da Vinci's Laatste Avondmaal",
          "es": "Leonardo Da Vinci's Laatste Avondmaal",
          "nl": "Leonardo Da Vinci's Laatste Avondmaal",
          "pap": "Leonardo Da Vinci's Laatste Avondmaal"
        },
        "url": "./images/last-supper.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De Planeten in relatie met de Chakras",
          "es": "De Planeten in relatie met de Chakras",
          "nl": "De Planeten in relatie met de Chakras",
          "pap": "De Planeten in relatie met de Chakras"
        },
        "url": "./images/planets-chacras.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbool van de Zon",
          "es": "Symbool van de Zon",
          "nl": "Symbool van de Zon",
          "pap": "Symbool van de Zon"
        },
        "url": "./images/circle-dot.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Het Centrum van onze Melkweg",
          "es": "Het Centrum van onze Melkweg",
          "nl": "Het Centrum van onze Melkweg",
          "pap": "Het Centrum van onze Melkweg"
        },
        "url": "./images/milky-way-center.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De Ster van David (met de 2D Kubus)",
          "es": "De Ster van David (met de 2D Kubus)",
          "nl": "De Ster van David (met de 2D Kubus)",
          "pap": "De Ster van David (met de 2D Kubus)"
        },
        "url": "./images/david-star-cube.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Symbolische Temple van Salomon",
          "es": "Symbolische Temple van Salomon",
          "nl": "Symbolische Temple van Salomon",
          "pap": "Symbolische Temple van Salomon"
        },
        "url": "./images/symbolic-temple.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Correspondentie tussen de Wereld and Religies",
          "es": "Correspondentie tussen de Wereld and Religies",
          "nl": "Correspondentie tussen de Wereld and Religies",
          "pap": "Correspondentie tussen de Wereld and Religies"
        },
        "url": "./images/correspondance.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Cerebellum",
          "es": "Cerebellum",
          "nl": "Cerebellum",
          "pap": "Cerebellum"
        },
        "url": "./images/cerebellum.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "Ma'at/Maria",
          "es": "Ma'at/Maria",
          "nl": "Ma'at/Maria",
          "pap": "Ma'at/Maria"
        },
        "url": "./images/maat.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Kabbalistische levensboom",
          "es": "Kabbalistische levensboom",
          "nl": "Kabbalistische levensboom",
          "pap": "Kabbalistische levensboom"
        },
        "url": "./images/treeoflife.png",
        "type": "external"
      },
      {
        "label": {
          "en": "De Seizoenen",
          "es": "De Seizoenen",
          "nl": "De Seizoenen",
          "pap": "De Seizoenen"
        },
        "url": "./images/seasons.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Ons Zonnestelsel",
          "es": "Ons Zonnestelsel",
          "nl": "Ons Zonnestelsel",
          "pap": "Ons Zonnestelsel"
        },
        "url": "./images/zonnestelsel.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "Astro Theologie",
          "es": "Astro Theologie",
          "nl": "Astro Theologie",
          "pap": "Astro Theologie"
        },
        "url": "./images/astro-theologie.png",
        "type": "external"
      },
      {
        "label": {
          "en": "Tijdlijn van Religies",
          "es": "Tijdlijn van Religies",
          "nl": "Tijdlijn van Religies",
          "pap": "Tijdlijn van Religies"
        },
        "url": "./images/religions-chart.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-11-religie-deel-1",
    "nextEpisode": "legacy-season-02-al-haar-namen-one-forgiven",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 948,
      "kind": "podcast",
      "image": "images/religion-bg-3.jpg"
    }
  },
  {
    "id": "legacy-season-02-al-haar-namen-one-forgiven",
    "slug": {
      "en": "season-02-al-haar-namen-one-forgiven",
      "es": "season-02-al-haar-namen-one-forgiven",
      "nl": "season-02-al-haar-namen-one-forgiven",
      "pap": "season-02-al-haar-namen-one-forgiven"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 124,
    "title": {
      "en": "Season 02/All Her Names: One Forgiven",
      "es": "Temporada 02/Todos Sus Nombres: One Forgiven",
      "nl": "Season 02/Al Haar Namen: One Forgiven",
      "pap": "Temporada 02/Tur Su Nòmbernan: One Forgiven"
    },
    "language": "en",
    "summary": {
      "en": "In the occult traditions the Serpent has many other names, such as Shekinah, Ruach, Queen of Harmony, Beauty, or Holy Spirit. In the East she is known as the Kundalini. She is the source of both life and death. She is a transforming Power. She is the source of the ability of Divinity itself. Before the Lion, the Serpent was the king of the jungle. That is why the Serpent is also depicted as a Lion in the West and as a Dragon in the East. When the Serpent manifests, you will KNOW, and there will be no doubt in you.\n\nIn the Bible the Serpent has a bad reputation, but many misunderstand her true Power. She is the Bringer of Knowledge and Understanding, the Bringer of Light, hence her name Lucifer. She is the Bringer of Grace and Salvation. She is your Healer. I say 'her' because it is the feminine aspect of Divinity, which the Ancients called Isis or Sophia. Last I checked, they call her Mary — the Queen of the Night. The Serpent has many names, each offering only a glimpse of the many manifestations of her Power. She is your true Spouse. Defile her and she becomes Satan. Respect her and she becomes the Holy Spirit — the choice is yours. I address her as my Beloved. I suggest you do the same.",
      "es": "En las tradiciones ocultas la Serpiente tiene muchos otros nombres, como Shekinah, Ruach, Reina de la Armonía, Belleza o Espíritu Santo. En Oriente se la conoce como la Kundalini. Es la fuente tanto de la vida como de la muerte. Es un Poder transformador. Es la fuente de la capacidad de la Divinidad misma. Antes que el León, la Serpiente era el rey de la selva. Por eso la Serpiente también se representa como un León en Occidente y como un Dragón en Oriente. Cuando la Serpiente se manifiesta, lo SABRÁS, y no habrá duda en ti.\n\nEn la Biblia la Serpiente tiene mala reputación, pero muchos malinterpretan su verdadero Poder. Es la Portadora del Conocimiento y la Comprensión, la Portadora de la Luz, de ahí su nombre Lucifer. Es la Portadora de la Gracia y la Salvación. Es tu Sanadora. Digo 'ella' porque es el aspecto femenino de la Divinidad, al que los Antiguos llamaron Isis o Sofía. La última vez que comprobé, la llaman María, la Reina de la Noche. La Serpiente tiene muchos nombres, cada uno ofrece solo un vistazo de las muchas manifestaciones de su Poder. Es tu verdadera Esposa. Profánala y se convierte en Satanás. Respétala y se convierte en el Espíritu Santo: la elección es tuya. Yo me dirijo a ella como mi Amada. Te sugiero que hagas lo mismo.",
      "nl": "In de occulte tradities heeft de Slang vele andere namen, zoals Shekinah, Ruach, Koningin van Harmonie, Schoonheid of Heilige Geest. In het oosten staat ze bekend als de Kundalini. Ze is de bron van zowel leven als dood. Ze is een transformerende Kracht. Ze is de bron van het vermogen van de Goddelijkheid zelf. Vóór de Leeuw was de Slang de koning van de jungle. Daarom wordt de Slang ook voorgesteld als een Leeuw in het westen en als een Draak in het oosten. Wanneer de Slang zich manifesteert, zul je het WETEN en zal er geen twijfel in je zijn.\n\nIn de Bijbel heeft de Slang een slechte reputatie, maar velen begrijpen de ware Kracht van haar verkeerd. Zij is de Brenger van Kennis en Begrip, de Brenger van Licht, vandaar haar naam Lucifer. Zij is de Brenger van Genade en Redding. Zij is je Genezer. Ik zeg 'haar' omdat het het vrouwelijke aspect van Goddelijkheid is, dat de Ouden Isis of Sophia noemden. De laatste keer dat ik keek, noemen ze haar Maria - de Nachtkoningin. De Slang heeft vele namen, die elk slechts een blik werpen op de vele manifestaties van haar Kracht. Zij is je ware Echtgenoot. Verontreinig haar en ze wordt Satan. Respecteer haar en zij wordt de Heilige Geest - de keuze is aan jou. Ik spreek haar aan als mijn Schat. Ik stel voor dat jij hetzelfde doet.",
      "pap": "Den e tradishonnan okulto e Kolebra tin hopi otro nòmber, manera Shekinah, Ruach, Reina di Armonia, Beyesa òf Spiritu Santu. Na oriente nan konos'é komo e Kundalini. E ta e fuente di tantu bida komo morto. E ta un Forsa transformadó. E ta e fuente di e abilidat di Divinidat mes. Promé ku e Leon, e Kolebra tabata e rei di mondi. P'esei e Kolebra ta wòrdu representá komo un Leon na oksidente i komo un Dragon na oriente. Ora e Kolebra manifestá, lo bo SA, i lo no tin duda den bo.\n\nDen Beibel e Kolebra tin un mal reputashon, pero hopi hende ta komprondé su berdadero Forsa robes. E ta e Trahedó di Konosementu i Komprondementu, e Trahedó di Lus, p'esei su nòmber Lucifer. E ta e Trahedó di Grasia i Salbashon. E ta bo Kuradó. Mi ta bisa 'e' pasobra e ta e aspekto femenino di Divinidat, ku e Antiguonan tabata yama Isis òf Sophia. Último biaha ku mi a wak, nan ta yam'é Maria - e Reina di Anochi. E Kolebra tin hopi nòmber, kada un ta duna djis un bista di e hopi manifestashonnan di su Forsa. E ta bo berdadero Kasá. Kontaminá e i e ta bira Satanas. Respet'é i e ta bira e Spiritu Santu - e eskoho ta di bo. Mi ta dirigí mi na dje komo mi Stimá. Mi ta sugerí ku bo hasi meskos."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/one-forgiven.mp3",
    "image": "/assets/images/snake.jpg",
    "imageAlt": "Season 02/Al Haar Namen: One Forgiven - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-11-religie-deel-2",
    "nextEpisode": "legacy-season-02-episode-12-deel-1-1-de-egyptische-opwekking",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1076,
      "kind": "podcast",
      "image": "images/snake.jpg"
    }
  },
  {
    "id": "legacy-season-02-episode-12-deel-1-1-de-egyptische-opwekking",
    "slug": {
      "en": "season-02-episode-12-deel-1-1-de-egyptische-opwekking",
      "es": "season-02-episode-12-deel-1-1-de-egyptische-opwekking",
      "nl": "season-02-episode-12-deel-1-1-de-egyptische-opwekking",
      "pap": "season-02-episode-12-deel-1-1-de-egyptische-opwekking"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 125,
    "title": {
      "en": "Season 02/Episode 12: Part 1.1 - The Egyptian Revival",
      "es": "Temporada 02/Episodio 12: Parte 1.1 - El Renacimiento Egipcio",
      "nl": "Season 02/Episode 12: Deel 1.1 - De Egyptische Opwekking",
      "pap": "Temporada 02/Episodio 12: Parti 1.1 - E Renasementu Egipsio"
    },
    "language": "nl",
    "summary": {
      "en": "The start of a new season. We dive deeper into the origin and structure of the tarot and explore some notable examples of people who helped shape the card system. In addition, we introduce here the Jungian archetype and the way it interweaves with the rich tradition of the tarot.",
      "es": "El comienzo de una nueva temporada. Profundizamos en el origen y la estructura del tarot y exploramos algunos ejemplos notables de personas que ayudaron a formar el sistema de cartas. Además, introducimos aquí el arquetipo junguiano y la manera en que se entrelaza con la rica tradición del tarot.",
      "nl": "Het begin van een nieuw seizoen. We duiken dieper in de oorsprong en structuur van de tarot en verkennen enkele bijzondere voorbeelden van mensen die hebben bijgedragen aan de vorming van het kaartensysteem. Bovendien introduceren we hier het Jungiaanse archetype en de manier waarop dit zich verweeft met de rijke traditie van de tarot",
      "pap": "E komienso di un temporada nobo. Nos ta profundisá den e orígen i struktura di tarot i ta eksplorá algun ehèmpel notabel di hende ku a yuda forma e sistema di karta. Ademas, akinan nos ta introdusí e arketipo Jungiano i e manera ku e ta entrelasá ku e rika tradishon di tarot."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-s4e1-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 12: Deel 1.1 - De Egyptische Opwekking - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-I-s4e1.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-al-haar-namen-one-forgiven",
    "nextEpisode": "legacy-season-02-episode-13-deel-2-1-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1098,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-13-deel-2-1-de-grote-arcana",
    "slug": {
      "en": "season-02-episode-13-deel-2-1-de-grote-arcana",
      "es": "season-02-episode-13-deel-2-1-de-grote-arcana",
      "nl": "season-02-episode-13-deel-2-1-de-grote-arcana",
      "pap": "season-02-episode-13-deel-2-1-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 126,
    "title": {
      "en": "Season 02/Episode 13: Part 2.1 - The Major Arcana",
      "es": "Temporada 02/Episodio 13: Parte 2.1 - Los Arcanos Mayores",
      "nl": "Season 02/Episode 13: Deel 2.1 - De Grote Arcana",
      "pap": "Temporada 02/Episodio 13: Parti 2.1 - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "Today we continue the journey of the soul. In this episode we dive into the meaning of the tarot as a tool for conscious development. I will also give a basic explanation of the first six cards: The Fool, The Magician, The High Priestess, The Empress, The Emperor, and The Hierophant.",
      "es": "Hoy continuamos el viaje del alma. En este episodio profundizamos en el significado del tarot como herramienta de desarrollo consciente. También daré una explicación básica de las primeras seis cartas: El Loco, El Mago, La Sacerdotisa, La Emperatriz, El Emperador y El Hierofante.",
      "nl": "Vandaag gaan we verder met de reis van de ziel. In deze aflevering duiken we in de betekenis van de tarot als hulpmiddel voor bewuste ontwikkeling. Ik zal ook een basisuitleg geven van de eerste zes kaarten: De Dwaas, De Magiër, De Hogepriesteres, De Keizerin, De Keizer en De Hierofant.",
      "pap": "Awe nos ta sigui e biahe di e alma. Den e episodio aki nos ta profundisá den e nifikashon di tarot komo un hèrmènt pa desaroyo konsiente. Lo mi duna tambe un splikashon básiko di e promé seis kartanan: E Bobo, E Mago, E Sumo Saserdotisa, E Emperatris, E Emperador i E Hierofante."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-II-s4e2-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 13: Deel 2.1 - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e2.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-12-deel-1-1-de-egyptische-opwekking",
    "nextEpisode": "legacy-season-02-episode-14-deel-2-2-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1165,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-14-deel-2-2-de-grote-arcana",
    "slug": {
      "en": "season-02-episode-14-deel-2-2-de-grote-arcana",
      "es": "season-02-episode-14-deel-2-2-de-grote-arcana",
      "nl": "season-02-episode-14-deel-2-2-de-grote-arcana",
      "pap": "season-02-episode-14-deel-2-2-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 127,
    "title": {
      "en": "Season 02/Episode 14: Part 2.2 - The Major Arcana",
      "es": "Temporada 02/Episodio 14: Parte 2.2 - Los Arcanos Mayores",
      "nl": "Season 02/Episode 14: Deel 2.2 - De Grote Arcana",
      "pap": "Temporada 02/Episodio 14: Parti 2.2 - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we continue our journey through the Major Arcana and discuss six new cards: The Lovers, The Chariot, Strength, The Hermit, The Wheel of Fortune, and Justice. Each card carries its own powerful symbolism and meaning. These cards deepen the themes of duality, willpower, inner strength, and cosmic justice.",
      "es": "En este episodio continuamos nuestro viaje por los Arcanos Mayores y hablamos de seis cartas nuevas: Los Enamorados, El Carro, La Fuerza, El Ermitaño, La Rueda de la Fortuna y La Justicia. Cada carta lleva su propia simbología y significado poderosos. Estas cartas profundizan los temas de la dualidad, la voluntad, la fuerza interior y la justicia cósmica.",
      "nl": "In deze aflevering zetten we onze reis door de Grote Arcana voort en bespreken we zes nieuwe kaarten: De Geliefden, De Zegewagen, Kracht, De Kluizenaar, Het Rad van Fortuin en Gerechtigheid. Elke kaart draagt zijn eigen krachtige symboliek en betekenis. Deze kaarten verdiepen de thema’s van dualiteit, wilskracht, innerlijke kracht en kosmische rechtvaardigheid.",
      "pap": "Den e episodio aki nos ta sigui nos biahe dor di e Arkano Mayor i ta papia di seis karta nobo: E Namorá, E Garoshi, Forsa, E Ermitaño, E Wil di Fortuna i Hustisia. Kada karta tin su mes simbolismo i nifikashon poderoso. E kartanan aki ta profundisá e temanan di dualidat, forsa di boluntat, forsa interno i hustisia kósmiko."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-II-s4e3-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 14: Deel 2.2 - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e3.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-13-deel-2-1-de-grote-arcana",
    "nextEpisode": "legacy-season-02-episode-15-deel-2-3-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1232,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-15-deel-2-3-de-grote-arcana",
    "slug": {
      "en": "season-02-episode-15-deel-2-3-de-grote-arcana",
      "es": "season-02-episode-15-deel-2-3-de-grote-arcana",
      "nl": "season-02-episode-15-deel-2-3-de-grote-arcana",
      "pap": "season-02-episode-15-deel-2-3-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 128,
    "title": {
      "en": "Season 02/Episode 15: Part 2.3 - The Major Arcana",
      "es": "Temporada 02/Episodio 15: Parte 2.3 - Los Arcanos Mayores",
      "nl": "Season 02/Episode 15: Deel 2.3 - De Grote Arcana",
      "pap": "Temporada 02/Episodio 15: Parti 2.3 - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode of our tarot series we discuss the meaning of six cards: The Hanged Man (XII), symbolizing self-sacrifice and a new perspective; Death (XIII), a card of transformation; Temperance (XIV), about balance and harmony; The Devil (XV), showing bondage and temptation; The Tower (XVI), a card of sudden change; and The Star (XVII), which brings hope and inspiration. These cards offer deep insight into personal growth and transformation.",
      "es": "En este episodio de nuestra serie de tarot hablamos del significado de seis cartas: El Colgado (XII), que simboliza el autosacrificio y una nueva perspectiva; La Muerte (XIII), carta de transformación; La Templanza (XIV), sobre equilibrio y armonía; El Diablo (XV), que muestra la atadura y la tentación; La Torre (XVI), carta de cambio repentino; y La Estrella (XVII), que trae esperanza e inspiración. Estas cartas ofrecen una visión profunda del crecimiento y la transformación personal.",
      "nl": "In deze aflevering van onze tarotserie bespreken we de betekenis van zes kaarten: De Gehangene (XII), die zelfopoffering en nieuw perspectief symboliseert, Dood (XIII), een kaart van transformatie, Matigheid (XIV), over balans en harmonie, De Duivel (XV), die gebondenheid en verleiding toont, De Toren (XVI), een kaart van plotselinge verandering, en De Ster (XVII), die hoop en inspiratie brengt. Deze kaarten bieden diepe inzichten in persoonlijke groei en transformatie.",
      "pap": "Den e episodio aki di nos seri di tarot nos ta papia di e nifikashon di seis karta: E Kologá (XII), ku ta simbolisá outosakrifisio i un nobo perspektiva; Morto (XIII), un karta di transformashon; Temperansa (XIV), tokante balansa i armonia; E Diabel (XV), ku ta mustra atamentu i tentashon; E Tore (XVI), un karta di kambio repentino; i E Strea (XVII), ku ta trese speransa i inspirashon. E kartanan aki ta ofresé bista profundo den kresementu i transformashon personal."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-II-s4e4-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 15: Deel 2.3 - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e4.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-14-deel-2-2-de-grote-arcana",
    "nextEpisode": "legacy-season-02-episode-16-deel-2-4-de-grote-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1298,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-16-deel-2-4-de-grote-arcana",
    "slug": {
      "en": "season-02-episode-16-deel-2-4-de-grote-arcana",
      "es": "season-02-episode-16-deel-2-4-de-grote-arcana",
      "nl": "season-02-episode-16-deel-2-4-de-grote-arcana",
      "pap": "season-02-episode-16-deel-2-4-de-grote-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 129,
    "title": {
      "en": "Season 02/Episode 16: Part 2.4 - The Major Arcana",
      "es": "Temporada 02/Episodio 16: Parte 2.4 - Los Arcanos Mayores",
      "nl": "Season 02/Episode 16: Deel 2.4 - De Grote Arcana",
      "pap": "Temporada 02/Episodio 16: Parti 2.4 - E Arkano Mayor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we discuss the last four cards of the Major Arcana in the tarot: The Moon (XVIII), The Sun (XIX), Judgement (XX), and The World (XXI). We dive deep into their symbolism and meaning, and how they can guide us on our spiritual journey. At the end of the show we also have a little bonus for you, so be sure to keep listening!",
      "es": "En este episodio hablamos de las últimas cuatro cartas de los Arcanos Mayores: La Luna (XVIII), El Sol (XIX), El Juicio (XX) y El Mundo (XXI). Profundizamos en su simbología y significado, y en cómo pueden guiarnos en nuestro viaje espiritual. ¡Al final del programa también tenemos un pequeño extra para ti, así que no dejes de escuchar!",
      "nl": "In deze aflevering bespreken we de laatste vier kaarten van de Grote Arcana in de tarot: De Maan(XVIII), De Zon(XIX), Het Oordeel(XX), en De Wereld(XXI). We duiken diep in hun symboliek en betekenis, en hoe ze ons kunnen begeleiden op onze spirituele reis. Aan het einde van de show hebben we ook een kleine bonus voor je, dus blijf zeker luisteren!",
      "pap": "Den e episodio aki nos ta papia di e último kuater kartanan di e Arkano Mayor: E Luna (XVIII), E Solo (XIX), E Huisio (XX) i E Mundu (XXI). Nos ta profundisá den nan simbolismo i nifikashon, i kon nan por guia nos riba nos biahe spiritual. Na fin di e show nos tin tambe un bonus chikitu pa bo, p'esei sigui skucha!"
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-II-s4e5-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 16: Deel 2.4 - De Grote Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e5.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten Bundel",
          "es": "Rider Waite Kaarten Bundel",
          "nl": "Rider Waite Kaarten Bundel",
          "pap": "Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-15-deel-2-3-de-grote-arcana",
    "nextEpisode": "legacy-season-02-episode-17-deel-3-1-de-kleine-arcana-staven",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1364,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-17-deel-3-1-de-kleine-arcana-staven",
    "slug": {
      "en": "season-02-episode-17-deel-3-1-de-kleine-arcana-staven",
      "es": "season-02-episode-17-deel-3-1-de-kleine-arcana-staven",
      "nl": "season-02-episode-17-deel-3-1-de-kleine-arcana-staven",
      "pap": "season-02-episode-17-deel-3-1-de-kleine-arcana-staven"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 130,
    "title": {
      "en": "Season 02/Episode 17: Part 3.1 - The Minor Arcana/Wands",
      "es": "Temporada 02/Episodio 17: Parte 3.1 - Los Arcanos Menores/Bastos",
      "nl": "Season 02/Episode 17: Deel 3.1 - De Kleine Arcana/Staven",
      "pap": "Temporada 02/Episodio 17: Parti 3.1 - E Arkano Menor/Garoti"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Fire and the 14 cards of the Wands suit. Wands symbolize action, willpower, inspiration, and energy. They represent our passion, creativity, and the fire that drives us into motion.",
      "es": "En este episodio nos adentramos en el elemento Fuego y las 14 cartas del palo de Bastos. Los Bastos simbolizan la acción, la voluntad, la inspiración y la energía. Representan nuestra pasión, creatividad y el fuego que nos impulsa a movernos.",
      "nl": "In deze aflevering duiken we in het element Vuur en de 14 kaarten van de Staven-serie. Staven staan symbool voor actie, wilskracht, inspiratie en energie. Ze vertegenwoordigen onze passie, creativiteit en het vuur dat ons drijft om in beweging te komen.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Kandela i e 14 kartanan di e seri di Garoti. Garoti ta simbolisá akshon, forsa di boluntat, inspirashon i energia. Nan ta representá nos pashon, kreatividat i e kandela ku ta pusha nos pa move."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e6-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 17: Deel 3.1 - De Kleine Arcana/Staven - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e6.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-16-deel-2-4-de-grote-arcana",
    "nextEpisode": "legacy-season-02-episode-18-deel-3-2-de-kleine-arcana-bekers",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1430,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-18-deel-3-2-de-kleine-arcana-bekers",
    "slug": {
      "en": "season-02-episode-18-deel-3-2-de-kleine-arcana-bekers",
      "es": "season-02-episode-18-deel-3-2-de-kleine-arcana-bekers",
      "nl": "season-02-episode-18-deel-3-2-de-kleine-arcana-bekers",
      "pap": "season-02-episode-18-deel-3-2-de-kleine-arcana-bekers"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 131,
    "title": {
      "en": "Season 02/Episode 18: Part 3.2 - The Minor Arcana/Cups",
      "es": "Temporada 02/Episodio 18: Parte 3.2 - Los Arcanos Menores/Copas",
      "nl": "Season 02/Episode 18: Deel 3.2 - De Kleine Arcana/Bekers",
      "pap": "Temporada 02/Episodio 18: Parti 3.2 - E Arkano Menor/Kopa"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Water and the 14 cards of the Cups suit. Cups symbolize emotions, feelings, relationships, and intuition. They represent our inner life, our connections with others, and the flow of our emotions that lead us to deeper insight and fulfillment.",
      "es": "En este episodio nos adentramos en el elemento Agua y las 14 cartas del palo de Copas. Las Copas simbolizan las emociones, los sentimientos, las relaciones y la intuición. Representan nuestra vida interior, nuestros vínculos con los demás y el fluir de nuestras emociones que nos llevan a una comprensión y plenitud más profundas.",
      "nl": "In deze aflevering duiken we in het element Water en de 14 kaarten van de Beker-serie. Bekers staan symbool voor emoties, gevoelens, relaties en intuïtie. Ze vertegenwoordigen ons innerlijk leven, onze verbindingen met anderen en de stroom van onze emoties die ons leiden naar diepere inzichten en vervulling.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Awa i e 14 kartanan di e seri di Kopa. Kopa ta simbolisá emoshon, sintimentu, relashon i intuishon. Nan ta representá nos bida interno, nos konekshonnan ku otro i e fluho di nos emoshonnan ku ta hiba nos na komprondementu i kumplimentu mas profundo."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e7-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 18: Deel 3.2 - De Kleine Arcana/Bekers - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e7.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-17-deel-3-1-de-kleine-arcana-staven",
    "nextEpisode": "legacy-season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1496,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden",
    "slug": {
      "en": "season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden",
      "es": "season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden",
      "nl": "season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden",
      "pap": "season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 132,
    "title": {
      "en": "Season 02/Episode 19: Part 3.3 - The Minor Arcana/Swords",
      "es": "Temporada 02/Episodio 19: Parte 3.3 - Los Arcanos Menores/Espadas",
      "nl": "Season 02/Episode 19: Deel 3.3 - De Kleine Arcana/Zwaarden",
      "pap": "Temporada 02/Episodio 19: Parti 3.3 - E Arkano Menor/Spada"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Air and the 14 cards of the Swords suit. Swords symbolize intellect, thought, communication, and decisiveness. They represent our mental life, the sharpness of our thinking, and our power to overcome obstacles through logic and reason. The Swords cards invite us to examine our thoughts, find clarity in complex situations, and make conscious choices that lead to truth and insight.",
      "es": "En este episodio nos adentramos en el elemento Aire y las 14 cartas del palo de Espadas. Las Espadas simbolizan el intelecto, el pensamiento, la comunicación y la decisión. Representan nuestra vida mental, la agudeza de nuestro pensar y nuestra capacidad de superar obstáculos mediante la lógica y la razón. Las cartas de Espadas nos invitan a examinar nuestros pensamientos, hallar claridad en situaciones complejas y tomar decisiones conscientes que conduzcan a la verdad y la comprensión.",
      "nl": "In deze aflevering duiken we in het element Lucht en de 14 kaarten van de Zwaarden-serie. Zwaarden staan symbool voor intellect, gedachten, communicatie en besluitvaardigheid. Ze vertegenwoordigen ons mentale leven, de scherpte van ons denken en onze kracht om obstakels te overwinnen door middel van logica en verstand. De Zwaarden kaarten nodigen ons uit om onze gedachten te onderzoeken, helderheid te vinden in complexe situaties, en bewuste keuzes te maken die leiden tot waarheid en inzicht.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Airu i e 14 kartanan di e seri di Spada. Spada ta simbolisá intelekto, pensamentu, komunikashon i desishon. Nan ta representá nos bida mental, e skèrpnan di nos pensamentu i nos forsa pa superá opstákulo via lógika i rason. E kartanan di Spada ta invitá nos pa analisá nos pensamentunan, haña klaridat den situashonnan kompliká, i hasi eskohonan konsiente ku ta hiba na bèrdat i komprondementu."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e8-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 19: Deel 3.3 - De Kleine Arcana/Zwaarden - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e8.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-18-deel-3-2-de-kleine-arcana-bekers",
    "nextEpisode": "legacy-season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1564,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels",
    "slug": {
      "en": "season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels",
      "es": "season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels",
      "nl": "season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels",
      "pap": "season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 133,
    "title": {
      "en": "Season 02/Episode 20: Part 3.4 - The Minor Arcana/Pentacles",
      "es": "Temporada 02/Episodio 20: Parte 3.4 - Los Arcanos Menores/Oros",
      "nl": "Season 02/Episode 20: Deel 3.4 - De Kleine Arcana/Pentakels",
      "pap": "Temporada 02/Episodio 20: Parti 3.4 - E Arkano Menor/Pentákulo"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the element of Earth and the 14 cards of the Pentacles suit. Pentacles symbolize material security, work, health, and abundance. They represent our physical world, the tangible result of our efforts, and the balance between work, well-being, and matter. The Pentacles cards invite us to examine our relationship with the material world, to appreciate the work we do, and to build a solid foundation for our future. They remind us of the importance of patience, discipline, and perseverance in manifesting our goals and creating inner and outer wealth.",
      "es": "En este episodio nos adentramos en el elemento Tierra y las 14 cartas del palo de Oros. Los Oros simbolizan la seguridad material, el trabajo, la salud y la abundancia. Representan nuestro mundo físico, el resultado tangible de nuestros esfuerzos y el equilibrio entre trabajo, bienestar y materia. Las cartas de Oros nos invitan a examinar nuestra relación con el mundo material, a valorar el trabajo que realizamos y a construir una base sólida para nuestro futuro. Nos recuerdan la importancia de la paciencia, la disciplina y la perseverancia para manifestar nuestras metas y crear riqueza interior y exterior.",
      "nl": "In deze aflevering duiken we in het element Aarde en de 14 kaarten van de Pentakels-serie. Pentakels staan symbool voor materiële zekerheid, werk, gezondheid en overvloed. Ze vertegenwoordigen onze fysieke wereld, het tastbare resultaat van onze inspanningen en de balans tussen werk, welzijn en materie. De Pentakels kaarten nodigen ons uit om onze relatie met de materiële wereld te onderzoeken, om waardering te vinden voor het werk dat we verrichten, en om een solide basis op te bouwen voor onze toekomst. Ze herinneren ons aan het belang van geduld, discipline en doorzettingsvermogen om onze doelen te manifesteren en innerlijke en uiterlijke rijkdom te creëren.",
      "pap": "Den e episodio aki nos ta sumi den e elemento Tera i e 14 kartanan di e seri di Pentákulo. Pentákulo ta simbolisá siguridat material, trabou, salú i abundansia. Nan ta representá nos mundu físiko, e resultado tanjibel di nos esfuerso i e balansa entre trabou, bienestar i materia. E kartanan di Pentákulo ta invitá nos pa analisá nos relashon ku e mundu material, pa apresiá e trabou ku nos ta hasi, i pa konstruí un base solido pa nos futuro. Nan ta korda nos di e importansia di pasenshi, disiplina i perseveransia pa manifestá nos metanan i krea rikesa interno i externo."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e9-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 20: Deel 3.4 - De Kleine Arcana/Pentakels - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e9.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-19-deel-3-3-de-kleine-arcana-zwaarden",
    "nextEpisode": "legacy-season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1632,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana",
    "slug": {
      "en": "season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana",
      "es": "season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana",
      "nl": "season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana",
      "pap": "season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 134,
    "title": {
      "en": "Season 02/Episode 21: Part 3.5 - Integration of the Major and Minor Arcana",
      "es": "Temporada 02/Episodio 21: Parte 3.5 - Integración de los Arcanos Mayores y Menores",
      "nl": "Season 02/Episode 21: Deel 3.5 - Integratie van de Grote en Kleine Arcana",
      "pap": "Temporada 02/Episodio 21: Parti 3.5 - Integrashon di e Arkano Mayor i Menor"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we go deeper into the integration of the Major and Minor Arcana in the tarot and explore how these cards together represent a full spectrum of human and spiritual life. The Major Arcana, with its archetypal journey through universal themes and transformations, shows us the essence of our life's journey: growth, challenge, and the development of wisdom. The Minor Arcana, divided across the elements of Fire, Water, Air, and Earth, brings this back to daily life. Each card offers lessons and insights that manifest in our everyday existence and gives us tools to find balance between the material and the spiritual. This episode invites us to explore the interplay between the larger life path and daily challenges, and inspires us to use the Major Arcana as a guide while the Minor Arcana helps us walk the path step by step. Together these cards remind us that both the grandeur of our spiritual aspirations and the simplicity of our daily life are valuable and must be brought into harmony to achieve inner and outer balance.",
      "es": "En este episodio profundizamos en la integración de los Arcanos Mayores y Menores del tarot y exploramos cómo, juntas, estas cartas representan todo el espectro de la vida humana y espiritual. Los Arcanos Mayores, con su viaje arquetípico por temas y transformaciones universales, nos muestran la esencia del viaje de la vida: crecimiento, desafío y desarrollo de la sabiduría. Los Arcanos Menores, repartidos entre los elementos Fuego, Agua, Aire y Tierra, lo traen de vuelta a la vida cotidiana. Cada carta ofrece lecciones e ideas que se manifiestan en nuestra existencia diaria y nos da herramientas para hallar el equilibrio entre lo material y lo espiritual. Este episodio nos invita a explorar la interacción entre el gran camino de la vida y los retos cotidianos, y nos inspira a usar los Arcanos Mayores como guía mientras los Menores nos ayudan a recorrer el camino paso a paso. Juntas, estas cartas nos recuerdan que tanto la grandeza de nuestras aspiraciones espirituales como la sencillez de nuestra vida diaria son valiosas y deben armonizarse para alcanzar el equilibrio interior y exterior.",
      "nl": "In deze aflevering gaan we dieper in op de integratie van de Grote en Kleine Arcana in de tarot en onderzoeken we hoe deze kaarten samen een volledig spectrum van het menselijke en spirituele leven vertegenwoordigen. De Grote Arcana, met zijn archetypische reis door universele thema's en transformaties, laat ons de essentie van onze levensreis zien: groei, uitdaging, en de ontwikkeling van wijsheid. De Kleine Arcana, verdeeld over de elementen Vuur, Water, Lucht en Aarde, brengt dit terug naar het dagelijkse leven. Elke kaart biedt lessen en inzichten die zich in ons alledaagse bestaan manifesteren en geeft ons handvatten om evenwicht te vinden tussen het materiële en spirituele. Deze aflevering nodigt ons uit om de wisselwerking tussen het grotere levenspad en de dagelijkse uitdagingen te verkennen en inspireert ons om de Grote Arcana als leidraad te gebruiken terwijl de Kleine Arcana ons helpt het pad stap voor stap te belopen. Samen herinneren deze kaarten ons eraan dat zowel de grootsheid van onze spirituele ambities als de eenvoud van ons dagelijks leven waardevol zijn en in harmonie moeten worden gebracht om innerlijke en uiterlijke balans te bereiken.",
      "pap": "Den e episodio aki nos ta profundisá den e integrashon di e Arkano Mayor i Menor di tarot i ta eksplorá kon huntu e kartanan aki ta representá un spektro kompleto di bida humano i spiritual. E Arkano Mayor, ku su biahe arketípiko dor di temanan i transformashonnan universal, ta mustra nos e esensia di nos biahe di bida: kresementu, desafio i desaroyo di sabiduria. E Arkano Menor, dividí entre e elementonan Kandela, Awa, Airu i Tera, ta trese esaki bèk na bida diario. Kada karta ta ofresé lès i komprondementu ku ta manifestá den nos eksistensia diario i ta duna nos hèrmèntnan pa haña balansa entre e material i e spiritual. E episodio aki ta invitá nos pa eksplorá e interakshon entre e kaminda di bida mas grandi i e retonan diario, i ta inspirá nos pa usa e Arkano Mayor komo guia miéntras e Arkano Menor ta yuda nos kana e kaminda paso pa paso. Huntu, e kartanan aki ta korda nos ku tantu e grandesa di nos aspirashonnan spiritual komo e simplisidat di nos bida diario ta balioso i mester wòrdu trahé na armonia pa alkansá balansa interno i externo."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e10-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 21: Deel 3.5 - Integratie van de Grote en Kleine Arcana - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e10.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-20-deel-3-4-de-kleine-arcana-pentakels",
    "nextEpisode": "legacy-season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalistische-levensboom",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1700,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalistische-levensboom",
    "slug": {
      "en": "season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalis",
      "es": "season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalis",
      "nl": "season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalis",
      "pap": "season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalis"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 135,
    "title": {
      "en": "Season 02/Episode 22: Part 3.6 - Hebrew Letters, Numbers and the Kabbalistic Tree of Life",
      "es": "Temporada 02/Episodio 22: Parte 3.6 - Letras Hebreas, Números y el Árbol de la Vida Cabalístico",
      "nl": "Season 02/Episode 22: Deel 3.6 - Hebreeuwse letters, getallen en de Kabbalistische Levensboom",
      "pap": "Temporada 02/Episodio 22: Parti 3.6 - Lèternan Hebreo, Number i e Palu di Bida Kabalístiko"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the mystical world of the Hebrew letters, numbers, and the Kabbalistic Tree of Life. The Hebrew letters carry not only deep spiritual meaning but also form the building blocks of the universe. Each number holds a hidden wisdom that helps us understand the connection between the divine and the earthly. The Kabbalistic Tree of Life, with its ten sefirot and 22 paths, functions as a map of consciousness and a guide for spiritual growth. These symbols invite us to examine our relationship with the transcendent, find balance between heaven and earth, and discover the mysteries of our inner universe.",
      "es": "En este episodio nos adentramos en el mundo místico de las letras hebreas, los números y el Árbol de la Vida cabalístico. Las letras hebreas no solo portan un profundo significado espiritual, sino que también son los pilares del universo. Cada número guarda una sabiduría oculta que nos ayuda a entender la conexión entre lo divino y lo terrenal. El Árbol de la Vida cabalístico, con sus diez sefirot y 22 senderos, funciona como un mapa de la conciencia y una guía para el crecimiento espiritual. Estos símbolos nos invitan a examinar nuestra relación con lo trascendente, hallar el equilibrio entre el cielo y la tierra y descubrir los misterios de nuestro universo interior.",
      "nl": "In deze aflevering duiken we in de mystieke wereld van de Hebreeuwse letters, getallen en de Kabbalistische Levensboom. De Hebreeuwse letters dragen niet alleen diepe spirituele betekenis, maar vormen ook de bouwstenen van het universum. Elk getal heeft een verborgen wijsheid die ons helpt om de verbinding tussen het goddelijke en het aardse te begrijpen. De Kabbalistische Levensboom, met zijn tien sefirot en 22 paden, fungeert als een kaart van bewustzijn en een gids voor spirituele groei. Deze symbolen nodigen ons uit om onze relatie met het transcendente te onderzoeken, balans te vinden tussen hemel en aarde, en de mysteries van ons innerlijke universum te ontdekken.",
      "pap": "Den e episodio aki nos ta sumi den e mundu místiko di e lèternan hebreo, e number i e Palu di Bida kabalístiko. E lèternan hebreo no solamente ta karga un nifikashon spiritual profundo, sino tambe ta forma e blòkinan di konstrukshon di e universo. Kada number tin un sabiduria skondí ku ta yuda nos komprondé e konekshon entre e divino i e terenal. E Palu di Bida kabalístiko, ku su dies sefirot i 22 kaminda, ta funshoná komo un mapa di konsenshi i un guia pa kresementu spiritual. E símbolonan aki ta invitá nos pa analisá nos relashon ku e transendente, haña balansa entre shelu i tera, i deskubrí e misterionan di nos universo interno."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e11-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 22: Deel 3.6 - Hebreeuwse letters, getallen en de Kabbalistische Levensboom - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e11.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-21-deel-3-5-integratie-van-de-grote-en-kleine-arcana",
    "nextEpisode": "legacy-season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftransformatie",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1770,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftransformatie",
    "slug": {
      "en": "season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftran",
      "es": "season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftran",
      "nl": "season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftran",
      "pap": "season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftran"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 136,
    "title": {
      "en": "Season 02/Episode 23: Part 3.7 - Alchemical Symbolism in Tarot – Self-Transformation",
      "es": "Temporada 02/Episodio 23: Parte 3.7 - Simbolismo Alquímico en el Tarot – Autotransformación",
      "nl": "Season 02/Episode 23: Deel 3.7 - Alchemistische symboliek in Tarot – Zelftransformatie",
      "pap": "Temporada 02/Episodio 23: Parti 3.7 - Simbolismo Alkímiko den Tarot – Outotransformashon"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we explore the profound alchemical symbolism hidden in the Tarot, and how it can guide us on the path of self-transformation. The Tarot acts as a mirror of our inner world and reveals the elements of fire, water, air, and earth as forces that shape our psyche.",
      "es": "En este episodio exploramos la profunda simbología alquímica oculta en el Tarot y cómo puede guiarnos en el camino de la autotransformación. El Tarot actúa como un espejo de nuestro mundo interior y revela los elementos de fuego, agua, aire y tierra como fuerzas que dan forma a nuestra psique.",
      "nl": "In deze aflevering verkennen we de diepgaande alchemistische symboliek die verborgen ligt in de Tarot, en hoe deze ons kan leiden op het pad van zelftransformatie. De Tarot fungeert als een spiegel van onze innerlijke wereld en onthult de elementen van vuur, water, lucht en aarde als krachten die onze psyche vormgeven.",
      "pap": "Den e episodio aki nos ta eksplorá e simbolismo alkímiko profundo skondí den Tarot, i kon e por guia nos riba e kaminda di outotransformashon. Tarot ta aktua komo un spil di nos mundu interno i ta revelá e elementonan di kandela, awa, airu i tera komo forsanan ku ta forma nos sike."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e12-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 23: Deel 3.7 - Alchemistische symboliek in Tarot – Zelftransformatie - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e12.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-22-deel-3-6-hebreeuwse-letters-getallen-en-de-kabbalistische-levensboom",
    "nextEpisode": "legacy-season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktische-toepassing",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1838,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktische-toepassing",
    "slug": {
      "en": "season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktisch",
      "es": "season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktisch",
      "nl": "season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktisch",
      "pap": "season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktisch"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 137,
    "title": {
      "en": "Season 02/Episode 24: Part 3.8 - Divination, Card Spreads and Practical Application",
      "es": "Temporada 02/Episodio 24: Parte 3.8 - Adivinación, Tiradas de Cartas y Aplicación Práctica",
      "nl": "Season 02/Episode 24: Deel 3.8 - Waarzeggerij, Kaartenleggingen en Praktische Toepassing",
      "pap": "Temporada 02/Episodio 24: Parti 3.8 - Divinashon, Plasamentu di Karta i Aplikashon Práktiko"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode we dive into the art of divination, card spreads, and their practical applications in daily life. We explore how the symbolism of the cards offers insight into the unconscious and also serves as a compass for making decisions and understanding life patterns. Here the Tarot reveals itself as a powerful instrument that bridges intuition and action, bringing the spiritual and the practical into harmony.",
      "es": "En este episodio nos adentramos en el arte de la adivinación, las tiradas de cartas y sus aplicaciones prácticas en la vida diaria. Exploramos cómo la simbología de las cartas no solo ofrece una visión del inconsciente, sino que también sirve de brújula para tomar decisiones y comprender los patrones de la vida. Aquí el Tarot se revela como un instrumento poderoso que tiende un puente entre la intuición y la acción, armonizando lo espiritual y lo práctico.",
      "nl": "In deze aflevering duiken we in de kunst van waarzeggerij, kaartenleggingen en hun praktische toepassingen in het dagelijks leven. We onderzoeken hoe de symboliek van de kaarten niet alleen inzicht biedt in het onbewuste, maar ook dient als een kompas voor het nemen van beslissingen en het begrijpen van levenspatronen. De Tarot onthult zich hier als een krachtig instrument dat de brug slaat tussen intuïtie en actie, waardoor het spirituele en het praktische in harmonie samenkomen.",
      "pap": "Den e episodio aki nos ta sumi den e arte di divinashon, plasamentu di karta i nan aplikashonnan práktiko den bida diario. Nos ta eksplorá kon e simbolismo di e kartanan ta ofresé bista den e inkonsiente i tambe ta sirbi komo un kompas pa tuma desishon i komprondé patronchi di bida. Akinan Tarot ta revelá su mes komo un instrumento poderoso ku ta uni intuishon i akshon, trayendo e spiritual i e práktiko na armonia."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/de-steeds-opkomende-zon-deel-III-s4e13-audio.mp3",
    "image": "/assets/images/steeds-opkomende-zon-cover.png",
    "imageAlt": "Season 02/Episode 24: Deel 3.8 - Waarzeggerij, Kaartenleggingen en Praktische Toepassing - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "Presentatie Sheets",
          "es": "Láminas de presentación",
          "nl": "Presentatiebladen",
          "pap": "Blachinan di presentashon"
        },
        "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e13.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Egyptian Revival",
          "es": "Egyptian Revival",
          "nl": "Egyptian Revival",
          "pap": "Egyptian Revival"
        },
        "url": "./media/s4/Egyptian Revival.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Esoteric Origins Of Tarot",
          "es": "Esoteric Origins Of Tarot",
          "nl": "Esoteric Origins Of Tarot",
          "pap": "Esoteric Origins Of Tarot"
        },
        "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Gnostic Tarot",
          "es": "Gnostic Tarot",
          "nl": "Gnostic Tarot",
          "pap": "Gnostic Tarot"
        },
        "url": "./media/s4/Gnostic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Oracle Of The Tarot",
          "es": "Oracle Of The Tarot",
          "nl": "Oracle Of The Tarot",
          "pap": "Oracle Of The Tarot"
        },
        "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Qabalistic Tarot",
          "es": "Qabalistic Tarot",
          "nl": "Qabalistic Tarot",
          "pap": "Qabalistic Tarot"
        },
        "url": "./media/s4/Qabalistic Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Symbolist - Guide To Tarot",
          "es": "Symbolist - Guide To Tarot",
          "nl": "Symbolist - Guide To Tarot",
          "pap": "Symbolist - Guide To Tarot"
        },
        "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Golden Dawn Magical Kaarten Bundel",
          "es": "Golden Dawn Magical Kaarten Bundel",
          "nl": "Golden Dawn Magical Kaarten Bundel",
          "pap": "Golden Dawn Magical Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn Magical.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Golden Dawn Kaarten Bundel",
          "es": "Golden Dawn Kaarten Bundel",
          "nl": "Golden Dawn Kaarten Bundel",
          "pap": "Golden Dawn Kaarten Bundel"
        },
        "url": "./media/s4/Golden Dawn.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Greater Trumps Kaarten Bundel",
          "es": "Greater Trumps Kaarten Bundel",
          "nl": "Greater Trumps Kaarten Bundel",
          "pap": "Greater Trumps Kaarten Bundel"
        },
        "url": "./media/s4/Greater Trumps.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Old English Kaarten Bundel",
          "es": "Old English Kaarten Bundel",
          "nl": "Old English Kaarten Bundel",
          "pap": "Old English Kaarten Bundel"
        },
        "url": "./media/s4/Old English.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "BOTA Kaarten Bundel",
          "es": "BOTA Kaarten Bundel",
          "nl": "BOTA Kaarten Bundel",
          "pap": "BOTA Kaarten Bundel"
        },
        "url": "./media/s4/BOTA.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Radiant Rider Waite Kaarten Bundel",
          "es": "Radiant Rider Waite Kaarten Bundel",
          "nl": "Radiant Rider Waite Kaarten Bundel",
          "pap": "Radiant Rider Waite Kaarten Bundel"
        },
        "url": "./media/s4/Radiant Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten ndel",
          "es": "Rider Waite Kaarten ndel",
          "nl": "Rider Waite Kaarten ndel",
          "pap": "Rider Waite Kaarten ndel"
        },
        "url": "./media/s4/Rider Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Rider Waite Kaarten NL Bundel",
          "es": "Rider Waite Kaarten NL Bundel",
          "nl": "Rider Waite Kaarten NL Bundel",
          "pap": "Rider Waite Kaarten NL Bundel"
        },
        "url": "./media/s4/Rider Waite (NL).zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Universal Waite Kaarten Bundel",
          "es": "Universal Waite Kaarten Bundel",
          "nl": "Universal Waite Kaarten Bundel",
          "pap": "Universal Waite Kaarten Bundel"
        },
        "url": "./media/s4/Universal Waite.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Thoth Kaarten Bundel",
          "es": "Thoth Kaarten Bundel",
          "nl": "Thoth Kaarten Bundel",
          "pap": "Thoth Kaarten Bundel"
        },
        "url": "./media/s4/Thoth.zip",
        "type": "external"
      },
      {
        "label": {
          "en": "Lijst van Emoties",
          "es": "Lijst van Emoties",
          "nl": "Lijst van Emoties",
          "pap": "Lijst van Emoties"
        },
        "url": "./media/s4/lijst-van-emoties.pdf",
        "type": "pdf"
      },
      {
        "label": {
          "en": "Eigen Pad Seizoen 4/Tarot Series",
          "es": "Eigen Pad Seizoen 4/Tarot Series",
          "nl": "Eigen Pad Seizoen 4/Tarot Series",
          "pap": "Eigen Pad Seizoen 4/Tarot Series"
        },
        "url": "./media-5.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "index.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "index-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "index-3.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-23-deel-3-7-alchemistische-symboliek-in-tarot-zelftransformatie",
    "nextEpisode": "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-2.html",
      "sourceLine": 1906,
      "kind": "podcast",
      "image": "images/steeds-opkomende-zon-cover.png"
    }
  },
  {
    "id": "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken-2",
    "slug": {
      "en": "season-02-episode-01-het-ego-en-manipulatie-technieken-2",
      "es": "season-02-episode-01-het-ego-en-manipulatie-technieken-2",
      "nl": "season-02-episode-01-het-ego-en-manipulatie-technieken-2",
      "pap": "season-02-episode-01-het-ego-en-manipulatie-technieken-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 138,
    "title": {
      "en": "Season 02/Episode 01: The Ego and Manipulation Techniques",
      "es": "Temporada 02/Episodio 01: El Ego y las Técnicas de Manipulación",
      "nl": "Season 02/Episode 01: Het Ego en Manipulatie Technieken",
      "pap": "Temporada 02/Episodio 01: E Ego i Teknikanan di Manipulashon"
    },
    "language": "nl",
    "summary": {
      "en": "An extensive discussion about the ego and some manipulation techniques. This is the first episode that will lead us into many other discussions about manipulation.",
      "es": "Una amplia discusión sobre el ego y algunas técnicas de manipulación. Este es el primer episodio que nos llevará a muchas otras discusiones sobre la manipulación.",
      "nl": "Een uitgebreide discussie over het ego en enkele manipulatietechnieken. Dit is de eerste aflevering die ons naar vele andere discussies over manipulatie zal leiden.",
      "pap": "Un diskushon amplio tokante e ego i algun teknika di manipulashon. Esaki ta e promé episodio ku lo hiba nos den hopi otro diskushon tokante manipulashon."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/ego.jpg",
    "imageAlt": "Season 02/Episode 01: Het Ego en Manipulatie Technieken - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      },
      {
        "label": {
          "en": "De zwarte zon",
          "es": "De zwarte zon",
          "nl": "De zwarte zon",
          "pap": "De zwarte zon"
        },
        "url": "./images/darksun.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "De omgekeerde pentagram",
          "es": "De omgekeerde pentagram",
          "nl": "De omgekeerde pentagram",
          "pap": "De omgekeerde pentagram"
        },
        "url": "./images/pentagram.jpg",
        "type": "external"
      },
      {
        "label": {
          "en": "De primaire kleuren",
          "es": "De primaire kleuren",
          "nl": "De primaire kleuren",
          "pap": "De primaire kleuren"
        },
        "url": "./images/colors.png",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-24-deel-3-8-waarzeggerij-kaartenleggingen-en-praktische-toepassing",
    "nextEpisode": "legacy-season-01-episode-00-re-member",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 194,
      "kind": "podcast",
      "image": "images/ego.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-00-re-member",
    "slug": {
      "en": "season-01-episode-00-re-member",
      "es": "season-01-episode-00-re-member",
      "nl": "season-01-episode-00-re-member",
      "pap": "season-01-episode-00-re-member"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 139,
    "title": {
      "en": "Season 01/Episode 00: Re-Member",
      "es": "Temporada 01/Episodio 00: Re-Cordar",
      "nl": "Season 01/Episode 00: Re-Member",
      "pap": "Temporada 01/Episodio 00: Re-Kòrda"
    },
    "language": "nl",
    "summary": {
      "en": "An introduction to the podcasts presented this season and the topics to be expected and discussed.",
      "es": "Una introducción a los podcasts que se presentan esta temporada y a los temas que cabe esperar y comentar.",
      "nl": "Een inleiding op de podcasts die dit seizoen gepresenteerd worden en de onderwerpen die te verwachten - en te bespreken zijn.",
      "pap": "Un introdukshon na e podcastnan ku ta presentá e temporada aki i e tópikonan ku bo por spera i ku lo wòrdu tratá."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/remember.jpg",
    "imageAlt": "Season 01/Episode 00: Re-Member - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-02-episode-01-het-ego-en-manipulatie-technieken-2",
    "nextEpisode": "legacy-season-01-episode-01-de-alles",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 219,
      "kind": "podcast",
      "image": "images/remember.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-01-de-alles",
    "slug": {
      "en": "season-01-episode-01-de-alles",
      "es": "season-01-episode-01-de-alles",
      "nl": "season-01-episode-01-de-alles",
      "pap": "season-01-episode-01-de-alles"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 140,
    "title": {
      "en": "Season 01/Episode 01: The ALL",
      "es": "Temporada 01/Episodio 01: El TODO",
      "nl": "Season 01/Episode 01: De ALLES",
      "pap": "Temporada 01/Episodio 01: E TUR"
    },
    "language": "nl",
    "summary": {
      "en": "An introduction to self-awareness, intelligence, and wisdom. What it is and how we differ from the rest. The subject of 'God' (The ALL-NOTHING) is discussed in relation to Creation.",
      "es": "Una introducción a la autoconciencia, la inteligencia y la sabiduría. Qué es y en qué nos diferenciamos del resto. El tema de 'Dios' (el TODO-NADA) se aborda en relación con la Creación.",
      "nl": "Een inleiding tot zelfbewustzijn, intelligentie en wijsheid. Wat het is en hoe we verschillend zijn ten opzichte van de rest. Het onderwerp 'God' (Het ALLES-NIETS) wordt besproken in relatie tot de Schepping.",
      "pap": "Un introdukshon na outokonsenshi, inteligensia i sabiduria. Kiko e ta i kon nos ta diferensiá for di e resto. E tema di 'Dios' (e TUR-NADA) ta wòrdu tratá den relashon ku e Kreashon."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/img_1.jpg",
    "imageAlt": "Season 01/Episode 01: De ALLES - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-00-re-member",
    "nextEpisode": "legacy-season-01-episode-02-natuur-wetten",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 238,
      "kind": "podcast",
      "image": "images/img_1.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-02-natuur-wetten",
    "slug": {
      "en": "season-01-episode-02-natuur-wetten",
      "es": "season-01-episode-02-natuur-wetten",
      "nl": "season-01-episode-02-natuur-wetten",
      "pap": "season-01-episode-02-natuur-wetten"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 141,
    "title": {
      "en": "Season 01/Episode 02: Natural Laws",
      "es": "Temporada 01/Episodio 02: Leyes Naturales",
      "nl": "Season 01/Episode 02: Natuur Wetten",
      "pap": "Temporada 01/Episodio 02: Leinan Natural"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode the concept of natural law is introduced to my cubs, its importance, and its understanding. Living according to those laws is of the utmost importance to attain the happiness everyone so longs for.",
      "es": "En este episodio se introduce el concepto de la ley natural a mis cachorros, su importancia y su comprensión. Vivir según esas leyes es de suma importancia para alcanzar la felicidad que todos tanto anhelan.",
      "nl": "In deze aflevering wordt het concept van natuurwetten bij mijn welpen geïntroduceerd, het belang ervan en het begrip ervan. Leven volgens die wetten is van het grootste belang om het geluk te bereiken waar iedereen zo naar verlangt.",
      "pap": "Den e episodio aki ta introdusí e konsepto di lei natural na mi yu-lobonan, su importansia i su komprondementu. Biba segun e leinan ei ta di mas grandi importansia pa alkansá e felisidat ku tur hende ta anhelá asina tantu."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/img_2.jpg",
    "imageAlt": "Season 01/Episode 02: Natuur Wetten - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-01-de-alles",
    "nextEpisode": "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 256,
      "kind": "podcast",
      "image": "images/img_2.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad",
    "slug": {
      "en": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad",
      "es": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad",
      "nl": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad",
      "pap": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 142,
    "title": {
      "en": "Season 01/Episode 02&#189;: Announcement of Good and Evil",
      "es": "Temporada 01/Episodio 02&#189;: Anuncio del Bien y del Mal",
      "nl": "Season 01/Episode 02&#189;: Aankondiging van Goed en Kwaad",
      "pap": "Temporada 01/Episodio 02&#189;: Anunsio di Bon i Maldat"
    },
    "language": "nl",
    "summary": {
      "en": "Season 1, Episode 2½: an introduction to Good and Evil.",
      "es": "Temporada 1, Episodio 2½: una introducción al Bien y al Mal.",
      "nl": "Seizoen 1, Aflevering 2½: een inleiding tot Goed en Kwaad.",
      "pap": "Temporada 1, Episodio 2½: un introdukshon na Bon i Maldat."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/lion.jpg",
    "imageAlt": "Season 01/Episode 02&#189;: Aankondiging van Goed en Kwaad - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-02-natuur-wetten",
    "nextEpisode": "legacy-season-01-episode-03-goed-en-kwaad",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 275,
      "kind": "podcast",
      "image": "images/lion.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-03-goed-en-kwaad",
    "slug": {
      "en": "season-01-episode-03-goed-en-kwaad",
      "es": "season-01-episode-03-goed-en-kwaad",
      "nl": "season-01-episode-03-goed-en-kwaad",
      "pap": "season-01-episode-03-goed-en-kwaad"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 143,
    "title": {
      "en": "Season 01/Episode 03: Good and Evil",
      "es": "Temporada 01/Episodio 03: El Bien y el Mal",
      "nl": "Season 01/Episode 03: Goed en Kwaad",
      "pap": "Temporada 01/Episodio 03: Bon i Maldat"
    },
    "language": "nl",
    "summary": {
      "en": "An introduction to understanding and recognizing what is Good or Evil. In our society there is a constant struggle between these two forces, and it confuses many, BUT not if truth is your starting point!",
      "es": "Una introducción a comprender y reconocer qué es el Bien o el Mal. En nuestra sociedad hay una lucha constante entre estas dos fuerzas que confunde a muchos, ¡PERO no si la verdad es tu punto de partida!",
      "nl": "Een inleiding tot het begrijpen en erkennen van wat Goed of Kwaad is. In onze maatschappij is er een constante gevecht tussen deze twee krachten en brengt velen in verwarring, MAAR niet als de waarheid jou uitgangspositie is!",
      "pap": "Un introdukshon pa komprondé i rekonosé kiko ta Bon òf Maldat. Den nos sosiedat tin un lucha konstante entre e dos forsanan aki ku ta konfundí hopi hende, PERO no si bèrdat ta bo punto di salida!"
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/goodvsevil.jpeg",
    "imageAlt": "Season 01/Episode 03: Goed en Kwaad - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad",
    "nextEpisode": "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 294,
      "kind": "podcast",
      "image": "images/goodvsevil.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde",
    "slug": {
      "en": "season-01-episode-03-and-189-aankondiging-van-ware-liefde",
      "es": "season-01-episode-03-and-189-aankondiging-van-ware-liefde",
      "nl": "season-01-episode-03-and-189-aankondiging-van-ware-liefde",
      "pap": "season-01-episode-03-and-189-aankondiging-van-ware-liefde"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 144,
    "title": {
      "en": "Season 01/Episode 03&#189;: Announcement of True Love",
      "es": "Temporada 01/Episodio 03&#189;: Anuncio del Amor Verdadero",
      "nl": "Season 01/Episode 03&#189;: Aankondiging van Ware Liefde",
      "pap": "Temporada 01/Episodio 03&#189;: Anunsio di Berdadero Amor"
    },
    "language": "nl",
    "summary": {
      "en": "A very loving introduction to the coming episode on True Love. The ambience conveys the idea of the constant longing of Agape, the corrective Love, the Love of a Father for his son, to give his children the right direction.",
      "es": "Una introducción muy amorosa al próximo episodio sobre el Amor Verdadero. El ambiente transmite la idea del anhelo constante del Ágape, el Amor correctivo, el Amor de un Padre por su hijo, para dar a sus hijos la dirección correcta.",
      "nl": "Een zeer liefde volle inleiding tot de komende aflevering van Ware Liefde. De ambient geeft het idee van het constante verlange van Agape, de corrigerende Liefde, de Liefde van een Vader naar zijn zoon, om zijn kinderen de goede richting te geven.",
      "pap": "Un introdukshon masha amoroso na e episodio ku ta bin tokante Berdadero Amor. E ambiente ta transmití e idea di e anhelo konstante di Agape, e Amor korektivo, e Amor di un Tata pa su yu, pa duna su yunan e direkshon korekto."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/agape.jpg",
    "imageAlt": "Season 01/Episode 03&#189;: Aankondiging van Ware Liefde - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-03-goed-en-kwaad",
    "nextEpisode": "legacy-season-01-episode-04-ware-liefde",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 313,
      "kind": "podcast",
      "image": "images/agape.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-04-ware-liefde",
    "slug": {
      "en": "season-01-episode-04-ware-liefde",
      "es": "season-01-episode-04-ware-liefde",
      "nl": "season-01-episode-04-ware-liefde",
      "pap": "season-01-episode-04-ware-liefde"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 145,
    "title": {
      "en": "Season 01/Episode 04: True Love",
      "es": "Temporada 01/Episodio 04: Amor Verdadero",
      "nl": "Season 01/Episode 04: Ware Liefde",
      "pap": "Temporada 01/Episodio 04: Berdadero Amor"
    },
    "language": "nl",
    "summary": {
      "en": "The consequences of our two fundamental polar feelings are discussed here. These feelings give us a reference point. It is also discussed that True Love is a corrective force, and that at its core True Love is Natural Law.",
      "es": "Aquí se analizan las consecuencias de nuestros dos sentimientos polares fundamentales. Estos sentimientos nos dan un punto de referencia. También se comenta que el Amor Verdadero es una fuerza correctiva y que, en su esencia, el Amor Verdadero es la Ley Natural.",
      "nl": "De gevolgen van onze twee fundamentele poolgevoelens wordt hier besproken. Deze gevoelens geven ons een referentiepunt. Ook wordt er besproken dat Ware liefde een corrigerende kracht is en in de kern is Ware Liefde de Natuurwetten.",
      "pap": "Akinan ta analisá e konsekuensianan di nos dos sintimentunan polar fundamental. E sintimentunan aki ta duna nos un punto di referensia. Tambe ta papia ku Berdadero Amor ta un forsa korektivo i ku, den su esensia, Berdadero Amor ta Lei Natural."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/true.jpeg",
    "imageAlt": "Season 01/Episode 04: Ware Liefde - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde",
    "nextEpisode": "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 332,
      "kind": "podcast",
      "image": "images/true.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld",
    "slug": {
      "en": "season-01-episode-05-het-brein-en-jou-wereldbeeld",
      "es": "season-01-episode-05-het-brein-en-jou-wereldbeeld",
      "nl": "season-01-episode-05-het-brein-en-jou-wereldbeeld",
      "pap": "season-01-episode-05-het-brein-en-jou-wereldbeeld"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 146,
    "title": {
      "en": "Season 01/Episode 05: The Brain and Your Worldview",
      "es": "Temporada 01/Episodio 05: El Cerebro y Tu Cosmovisión",
      "nl": "Season 01/Episode 05: Het Brein en Jou Wereldbeeld",
      "pap": "Temporada 01/Episodio 05: E Serebro i Bo Vishon di Mundu"
    },
    "language": "nl",
    "summary": {
      "en": "One of the most important episodes to listen to. The two worldviews are discussed and how this relates to and reacts within your physical brain.",
      "es": "Uno de los episodios más importantes para escuchar. Se analizan las dos cosmovisiones y cómo se relacionan y reaccionan dentro de tu cerebro físico.",
      "nl": "Een van de belangrijkste afleveringen om naar te luisteren. De twee wereldbeelden worden besproken en hoe dit zich verhoudt en reageert in je fysieke brein.",
      "pap": "Un di e episodionan di mas importante pa skucha. Ta analisá e dos vishonnan di mundu i kon esaki ta relashoná i ta reakshoná den bo serebro físiko."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/worldview.jpeg",
    "imageAlt": "Season 01/Episode 05: Het Brein en Jou Wereldbeeld - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      },
      {
        "label": {
          "en": "het drievoudige brein",
          "es": "het drievoudige brein",
          "nl": "het drievoudige brein",
          "pap": "het drievoudige brein"
        },
        "url": "./images/thebrain.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "linker- vs. rechterhersenhelft",
          "es": "linker- vs. rechterhersenhelft",
          "nl": "linker- vs. rechterhersenhelft",
          "pap": "linker- vs. rechterhersenhelft"
        },
        "url": "./images/leftrightbrain.jpeg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-04-ware-liefde",
    "nextEpisode": "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 352,
      "kind": "podcast",
      "image": "images/worldview.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden",
    "slug": {
      "en": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden",
      "es": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden",
      "nl": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden",
      "pap": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 147,
    "title": {
      "en": "Season 01/Episode 06: Modality, Free Will and the 7 Deadly Sins",
      "es": "Temporada 01/Episodio 06: Modalidad, Libre Albedrío y los 7 Pecados Capitales",
      "nl": "Season 01/Episode 06: Modaliteit, Vrije Wil en de 7 Dodelijke Hoofdzonden",
      "pap": "Temporada 01/Episodio 06: Modalidat, Boluntat Liber i e 7 Pikánan Mortal"
    },
    "language": "nl",
    "summary": {
      "en": "The modality of the right and left hemisphere, free will, and the 7 deadly sins are discussed in relation to the two worldviews. This podcast also discusses what it means to be a sovereign and balanced person.",
      "es": "La modalidad del hemisferio derecho e izquierdo, el libre albedrío y los 7 pecados capitales se analizan en relación con las dos cosmovisiones. Este podcast también trata lo que significa ser una persona soberana y equilibrada.",
      "nl": "De modaliteit van de rechter en linker hersenhelft, de vrije wil en de 7 dodelijke hoofdzonden worden besproken in relatie tot de twee wereldbeelden. Deze podcast bespreek ook wat het betekent om een soeverein en evenwichtig persoon te zijn.",
      "pap": "E modalidat di e banda drechi i robes di serebro, boluntat liber i e 7 pikánan mortal ta wòrdu tratá den relashon ku e dos vishonnan di mundu. E podcast aki tambe ta papia di kiko ta nifiká pa ta un persona soberano i balansá."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/freewill.jpeg",
    "imageAlt": "Season 01/Episode 06: Modaliteit, Vrije Wil en de 7 Dodelijke Hoofdzonden - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld",
    "nextEpisode": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 373,
      "kind": "podcast",
      "image": "images/freewill.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit",
    "slug": {
      "en": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit",
      "es": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit",
      "nl": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit",
      "pap": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 148,
    "title": {
      "en": "Season 01/Episode 07: The Path to Real Freedom and Sovereignty",
      "es": "Temporada 01/Episodio 07: El Camino hacia la Verdadera Libertad y Soberanía",
      "nl": "Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit",
      "pap": "Temporada 01/Episodio 07: E Kaminda pa Berdadero Libertat i Soberania"
    },
    "language": "nl",
    "summary": {
      "en": "Here the previous themes are brought together into one whole. Truth is discussed in relation to Real Freedom and Sovereignty. Sovereignty — and thus being ruler over one's own body, feelings, and actions — can only be attained when one takes the standpoint of Truth.",
      "es": "Aquí se reúnen los temas anteriores en un solo conjunto. Se analiza la Verdad en relación con la Libertad Real y la Soberanía. La Soberanía —y, por tanto, ser señor del propio cuerpo, sentimientos y acciones— solo puede alcanzarse cuando uno adopta el punto de vista de la Verdad.",
      "nl": "Hier worden de vorige thema's tot een (1) geheel gebracht. Waarheid wordt besproken in relatie tot Echte Vrijheid en Soevereiniteit. Soevereiniteit, en dus Zelf heerser over eigen lichaam, gevoelens en acties kan alleen worden bereikt als men de standpunt van Waarheid nemen.",
      "pap": "Akinan e temanan anterior ta wòrdu trahé huntu den un solo henter. Ta analisá Bèrdat den relashon ku Berdadero Libertat i Soberania. Soberania —i pesei ta señor riba bo mes kurpa, sintimentu i akshon— solamente por wòrdu alkansá ora un hende tuma e punto di bista di Bèrdat."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/thesun.jpeg",
    "imageAlt": "Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Anarkhos",
          "es": "Anarkhos",
          "nl": "Anarkhos",
          "pap": "Anarkhos"
        },
        "url": "https://www.amazon.com/Anarkhos-Ancient-Knowledge-Modern-Societies-ebook/dp/B07PF52Q2V/ref=sr_1_1?dchild=1&keywords=anarkhos&qid=1604257731&sr=8-1",
        "type": "external"
      },
      {
        "label": {
          "en": "de kluizenaar of zoekende",
          "es": "de kluizenaar of zoekende",
          "nl": "de kluizenaar of zoekende",
          "pap": "de kluizenaar of zoekende"
        },
        "url": "./images/dekluizenaar.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "de dwaas, joker of idioot",
          "es": "de dwaas, joker of idioot",
          "nl": "de dwaas, joker of idioot",
          "pap": "de dwaas, joker of idioot"
        },
        "url": "./images/dedwaas.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "hier",
          "es": "hier",
          "nl": "hier",
          "pap": "hier"
        },
        "url": "./articles/AquinasOverVrijheid.pdf#toolbar=0",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden",
    "nextEpisode": "legacy-episode-06-how-to-create-web-page-using-bootstrap-4",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 393,
      "kind": "podcast",
      "image": "images/thesun.jpeg"
    }
  },
  {
    "id": "legacy-episode-06-how-to-create-web-page-using-bootstrap-4",
    "slug": {
      "en": "episode-06-how-to-create-web-page-using-bootstrap-4",
      "es": "episode-06-how-to-create-web-page-using-bootstrap-4",
      "nl": "episode-06-how-to-create-web-page-using-bootstrap-4",
      "pap": "episode-06-how-to-create-web-page-using-bootstrap-4"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 149,
    "title": {
      "en": "Episode 06: How To Create Web Page Using Bootstrap 4",
      "es": "Episodio 06: Cómo Crear una Página Web con Bootstrap 4",
      "nl": "Aflevering 06: Een Webpagina Maken met Bootstrap 4",
      "pap": "Episodio 06: Kon Traha un Página Web ku Bootstrap 4"
    },
    "language": "nl",
    "summary": {
      "en": "A short tutorial on building a web page with Bootstrap 4 (Episode 06).",
      "es": "Un breve tutorial sobre cómo crear una página web con Bootstrap 4 (Episodio 06).",
      "nl": "Een korte tutorial over het bouwen van een webpagina met Bootstrap 4 (aflevering 06).",
      "pap": "Un tutorial kòrtiku tokante kon traha un página web ku Bootstrap 4 (Episodio 06)."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/img_3.jpg",
    "imageAlt": "Episode 06: How To Create Web Page Using Bootstrap 4 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Episode 06: How To Create Web Page Using Bootstrap 4",
          "es": "Episode 06: How To Create Web Page Using Bootstrap 4",
          "nl": "Episode 06: How To Create Web Page Using Bootstrap 4",
          "pap": "Episode 06: How To Create Web Page Using Bootstrap 4"
        },
        "url": "single-post.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit",
    "nextEpisode": "legacy-episode-05-how-to-create-web-page-using-bootstrap-4",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 416,
      "kind": "podcast",
      "image": "images/img_3.jpg"
    }
  },
  {
    "id": "legacy-episode-05-how-to-create-web-page-using-bootstrap-4",
    "slug": {
      "en": "episode-05-how-to-create-web-page-using-bootstrap-4",
      "es": "episode-05-how-to-create-web-page-using-bootstrap-4",
      "nl": "episode-05-how-to-create-web-page-using-bootstrap-4",
      "pap": "episode-05-how-to-create-web-page-using-bootstrap-4"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 150,
    "title": {
      "en": "Episode 05: How To Create Web Page Using Bootstrap 4",
      "es": "Episodio 05: Cómo Crear una Página Web con Bootstrap 4",
      "nl": "Aflevering 05: Een Webpagina Maken met Bootstrap 4",
      "pap": "Episodio 05: Kon Traha un Página Web ku Bootstrap 4"
    },
    "language": "nl",
    "summary": {
      "en": "A short tutorial on building a web page with Bootstrap 4 (Episode 05).",
      "es": "Un breve tutorial sobre cómo crear una página web con Bootstrap 4 (Episodio 05).",
      "nl": "Een korte tutorial over het bouwen van een webpagina met Bootstrap 4 (aflevering 05).",
      "pap": "Un tutorial kòrtiku tokante kon traha un página web ku Bootstrap 4 (Episodio 05)."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/img_4.jpg",
    "imageAlt": "Episode 05: How To Create Web Page Using Bootstrap 4 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Episode 05: How To Create Web Page Using Bootstrap 4",
          "es": "Episode 05: How To Create Web Page Using Bootstrap 4",
          "nl": "Episode 05: How To Create Web Page Using Bootstrap 4",
          "pap": "Episode 05: How To Create Web Page Using Bootstrap 4"
        },
        "url": "single-post.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-episode-06-how-to-create-web-page-using-bootstrap-4",
    "nextEpisode": "legacy-episode-04-how-to-create-web-page-using-bootstrap-4",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 433,
      "kind": "podcast",
      "image": "images/img_4.jpg"
    }
  },
  {
    "id": "legacy-episode-04-how-to-create-web-page-using-bootstrap-4",
    "slug": {
      "en": "episode-04-how-to-create-web-page-using-bootstrap-4",
      "es": "episode-04-how-to-create-web-page-using-bootstrap-4",
      "nl": "episode-04-how-to-create-web-page-using-bootstrap-4",
      "pap": "episode-04-how-to-create-web-page-using-bootstrap-4"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 151,
    "title": {
      "en": "Episode 04: How To Create Web Page Using Bootstrap 4",
      "es": "Episodio 04: Cómo Crear una Página Web con Bootstrap 4",
      "nl": "Aflevering 04: Een Webpagina Maken met Bootstrap 4",
      "pap": "Episodio 04: Kon Traha un Página Web ku Bootstrap 4"
    },
    "language": "nl",
    "summary": {
      "en": "A short tutorial on building a web page with Bootstrap 4 (Episode 04).",
      "es": "Un breve tutorial sobre cómo crear una página web con Bootstrap 4 (Episodio 04).",
      "nl": "Een korte tutorial over het bouwen van een webpagina met Bootstrap 4 (aflevering 04).",
      "pap": "Un tutorial kòrtiku tokante kon traha un página web ku Bootstrap 4 (Episodio 04)."
    },
    "videoUrl": null,
    "audioUrl": null,
    "image": "/assets/images/img_5.jpg",
    "imageAlt": "Episode 04: How To Create Web Page Using Bootstrap 4 - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "Episode 04: How To Create Web Page Using Bootstrap 4",
          "es": "Episode 04: How To Create Web Page Using Bootstrap 4",
          "nl": "Episode 04: How To Create Web Page Using Bootstrap 4",
          "pap": "Episode 04: How To Create Web Page Using Bootstrap 4"
        },
        "url": "single-post.html",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "index.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "index-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "index-3.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-episode-05-how-to-create-web-page-using-bootstrap-4",
    "nextEpisode": "legacy-season-01-episode-00-re-member-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index-3.html",
      "sourceLine": 450,
      "kind": "podcast",
      "image": "images/img_5.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-00-re-member-2",
    "slug": {
      "en": "season-01-episode-00-re-member-2",
      "es": "season-01-episode-00-re-member-2",
      "nl": "season-01-episode-00-re-member-2",
      "pap": "season-01-episode-00-re-member-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 152,
    "title": {
      "en": "Season 01/Episode 00: Re-Member",
      "es": "Temporada 01/Episodio 00: Re-Cordar",
      "nl": "Season 01/Episode 00: Re-Member",
      "pap": "Temporada 01/Episodio 00: Re-Kòrda"
    },
    "language": "nl",
    "summary": {
      "en": "An introduction to the podcasts presented this season and the topics to be expected and discussed.",
      "es": "Una introducción a los podcasts que se presentan esta temporada y a los temas que cabe esperar y comentar.",
      "nl": "Een inleiding op de podcasts die dit seizoen gepresenteerd worden en de onderwerpen die te verwachten - en te bespreken zijn.",
      "pap": "Un introdukshon na e podcastnan ku ta presentá e temporada aki i e tópikonan ku bo por spera i ku lo wòrdu tratá."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S01E00%20-%20Re-Member.mp3",
    "image": "/assets/images/remember.jpg",
    "imageAlt": "Season 01/Episode 00: Re-Member - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-episode-04-how-to-create-web-page-using-bootstrap-4",
    "nextEpisode": "legacy-season-01-episode-01-de-alles-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 271,
      "kind": "podcast",
      "image": "images/remember.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-01-de-alles-2",
    "slug": {
      "en": "season-01-episode-01-de-alles-2",
      "es": "season-01-episode-01-de-alles-2",
      "nl": "season-01-episode-01-de-alles-2",
      "pap": "season-01-episode-01-de-alles-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 153,
    "title": {
      "en": "Season 01/Episode 01: The ALL",
      "es": "Temporada 01/Episodio 01: El TODO",
      "nl": "Season 01/Episode 01: De ALLES",
      "pap": "Temporada 01/Episodio 01: E TUR"
    },
    "language": "nl",
    "summary": {
      "en": "An introduction to self-awareness, intelligence, and wisdom. What it is and how we differ from the rest. The subject of 'God' (The ALL-NOTHING) is discussed in relation to Creation.",
      "es": "Una introducción a la autoconciencia, la inteligencia y la sabiduría. Qué es y en qué nos diferenciamos del resto. El tema de 'Dios' (el TODO-NADA) se aborda en relación con la Creación.",
      "nl": "Een inleiding tot zelfbewustzijn, intelligentie en wijsheid. Wat het is en hoe we verschillend zijn ten opzichte van de rest. Het onderwerp 'God' (Het ALLES-NIETS) wordt besproken in relatie tot de Schepping.",
      "pap": "Un introdukshon na outokonsenshi, inteligensia i sabiduria. Kiko e ta i kon nos ta diferensiá for di e resto. E tema di 'Dios' (e TUR-NADA) ta wòrdu tratá den relashon ku e Kreashon."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S01E01%20-%20De%20ALLES.mp3",
    "image": "/assets/images/img_1.jpg",
    "imageAlt": "Season 01/Episode 01: De ALLES - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-00-re-member-2",
    "nextEpisode": "legacy-season-01-episode-02-natuurwetten",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 290,
      "kind": "podcast",
      "image": "images/img_1.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-02-natuurwetten",
    "slug": {
      "en": "season-01-episode-02-natuurwetten",
      "es": "season-01-episode-02-natuurwetten",
      "nl": "season-01-episode-02-natuurwetten",
      "pap": "season-01-episode-02-natuurwetten"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 154,
    "title": {
      "en": "Season 01/Episode 02: Natural Laws",
      "es": "Temporada 01/Episodio 02: Leyes Naturales",
      "nl": "Season 01/Episode 02: Natuurwetten",
      "pap": "Temporada 01/Episodio 02: Leinan Natural"
    },
    "language": "nl",
    "summary": {
      "en": "In this episode the concept of natural law is introduced to my cubs, its importance, and its understanding. Living according to those laws is of the utmost importance to attain the happiness everyone so longs for.",
      "es": "En este episodio se introduce el concepto de la ley natural a mis cachorros, su importancia y su comprensión. Vivir según esas leyes es de suma importancia para alcanzar la felicidad que todos tanto anhelan.",
      "nl": "In deze aflevering wordt het concept van natuurwetten bij mijn welpen geïntroduceerd, het belang ervan en het begrip ervan. Leven volgens die wetten is van het grootste belang om het geluk te bereiken waar iedereen zo naar verlangt.",
      "pap": "Den e episodio aki ta introdusí e konsepto di lei natural na mi yu-lobonan, su importansia i su komprondementu. Biba segun e leinan ei ta di mas grandi importansia pa alkansá e felisidat ku tur hende ta anhelá asina tantu."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S01E02%20-%20Natuur%20Wetten.mp3",
    "image": "/assets/images/img_2.jpg",
    "imageAlt": "Season 01/Episode 02: Natuurwetten - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-01-de-alles-2",
    "nextEpisode": "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 307,
      "kind": "podcast",
      "image": "images/img_2.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2",
    "slug": {
      "en": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2",
      "es": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2",
      "nl": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2",
      "pap": "season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 155,
    "title": {
      "en": "Season 01/Episode 02&#189;: Announcement of Good and Evil",
      "es": "Temporada 01/Episodio 02&#189;: Anuncio del Bien y del Mal",
      "nl": "Season 01/Episode 02&#189;: Aankondiging van Goed en Kwaad",
      "pap": "Temporada 01/Episodio 02&#189;: Anunsio di Bon i Maldat"
    },
    "language": "nl",
    "summary": {
      "en": "Season 1, Episode 2½: an introduction to Good and Evil.",
      "es": "Temporada 1, Episodio 2½: una introducción al Bien y al Mal.",
      "nl": "Seizoen 1, Aflevering 2½: een inleiding tot Goed en Kwaad.",
      "pap": "Temporada 1, Episodio 2½: un introdukshon na Bon i Maldat."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE-S01E2.5-Aankonding-v-Goed-en-Kwaad.mp3",
    "image": "/assets/images/lion.jpg",
    "imageAlt": "Season 01/Episode 02&#189;: Aankondiging van Goed en Kwaad - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-02-natuurwetten",
    "nextEpisode": "legacy-season-01-episode-03-goed-en-kwaad-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 327,
      "kind": "podcast",
      "image": "images/lion.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-03-goed-en-kwaad-2",
    "slug": {
      "en": "season-01-episode-03-goed-en-kwaad-2",
      "es": "season-01-episode-03-goed-en-kwaad-2",
      "nl": "season-01-episode-03-goed-en-kwaad-2",
      "pap": "season-01-episode-03-goed-en-kwaad-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 156,
    "title": {
      "en": "Season 01/Episode 03: Good and Evil",
      "es": "Temporada 01/Episodio 03: El Bien y el Mal",
      "nl": "Season 01/Episode 03: Goed en Kwaad",
      "pap": "Temporada 01/Episodio 03: Bon i Maldat"
    },
    "language": "nl",
    "summary": {
      "en": "An introduction to understanding and recognizing what is Good or Evil. In our society there is a constant struggle between these two forces, and it confuses many, BUT not if truth is your starting point!",
      "es": "Una introducción a comprender y reconocer qué es el Bien o el Mal. En nuestra sociedad hay una lucha constante entre estas dos fuerzas que confunde a muchos, ¡PERO no si la verdad es tu punto de partida!",
      "nl": "Een inleiding tot het begrijpen en erkennen van wat Goed of Kwaad is. In onze maatschappij is er een constante gevecht tussen deze twee krachten en brengt velen in verwarring, MAAR niet als de waarheid jou uitgangspositie is!",
      "pap": "Un introdukshon pa komprondé i rekonosé kiko ta Bon òf Maldat. Den nos sosiedat tin un lucha konstante entre e dos forsanan aki ku ta konfundí hopi hende, PERO no si bèrdat ta bo punto di salida!"
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S01E03%20-%20Goed%20en%20Kwaad.mp3",
    "image": "/assets/images/goodvsevil.jpeg",
    "imageAlt": "Season 01/Episode 03: Goed en Kwaad - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-02-and-189-aankondiging-van-goed-en-kwaad-2",
    "nextEpisode": "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 347,
      "kind": "podcast",
      "image": "images/goodvsevil.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde-2",
    "slug": {
      "en": "season-01-episode-03-and-189-aankondiging-van-ware-liefde-2",
      "es": "season-01-episode-03-and-189-aankondiging-van-ware-liefde-2",
      "nl": "season-01-episode-03-and-189-aankondiging-van-ware-liefde-2",
      "pap": "season-01-episode-03-and-189-aankondiging-van-ware-liefde-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 157,
    "title": {
      "en": "Season 01/Episode 03&#189;: Announcement of True Love",
      "es": "Temporada 01/Episodio 03&#189;: Anuncio del Amor Verdadero",
      "nl": "Season 01/Episode 03&#189;: Aankondiging van Ware Liefde",
      "pap": "Temporada 01/Episodio 03&#189;: Anunsio di Berdadero Amor"
    },
    "language": "nl",
    "summary": {
      "en": "A very loving introduction to the coming episode on True Love. The ambience conveys the idea of the constant longing of Agape, the corrective Love, the Love of a Father for his son, to give his children the right direction.",
      "es": "Una introducción muy amorosa al próximo episodio sobre el Amor Verdadero. El ambiente transmite la idea del anhelo constante del Ágape, el Amor correctivo, el Amor de un Padre por su hijo, para dar a sus hijos la dirección correcta.",
      "nl": "Een zeer liefde volle inleiding tot de komende aflevering van Ware Liefde. De ambient geeft het idee van het constante verlange van Agape, de corrigerende Liefde, de Liefde van een Vader naar zijn zoon, om zijn kinderen de goede richting te geven.",
      "pap": "Un introdukshon masha amoroso na e episodio ku ta bin tokante Berdadero Amor. E ambiente ta transmití e idea di e anhelo konstante di Agape, e Amor korektivo, e Amor di un Tata pa su yu, pa duna su yunan e direkshon korekto."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0103.5%20-%20Aankondiging%20van%20Ware%20Liefde.mp3",
    "image": "/assets/images/agape.jpg",
    "imageAlt": "Season 01/Episode 03&#189;: Aankondiging van Ware Liefde - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-03-goed-en-kwaad-2",
    "nextEpisode": "legacy-season-01-episode-04-ware-liefde-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 367,
      "kind": "podcast",
      "image": "images/agape.jpg"
    }
  },
  {
    "id": "legacy-season-01-episode-04-ware-liefde-2",
    "slug": {
      "en": "season-01-episode-04-ware-liefde-2",
      "es": "season-01-episode-04-ware-liefde-2",
      "nl": "season-01-episode-04-ware-liefde-2",
      "pap": "season-01-episode-04-ware-liefde-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 158,
    "title": {
      "en": "Season 01/Episode 04: True Love",
      "es": "Temporada 01/Episodio 04: Amor Verdadero",
      "nl": "Season 01/Episode 04: Ware Liefde",
      "pap": "Temporada 01/Episodio 04: Berdadero Amor"
    },
    "language": "nl",
    "summary": {
      "en": "The consequences of our two fundamental polar feelings are discussed here. These feelings give us a reference point. It is also discussed that True Love is a corrective force, and that at its core True Love is Natural Law.",
      "es": "Aquí se analizan las consecuencias de nuestros dos sentimientos polares fundamentales. Estos sentimientos nos dan un punto de referencia. También se comenta que el Amor Verdadero es una fuerza correctiva y que, en su esencia, el Amor Verdadero es la Ley Natural.",
      "nl": "De gevolgen van onze twee fundamentele poolgevoelens wordt hier besproken. Deze gevoelens geven ons een referentiepunt. Ook wordt er besproken dat Ware liefde een corrigerende kracht is en in de kern is Ware Liefde de Natuurwetten.",
      "pap": "Akinan ta analisá e konsekuensianan di nos dos sintimentunan polar fundamental. E sintimentunan aki ta duna nos un punto di referensia. Tambe ta papia ku Berdadero Amor ta un forsa korektivo i ku, den su esensia, Berdadero Amor ta Lei Natural."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0104%20-%20Ware%20Liefde.mp3",
    "image": "/assets/images/true.jpeg",
    "imageAlt": "Season 01/Episode 04: Ware Liefde - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-03-and-189-aankondiging-van-ware-liefde-2",
    "nextEpisode": "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 387,
      "kind": "podcast",
      "image": "images/true.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld-2",
    "slug": {
      "en": "season-01-episode-05-het-brein-en-jou-wereldbeeld-2",
      "es": "season-01-episode-05-het-brein-en-jou-wereldbeeld-2",
      "nl": "season-01-episode-05-het-brein-en-jou-wereldbeeld-2",
      "pap": "season-01-episode-05-het-brein-en-jou-wereldbeeld-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 159,
    "title": {
      "en": "Season 01/Episode 05: The Brain and Your Worldview",
      "es": "Temporada 01/Episodio 05: El Cerebro y Tu Cosmovisión",
      "nl": "Season 01/Episode 05: Het Brein en Jou Wereldbeeld",
      "pap": "Temporada 01/Episodio 05: E Serebro i Bo Vishon di Mundu"
    },
    "language": "nl",
    "summary": {
      "en": "One of the most important episodes to listen to. The two worldviews are discussed and how this relates to and reacts within your physical brain.",
      "es": "Uno de los episodios más importantes para escuchar. Se analizan las dos cosmovisiones y cómo se relacionan y reaccionan dentro de tu cerebro físico.",
      "nl": "Een van de belangrijkste afleveringen om naar te luisteren. De twee wereldbeelden worden besproken en hoe dit zich verhoudt en reageert in je fysieke brein.",
      "pap": "Un di e episodionan di mas importante pa skucha. Ta analisá e dos vishonnan di mundu i kon esaki ta relashoná i ta reakshoná den bo serebro físiko."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0105%20-%20De%20Brein%20en%20Wereldbeeld.mp3",
    "image": "/assets/images/worldview.jpeg",
    "imageAlt": "Season 01/Episode 05: Het Brein en Jou Wereldbeeld - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "het drievoudige brein",
          "es": "het drievoudige brein",
          "nl": "het drievoudige brein",
          "pap": "het drievoudige brein"
        },
        "url": "./images/thebrain.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "linker- vs. rechterhersenhelft",
          "es": "linker- vs. rechterhersenhelft",
          "nl": "linker- vs. rechterhersenhelft",
          "pap": "linker- vs. rechterhersenhelft"
        },
        "url": "./images/leftrightbrain.jpeg",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-04-ware-liefde-2",
    "nextEpisode": "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 407,
      "kind": "podcast",
      "image": "images/worldview.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2",
    "slug": {
      "en": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2",
      "es": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2",
      "nl": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2",
      "pap": "season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 160,
    "title": {
      "en": "Season 01/Episode 06: Modality, Free Will and the 7 Deadly Sins",
      "es": "Temporada 01/Episodio 06: Modalidad, Libre Albedrío y los 7 Pecados Capitales",
      "nl": "Season 01/Episode 06: Modaliteit, Vrije Wil en de 7 Dodelijke Hoofdzonden",
      "pap": "Temporada 01/Episodio 06: Modalidat, Boluntat Liber i e 7 Pikánan Mortal"
    },
    "language": "nl",
    "summary": {
      "en": "The modality of the right and left hemisphere, free will, and the 7 deadly sins are discussed in relation to the two worldviews. This podcast also discusses what it means to be a sovereign and balanced person.",
      "es": "La modalidad del hemisferio derecho e izquierdo, el libre albedrío y los 7 pecados capitales se analizan en relación con las dos cosmovisiones. Este podcast también trata lo que significa ser una persona soberana y equilibrada.",
      "nl": "De modaliteit van de rechter en linker hersenhelft, de vrije wil en de 7 dodelijke hoofdzonden worden besproken in relatie tot de twee wereldbeelden. Deze podcast bespreek ook wat het betekent om een soeverein en evenwichtig persoon te zijn.",
      "pap": "E modalidat di e banda drechi i robes di serebro, boluntat liber i e 7 pikánan mortal ta wòrdu tratá den relashon ku e dos vishonnan di mundu. E podcast aki tambe ta papia di kiko ta nifiká pa ta un persona soberano i balansá."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0106%20-%20Modaliteit%20-%20Vrijewil%20en%20de%207%20Hoofdzonden.mp3",
    "image": "/assets/images/freewill.jpeg",
    "imageAlt": "Season 01/Episode 06: Modaliteit, Vrije Wil en de 7 Dodelijke Hoofdzonden - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-05-het-brein-en-jou-wereldbeeld-2",
    "nextEpisode": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 435,
      "kind": "podcast",
      "image": "images/freewill.jpeg"
    }
  },
  {
    "id": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2",
    "slug": {
      "en": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2",
      "es": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2",
      "nl": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2",
      "pap": "season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 161,
    "title": {
      "en": "Season 01/Episode 07: The Path to Real Freedom and Sovereignty",
      "es": "Temporada 01/Episodio 07: El Camino hacia la Verdadera Libertad y Soberanía",
      "nl": "Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit",
      "pap": "Temporada 01/Episodio 07: E Kaminda pa Berdadero Libertat i Soberania"
    },
    "language": "nl",
    "summary": {
      "en": "Here the previous themes are brought together into one whole. Truth is discussed in relation to Real Freedom and Sovereignty. Sovereignty — and thus being ruler over one's own body, feelings, and actions — can only be attained when one takes the standpoint of Truth.",
      "es": "Aquí se reúnen los temas anteriores en un solo conjunto. Se analiza la Verdad en relación con la Libertad Real y la Soberanía. La Soberanía —y, por tanto, ser señor del propio cuerpo, sentimientos y acciones— solo puede alcanzarse cuando uno adopta el punto de vista de la Verdad.",
      "nl": "Hier worden de vorige thema's tot een (1) geheel gebracht. Waarheid wordt besproken in relatie tot Echte Vrijheid en Soevereiniteit. Soevereiniteit, en dus Zelf heerser over eigen lichaam, gevoelens en acties kan alleen worden bereikt als men de standpunt van Waarheid nemen.",
      "pap": "Akinan e temanan anterior ta wòrdu trahé huntu den un solo henter. Ta analisá Bèrdat den relashon ku Berdadero Libertat i Soberania. Soberania —i pesei ta señor riba bo mes kurpa, sintimentu i akshon— solamente por wòrdu alkansá ora un hende tuma e punto di bista di Bèrdat."
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/TGWE%20-%20S0107%20-%20De%20Weg%20naar%20Echte%20Vrijheid%20en%20Soeveraniteit.mp3",
    "image": "/assets/images/thesun.jpeg",
    "imageAlt": "Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "de kluizenaar of zoekende",
          "es": "de kluizenaar of zoekende",
          "nl": "de kluizenaar of zoekende",
          "pap": "de kluizenaar of zoekende"
        },
        "url": "./images/dekluizenaar.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "de dwaas, joker of idioot",
          "es": "de dwaas, joker of idioot",
          "nl": "de dwaas, joker of idioot",
          "pap": "de dwaas, joker of idioot"
        },
        "url": "./images/dedwaas.jpeg",
        "type": "external"
      },
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "./articles/AquinasOnLiberty.pdf#toolbar=0",
        "type": "pdf"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "./articles/AquinasOverVrijheid.pdf#toolbar=0",
        "type": "pdf"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-06-modaliteit-vrije-wil-en-de-7-dodelijke-hoofdzonden-2",
    "nextEpisode": "legacy-season-01-transformeren-naar-het-goede-closure",
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 456,
      "kind": "podcast",
      "image": "images/thesun.jpeg"
    }
  },
  {
    "id": "legacy-season-01-transformeren-naar-het-goede-closure",
    "slug": {
      "en": "season-01-transformeren-naar-het-goede-closure",
      "es": "season-01-transformeren-naar-het-goede-closure",
      "nl": "season-01-transformeren-naar-het-goede-closure",
      "pap": "season-01-transformeren-naar-het-goede-closure"
    },
    "seasonId": "legacy-media-preservation-season",
    "episodeNumber": 162,
    "title": {
      "en": "Season 01/Transforming Toward the Good: Closure",
      "es": "Temporada 01/Transformarse Hacia el Bien: Closure",
      "nl": "Season 01/Transformeren naar Het Goede: Closure",
      "pap": "Temporada 01/Transformá pa e Bon: Closure"
    },
    "language": "nl",
    "summary": {
      "en": "A beautiful closing song for our first season. We have now established some basic concepts. In the next season we will give more depth to these concepts and explore a number of manipulation techniques. After this point we will use the gold nuggets (top right) to tell you that this is advice, information, or a tip worth gold. When you see it, pay attention. In ancient Egypt the scarab was also a symbol of transformation. The winged scarab beside this, holding the sun god Ra, symbolizes you in a phase of transformation or becoming toward the light. See you soon in season 2!",
      "es": "Una hermosa canción de cierre para nuestra primera temporada. Ya hemos establecido algunos conceptos básicos. En la próxima temporada daremos más profundidad a estos conceptos y exploraremos varias técnicas de manipulación. A partir de este punto usaremos las pepitas de oro (arriba a la derecha) para indicarte que se trata de un consejo, una información o un dato que vale oro. Cuando lo veas, presta atención. En el antiguo Egipto el escarabajo también era símbolo de transformación. El escarabajo alado que aparece al lado, sosteniendo al dios sol Ra, te simboliza a ti en una fase de transformación o de devenir hacia la luz. ¡Nos vemos pronto en la temporada 2!",
      "nl": "Een mooie afsluitingslied van onze eerste seizoen. We hebben nu sommige basis concepten vastgelegd. De volgende seizoen zullen we meer diepte geven aan deze concepten en gaan we een aantal manipulatie technieken verkennen. Na dit punt zullen we de goudklompjes (rechtsboven) gebruiken om je te vertellen dat dit een advies, informatie of tip is dat goud waard is. Als je het ziet, let dan op. In het oude Egypte was de scarabee ook een symbool van transformatie. De gevleugelde scarabee hiernaast die de zonnegod Ra vasthoudt symboliseert jou in een transformatie- of wordingsfase naar het licht. We zien elkaar zo in seizoen 2!",
      "pap": "Un bunita kantika di sera pa nos promé temporada. Awor nos a establesé algun konsepto básiko. Den e siguiente temporada nos lo duna mas profundidat na e konseptonan aki i ta eksplorá un kantidat di teknika di manipulashon. For di e punto aki nos lo usa e pida-pidanan di oro (ariba na man drechi) pa bisa bo ku esaki ta un konseho, informashon òf tip ku ta bal oro. Ora bo mir'é, presta atenshon. Den Egipto antiguo e skarabé tabata tambe un símbolo di transformashon. E skarabé ku ala banda di esaki, ku ta tene e dios solo Ra, ta simbolisá bo den un fase di transformashon òf di bira pa direkshon di e lus. Te aworó den temporada 2!"
    },
    "videoUrl": null,
    "audioUrl": "https://thegreatworkexperience.com/pods/closure.mp3",
    "image": "/assets/images/scarab.jpg",
    "imageAlt": "Season 01/Transformeren naar Het Goede: Closure - media image from the The Great Work Experience archive",
    "materialLinks": [
      {
        "label": {
          "en": "EN",
          "es": "EN",
          "nl": "EN",
          "pap": "EN"
        },
        "url": "https://www.amazon.com/dp/B0DVZ2NWWX",
        "type": "external"
      },
      {
        "label": {
          "en": "ES",
          "es": "ES",
          "nl": "ES",
          "pap": "ES"
        },
        "url": "https://www.amazon.es/dp/B0DW8Y6M6Z",
        "type": "external"
      },
      {
        "label": {
          "en": "NL",
          "es": "NL",
          "nl": "NL",
          "pap": "NL"
        },
        "url": "https://www.amazon.nl/dp/B0DW44SM2T",
        "type": "external"
      },
      {
        "label": {
          "en": "1",
          "es": "1",
          "nl": "1",
          "pap": "1"
        },
        "url": "index.html",
        "type": "external"
      },
      {
        "label": {
          "en": "2",
          "es": "2",
          "nl": "2",
          "pap": "2"
        },
        "url": "index-2.html",
        "type": "external"
      },
      {
        "label": {
          "en": "3",
          "es": "3",
          "nl": "3",
          "pap": "3"
        },
        "url": "index-3.html",
        "type": "external"
      }
    ],
    "previousEpisode": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2",
    "nextEpisode": null,
    "relatedArticles": [],
    "relatedCourses": [],
    "legacy": {
      "sourcePage": "index.html",
      "sourceLine": 485,
      "kind": "podcast",
      "image": "images/scarab.jpg"
    }
  }
];
